(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sheet = require('@emotion/sheet');
var stylis = require('stylis');
var weakMemoize = require('@emotion/weak-memoize');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var weakMemoize__default = /*#__PURE__*/_interopDefault(weakMemoize);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = stylis.peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (stylis.token(character)) {
      break;
    }

    stylis.next();
  }

  return stylis.slice(begin, stylis.position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (stylis.token(character)) {
      case 0:
        // &\f
        if (character === 38 && stylis.peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(stylis.position - 1, points, index);
        break;

      case 2:
        parsed[index] += stylis.delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = stylis.peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += stylis.from(character);
    }
  } while (character = stylis.next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return stylis.dealloc(toRules(stylis.alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (stylis.hash(value, length)) {
    // color-adjust
    case 5103:
      return stylis.WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return stylis.WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return stylis.WEBKIT + value + stylis.MOZ + value + stylis.MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return stylis.WEBKIT + value + stylis.MS + value + value;
    // order

    case 6165:
      return stylis.WEBKIT + value + stylis.MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return stylis.WEBKIT + value + stylis.replace(value, /(\w+).+(:[^]+)/, stylis.WEBKIT + 'box-$1$2' + stylis.MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return stylis.WEBKIT + value + stylis.MS + 'flex-item-' + stylis.replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return stylis.WEBKIT + value + stylis.MS + 'flex-line-pack' + stylis.replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return stylis.WEBKIT + 'box-' + stylis.replace(value, '-grow', '') + stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return stylis.WEBKIT + stylis.replace(value, /([^-])(transform)/g, '$1' + stylis.WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return stylis.replace(stylis.replace(stylis.replace(value, /(zoom-|grab)/, stylis.WEBKIT + '$1'), /(image-set)/, stylis.WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return stylis.replace(value, /(image-set\([^]*)/, stylis.WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return stylis.replace(stylis.replace(value, /(.+:)(flex-)?(.*)/, stylis.WEBKIT + 'box-pack:$3' + stylis.MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + stylis.WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return stylis.replace(value, /(.+)-inline(.+)/, stylis.WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (stylis.strlen(value) - 1 - length > 6) switch (stylis.charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (stylis.charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return stylis.replace(value, /(.+:)(.+)-([^]+)/, '$1' + stylis.WEBKIT + '$2-$3' + '$1' + stylis.MOZ + (stylis.charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~stylis.indexof(value, 'stretch') ? prefix(stylis.replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (stylis.charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (stylis.charat(value, stylis.strlen(value) - 3 - (~stylis.indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return stylis.replace(value, ':', ':' + stylis.WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return stylis.replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + stylis.WEBKIT + (stylis.charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + stylis.WEBKIT + '$2$3' + '$1' + stylis.MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (stylis.charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return stylis.WEBKIT + value + stylis.MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case stylis.DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case stylis.KEYFRAMES:
      return stylis.serialize([stylis.copy(element, {
        value: stylis.replace(element.value, '@', '@' + stylis.WEBKIT)
      })], callback);

    case stylis.RULESET:
      if (element.length) return stylis.combine(element.props, function (value) {
        switch (stylis.match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(read-\w+)/, ':' + stylis.MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.WEBKIT + 'input-$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.MOZ + '$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, stylis.MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize__default["default"](function () {
  return memoize__default["default"](function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if ("production" !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if ("production" !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if ("production" !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [stylis.stringify, "production" !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== stylis.COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : stylis.rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis$1 = function stylis$1(styles) {
      return stylis.serialize(stylis.compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if ("production" !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis$1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stylis.stringify];

    var _serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return stylis.serialize(stylis.compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        "production" === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new sheet.StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

exports["default"] = createCache;

},{"@emotion/memoize":13,"@emotion/sheet":19,"@emotion/weak-memoize":28,"stylis":99}],2:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-cache.cjs.prod.js");
} else {
  module.exports = require("./emotion-cache.cjs.dev.js");
}

},{"./emotion-cache.cjs.dev.js":1,"./emotion-cache.cjs.prod.js":3}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sheet = require('@emotion/sheet');
var stylis = require('stylis');
var weakMemoize = require('@emotion/weak-memoize');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var weakMemoize__default = /*#__PURE__*/_interopDefault(weakMemoize);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = stylis.peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (stylis.token(character)) {
      break;
    }

    stylis.next();
  }

  return stylis.slice(begin, stylis.position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (stylis.token(character)) {
      case 0:
        // &\f
        if (character === 38 && stylis.peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(stylis.position - 1, points, index);
        break;

      case 2:
        parsed[index] += stylis.delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = stylis.peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += stylis.from(character);
    }
  } while (character = stylis.next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return stylis.dealloc(toRules(stylis.alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (stylis.hash(value, length)) {
    // color-adjust
    case 5103:
      return stylis.WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return stylis.WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return stylis.WEBKIT + value + stylis.MOZ + value + stylis.MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return stylis.WEBKIT + value + stylis.MS + value + value;
    // order

    case 6165:
      return stylis.WEBKIT + value + stylis.MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return stylis.WEBKIT + value + stylis.replace(value, /(\w+).+(:[^]+)/, stylis.WEBKIT + 'box-$1$2' + stylis.MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return stylis.WEBKIT + value + stylis.MS + 'flex-item-' + stylis.replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return stylis.WEBKIT + value + stylis.MS + 'flex-line-pack' + stylis.replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return stylis.WEBKIT + 'box-' + stylis.replace(value, '-grow', '') + stylis.WEBKIT + value + stylis.MS + stylis.replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return stylis.WEBKIT + stylis.replace(value, /([^-])(transform)/g, '$1' + stylis.WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return stylis.replace(stylis.replace(stylis.replace(value, /(zoom-|grab)/, stylis.WEBKIT + '$1'), /(image-set)/, stylis.WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return stylis.replace(value, /(image-set\([^]*)/, stylis.WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return stylis.replace(stylis.replace(value, /(.+:)(flex-)?(.*)/, stylis.WEBKIT + 'box-pack:$3' + stylis.MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + stylis.WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return stylis.replace(value, /(.+)-inline(.+)/, stylis.WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (stylis.strlen(value) - 1 - length > 6) switch (stylis.charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (stylis.charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return stylis.replace(value, /(.+:)(.+)-([^]+)/, '$1' + stylis.WEBKIT + '$2-$3' + '$1' + stylis.MOZ + (stylis.charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~stylis.indexof(value, 'stretch') ? prefix(stylis.replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (stylis.charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (stylis.charat(value, stylis.strlen(value) - 3 - (~stylis.indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return stylis.replace(value, ':', ':' + stylis.WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return stylis.replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + stylis.WEBKIT + (stylis.charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + stylis.WEBKIT + '$2$3' + '$1' + stylis.MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (stylis.charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return stylis.WEBKIT + value + stylis.MS + stylis.replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return stylis.WEBKIT + value + stylis.MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case stylis.DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case stylis.KEYFRAMES:
      return stylis.serialize([stylis.copy(element, {
        value: stylis.replace(element.value, '@', '@' + stylis.WEBKIT)
      })], callback);

    case stylis.RULESET:
      if (element.length) return stylis.combine(element.props, function (value) {
        switch (stylis.match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(read-\w+)/, ':' + stylis.MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return stylis.serialize([stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.WEBKIT + 'input-$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, ':' + stylis.MOZ + '$1')]
            }), stylis.copy(element, {
              props: [stylis.replace(value, /:(plac\w+)/, stylis.MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize__default["default"](function () {
  return memoize__default["default"](function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [stylis.stringify, stylis.rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis$1 = function stylis$1(styles) {
      return stylis.serialize(stylis.compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis$1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stylis.stringify];

    var _serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return stylis.serialize(stylis.compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new sheet.StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

exports["default"] = createCache;

},{"@emotion/memoize":13,"@emotion/sheet":19,"@emotion/weak-memoize":28,"stylis":99}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createCache = require('@emotion/cache');
var serialize = require('@emotion/serialize');
var utils = require('@emotion/utils');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var createCache__default = /*#__PURE__*/_interopDefault(createCache);

function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = createCache__default['default'](options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if ("production" !== 'production' && this.ctr !== 0) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serialize.serializeStyles(args, cache.registered, undefined);
    utils.insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serialize.serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serialize.serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

exports.default = createEmotion;

},{"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var createCache = require("@emotion/cache"), serialize = require("@emotion/serialize"), utils = require("@emotion/utils");

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var createCache__default = _interopDefault(createCache);

function insertWithoutScoping(cache, serialized) {
  if (void 0 === cache.inserted[serialized.name]) return cache.insert("", serialized, cache.sheet, !0);
}

function merge(registered, css, className) {
  var registeredStyles = [], rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
  return registeredStyles.length < 2 ? className : rawClassName + css(registeredStyles);
}

var createEmotion = function(options) {
  var cache = createCache__default.default(options);
  cache.sheet.speedy = function(value) {
    this.isSpeedy = value;
  }, cache.compat = !0;
  var css = function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    var serialized = serialize.serializeStyles(args, cache.registered, void 0);
    return utils.insertStyles(cache, serialized, !1), cache.key + "-" + serialized.name;
  };
  return {
    css: css,
    cx: function() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
      return merge(cache.registered, css, classnames(args));
    },
    injectGlobal: function() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
      var serialized = serialize.serializeStyles(args, cache.registered);
      insertWithoutScoping(cache, serialized);
    },
    keyframes: function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
      var serialized = serialize.serializeStyles(args, cache.registered), animation = "animation-" + serialized.name;
      return insertWithoutScoping(cache, {
        name: serialized.name,
        styles: "@keyframes " + animation + "{" + serialized.styles + "}"
      }), animation;
    },
    hydrate: function(ids) {
      ids.forEach((function(key) {
        cache.inserted[key] = !0;
      }));
    },
    flush: function() {
      cache.registered = {}, cache.inserted = {}, cache.sheet.flush();
    },
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
}, classnames = function classnames(args) {
  for (var cls = "", i = 0; i < args.length; i++) {
    var arg = args[i];
    if (null != arg) {
      var toAdd = void 0;
      switch (typeof arg) {
       case "boolean":
        break;

       case "object":
        if (Array.isArray(arg)) toAdd = classnames(arg); else for (var k in toAdd = "", 
        arg) arg[k] && k && (toAdd && (toAdd += " "), toAdd += k);
        break;

       default:
        toAdd = arg;
      }
      toAdd && (cls && (cls += " "), cls += toAdd);
    }
  }
  return cls;
};

exports.default = createEmotion;

},{"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('@emotion/cache');
require('@emotion/serialize');
require('@emotion/utils');
var createInstance_dist_emotionCssCreateInstance = require('../create-instance/dist/emotion-css-create-instance.cjs.dev.js');

var _createEmotion = createInstance_dist_emotionCssCreateInstance['default']({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;

exports.cache = cache;
exports.css = css;
exports.cx = cx;
exports.flush = flush;
exports.getRegisteredStyles = getRegisteredStyles;
exports.hydrate = hydrate;
exports.injectGlobal = injectGlobal;
exports.keyframes = keyframes;
exports.merge = merge;
exports.sheet = sheet;

},{"../create-instance/dist/emotion-css-create-instance.cjs.dev.js":4,"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],7:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-css.cjs.prod.js");
} else {
  module.exports = require("./emotion-css.cjs.dev.js");
}

},{"./emotion-css.cjs.dev.js":6,"./emotion-css.cjs.prod.js":8}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), require("@emotion/cache"), require("@emotion/serialize"), require("@emotion/utils");

var createInstance_dist_emotionCssCreateInstance = require("../create-instance/dist/emotion-css-create-instance.cjs.prod.js"), _createEmotion = createInstance_dist_emotionCssCreateInstance.default({
  key: "css"
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

exports.cache = cache, exports.css = css, exports.cx = cx, exports.flush = flush, 
exports.getRegisteredStyles = getRegisteredStyles, exports.hydrate = hydrate, exports.injectGlobal = injectGlobal, 
exports.keyframes = keyframes, exports.merge = merge, exports.sheet = sheet;

},{"../create-instance/dist/emotion-css-create-instance.cjs.prod.js":5,"@emotion/cache":2,"@emotion/serialize":16,"@emotion/utils":25}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

exports["default"] = murmur2;

},{}],10:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-hash.cjs.prod.js");
} else {
  module.exports = require("./emotion-hash.cjs.dev.js");
}

},{"./emotion-hash.cjs.dev.js":9,"./emotion-hash.cjs.prod.js":11}],11:[function(require,module,exports){
arguments[4][9][0].apply(exports,arguments)
},{"dup":9}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

exports["default"] = memoize;

},{}],13:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-memoize.cjs.prod.js");
} else {
  module.exports = require("./emotion-memoize.cjs.dev.js");
}

},{"./emotion-memoize.cjs.dev.js":12,"./emotion-memoize.cjs.prod.js":14}],14:[function(require,module,exports){
arguments[4][12][0].apply(exports,arguments)
},{"dup":12}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hashString = require('@emotion/hash');
var unitless = require('@emotion/unitless');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var hashString__default = /*#__PURE__*/_interopDefault(hashString);
var unitless__default = /*#__PURE__*/_interopDefault(unitless);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize__default["default"](function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless__default["default"][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if ("production" !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if ("production" !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if ("production" !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if ("production" !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if ("production" !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if ("production" !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if ("production" !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if ("production" !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if ("production" !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if ("production" !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hashString__default["default"](styles) + identifierName;

  if ("production" !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

exports.serializeStyles = serializeStyles;

},{"@emotion/hash":10,"@emotion/memoize":13,"@emotion/unitless":22}],16:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-serialize.cjs.prod.js");
} else {
  module.exports = require("./emotion-serialize.cjs.dev.js");
}

},{"./emotion-serialize.cjs.dev.js":15,"./emotion-serialize.cjs.prod.js":17}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hashString = require('@emotion/hash');
var unitless = require('@emotion/unitless');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var hashString__default = /*#__PURE__*/_interopDefault(hashString);
var unitless__default = /*#__PURE__*/_interopDefault(unitless);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize__default["default"](function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless__default["default"][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' &&         "production" !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {

      styles += strings[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hashString__default["default"](styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

exports.serializeStyles = serializeStyles;

},{"@emotion/hash":10,"@emotion/memoize":13,"@emotion/unitless":22}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if ("production" !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if ("production" !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if ("production" !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

exports.StyleSheet = StyleSheet;

},{}],19:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-sheet.cjs.prod.js");
} else {
  module.exports = require("./emotion-sheet.cjs.dev.js");
}

},{"./emotion-sheet.cjs.dev.js":18,"./emotion-sheet.cjs.prod.js":20}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ?         "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

exports.StyleSheet = StyleSheet;

},{}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

exports["default"] = unitlessKeys;

},{}],22:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-unitless.cjs.prod.js");
} else {
  module.exports = require("./emotion-unitless.cjs.dev.js");
}

},{"./emotion-unitless.cjs.dev.js":21,"./emotion-unitless.cjs.prod.js":23}],23:[function(require,module,exports){
arguments[4][21][0].apply(exports,arguments)
},{"dup":21}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

exports.getRegisteredStyles = getRegisteredStyles;
exports.insertStyles = insertStyles;
exports.registerStyles = registerStyles;

},{}],25:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-utils.cjs.prod.js");
} else {
  module.exports = require("./emotion-utils.cjs.dev.js");
}

},{"./emotion-utils.cjs.dev.js":24,"./emotion-utils.cjs.prod.js":26}],26:[function(require,module,exports){
arguments[4][24][0].apply(exports,arguments)
},{"dup":24}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

exports["default"] = weakMemoize;

},{}],28:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-weak-memoize.cjs.prod.js");
} else {
  module.exports = require("./emotion-weak-memoize.cjs.dev.js");
}

},{"./emotion-weak-memoize.cjs.dev.js":27,"./emotion-weak-memoize.cjs.prod.js":29}],29:[function(require,module,exports){
arguments[4][27][0].apply(exports,arguments)
},{"dup":27}],30:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":32}],31:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var buildURL = require('./../helpers/buildURL');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = require('./../helpers/cookies');

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/createError":38,"./../core/settle":42,"./../helpers/buildURL":46,"./../helpers/cookies":48,"./../helpers/isURLSameOrigin":50,"./../helpers/parseHeaders":52,"./../utils":54}],32:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":33,"./cancel/CancelToken":34,"./cancel/isCancel":35,"./core/Axios":36,"./core/mergeConfig":41,"./defaults":44,"./helpers/bind":45,"./helpers/spread":53,"./utils":54}],33:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],34:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":33}],35:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],36:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);
  config.method = config.method ? config.method.toLowerCase() : 'get';

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":46,"./../utils":54,"./InterceptorManager":37,"./dispatchRequest":39,"./mergeConfig":41}],37:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":54}],38:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":40}],39:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');
var isAbsoluteURL = require('./../helpers/isAbsoluteURL');
var combineURLs = require('./../helpers/combineURLs');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":35,"../defaults":44,"./../helpers/combineURLs":47,"./../helpers/isAbsoluteURL":49,"./../utils":54,"./transformData":43}],40:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],41:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach([
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
    'socketPath'
  ], function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};

},{"../utils":54}],42:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":38}],43:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

},{"./../utils":54}],44:[function(require,module,exports){
(function (process){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  // Only Node.JS has a process variable that is of [[Class]] process
  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  } else if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this,require('_process'))
},{"./adapters/http":31,"./adapters/xhr":31,"./helpers/normalizeHeaderName":51,"./utils":54,"_process":98}],45:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],46:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":54}],47:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],48:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":54}],49:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],50:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":54}],51:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":54}],52:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":54}],53:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],54:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');
var isBuffer = require('is-buffer');

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

},{"./helpers/bind":45,"is-buffer":96}],55:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":57}],56:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":58}],57:[function(require,module,exports){
var core = require('../../modules/_core');
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

},{"../../modules/_core":63}],58:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":63,"../../modules/es6.object.assign":94}],59:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],60:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":76}],61:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":87,"./_to-iobject":89,"./_to-length":90}],62:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],63:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],64:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":59}],65:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],66:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":70}],67:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":71,"./_is-object":76}],68:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],69:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":63,"./_ctx":64,"./_global":71,"./_has":72,"./_hide":73}],70:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],71:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],72:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],73:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":66,"./_object-dp":79,"./_property-desc":84}],74:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":66,"./_dom-create":67,"./_fails":70}],75:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":62}],76:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],77:[function(require,module,exports){
module.exports = true;

},{}],78:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":66,"./_fails":70,"./_iobject":75,"./_object-gops":80,"./_object-keys":82,"./_object-pie":83,"./_to-object":91}],79:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":60,"./_descriptors":66,"./_ie8-dom-define":74,"./_to-primitive":92}],80:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],81:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":61,"./_has":72,"./_shared-key":85,"./_to-iobject":89}],82:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":68,"./_object-keys-internal":81}],83:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],84:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],85:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":86,"./_uid":93}],86:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":63,"./_global":71,"./_library":77}],87:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":88}],88:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],89:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":65,"./_iobject":75}],90:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":88}],91:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":65}],92:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":76}],93:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],94:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":69,"./_object-assign":78}],95:[function(require,module,exports){
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * A local reference to the document.
 */
var document = window.document;


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  if (parent && parent.assignedSlot) {
    // If the parent is distributed in a <slot>, return the parent of a slot.
    return parent.assignedSlot.parentNode;
  }

  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());

},{}],96:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

},{}],97:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v2.1.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:01Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	});
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));

},{}],98:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],99:[function(require,module,exports){
(function(e,r){typeof exports==="object"&&typeof module!=="undefined"?r(exports):typeof define==="function"&&define.amd?define(["exports"],r):(e=e||self,r(e.stylis={}))})(this,(function(e){"use strict";var r="-ms-";var a="-moz-";var c="-webkit-";var n="comm";var t="rule";var s="decl";var i="@page";var u="@media";var o="@import";var f="@charset";var l="@viewport";var p="@supports";var h="@document";var v="@namespace";var d="@keyframes";var b="@font-face";var w="@counter-style";var m="@font-feature-values";var g="@layer";var k=Math.abs;var $=String.fromCharCode;var x=Object.assign;function E(e,r){return M(e,0)^45?(((r<<2^M(e,0))<<2^M(e,1))<<2^M(e,2))<<2^M(e,3):0}function y(e){return e.trim()}function T(e,r){return(e=r.exec(e))?e[0]:e}function A(e,r,a){return e.replace(r,a)}function O(e,r){return e.indexOf(r)}function M(e,r){return e.charCodeAt(r)|0}function C(e,r,a){return e.slice(r,a)}function R(e){return e.length}function S(e){return e.length}function z(e,r){return r.push(e),e}function N(e,r){return e.map(r).join("")}e.line=1;e.column=1;e.length=0;e.position=0;e.character=0;e.characters="";function P(r,a,c,n,t,s,i){return{value:r,root:a,parent:c,type:n,props:t,children:s,line:e.line,column:e.column,length:i,return:""}}function j(e,r){return x(P("",null,null,"",null,null,0),e,{length:-e.length},r)}function U(){return e.character}function _(){e.character=e.position>0?M(e.characters,--e.position):0;if(e.column--,e.character===10)e.column=1,e.line--;return e.character}function F(){e.character=e.position<e.length?M(e.characters,e.position++):0;if(e.column++,e.character===10)e.column=1,e.line++;return e.character}function I(){return M(e.characters,e.position)}function L(){return e.position}function D(r,a){return C(e.characters,r,a)}function Y(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function K(r){return e.line=e.column=1,e.length=R(e.characters=r),e.position=0,[]}function V(r){return e.characters="",r}function W(r){return y(D(e.position-1,q(r===91?r+2:r===40?r+1:r)))}function B(e){return V(H(K(e)))}function G(r){while(e.character=I())if(e.character<33)F();else break;return Y(r)>2||Y(e.character)>3?"":" "}function H(r){while(F())switch(Y(e.character)){case 0:z(Q(e.position-1),r);break;case 2:z(W(e.character),r);break;default:z($(e.character),r)}return r}function Z(r,a){while(--a&&F())if(e.character<48||e.character>102||e.character>57&&e.character<65||e.character>70&&e.character<97)break;return D(r,L()+(a<6&&I()==32&&F()==32))}function q(r){while(F())switch(e.character){case r:return e.position;case 34:case 39:if(r!==34&&r!==39)q(e.character);break;case 40:if(r===41)q(r);break;case 92:F();break}return e.position}function J(r,a){while(F())if(r+e.character===47+10)break;else if(r+e.character===42+42&&I()===47)break;return"/*"+D(a,e.position-1)+"*"+$(r===47?r:F())}function Q(r){while(!Y(I()))F();return D(r,e.position)}function X(e){return V(ee("",null,null,null,[""],e=K(e),0,[0],e))}function ee(e,r,a,c,n,t,s,i,u){var o=0;var f=0;var l=s;var p=0;var h=0;var v=0;var d=1;var b=1;var w=1;var m=0;var g="";var k=n;var x=t;var E=c;var y=g;while(b)switch(v=m,m=F()){case 40:if(v!=108&&M(y,l-1)==58){if(O(y+=A(W(m),"&","&\f"),"&\f")!=-1)w=-1;break}case 34:case 39:case 91:y+=W(m);break;case 9:case 10:case 13:case 32:y+=G(v);break;case 92:y+=Z(L()-1,7);continue;case 47:switch(I()){case 42:case 47:z(ae(J(F(),L()),r,a),u);break;default:y+="/"}break;case 123*d:i[o++]=R(y)*w;case 125*d:case 59:case 0:switch(m){case 0:case 125:b=0;case 59+f:if(w==-1)y=A(y,/\f/g,"");if(h>0&&R(y)-l)z(h>32?ce(y+";",c,a,l-1):ce(A(y," ","")+";",c,a,l-2),u);break;case 59:y+=";";default:z(E=re(y,r,a,o,f,n,i,g,k=[],x=[],l),t);if(m===123)if(f===0)ee(y,r,E,E,k,t,l,i,x);else switch(p===99&&M(y,3)===110?100:p){case 100:case 108:case 109:case 115:ee(e,E,E,c&&z(re(e,E,E,0,0,n,i,g,n,k=[],l),x),n,x,l,i,c?k:x);break;default:ee(y,E,E,E,[""],x,0,i,x)}}o=f=h=0,d=w=1,g=y="",l=s;break;case 58:l=1+R(y),h=v;default:if(d<1)if(m==123)--d;else if(m==125&&d++==0&&_()==125)continue;switch(y+=$(m),m*d){case 38:w=f>0?1:(y+="\f",-1);break;case 44:i[o++]=(R(y)-1)*w,w=1;break;case 64:if(I()===45)y+=W(F());p=I(),f=l=R(g=y+=Q(L())),m++;break;case 45:if(v===45&&R(y)==2)d=0}}return t}function re(e,r,a,c,n,s,i,u,o,f,l){var p=n-1;var h=n===0?s:[""];var v=S(h);for(var d=0,b=0,w=0;d<c;++d)for(var m=0,g=C(e,p+1,p=k(b=i[d])),$=e;m<v;++m)if($=y(b>0?h[m]+" "+g:A(g,/&\f/g,h[m])))o[w++]=$;return P(e,r,a,n===0?t:u,o,f,l)}function ae(e,r,a){return P(e,r,a,n,$(U()),C(e,2,-2),0)}function ce(e,r,a,c){return P(e,r,a,s,C(e,0,c),C(e,c+1,-1),c)}function ne(e,n,t){switch(E(e,n)){case 5103:return c+"print-"+e+e;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return c+e+e;case 4789:return a+e+e;case 5349:case 4246:case 4810:case 6968:case 2756:return c+e+a+e+r+e+e;case 5936:switch(M(e,n+11)){case 114:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"tb")+e;case 108:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"tb-rl")+e;case 45:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"lr")+e}case 6828:case 4268:case 2903:return c+e+r+e+e;case 6165:return c+e+r+"flex-"+e+e;case 5187:return c+e+A(e,/(\w+).+(:[^]+)/,c+"box-$1$2"+r+"flex-$1$2")+e;case 5443:return c+e+r+"flex-item-"+A(e,/flex-|-self/g,"")+(!T(e,/flex-|baseline/)?r+"grid-row-"+A(e,/flex-|-self/g,""):"")+e;case 4675:return c+e+r+"flex-line-pack"+A(e,/align-content|flex-|-self/g,"")+e;case 5548:return c+e+r+A(e,"shrink","negative")+e;case 5292:return c+e+r+A(e,"basis","preferred-size")+e;case 6060:return c+"box-"+A(e,"-grow","")+c+e+r+A(e,"grow","positive")+e;case 4554:return c+A(e,/([^-])(transform)/g,"$1"+c+"$2")+e;case 6187:return A(A(A(e,/(zoom-|grab)/,c+"$1"),/(image-set)/,c+"$1"),e,"")+e;case 5495:case 3959:return A(e,/(image-set\([^]*)/,c+"$1"+"$`$1");case 4968:return A(A(e,/(.+:)(flex-)?(.*)/,c+"box-pack:$3"+r+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+c+e+e;case 4200:if(!T(e,/flex-|baseline/))return r+"grid-column-align"+C(e,n)+e;break;case 2592:case 3360:return r+A(e,"template-","")+e;case 4384:case 3616:if(t&&t.some((function(e,r){return n=r,T(e.props,/grid-\w+-end/)}))){return~O(e+(t=t[n].value),"span")?e:r+A(e,"-start","")+e+r+"grid-row-span:"+(~O(t,"span")?T(t,/\d+/):+T(t,/\d+/)-+T(e,/\d+/))+";"}return r+A(e,"-start","")+e;case 4896:case 4128:return t&&t.some((function(e){return T(e.props,/grid-\w+-start/)}))?e:r+A(A(e,"-end","-span"),"span ","")+e;case 4095:case 3583:case 4068:case 2532:return A(e,/(.+)-inline(.+)/,c+"$1$2")+e;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(R(e)-1-n>6)switch(M(e,n+1)){case 109:if(M(e,n+4)!==45)break;case 102:return A(e,/(.+:)(.+)-([^]+)/,"$1"+c+"$2-$3"+"$1"+a+(M(e,n+3)==108?"$3":"$2-$3"))+e;case 115:return~O(e,"stretch")?ne(A(e,"stretch","fill-available"),n,t)+e:e}break;case 5152:case 5920:return A(e,/(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/,(function(a,c,n,t,s,i,u){return r+c+":"+n+u+(t?r+c+"-span:"+(s?i:+i-+n)+u:"")+e}));case 4949:if(M(e,n+6)===121)return A(e,":",":"+c)+e;break;case 6444:switch(M(e,M(e,14)===45?18:11)){case 120:return A(e,/(.+:)([^;\s!]+)(;|(\s+)?!.+)?/,"$1"+c+(M(e,14)===45?"inline-":"")+"box$3"+"$1"+c+"$2$3"+"$1"+r+"$2box$3")+e;case 100:return A(e,":",":"+r)+e}break;case 5719:case 2647:case 2135:case 3927:case 2391:return A(e,"scroll-","scroll-snap-")+e}return e}function te(e,r){var a="";var c=S(e);for(var n=0;n<c;n++)a+=r(e[n],n,e,r)||"";return a}function se(e,r,a,c){switch(e.type){case g:if(e.children.length)break;case o:case s:return e.return=e.return||e.value;case n:return"";case d:return e.return=e.value+"{"+te(e.children,c)+"}";case t:e.value=e.props.join(",")}return R(a=te(e.children,c))?e.return=e.value+"{"+a+"}":""}function ie(e){var r=S(e);return function(a,c,n,t){var s="";for(var i=0;i<r;i++)s+=e[i](a,c,n,t)||"";return s}}function ue(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function oe(e,n,i,u){if(e.length>-1)if(!e.return)switch(e.type){case s:e.return=ne(e.value,e.length,i);return;case d:return te([j(e,{value:A(e.value,"@","@"+c)})],u);case t:if(e.length)return N(e.props,(function(n){switch(T(n,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return te([j(e,{props:[A(n,/:(read-\w+)/,":"+a+"$1")]})],u);case"::placeholder":return te([j(e,{props:[A(n,/:(plac\w+)/,":"+c+"input-$1")]}),j(e,{props:[A(n,/:(plac\w+)/,":"+a+"$1")]}),j(e,{props:[A(n,/:(plac\w+)/,r+"input-$1")]})],u)}return""}))}}function fe(e){switch(e.type){case t:e.props=e.props.map((function(r){return N(B(r),(function(r,a,c){switch(M(r,0)){case 12:return C(r,1,R(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(c[++a]==="global")c[a]="",c[++a]="\f"+C(c[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return S(c)>1?"":r;case a=S(c)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}e.CHARSET=f;e.COMMENT=n;e.COUNTER_STYLE=w;e.DECLARATION=s;e.DOCUMENT=h;e.FONT_FACE=b;e.FONT_FEATURE_VALUES=m;e.IMPORT=o;e.KEYFRAMES=d;e.LAYER=g;e.MEDIA=u;e.MOZ=a;e.MS=r;e.NAMESPACE=v;e.PAGE=i;e.RULESET=t;e.SUPPORTS=p;e.VIEWPORT=l;e.WEBKIT=c;e.abs=k;e.alloc=K;e.append=z;e.assign=x;e.caret=L;e.char=U;e.charat=M;e.combine=N;e.comment=ae;e.commenter=J;e.compile=X;e.copy=j;e.dealloc=V;e.declaration=ce;e.delimit=W;e.delimiter=q;e.escaping=Z;e.from=$;e.hash=E;e.identifier=Q;e.indexof=O;e.match=T;e.middleware=ie;e.namespace=fe;e.next=F;e.node=P;e.parse=ee;e.peek=I;e.prefix=ne;e.prefixer=oe;e.prev=_;e.replace=A;e.ruleset=re;e.rulesheet=ue;e.serialize=te;e.sizeof=S;e.slice=D;e.stringify=se;e.strlen=R;e.substr=C;e.token=Y;e.tokenize=B;e.tokenizer=H;e.trim=y;e.whitespace=G;Object.defineProperty(e,"__esModule",{value:true})}));


},{}],100:[function(require,module,exports){
/**
 * Swiper 5.2.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 16, 2019
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  function filter(callback) {
    var matchedItems = [];
    var dom = this;
    for (var i = 0; i < dom.length; i += 1) {
      if (callback.call(dom[i], i, dom[i])) { matchedItems.push(dom[i]); }
    }
    return new Dom7(matchedItems);
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    filter: filter,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!win.PointerEvent && ('maxTouchPoints' in win.navigator) && win.navigator.maxTouchPoints > 0,

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
      handler.apply(self, args);
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    function slidesForMargin(slideIndex) {
      if (!params.cssMode) { return true; }
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
          var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
          var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
          var columnsInGroup = groupIndex === 0
            ? params.slidesPerGroup
            : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
          row = Math.floor(slideIndexInGroup / columnsInGroup);
          column = (slideIndexInGroup - row * columnsInGroup) + groupIndex * params.slidesPerGroup;

          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - (column * slidesPerColumn);
          if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
            row += 1;
            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide.css(
          ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
          (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
        );
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box') {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.filter(slidesForMargin).css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.filter(slidesForMargin).css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.filter(slidesForMargin).css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centeredSlides && params.centeredSlidesBounds) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      var maxSnap = allSlidesSize - swiperSize;
      snapGrid = snapGrid.map(function (snap) {
        if (snap < 0) { return -offsetBefore; }
        if (snap > maxSnap) { return maxSnap + offsetAfter; }
        return snap;
      });
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize$1 = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize$1 += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize$1 -= params.spaceBetween;
      if (allSlidesSize$1 < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize$1) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
      var multiplier = swiper.rtlTranslate ? -1 : 1;
      // eslint-disable-next-line
      translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }
    if (params.cssMode) {
      return translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var wrapperEl = swiper.wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)"));
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  function translateTo (translate, speed, runCallbacks, translateBounds, internal) {
    var obj;

    if ( translate === void 0 ) translate = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;
    if ( translateBounds === void 0 ) translateBounds = true;
    var swiper = this;

    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) { newTranslate = minTranslate; }
    else if (translateBounds && translate < maxTranslate) { newTranslate = maxTranslate; }
    else { newTranslate = translate; }

    // Update progress
    swiper.updateProgress(newTranslate);

    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          wrapperEl.scrollTo(( obj = {}, obj[isH ? 'left' : 'top'] = -newTranslate, obj.behavior = 'smooth', obj ));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        }
      }
      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionEnd');
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionStart');
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            if (runCallbacks) {
              swiper.emit('transitionEnd');
            }
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
      }
    }

    return true;
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    if (!swiper.params.cssMode) {
      swiper.$wrapperEl.transition(duration);
    }

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.cssMode) { return; }
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) { return; }
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    var obj;

    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    var wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -translate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          wrapperEl.scrollTo(( obj = {}, obj[isH ? 'left' : 'top'] = -translate, obj.behavior = 'smooth', obj ));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -translate;
        }
      }
      return true;
    }

    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
      snapGrid.forEach(function (snap) {
        if (!prevSnap && normalizedTranslate >= snap) { prevSnap = snap; }
      });
    }
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal, threshold) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;
    if ( threshold === void 0 ) threshold = 0.5;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    if (translate >= swiper.snapGrid[snapIndex]) {
      // The current translate is on or after the current snap index, so the choice
      // is between the current index and the one after it.
      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];
      if ((translate - currentSnap) > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      // The current translate is before the current snap index, so the choice
      // is between the current index and the one before it.
      var prevSnap = swiper.snapGrid[snapIndex - 1];
      var currentSnap$1 = swiper.snapGrid[snapIndex];
      if ((translate - prevSnap) <= (currentSnap$1 - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.snapGrid.length - 1);

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;

    swiper.emit('beforeLoopFix');

    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();

    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (activeIndex >= slides.length - loopedSlides) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    swiper.emit('loopFix');
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var platform = win.navigator.platform;
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      iphone: false,
      ipod: false,
      ipad: false,
      edge: false,
      ie: false,
      firefox: false,
      macos: false,
      windows: false,
      cordova: !!(win.cordova || win.phonegap),
      phonegap: !!(win.cordova || win.phonegap),
      electron: false,
    };

    var screenWidth = win.screen.width;
    var screenHeight = win.screen.height;

    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
    var edge = ua.indexOf('Edge/') >= 0;
    var firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
    var windows = platform === 'Win32';
    var electron = ua.toLowerCase().indexOf('electron') >= 0;
    var macos = platform === 'MacIntel';

    // iPadOs 13 fix
    if (!ipad
      && macos
      && Support.touch
      && (
        (screenWidth === 1024 && screenHeight === 1366) // Pro 12.9
        || (screenWidth === 834 && screenHeight === 1194) // Pro 11
        || (screenWidth === 834 && screenHeight === 1112) // Pro 10.5
        || (screenWidth === 768 && screenHeight === 1024) // other
      )
    ) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      macos = false;
    }

    device.ie = ie;
    device.edge = edge;
    device.firefox = firefox;

    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.ipod = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Webview
    device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone))
      || (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
    device.webview = device.webView;
    device.standalone = device.webView;

    // Desktop
    device.desktop = !(device.ios || device.android) || electron;
    if (device.desktop) {
      device.electron = electron;
      device.macos = macos;
      device.windows = windows;
      if (device.macos) {
        device.os = 'macos';
      }
      if (device.windows) {
        device.os = 'windows';
      }
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;

    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    var $targetEl = $(e.target);

    if (params.touchEventsTarget === 'wrapper') {
      if (!$targetEl.closest(swiper.wrapperEl).length) { return; }
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$targetEl.closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($targetEl.is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== $targetEl[0]
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode) {
      e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger || params.cssMode) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap click', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        swiper.emit('doubleTap doubleClick', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.cssMode) {
      return;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
          if (params.freeModeSticky) {
            // If freeModeSticky is active and the user ends a swipe with a slow-velocity
            // event, then durations can be 20+ seconds to slide one (or zero!) slides.
            // It's easy to see this when simulating touch with mouse events. To fix this,
            // limit single-slide swipes to the default slide duration. This also has the
            // nice side effect of matching slide speed if the user stopped moving before
            // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
            // For faster swipes, also apply limits (albeit higher ones).
            var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
            var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
            if (moveDistance < currentSlideSize) {
              momentumDuration = params.speed;
            } else if (moveDistance < 2 * currentSlideSize) {
              momentumDuration = params.speed * 1.5;
            } else {
              momentumDuration = params.speed * 2.5;
            }
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + params.slidesPerGroup);
        }
        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }

    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function onScroll () {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl;
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? -wrapperEl.scrollLeft : -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === -0) { swiper.translate = 0; }

    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(swiper.translate);
    }

    swiper.emit('setTranslate', swiper.translate, false);
  }

  var dummyEventAttached = false;
  function dummyEventListener() {}

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var capture = !!params.nested;

    // Touch Events
    if (!Support.touch && Support.pointerEvents) {
      el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
        el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
        if (!dummyEventAttached) {
          doc.addEventListener('touchstart', dummyEventListener);
          dummyEventAttached = true;
        }
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        el.addEventListener('mousedown', swiper.onTouchStart, false);
        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      el.addEventListener('click', swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl.addEventListener('scroll', swiper.onScroll);
    }

    // Resize handler
    if (params.updateOnWindowResize) {
      swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
    } else {
      swiper.on('observerUpdate', onResize, true);
    }
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var capture = !!params.nested;

    // Touch Events
    if (!Support.touch && Support.pointerEvents) {
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        el.removeEventListener('mousedown', swiper.onTouchStart, false);
        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      el.removeEventListener('click', swiper.onClick, true);
    }

    if (params.cssMode) {
      wrapperEl.removeEventListener('scroll', swiper.onScroll);
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerColumn'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var wasMultiRow = params.slidesPerColumn > 1;
      var isMultiRow = breakpointParams.slidesPerColumn > 1;
      if (wasMultiRow && !isMultiRow) {
        $el.removeClass(((params.containerModifierClass) + "multirow " + (params.containerModifierClass) + "multirow-column"));
      } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(((params.containerModifierClass) + "multirow"));
        if (breakpointParams.slidesPerColumnFill === 'column') {
          $el.addClass(((params.containerModifierClass) + "multirow-column"));
        }
      }

      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (point <= win.innerWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
      if (params.slidesPerColumnFill === 'column') {
        suffixes.push('multirow-column');
      }
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }

    if (params.cssMode) {
      suffixes.push('css-mode');
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && (params.slidesOffsetBefore + (params.spaceBetween * (swiper.slides.length - 1)) + ((swiper.slides[0]).offsetWidth) * swiper.slides.length);

    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
      swiper.isLocked = lastSlidePosition <= swiper.size;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }

    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl;
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        $wrapperEl = $(el.shadowRoot.querySelector(("." + (swiper.params.wrapperClass))));
        // Children needs to return slot items
        $wrapperEl.children = function (options) { return $el.children(options); };
      } else {
        $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
      }
      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
            cancel: touch[3],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          var $cachedEl = cache[cachedIndex];
          var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
          if (cachedElIndex) {
            $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
          }
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    },
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if (e.shiftKey && !pX) { // if user scrolls with shift he wants horizontal scroll
        pX = pY;
        pY = 0;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (swiper.params.cssMode) {
        e.preventDefault();
      }

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        // Register the new event in a variable which stores the relevant data
        var newEvent = {
          time: Utils.now(),
          delta: Math.abs(delta),
          direction: Math.sign(delta),
          raw: event,
        };

        // Keep the most recent events
        var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
        if (recentWheelEvents.length >= 2) {
          recentWheelEvents.shift(); // only store the last N events
        }
        var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
        recentWheelEvents.push(newEvent);

        // If there is at least one previous recorded event:
        //   If direction has changed or
        //   if the scroll is quicker than the previous one:
        //     Animate the slider.
        // Else (this is the first time the wheel is moved):
        //     Animate the slider.
        if (prevEvent) {
          if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta) {
            swiper.mousewheel.animateSlider(newEvent);
          }
        } else {
          swiper.mousewheel.animateSlider(newEvent);
        }

        // If it's time to release the scroll:
        //   Return now so you don't hit the preventDefault.
        if (swiper.mousewheel.releaseScroll(newEvent)) {
          return true;
        }
      } else {
        // Freemode or scrollContainer:

        // If we recently snapped after a momentum scroll, then ignore wheel events
        // to give time for the deceleration to finish. Stop ignoring after 500 msecs
        // or if it's a new scroll (larger delta or inverse sign as last event before
        // an end-of-momentum snap).
        var newEvent$1 = { time: Utils.now(), delta: Math.abs(delta), direction: Math.sign(delta) };
        var ref = swiper.mousewheel;
        var lastEventBeforeSnap = ref.lastEventBeforeSnap;
        var ignoreWheelEvents = lastEventBeforeSnap
          && newEvent$1.time < lastEventBeforeSnap.time + 500
          && newEvent$1.delta <= lastEventBeforeSnap.delta
          && newEvent$1.direction === lastEventBeforeSnap.direction;
        if (!ignoreWheelEvents) {
          swiper.mousewheel.lastEventBeforeSnap = undefined;

          if (swiper.params.loop) {
            swiper.loopFix();
          }
          var position = swiper.getTranslate() + (delta * params.sensitivity);
          var wasBeginning = swiper.isBeginning;
          var wasEnd = swiper.isEnd;

          if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
          if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

          swiper.setTransition(0);
          swiper.setTranslate(position);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();

          if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
            swiper.updateSlidesClasses();
          }

          if (swiper.params.freeModeSticky) {
            // When wheel scrolling starts with sticky (aka snap) enabled, then detect
            // the end of a momentum scroll by storing recent (N=15?) wheel events.
            // 1. do all N events have decreasing or same (absolute value) delta?
            // 2. did all N events arrive in the last M (M=500?) msecs?
            // 3. does the earliest event have an (absolute value) delta that's
            //    at least P (P=1?) larger than the most recent event's delta?
            // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
            // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
            // Snap immediately and ignore remaining wheel events in this scroll.
            // See comment above for "remaining wheel events in this scroll" determination.
            // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = undefined;
            var recentWheelEvents$1 = swiper.mousewheel.recentWheelEvents;
            if (recentWheelEvents$1.length >= 15) {
              recentWheelEvents$1.shift(); // only store the last N events
            }
            var prevEvent$1 = recentWheelEvents$1.length ? recentWheelEvents$1[recentWheelEvents$1.length - 1] : undefined;
            var firstEvent = recentWheelEvents$1[0];
            recentWheelEvents$1.push(newEvent$1);
            if (prevEvent$1 && (newEvent$1.delta > prevEvent$1.delta || newEvent$1.direction !== prevEvent$1.direction)) {
              // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
              recentWheelEvents$1.splice(0);
            } else if (recentWheelEvents$1.length >= 15
                && newEvent$1.time - firstEvent.time < 500
                && firstEvent.delta - newEvent$1.delta >= 1
                && newEvent$1.delta <= 6
            ) {
              // We're at the end of the deceleration of a momentum scroll, so there's no need
              // to wait for more events. Snap ASAP on the next tick.
              // Also, because there's some remaining momentum we'll bias the snap in the
              // direction of the ongoing scroll because it's better UX for the scroll to snap
              // in the same direction as the scroll instead of reversing to snap.  Therefore,
              // if it's already scrolled more than 20% in the current direction, keep going.
              var snapToThreshold = delta > 0 ? 0.8 : 0.2;
              swiper.mousewheel.lastEventBeforeSnap = newEvent$1;
              recentWheelEvents$1.splice(0);
              swiper.mousewheel.timeout = Utils.nextTick(function () {
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 0); // no delay; move on next tick
            }
            if (!swiper.mousewheel.timeout) {
              // if we get here, then we haven't detected the end of a momentum scroll, so
              // we'll consider a scroll "complete" when there haven't been any wheel events
              // for 500ms.
              swiper.mousewheel.timeout = Utils.nextTick(function () {
                var snapToThreshold = 0.5;
                swiper.mousewheel.lastEventBeforeSnap = newEvent$1;
                recentWheelEvents$1.splice(0);
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 500);
            }
          }

          // Emit event
          if (!ignoreWheelEvents) { swiper.emit('scroll', e); }

          // Stop autoplay
          if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
          // Return page scroll on edge positions
          if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
        }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    animateSlider: function animateSlider(newEvent) {
      var swiper = this;
      // If the movement is NOT big enough and
      // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
      //   Don't go any further (avoid insignificant scroll movement).
      if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
        // Return false as a default
        return true;
      }
      // If user is scrolling towards the end:
      //   If the slider hasn't hit the latest slide or
      //   if the slider is a loop and
      //   if the slider isn't moving right now:
      //     Go to next slide and
      //     emit a scroll event.
      // Else (the user is scrolling towards the beginning) and
      // if the slider hasn't hit the first slide or
      // if the slider is a loop and
      // if the slider isn't moving right now:
      //   Go to prev slide and
      //   emit a scroll event.
      if (newEvent.direction < 0) {
        if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
          swiper.slideNext();
          swiper.emit('scroll', newEvent.raw);
        }
      } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
        swiper.slidePrev();
        swiper.emit('scroll', newEvent.raw);
      }
      // If you got here is because an animation has been triggered so store the current time
      swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      // Return false as a default
      return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
      var swiper = this;
      var params = swiper.params.mousewheel;
      if (newEvent.direction < 0) {
        if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
          // Return true to animate scroll on edges
          return true;
        }
      } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      var event = Mousewheel.event();
      if (swiper.params.cssMode) {
        swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
        return true;
      }
      if (!event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      var event = Mousewheel.event();
      if (swiper.params.cssMode) {
        swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
        return true;
      }
      if (!event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          animateSlider: Mousewheel.animateSlider.bind(swiper),
          releaseScroll: Mousewheel.releaseScroll.bind(swiper),
          lastScrollTime: Utils.now(),
          lastEventBeforeSnap: undefined,
          recentWheelEvents: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
          swiper.mousewheel.disable();
        }
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.cssMode) {
          swiper.mousewheel.enable();
        }
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          var bulletIndex = $bullet.index();
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            if (swiper.params.loop) {
              if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                for (var i$1 = params.dynamicMainBullets; i$1 >= 0; i$1 -= 1) {
                  bullets.eq(bullets.length - i$1).addClass(((params.bulletActiveClass) + "-main"));
                }
                bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(((params.bulletActiveClass) + "-prev"));
              } else {
                $firstDisplayedBullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
                $lastDisplayedBullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            } else {
              $firstDisplayedBullet
                .prev()
                .addClass(((params.bulletActiveClass) + "-prev"))
                .prev()
                .addClass(((params.bulletActiveClass) + "-prev-prev"));
              $lastDisplayedBullet
                .next()
                .addClass(((params.bulletActiveClass) + "-next"))
                .next()
                .addClass(((params.bulletActiveClass) + "-next-next"));
            }
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        $dragEl[0].style.width = newSize + "px";
      } else {
        $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientX : e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientY : e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', 'none');
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', '');
        $wrapperEl.transition('');
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
      var activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.on(swiper.touchEvents.cancel, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        }
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
      var activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.off(swiper.touchEvents.cancel, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        }
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove, activeListenerWithCapture);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.cssMode) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop || !swiper.navigation) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.history.initialized && swiper.params.cssMode) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
        if (swiper.params.cssMode && swiper.autoplay.running) { swiper.autoplay.run(); }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onVisibilityChange: function onVisibilityChange() {
            if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
              swiper.autoplay.pause();
            }
            if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
              swiper.autoplay.run();
              swiper.autoplay.paused = false;
            }
          },
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
          document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      touchEnd: function touchEnd() {
        var swiper = this;
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.run();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
        document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      if (!swiper.params.thumbs.multipleActiveThumbs) {
        thumbsToActivate = 1;
      }

      thumbsToActivate = Math.floor(thumbsToActivate);

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        multipleActiveThumbs: true,
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));


},{}],101:[function(require,module,exports){
var Vue // late bind
var version
var map = Object.create(null)
if (typeof window !== 'undefined') {
  window.__VUE_HOT_MAP__ = map
}
var installed = false
var isBrowserify = false
var initHookName = 'beforeCreate'

exports.install = function (vue, browserify) {
  if (installed) { return }
  installed = true

  Vue = vue.__esModule ? vue.default : vue
  version = Vue.version.split('.').map(Number)
  isBrowserify = browserify

  // compat with < 2.0.0-alpha.7
  if (Vue.config._lifecycleHooks.indexOf('init') > -1) {
    initHookName = 'init'
  }

  exports.compatible = version[0] >= 2
  if (!exports.compatible) {
    console.warn(
      '[HMR] You are using a version of vue-hot-reload-api that is ' +
        'only compatible with Vue.js core ^2.0.0.'
    )
    return
  }
}

/**
 * Create a record for a hot module, which keeps track of its constructor
 * and instances
 *
 * @param {String} id
 * @param {Object} options
 */

exports.createRecord = function (id, options) {
  if(map[id]) { return }

  var Ctor = null
  if (typeof options === 'function') {
    Ctor = options
    options = Ctor.options
  }
  makeOptionsHot(id, options)
  map[id] = {
    Ctor: Ctor,
    options: options,
    instances: []
  }
}

/**
 * Check if module is recorded
 *
 * @param {String} id
 */

exports.isRecorded = function (id) {
  return typeof map[id] !== 'undefined'
}

/**
 * Make a Component options object hot.
 *
 * @param {String} id
 * @param {Object} options
 */

function makeOptionsHot(id, options) {
  if (options.functional) {
    var render = options.render
    options.render = function (h, ctx) {
      var instances = map[id].instances
      if (ctx && instances.indexOf(ctx.parent) < 0) {
        instances.push(ctx.parent)
      }
      return render(h, ctx)
    }
  } else {
    injectHook(options, initHookName, function() {
      var record = map[id]
      if (!record.Ctor) {
        record.Ctor = this.constructor
      }
      record.instances.push(this)
    })
    injectHook(options, 'beforeDestroy', function() {
      var instances = map[id].instances
      instances.splice(instances.indexOf(this), 1)
    })
  }
}

/**
 * Inject a hook to a hot reloadable component so that
 * we can keep track of it.
 *
 * @param {Object} options
 * @param {String} name
 * @param {Function} hook
 */

function injectHook(options, name, hook) {
  var existing = options[name]
  options[name] = existing
    ? Array.isArray(existing) ? existing.concat(hook) : [existing, hook]
    : [hook]
}

function tryWrap(fn) {
  return function (id, arg) {
    try {
      fn(id, arg)
    } catch (e) {
      console.error(e)
      console.warn(
        'Something went wrong during Vue component hot-reload. Full reload required.'
      )
    }
  }
}

function updateOptions (oldOptions, newOptions) {
  for (var key in oldOptions) {
    if (!(key in newOptions)) {
      delete oldOptions[key]
    }
  }
  for (var key$1 in newOptions) {
    oldOptions[key$1] = newOptions[key$1]
  }
}

exports.rerender = tryWrap(function (id, options) {
  var record = map[id]
  if (!options) {
    record.instances.slice().forEach(function (instance) {
      instance.$forceUpdate()
    })
    return
  }
  if (typeof options === 'function') {
    options = options.options
  }
  if (record.Ctor) {
    record.Ctor.options.render = options.render
    record.Ctor.options.staticRenderFns = options.staticRenderFns
    record.instances.slice().forEach(function (instance) {
      instance.$options.render = options.render
      instance.$options.staticRenderFns = options.staticRenderFns
      // reset static trees
      // pre 2.5, all static trees are cached together on the instance
      if (instance._staticTrees) {
        instance._staticTrees = []
      }
      // 2.5.0
      if (Array.isArray(record.Ctor.options.cached)) {
        record.Ctor.options.cached = []
      }
      // 2.5.3
      if (Array.isArray(instance.$options.cached)) {
        instance.$options.cached = []
      }

      // post 2.5.4: v-once trees are cached on instance._staticTrees.
      // Pure static trees are cached on the staticRenderFns array
      // (both already reset above)

      // 2.6: temporarily mark rendered scoped slots as unstable so that
      // child components can be forced to update
      var restore = patchScopedSlots(instance)
      instance.$forceUpdate()
      instance.$nextTick(restore)
    })
  } else {
    // functional or no instance created yet
    record.options.render = options.render
    record.options.staticRenderFns = options.staticRenderFns

    // handle functional component re-render
    if (record.options.functional) {
      // rerender with full options
      if (Object.keys(options).length > 2) {
        updateOptions(record.options, options)
      } else {
        // template-only rerender.
        // need to inject the style injection code for CSS modules
        // to work properly.
        var injectStyles = record.options._injectStyles
        if (injectStyles) {
          var render = options.render
          record.options.render = function (h, ctx) {
            injectStyles.call(ctx)
            return render(h, ctx)
          }
        }
      }
      record.options._Ctor = null
      // 2.5.3
      if (Array.isArray(record.options.cached)) {
        record.options.cached = []
      }
      record.instances.slice().forEach(function (instance) {
        instance.$forceUpdate()
      })
    }
  }
})

exports.reload = tryWrap(function (id, options) {
  var record = map[id]
  if (options) {
    if (typeof options === 'function') {
      options = options.options
    }
    makeOptionsHot(id, options)
    if (record.Ctor) {
      if (version[1] < 2) {
        // preserve pre 2.2 behavior for global mixin handling
        record.Ctor.extendOptions = options
      }
      var newCtor = record.Ctor.super.extend(options)
      // prevent record.options._Ctor from being overwritten accidentally
      newCtor.options._Ctor = record.options._Ctor
      record.Ctor.options = newCtor.options
      record.Ctor.cid = newCtor.cid
      record.Ctor.prototype = newCtor.prototype
      if (newCtor.release) {
        // temporary global mixin strategy used in < 2.0.0-alpha.6
        newCtor.release()
      }
    } else {
      updateOptions(record.options, options)
    }
  }
  record.instances.slice().forEach(function (instance) {
    if (instance.$vnode && instance.$vnode.context) {
      instance.$vnode.context.$forceUpdate()
    } else {
      console.warn(
        'Root or manually mounted instance modified. Full reload required.'
      )
    }
  })
})

// 2.6 optimizes template-compiled scoped slots and skips updates if child
// only uses scoped slots. We need to patch the scoped slots resolving helper
// to temporarily mark all scoped slots as unstable in order to force child
// updates.
function patchScopedSlots (instance) {
  if (!instance._u) { return }
  // https://github.com/vuejs/vue/blob/dev/src/core/instance/render-helpers/resolve-scoped-slots.js
  var original = instance._u
  instance._u = function (slots) {
    try {
      // 2.6.4 ~ 2.6.6
      return original(slots, true)
    } catch (e) {
      // 2.5 / >= 2.6.7
      return original(slots, null, true)
    }
  }
  return function () {
    instance._u = original
  }
}

},{}],102:[function(require,module,exports){
(function (global){
/*!
 * Vue.js v2.5.13
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
'use strict';

/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */


// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if ("production" !== 'production') {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if ("production" !== 'production' && customSetter) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if ("production" !== 'production') {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if ("production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if ("production" !== 'production') {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if ("production" !== 'production') {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if ("production" !== 'production') {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if ("production" !== 'production') {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if ("production" !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (
    "production" !== 'production' &&
    // skip validation for weex recycle-list child component props
    !(false && isObject(value) && ('@binding' in value))
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if ("production" !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if ("production" !== 'production') {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if ("production" !== 'production') {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if ("production" !== 'production') {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if ("production" !== 'production') {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                "production" !== 'production'
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if ("production" !== 'production') {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if ("production" !== 'production') {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if ("production" !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if ("production" !== 'production') {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if ("production" !== 'production') {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if ("production" !== 'production') {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ("production" !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression = "production" !== 'production'
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if ("production" !== 'production') {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if ("production" !== 'production') {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if ("production" !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if ("production" !== 'production') {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if ("production" !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if ("production" !== 'production') {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if ("production" !== 'production') {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if ("production" !== 'production') {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if ("production" !== 'production') {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if ("production" !== 'production' && !isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if ("production" !== 'production' && slotNodes._rendered) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.fnContext = contextVm;
    vnode.fnOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if ("production" !== 'production') {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if ("production" !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if ("production" !== 'production') {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        // _rendered is a flag added by renderSlot, but may not be present
        // if the slot is passed from manually written render functions
        if (slot._rendered || (slot[0] && slot[0].elm)) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if ("production" !== 'production') {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if ("production" !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if ("production" !== 'production' && config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if ("production" !== 'production') {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if ("production" !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if ("production" !== 'production' &&
    !(this instanceof Vue$3)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if ("production" !== 'production' && name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if ("production" !== 'production' && type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if ("production" !== 'production') {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.13';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if ("production" !== 'production') {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if ("production" !== 'production' && data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if ("production" !== 'production') {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if ("production" !== 'production') {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if ("production" !== 'production') {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if ("production" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if ("production" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if ("production" !== 'production') {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    "production" !== 'production' && warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = { value: value };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if ("production" !== 'production') {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if ("production" !== 'production') {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  if ("production" !== 'production') {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    if (value$1) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if ("production" !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if ("production" !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if ("production" !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if ("production" !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if ("production" !== 'production') {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if ("production" !== 'production' && isChrome) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if ("production" !== 'production' &&
    config.productionTip !== false &&
    inBrowser && typeof console !== 'undefined'
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if ("production" !== 'production' && staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if ("production" !== 'production') {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if ("production" !== 'production' && !stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if ("production" !== 'production' &&
          (i > pos || !tagName) &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if ("production" !== 'production') {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if ("production" !== 'production') {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if ("production" !== 'production') {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if ("production" !== 'production' && el.tag === 'template') {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if ("production" !== 'production') {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}

function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if ("production" !== 'production') {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if ("production" !== 'production' && children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if ("production" !== 'production' && el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if ("production" !== 'production' && slotScope) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if ("production" !== 'production' && el.attrsMap['v-for']) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if ("production" !== 'production' && name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if ("production" !== 'production') {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      "production" !== 'production' &&
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
      var typeBinding = getBindingAttr(el, 'type');
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$2
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var code = keyCodes[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(code)) + "," +
    "$event.key)"
  )
}

/*  */

function on (el, dir) {
  if ("production" !== 'production' && dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if ("production" !== 'production' &&
    state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if ("production" !== 'production' && (
    el.children.length !== 1 || ast.type !== 1
  )) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if ("production" !== 'production') {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if ("production" !== 'production') {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if ("production" !== 'production') {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if ("production" !== 'production') {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if ("production" !== 'production' && !template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if ("production" !== 'production') {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if ("production" !== 'production' && config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if ("production" !== 'production' && config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

module.exports = Vue$3;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],103:[function(require,module,exports){
var inserted = exports.cache = {}

function noop () {}

exports.insert = function (css) {
  if (inserted[css]) return noop
  inserted[css] = true

  var elem = document.createElement('style')
  elem.setAttribute('type', 'text/css')

  if ('textContent' in elem) {
    elem.textContent = css
  } else {
    elem.styleSheet.cssText = css
  }

  document.getElementsByTagName('head')[0].appendChild(elem)
  return function () {
    document.getElementsByTagName('head')[0].removeChild(elem)
    inserted[css] = false
  }
}

},{}],104:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var $ = require('jquery');

var SEND_LOG_SELECTOR = '.js-clickLog';
var DATA_SEND_URL_NAME = 'data-send-url';
var CLICK_EVENT = 'click.clickLog';
var AJAX_PARAM = {
  type: 'get',
  cache: false,
  timeout: 3000
};

/**
  * @desc ページ遷移前に指定の url を get させる
  */
var ClickLog = function ClickLog() {
  $(SEND_LOG_SELECTOR).each(function () {
    var $self = $(this);
    var url = $self.attr('href');
    $self.on(CLICK_EVENT, function (e) {
      e.preventDefault();
      $.ajax($self.attr(DATA_SEND_URL_NAME), AJAX_PARAM).always(function () {
        // クリックした箇所が画面遷移する場合
        if (!!url) {
          document.location.href = url;
        }
      });

      return false;
    });
  });
};

exports['default'] = ClickLog;
module.exports = exports['default'];

},{"jquery":97}],105:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $ = require('jquery');

var DATE_LIST_SELECTOR = '.js-dateList';
var DATE_ITEM_SELECTOR = '.js-dateItem';
var DATE_YEAR_SELECTOR = '.js-dateYear';
var DATE_NUMBER_SELECTOR = '.js-dateNumber';
var DATE_TEXT_SELECTOR = '.js-dateText';
var DATE_LENGTH_NAME = 'date-length';
var DATE_ITEM_NAME = 'date-item';
var DATE_LIST_MORE_HTML = '<li class="dateList__more">…</li>';

/**
  * @class ConvertDate
  * @desc 日付変換処理
  * 年/月/日/曜日 をセット => 日付カセット
  * 月/日/曜日/日付のセット上限数を超えたら省略表記 をセット => 導線カセット
  */

var ConvertDate = (function () {

  /**
    * @constructor
    */

  function ConvertDate() {
    _classCallCheck(this, ConvertDate);

    this.$dateList = $.makeArray($(DATE_LIST_SELECTOR));
    this.$dateItem = $.makeArray($(DATE_ITEM_SELECTOR));
    this._insert();
  }

  /**
    * @desc 各要素へ「日付」「曜日」「…」 挿入
    */

  _createClass(ConvertDate, [{
    key: '_insert',
    value: function _insert() {
      this._setAbbr();
      this._setDate();
    }

    /**
      * @desc 日付セットリスト以上日付が存在すればリストの末尾に「…」 挿入
      */
  }, {
    key: '_setAbbr',
    value: function _setAbbr() {
      var _this = this;

      if (this.$dateList.length === 0) return; // .js-dateList が存在しなければ省略「…」を表示しない
      this.$dateList.forEach(function (el) {
        var $el = $(el);
        var dateLength = $el.data(DATE_LENGTH_NAME);
        var listLength = $el.find('>li').length;
        if (dateLength < listLength) {
          _this._spreadList(dateLength, $el.find('>li'));
          $el.append(DATE_LIST_MORE_HTML);
        }
      });
    }

    /**
      * @desc 上限以上の日付が入っていた場合、最大長まで削る
      */
  }, {
    key: '_spreadList',
    value: function _spreadList(maxLength, $list) {
      for (var i = $list.length - 1; i > 0; i--) {
        if (i >= maxLength) {
          $list.eq(i).remove();
        }
      }
    }

    /**
      * @desc 日付/曜日/class 挿入
      */
  }, {
    key: '_setDate',
    value: function _setDate() {
      var _this2 = this;

      this.$dateItem.forEach(function (el) {
        var $el = $(el);
        var date = String($(el).data(DATE_ITEM_NAME));
        var year = date.slice(0, 4);
        var month = _this2._convertZero(date.slice(4, 6));
        var day = _this2._convertZero(date.slice(6, 8));
        var dayOfWeek = _this2._covertDayOfWeek(year, month, day);

        // 年 セット
        if ($el.find(DATE_YEAR_SELECTOR).length > 0) $el.find(DATE_YEAR_SELECTOR).text(year);

        // 月/日 セット
        $el.find(DATE_NUMBER_SELECTOR).text(month + '/' + day);

        // 曜日/class セット
        $el.find(DATE_TEXT_SELECTOR).text(dayOfWeek).addClass(_this2._convertTextToClassName(dayOfWeek));
      });
    }

    /**
      * @desc 月/日から0詰め
      * @param {string} text - 月 or 日
      * @return {string}} - 詰め処理後の 月 or 日
      */
  }, {
    key: '_convertZero',
    value: function _convertZero(text) {
      return text.charAt(0) === '0' ? text.charAt(1) : text;
    }

    /**
      * @desc 曜日変換
      * @param {string} year - 年
      * @param {string} month - 月
      * @param {string} day - 日
      * @return {string}} - 曜日名
      */
  }, {
    key: '_covertDayOfWeek',
    value: function _covertDayOfWeek(year, month, day) {
      var tmp = year + '/' + month + '/' + day;
      return '日月火水木金土'[new Date(tmp).getDay()];
    }

    /**
      * @desc 曜日名 → クラス名への変換
      * @param {Object} str - 曜日テキスト
      * @return {String} 曜日クラス名
      */
  }, {
    key: '_convertTextToClassName',
    value: function _convertTextToClassName(str) {
      if (str === '土') {
        return 'saturday';
      } else if (str === '日') {
        return 'sunday';
      }
    }
  }]);

  return ConvertDate;
})();

exports['default'] = ConvertDate;
module.exports = exports['default'];

},{"jquery":97}],106:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var $ = require('jquery');

var AJAX_PARAM = {
  type: 'get',
  cache: false,
  timeout: 3000
};

var SendLog = function SendLog(url) {
  $.ajax(url, AJAX_PARAM);
};

exports['default'] = SendLog;
module.exports = exports['default'];

},{"jquery":97}],107:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
var $ = require('jquery');

/**
 * @desc  なるには＆学問リンクのもっと見るを押下した時に全件表示するアコーディオン
 * @param {string} elementItems - 全てのなるにはリンクセレクタ名
 * @param {string} toggleTrigger - 全件表示押下された時イベントが走るようトリガー名
 * @param {string} removeEl - 全件表示or4件以下だった場合 もっと見るボタンの背景も非表示にするためための要素名
 */

var accordionButton = function accordionButton(elementItems, toggleTrigger, removeEl) {
	var elItems = document.querySelectorAll(elementItems);
	var $toggleTrigger = $(toggleTrigger);
	if (elItems.length <= 4) {
		$toggleTrigger.css('display', 'none');
		$('section').removeClass('pB20');
	}
	elItems.forEach(function (el, index) {
		if (index > 3) {
			el.style.display = 'none';
		}
	});

	$toggleTrigger.on('click', function () {
		elItems.forEach(function (el, index) {
			if (index > 3) {
				el.style.display = 'block';
			}
		});
		$toggleTrigger.css('display', 'none');
		$('section').removeClass(removeEl);
	});
};

exports['default'] = accordionButton;
module.exports = exports['default'];

},{"jquery":97}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disposableObserver = disposableObserver;

function disposableObserver(targetElement, callback) {
  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return mutation.addedNodes.length > 0;
    })) {
      callback();
      observer.disconnect();
    }
  });

  observer.observe(document.querySelector(targetElement), {
    childList: true,
    subtree: true
  });
}

},{}],109:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

require('intersection-observer');

/**
 * @desc Intersection Observer APIでlazyLoad
 * @param {string} lazySelector - HTMLのセレクタ
 * @param {string} dataName - データ属性名
 * @param {object} options - 設定したいオプション値のオブジェクト
 */
var lazyLoad = function lazyLoad(lazySelector, dataName) {
  var options = arguments.length <= 2 || arguments[2] === undefined ? {
    rootMargin: '0px',
    threshold: 0
  } : arguments[2];

  var lazyImages = [].slice.call(document.querySelectorAll(lazySelector));
  if ('IntersectionObserver' in window) {
    (function () {
      var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset[dataName];
            observer.unobserve(lazyImage);
          }
        });
      }, options);
      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    })();
  }
};

exports['default'] = lazyLoad;
module.exports = exports['default'];

},{"intersection-observer":95}],110:[function(require,module,exports){
// feat-94032-【UIUX】統合検索一覧_履歴導線追加（SP）

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

exports.setSearchHistory = setSearchHistory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function setSearchHistory() {
  var _map = ['.js-searchHistoryWrapper', '.js-searchHistoryCloseButton'].map(function (selector) {
    return document.querySelector(selector);
  });

  var _map2 = _slicedToArray(_map, 2);

  var searchHistoryWrapperElm = _map2[0];
  var searchHistoryCloseButton = _map2[1];

  // 検索履歴の要素がなければ早期リターン
  if (!searchHistoryWrapperElm) return;

  // 「×」ボタンクリック時の処理
  searchHistoryCloseButton.addEventListener('click', function () {
    // 今後同じ履歴情報を表示しないよう、APIを実行しcookieのデータを更新する
    _axios2['default'].post('/searchList/delListHistory/').then(function () {
      // 成功時, 失敗時の対応無し
    });

    searchHistoryWrapperElm.classList.add('is-disabled');
  });
}

},{"axios":30}],111:[function(require,module,exports){
/**
 * ログ送信
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param messageID メッセージID
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.sendLog = sendLog;
exports.initClickLog = initClickLog;

function sendLog(target, messageID) {
  if (!s) return;
  s.tl(target, 'o', messageID);
}

/**
 * @description クリックログ送信
 * @param clickLogElementList イベント観測対象
 * @param dataName - 飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
 */

function initClickLog(clickLogElementList, dataName) {
  var clickLogTriggerElements = Array.prototype.slice.call(clickLogElementList, 0);
  clickLogTriggerElements.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var clickedElement = event.currentTarget;
      var customLink = clickedElement.dataset[dataName];
      sendLog(clickedElement, customLink);
      event.stopPropagation();
    });
  });
}

},{}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCustomScrollLog = initCustomScrollLog;
exports.observeSettingLog = observeSettingLog;

var _disposableObserver = require("./_disposableObserver");

var _sendClickLog = require("./_sendClickLog");

/**
 * ログ送信
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param customLink カスタムリンク
 */
function sendLog(s, target, customLink) {
  if (!s) return;
  s.tl(target, 'o', customLink);
}

/**
 * スクロールログinit
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param scrollLogTargetList イベント観測対象
 * @param dataNameInView - 表示領域inで飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
 * @param thresholdValue - 対処要素の見える範囲を設定 0~1まで Default:1(要素全体が見えた時)
 * @returns 処理後のターゲットリスト
 */

function initCustomScrollLog(s, scrollLogTargetList, dataNameInView) {
  var thresholdValue = arguments.length <= 3 || arguments[3] === undefined ? 1 : arguments[3];

  // オプション設定
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: thresholdValue
  };
  // 要素が画面に入ったときの処理
  var inViewCallback = function inViewCallback(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var customLink = entry.target.dataset[dataNameInView];
      sendLog(s, entry.target, customLink);
      // 一度inViewログを飛ばしたら、監視をやめる
      observer.unobserve(entry.target);
    });
  };
  // IntersectionObserverを呼ぶ
  var observer = new IntersectionObserver(inViewCallback, options);
  scrollLogTargetList.forEach(function (target) {
    observer.observe(target);
  });
}

/**
 * @description 27卒ログ実装 - targetDOM生成を監視し生成された時特定のDOMにクリックログ、Viewログ機能を入れ込む
 * @param {string} targetDOM 監視対象のDOMクラス名（PR枠）
 * @returns なし
 */

function observeSettingLog(targetDOM) {
  // 引数値チェック：targetDOM(PR枠)が未指定、またはstring型でない場合は後続の処理を中断
  if (!targetDOM || typeof targetDOM !== 'string') return;

  // DOM存在チェック：対象要素がない画面では処理を中断
  var targetSelector = "." + targetDOM;
  var targetElement = document.querySelector(targetSelector);
  if (!targetElement) return;

  try {
    // 27ログ対応、PR枠imp時,click時ログ送信
    (0, _disposableObserver.disposableObserver)(targetSelector, function () {
      var inviewPrLogHook = document.querySelectorAll('.js-pr-isInView');
      var clickLogHook = document.querySelectorAll('.js-pr-clickLog');

      initCustomScrollLog(window.s, inviewPrLogHook, 'prInviewLog', 0);
      (0, _sendClickLog.initClickLog)(clickLogHook, 'prClickLog');
    });
  } catch (error) {
    // エラー時に関数名＋引数を含めたログを出力
    console.error("[observeSettingLog] disposableObserver failed for selector: " + targetSelector, error);
  }
}

},{"./_disposableObserver":108,"./_sendClickLog":111}],113:[function(require,module,exports){
/**
* ログ送信
* @param s 基本的に進路内にグローバルに存在する『s』をいれる
* @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
* @param customLink カスタムリンク
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.initScrollLog = initScrollLog;
function sendLog(s, target, customLink) {
  if (!s) return;
  s.tl(target, 'o', customLink);
}

/**
* スクロールログinit
* @param s 基本的に進路内にグローバルに存在する『s』をいれる
* @param scrollLogTargetList イベント観測対象
* @param dataNameInView - 表示領域inで飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
* @returns 処理後のターゲットリスト
*/

function initScrollLog(s, scrollLogTargetList, dataNameInView) {

  // オプション設定
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: 1
  };
  // 要素が画面に入ったときの処理
  var inViewCallback = function inViewCallback(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var customLink = entry.target.dataset[dataNameInView];
      sendLog(s, entry.target, customLink);
      // 一度inViewログを飛ばしたら、監視をやめる
      observer.unobserve(entry.target);
    });
  };

  // IntersectionObserverを呼ぶ
  var observer = new IntersectionObserver(inViewCallback, options);
  scrollLogTargetList.forEach(function (target) {
    observer.observe(target);
  });
}

},{}],114:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 共感一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  border-top: solid 1px #dddddd;\n  padding-block: 16px;\n'], ['\n  border-top: solid 1px #dddddd;\n  padding-block: 16px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  max-width: 692px;\n'], ['\n  max-width: 692px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: 15px 10px;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  padding: 15px 10px;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  margin-left: 12px;\n  width: calc(100% - 100px);\n'], ['\n  box-sizing: border-box;\n  margin-left: 12px;\n  width: calc(100% - 100px);\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-block: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-block: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: #24243f;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #24243f;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  position: relative;\n  width: 100px;\n  height: 100px;\n'], ['\n  overflow: hidden;\n  position: relative;\n  width: 100px;\n  height: 100px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  display: block;\n  width: auto;\n  height: 100%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n'], ['\n  display: block;\n  width: auto;\n  height: 100%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: ', ';\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 13px;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 13px;\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color:  #EFEFF3;\n  box-sizing: border-box;\n  color: #24243F;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 8px;\n  margin-left: 4px;\n'], ['\n  align-items: center;\n  background-color:  #EFEFF3;\n  box-sizing: border-box;\n  color: #24243F;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 700;\n  height: 20px;\n  padding: 2px 8px;\n  margin-left: 4px;\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  margin-top: 16px;\n  text-align: left;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  margin-top: 16px;\n  text-align: left;\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  width: 95%;\n  margin: 0 auto;\n  padding: 16px 0;\n'], ['\n  width: 95%;\n  margin: 0 auto;\n  padding: 16px 0;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  overflow: hidden;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  overflow: hidden;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 5px 10px;\n  width: calc(100% - 120px);\n'], ['\n  box-sizing: border-box;\n  padding: 5px 10px;\n  width: calc(100% - 120px);\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  color: #333;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  color: #333;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  font-weight: 300;\n  color: #24243F;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  font-size: 11px;\n  font-weight: 300;\n  color: #24243F;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject23 = _taggedTemplateLiteral(['\n  font-size: 10px;\n  font-weight: 300;\n  color: #808D96;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  font-size: 10px;\n  font-weight: 300;\n  color: #808D96;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject24 = _taggedTemplateLiteral(['\n  position: relative;\n  overflow: hidden;\n  width: 120px;\n  height: 120px;\n'], ['\n  position: relative;\n  overflow: hidden;\n  width: 120px;\n  height: 120px;\n']),
    _templateObject25 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject26 = _taggedTemplateLiteral(['\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n'], ['\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n']),
    _templateObject27 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: ', ';\n  bottom: 0;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1.3;\n  height: 20px;\n  padding: 2px 13px;\n  position: absolute;\n  right: 0;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  bottom: 0;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1.3;\n  height: 20px;\n  padding: 2px 13px;\n  position: absolute;\n  right: 0;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description 共感一覧用PRカセットDOM生成
 * @param {array} empathyContentsList - PR枠に表示する情報
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - 共感一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var concernFieldEmpathyContents = function concernFieldEmpathyContents(empathyContentsList) {
  var isSp = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var cassetteHtml = '';

  empathyContentsList.forEach(function (empathyContentsItem, index) {
    cassetteHtml += __createEmpathyContentsHtml(empathyContentsItem, isSp, index + 1);
  });

  return isSp ? '\n    <div class="' + spStyles + '">\n      <div class="' + spWrapperStyles + '">\n        <div class="' + spTextStyles + '">\n          <span class="' + spIconStyles + '">PR</span>\n        </div>\n        <div class="' + spListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaBorderWrapperStyles + '">\n      <div class="' + prAreaStyles + '">\n        <div class="' + prAreaWrapperStyles + '">\n          <div class="' + textStyles + '">\n            <p><span class="' + iconStyles + '">PR</span></p>\n          </div>\n          <div class="' + prAreaListStyles + '">\n            ' + cassetteHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット「おすすめの学校情報」パターンのバナーの単体HTMLフォーマット生成
 * @param {object} empathyContentsItem - PR枠カセット情報
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createEmpathyContentsHtml = function __createEmpathyContentsHtml(empathyContentsItem, isSp, order) {
  if (isSp === undefined) isSp = false;
  var planningType = empathyContentsItem.planningType;
  var gakkoCd = empathyContentsItem.gakkoCd;
  var productCd = empathyContentsItem.productCd;
  var mainImage = empathyContentsItem.mainImage;
  var mainCatch = empathyContentsItem.mainCatch;
  var semmonGakumon = empathyContentsItem.semmonGakumon;
  var shigotoNm = empathyContentsItem.shigotoNm;
  var shozokuShushinGakko = empathyContentsItem.shozokuShushinGakko;
  var gakubuGakkaCourseNm = empathyContentsItem.gakubuGakkaCourseNm;
  var headLine = empathyContentsItem.headLine;

  var planningString = __setPlannigTypeRule(planningType);

  var labelText = __getLabelTextByPlanningType(planningString);
  var labelBackgroundColor = (0, _modulesPrAreaUtilities_prAreaUtilities.getEmpathyContentsBackgroundColor)(labelText);

  // 「授業」とそれ以外でURLの形式が異なるため出し分けを行う
  var URL = ['sensei', 'campusLife', 'senpaiShigoto'].includes(planningString) ? '/gakko/' + gakkoCd + '/' + planningString + '/' + productCd + '/' : '/net/kokishin/detail/' + gakkoCd + '/' + productCd + '/';

  return isSp ? '\n    <div class="' + spItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="' + URL + '"\n        class="' + spLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + spImageBlockStyles + '">\n          <img class="' + spImageStyles + '" src="' + mainImage + '" alt="' + shozokuShushinGakko + '">\n          ' + (labelText ? '<span class="' + spCategoryStyles(labelBackgroundColor) + '">' + labelText + '</span>' : '') + '\n        </div>\n        <div class="' + spInfoStyles + '">\n          <h2 class="' + spTitleStyles + '">' + mainCatch + '</h2>\n          <div class="' + spOtherInfoStyles + '">' + (semmonGakumon ? "専門：" + semmonGakumon : '') + '</div>\n          <div class="' + spOtherInfoStyles + '">' + (shigotoNm ? shigotoNm : '') + '</div>\n          <div class="' + spOtherInfoStyles + '">' + shozokuShushinGakko + '／' + gakubuGakkaCourseNm + '</div>\n          <div class="' + spOtherInfoSmallTextStyles + '">' + (planningString === 'lesson' ? headLine : '') + '</div>\n        </div>\n      </a>\n    </div>\n  ' : '\n    <div class="' + prAreaItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="' + URL + '"\n        class="' + prAreaLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + prAreaImageBlockStyles + '">\n          <img class="' + prAreaImageStyles + '" src="' + mainImage + '" alt="' + shozokuShushinGakko + '">\n        </div>\n        <div class="' + prAreaInfoStyles + '">\n          <div class="">\n            ' + (labelText ? '<span class="' + categoryStyles(labelBackgroundColor) + '">' + labelText + '</span>' : '') + '\n            <span class="' + normalTagStyles + '">' + headLine + '</span>\n          </div>\n          <div class="' + prAreaTitleStyles + '">' + mainCatch + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + (semmonGakumon ? "専門：" + semmonGakumon : '') + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + (shigotoNm ? shigotoNm : '') + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + shozokuShushinGakko + '／' + gakubuGakkaCourseNm + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

/**
 * @private
 * @description 企画ごとにテキストを取得する関数
 * @param {string} planningString - 企画タイプ
 * @returns {string} - ラベル用テキスト
 */
var __getLabelTextByPlanningType = function __getLabelTextByPlanningType(planningString) {
  switch (planningString) {
    case 'sensei':
      return '先生・教授';
    case 'campusLife':
      return '在校生';
    case 'senpaiShigoto':
      return '卒業後';
    case 'lesson':
      return '授業';
    default:
      return '';
  }
};

/**
 * @private
 * @description json データ plannigTypeを正しいデータに紐付けし返す関数
 * @param {string} planningType - 1: 在校生 2: 先生・教授 3: 卒業生（先輩の仕事）
 * @returns {string} - planningString
 */
var __setPlannigTypeRule = function __setPlannigTypeRule(planningType) {
  switch (planningType) {
    case '1':
      return 'campusLife';
    case '2':
      return 'sensei';
    case '3':
      return 'senpaiShigoto';
    case '4':
      return 'lesson';
    default:
      return '';
  }
};

exports.concernFieldEmpathyContents = concernFieldEmpathyContents;

/*---- CSS定義 ----*/
var prAreaBorderWrapperStyles = (0, _emotionCss.css)(_templateObject);

var prAreaStyles = (0, _emotionCss.css)(_templateObject2);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject4);

var prAreaItemStyles = (0, _emotionCss.css)(_templateObject5);

var prAreaLinkStyles = (0, _emotionCss.css)(_templateObject6);

var prAreaInfoStyles = (0, _emotionCss.css)(_templateObject7);

var prAreaTitleStyles = (0, _emotionCss.css)(_templateObject8);

var prAreaOtherInfoStyles = (0, _emotionCss.css)(_templateObject9);

var prAreaImageBlockStyles = (0, _emotionCss.css)(_templateObject10);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject11);

var textStyles = (0, _emotionCss.css)(_templateObject12);

var iconStyles = (0, _emotionCss.css)(_templateObject13);

var categoryStyles = function categoryStyles(bgColor) {
  return (0, _emotionCss.css)(_templateObject14, bgColor);
};

var normalTagStyles = (0, _emotionCss.css)(_templateObject15);

/*---- SP CSS定義 ----*/
var spStyles = (0, _emotionCss.css)(_templateObject16);

var spWrapperStyles = (0, _emotionCss.css)(_templateObject17);

var spListStyles = (0, _emotionCss.css)(_templateObject4);

var spItemStyles = (0, _emotionCss.css)(_templateObject18);

var spLinkStyles = (0, _emotionCss.css)(_templateObject19);

var spInfoStyles = (0, _emotionCss.css)(_templateObject20);

var spTitleStyles = (0, _emotionCss.css)(_templateObject21);

var spOtherInfoStyles = (0, _emotionCss.css)(_templateObject22);

var spOtherInfoSmallTextStyles = (0, _emotionCss.css)(_templateObject23);

var spImageBlockStyles = (0, _emotionCss.css)(_templateObject24);

var spImageStyles = (0, _emotionCss.css)(_templateObject11);

var spTextStyles = (0, _emotionCss.css)(_templateObject25);

var spIconStyles = (0, _emotionCss.css)(_templateObject26);

var spCategoryStyles = function spCategoryStyles(bgColor) {
  return (0, _emotionCss.css)(_templateObject27, bgColor);
};

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],115:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 新増設一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  width: 100vw;\n\n  @media screen and (min-width: 960px) {\n    margin: 0 calc(50% - 50vw);\n  };\n'], ['\n  background-color: #E7F6FF;\n  width: 100vw;\n\n  @media screen and (min-width: 960px) {\n    margin: 0 calc(50% - 50vw);\n  };\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding-block: 16px;\n  margin: 0 auto 16px;\n  width: 960px;\n  text-align: left;\n'], ['\n  box-sizing: border-box;\n  padding-block: 16px;\n  margin: 0 auto 16px;\n  width: 960px;\n  text-align: left;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n'], ['\n  margin: 0 auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  margin-left: 0;\n'], ['\n  width: 100%;\n  margin-left: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-bottom: 8px;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-bottom: 8px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  background-color: #FFF;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: flex;\n  border-right: none;\n  border-left: none;\n  margin: 0;\n'], ['\n  background-color: #FFF;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: flex;\n  border-right: none;\n  border-left: none;\n  margin: 0;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  width: auto;\n  float: left;\n  text-align: center;\n'], ['\n  width: auto;\n  float: left;\n  text-align: center;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  display: block;\n  padding: 12px 16px 15px 16px;\n'], ['\n  display: block;\n  padding: 12px 16px 15px 16px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  margin: 0;\n'], ['\n  margin: 0;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  margin: 0 auto;\n  box-sizing: border-box;\n'], ['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  margin: 0 auto;\n  box-sizing: border-box;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  margin: 0;\n  line-height: 1;\n'], ['\n  margin: 0;\n  line-height: 1;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 14px;\n'], ['\n  font-weight: 700;\n  font-size: 14px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  border-left: 1px solid #D3D4D4;\n  box-sizing: border-box;\n  width: 100%;\n'], ['\n  border-left: 1px solid #D3D4D4;\n  box-sizing: border-box;\n  width: 100%;\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  padding: 12px 16px;\n  border-bottom: 1px solid #D3D4D4;\n'], ['\n  padding: 12px 16px;\n  border-bottom: 1px solid #D3D4D4;\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n'], ['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  padding: 0;\n  margin-bottom: 4px;\n  line-height: 1.5;\n'], ['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  padding: 0;\n  margin-bottom: 4px;\n  line-height: 1.5;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-bottom: 8px;\n  color: #0B41A0;\n  font-size: 18px;\n  line-height: 1.3;\n'], ['\n  padding: 0;\n  margin-bottom: 8px;\n  color: #0B41A0;\n  font-size: 18px;\n  line-height: 1.3;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  font-weight: 700;\n'], ['\n  font-weight: 700;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  padding: 0;\n  border-bottom: none;\n  color: #24243f;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.3;\n'], ['\n  padding: 0;\n  border-bottom: none;\n  color: #24243f;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.3;\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n  padding: 12px 16px 16px;\n'], ['\n  padding: 12px 16px 16px;\n']),
    _templateObject23 = _taggedTemplateLiteral(['\n  margin-bottom: 16px;\n  padding: 0;\n  color: #24243f;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n'], ['\n  margin-bottom: 16px;\n  padding: 0;\n  color: #24243f;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n']),
    _templateObject24 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 8px;\n  margin-left: 0;\n  padding-bottom: 5px;\n'], ['\n  display: flex;\n  gap: 8px;\n  margin-left: 0;\n  padding-bottom: 5px;\n']),
    _templateObject25 = _taggedTemplateLiteral(['\n  margin-top: 7px;\n'], ['\n  margin-top: 7px;\n']),
    _templateObject26 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n'], ['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n']),
    _templateObject27 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n'], ['\n  display: inline-block;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n']),
    _templateObject28 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  padding: 16px 10px;\n  margin: 0 calc(50% - 50vw) 20px;\n  width: 100xw;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  padding: 16px 10px;\n  margin: 0 calc(50% - 50vw) 20px;\n  width: 100xw;\n']),
    _templateObject29 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n  padding-bottom: 8px;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n  padding-bottom: 8px;\n']),
    _templateObject30 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  height: 19px;\n']),
    _templateObject31 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: table;\n  width: 100%;\n'], ['\n  background-color: #fff;\n  border-top: 2px solid #0B41A0;\n  border-bottom: 1px solid #D3D4D4;\n  display: table;\n  width: 100%;\n']),
    _templateObject32 = _taggedTemplateLiteral(['\n  display: table-cell;\n  float: none;\n  padding: 5px;\n  vertical-align: top;\n  width: 20% !important;\n'], ['\n  display: table-cell;\n  float: none;\n  padding: 5px;\n  vertical-align: top;\n  width: 20% !important;\n']),
    _templateObject33 = _taggedTemplateLiteral(['\n  height: auto;\n  margin: 0;\n  margin-bottom: 5px;\n  width: 100%;\n'], ['\n  height: auto;\n  margin: 0;\n  margin-bottom: 5px;\n  width: 100%;\n']),
    _templateObject34 = _taggedTemplateLiteral(['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  align-items: center;\n'], ['\n  border: 1px solid #0B41A0;\n  border-radius: 2px;\n  color: #0B41A0;\n  width: 74px;\n  height: 34px;\n  font-size: 10px;\n  padding: 3px;\n  text-align: center;\n  align-items: center;\n']),
    _templateObject35 = _taggedTemplateLiteral(['\n  margin: unset !important;\n  line-height: 1;\n'], ['\n  margin: unset !important;\n  line-height: 1;\n']),
    _templateObject36 = _taggedTemplateLiteral(['\n  display: table-cell;\n  float: none;\n  vertical-align: top;\n  width: 80%;\n  border-left: 1px solid #D3D4D4;\n'], ['\n  display: table-cell;\n  float: none;\n  vertical-align: top;\n  width: 80%;\n  border-left: 1px solid #D3D4D4;\n']),
    _templateObject37 = _taggedTemplateLiteral(['\n  padding: 12px;\n  border-bottom: 1px solid #D3D4D4;\n'], ['\n  padding: 12px;\n  border-bottom: 1px solid #D3D4D4;\n']),
    _templateObject38 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n'], ['\n  border-radius: 4px;\n  background-color: #0B41A0;\n  padding: 2px 6px;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  display: inline-block;\n']),
    _templateObject39 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-bottom: 4px;\n  color: #808d96;\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 1.5;\n'], ['\n  padding: 0;\n  margin-bottom: 4px;\n  color: #808d96;\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 1.5;\n']),
    _templateObject40 = _taggedTemplateLiteral(['\n  padding: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  padding: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject41 = _taggedTemplateLiteral(['\n  padding: 8px 12px 11px;\n'], ['\n  padding: 8px 12px 11px;\n']),
    _templateObject42 = _taggedTemplateLiteral(['\n  margin-bottom: 16px;\n  padding: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #24243f;\n'], ['\n  margin-bottom: 16px;\n  padding: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #24243f;\n']),
    _templateObject43 = _taggedTemplateLiteral(['\n  margin-left: 0;\n  padding-bottom: 12px;\n'], ['\n  margin-left: 0;\n  padding-bottom: 12px;\n']),
    _templateObject44 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-right: 5px;\n  vertical-align: middle;\n'], ['\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-right: 5px;\n  vertical-align: middle;\n']),
    _templateObject45 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 139px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 0;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n']),
    _templateObject46 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  width: 120px;\n  height: 29px;\n  background: url(/images/common/btn_gakko_s.png) no-repeat 0 -29px;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n']),
    _templateObject47 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n'], ['\n  margin-inline: unset !important;\n']),
    _templateObject48 = _taggedTemplateLiteral(['\n  display: inline-block;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n'], ['\n  display: inline-block;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

/**
 * @description 新増設一覧用PRカセットDOM生成
 * @param {array} shinzosetsuList - PR枠に表示する情報
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - 新増設一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var concernFieldShinsetsu = function concernFieldShinsetsu(shinzosetsuList) {
  var isSp = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var cassetteHtml = '';

  shinzosetsuList.forEach(function (shinzosetsuItem, index) {
    cassetteHtml += __createCassetteHtml(shinzosetsuItem, isSp, index + 1);
  });

  return isSp ? '\n    <div class="' + spStyles + '">\n      <div>\n        <div class="' + spTextStyles + '">\n          <span class="' + spIconStyles + '">PR</span>\n        </div>\n        <div class="' + spListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaOverWrapperStyles + '">\n      <div class="' + prAreaStyles + '">\n        <div class="' + prAreaWrapperStyles + '">\n          <div class="' + textStyles + '">\n            <p><span class="' + iconStyles + '">PR</span></p>\n          </div>\n          <div class="' + prAreaListStyles + '">\n            ' + cassetteHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description 新増設一覧用の単体HTMLフォーマット生成
 * @param {object} shinzosetsuItem - 新増設アイテム
 * @param {boolean} [isSp = false] - SP判定
 * @param {number} order - 表示順位
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(shinzosetsuItem, isSp, order) {
  if (isSp === undefined) isSp = false;
  var productCd = shinzosetsuItem.productCd;
  var gakkoCd = shinzosetsuItem.gakkoCd;
  var admissionYear = shinzosetsuItem.admissionYear;
  var koshuNm = shinzosetsuItem.koshuNm;
  var todofukenRnm = shinzosetsuItem.todofukenRnm;
  var gakkoNm = shinzosetsuItem.gakkoNm;
  var gakkoNmHosoku = shinzosetsuItem.gakkoNmHosoku;
  var gakubuNm = shinzosetsuItem.gakubuNm;
  var gakubuHosoku = shinzosetsuItem.gakubuHosoku;
  var topicsCatch = shinzosetsuItem.topicsCatch;
  var mainImage = shinzosetsuItem.mainImage;
  var optionSankakuNm = shinzosetsuItem.optionSankakuNm;
  var optionSankakuUrl = shinzosetsuItem.optionSankakuUrl;
  var optionSankakuImageUrl = shinzosetsuItem.optionSankakuImageUrl;
  var actionSankakuEnm = shinzosetsuItem.actionSankakuEnm;
  var actionSankakuUrl = shinzosetsuItem.actionSankakuUrl;
  var shinsetsuYear = shinzosetsuItem.shinsetsuYear;
  var shinsetsuMonth = shinzosetsuItem.shinsetsuMonth;
  var shinsetsuInfo = shinzosetsuItem.shinsetsuInfo;
  var yotei = shinzosetsuItem.yotei;
  var shinsetsuStatus = shinzosetsuItem.shinsetsuStatus;
  var shinsetsuStatusComment = shinzosetsuItem.shinsetsuStatusComment;
  var shinzosetsuShubetsuCd = shinzosetsuItem.shinzosetsuShubetsuCd;

  var linkUrl = '/gakko/' + gakkoCd + '/newfoundation/' + productCd + '/';
  var clickLog = trace_p + '_PRcassette_click_' + order + '_' + gakkoCd;

  var linkTagHtml = '';
  optionSankakuNm.forEach(function (_, index) {
    linkTagHtml += __createLinkTagHtml(optionSankakuNm[index], optionSankakuImageUrl[index], optionSankakuUrl[index], clickLog);
  });

  var pamphButtonHtml = '';
  actionSankakuEnm.forEach(function (_, index) {
    pamphButtonHtml += __createPamphButtonHtml(isSp, actionSankakuEnm[index], actionSankakuUrl[index], clickLog);
  });

  var shinsetsuLabel = function shinsetsuLabel() {
    return shinzosetsuShubetsuCd === '1' ? '新しい学校' : '新しい学部学科コース';
  };
  var gakubuLink = function gakubuLink() {
    return shinzosetsuShubetsuCd === '1' ? '' : '' + (gakubuNm + gakubuHosoku);
  };
  var shinsetsuCommnet = function shinsetsuCommnet() {
    var year = shinsetsuYear ? "年" : "";
    var month = shinsetsuMonth ? "月" : "";

    return shinsetsuYear + year + shinsetsuMonth + month + shinsetsuInfo + yotei + shinsetsuStatus + shinsetsuStatusComment;
  };

  return isSp ? '\n    <div class="' + spBoxStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <div class="' + spBoxLeftStyles + '">\n        <a href="' + linkUrl + '" class="js-pr-clickLog" target="_blank" data-pr-click-log="' + clickLog + '">\n          <img src="' + mainImage + '" border="0" alt=' + (gakkoNm + gakkoNmHosoku) + ' class="' + spImageStyles + '" height="80" width="80">\n        </a>\n        <div class="' + spBoxLeftTagStyles + '">\n          <p class="' + spBoxLeftTextStyles + '"><span class="' + spBoxLeftTextLargeStyles + '">' + admissionYear + '</span> 年度<br>入学から対象</p>\n        </div>\n      </div>\n      <div class="' + spBoxRightStyles + '">\n        <div class="' + spBoxRightTopStyles + '">\n          <div class="' + spBoxRightTagStyles + '">' + shinsetsuLabel() + '</div>\n          <div class="' + spBoxRightUniversityInfoStyles + '">' + koshuNm + ' ／ ' + todofukenRnm + '</div>\n          <div class="' + spBoxRightUniversityLinkStyles + '">\n            <h2 class="' + spUnsetMarginInlineStyles + ' ' + spBoxRightTitleStyles + '">\n              <a\n                href="' + linkUrl + '"\n                class="' + spBoxRightLinkStyles + ' js-pr-clickLog" \n                target="_blank"\n                data-pr-click-log="' + clickLog + '">\n              ' + (gakkoNm + gakkoNmHosoku) + '\n              ' + ('<br>' + gakubuLink()) + '\n              </a>\n            </h2>\n          </div>\n          <p class="' + spFoundingPlanTextStyles + ' ' + spUnsetMarginInlineStyles + '">' + shinsetsuCommnet() + '</p>\n        </div>\n        <div class="' + spBoxRightBottomStyles + '">\n          <p class="' + spBoxRightBottomDescriptionStyles + ' ' + spUnsetMarginInlineStyles + '">' + topicsCatch + '</p>\n          <div class="' + spBoxButtonListStyles + '">\n            ' + linkTagHtml + '\n          </div>\n          <div class="' + spPamphletButtonBoxStyles + '">\n            ' + pamphButtonHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaBoxStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <div class="' + prAreaBoxLeftStyles + '">\n        <a href="' + linkUrl + '" class="' + prAreaBoxLeftLinkStyles + ' js-pr-clickLog" target="_blank" data-pr-click-log="' + clickLog + '">\n          <img src="' + mainImage + '" border="0" alt=' + (gakkoNm + gakkoNmHosoku) + ' class="' + prAreaImageStyles + '" height="80" width="80">\n        </a>\n        <div class="' + prAreaBoxLeftTagStyles + '">\n          <p class="' + prAreaBoxLeftTextStyles + '">\n            <span class="' + prAreaBoxLeftTextLargeStyles + '">' + admissionYear + '</span> 年度\n            <br>入学から対象\n          </p>\n        </div>\n      </div>\n      <div class="' + prAreaBoxRightStyles + '">\n        <div class="' + prAreaBoxRightTopStyles + '">\n          <div class="' + prAreaBoxRightTagStyles + '">' + shinsetsuLabel() + '</div>\n          <div class="' + prAreaBoxRightUniversityInfoStyles + '">' + koshuNm + ' ／ ' + todofukenRnm + '</div>\n          <div class="' + prAreaBoxRightUniversityLinkWrapperStyles + '">\n            <h2 class="' + prAreaBoxRightTitleStyles + '">\n              <a\n                href="' + linkUrl + '"\n                class="' + prAreaBoxRightUniversityLinkStyles + ' js-pr-clickLog" \n                target="_blank"\n                data-pr-click-log="' + clickLog + '">\n              ' + (gakkoNm + gakkoNmHosoku) + '\n              ' + ('<br>' + gakubuLink()) + '\n              </a>\n            </h2>\n          </div>\n          <p class="' + prAreaFoundingPlanTextStyles + '">' + shinsetsuCommnet() + '</p>\n        </div>\n        <div class="' + prAreaBoxRightBottomStyles + '">\n          <p class="' + prAreaBoxRightBottomDescriptionStyles + '">' + topicsCatch + '</p>\n          <div class="' + prAreaBoxButtonListStyles + '">\n            ' + linkTagHtml + '\n          </div>\n          <div class="' + prAreaPamphletBoxStyles + '">\n            ' + pamphButtonHtml + '\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description リンク属性を引数で渡された数だけ生成する
 * @param {string} optionSankakuNm - リンク日本語ネーム
 * @param {string} optionSankakuImageUrl - リンクイメージURL
 * @param {string} optionSankakuUrl - リンク遷移URL
 * @param {string} clickLog - クリック時送信ログ
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createLinkTagHtml = function __createLinkTagHtml(optionSankakuNm, optionSankakuImageUrl, optionSankakuUrl, clickLog) {
  return '\n      <div class="' + linkTagStyles + '">\n        <a href="' + optionSankakuUrl + '" target="_blank" class="js-pr-clickLog" data-pr-click-log="' + clickLog + '">\n          <img src="' + optionSankakuImageUrl + '" alt="' + optionSankakuNm + '">\n        </a>\n      </div>\n    ';
};

/**
 * @private
 * @description PAMPH請求ボタンを生成する
 * @param {boolean} isSp - UA判定
 * @param {string} actionSankakuEnm - アクション英語ネーム
 * @param {string} actionSankakuUrl - 遷移先URL
 * @param {string} clickLog - クリック時送信ログ
 * @returns {string} - 「パンプを請求する、原書を請求する」DOM
 */
var __createPamphButtonHtml = function __createPamphButtonHtml(isSp, actionSankakuEnm, actionSankakuUrl, clickLog) {
  var style = '';
  if (isSp) {
    style = actionSankakuEnm === 'PAMPH' ? spPamphletButtonStyles : spApplicationButtonStyles;
  } else {
    style = actionSankakuEnm === 'PAMPH' ? prAreaPamphletButtonStyles : prAreaApplicationButtonStyles;
  }

  return '\n    <a href="' + actionSankakuUrl + '" target="_blank" class="' + style + ' js-pr-clickLog" data-pr-click-log="' + clickLog + '"></a>\n  ';
};

exports.concernFieldShinsetsu = concernFieldShinsetsu;

/*---- CSS定義 ----*/
var prAreaOverWrapperStyles = (0, _emotionCss.css)(_templateObject);

var prAreaStyles = (0, _emotionCss.css)(_templateObject2);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject4);

var textStyles = (0, _emotionCss.css)(_templateObject5);

var iconStyles = (0, _emotionCss.css)(_templateObject6);

var prAreaBoxStyles = (0, _emotionCss.css)(_templateObject7);

var prAreaBoxLeftStyles = (0, _emotionCss.css)(_templateObject8);

var prAreaBoxLeftLinkStyles = (0, _emotionCss.css)(_templateObject9);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject10);

var prAreaBoxLeftTagStyles = (0, _emotionCss.css)(_templateObject11);

var prAreaBoxLeftTextStyles = (0, _emotionCss.css)(_templateObject12);

var prAreaBoxLeftTextLargeStyles = (0, _emotionCss.css)(_templateObject13);

var prAreaBoxRightStyles = (0, _emotionCss.css)(_templateObject14);

var prAreaBoxRightTopStyles = (0, _emotionCss.css)(_templateObject15);

var prAreaBoxRightTagStyles = (0, _emotionCss.css)(_templateObject16);

var prAreaBoxRightUniversityInfoStyles = (0, _emotionCss.css)(_templateObject17);

var prAreaBoxRightUniversityLinkWrapperStyles = (0, _emotionCss.css)(_templateObject18);

var prAreaBoxRightTitleStyles = (0, _emotionCss.css)(_templateObject19);

var prAreaBoxRightUniversityLinkStyles = (0, _emotionCss.css)(_templateObject20);

var prAreaFoundingPlanTextStyles = (0, _emotionCss.css)(_templateObject21);

var prAreaBoxRightBottomStyles = (0, _emotionCss.css)(_templateObject22);

var prAreaBoxRightBottomDescriptionStyles = (0, _emotionCss.css)(_templateObject23);

var prAreaBoxButtonListStyles = (0, _emotionCss.css)(_templateObject24);

var prAreaPamphletBoxStyles = (0, _emotionCss.css)(_templateObject25);

var prAreaPamphletButtonStyles = (0, _emotionCss.css)(_templateObject26);

var prAreaApplicationButtonStyles = (0, _emotionCss.css)(_templateObject27);

/*---- SP CSS定義 ----*/
var spStyles = (0, _emotionCss.css)(_templateObject28);

var spListStyles = (0, _emotionCss.css)(_templateObject19);

var spTextStyles = (0, _emotionCss.css)(_templateObject29);

var spIconStyles = (0, _emotionCss.css)(_templateObject30);

var spBoxStyles = (0, _emotionCss.css)(_templateObject31);

var spBoxLeftStyles = (0, _emotionCss.css)(_templateObject32);

var spImageStyles = (0, _emotionCss.css)(_templateObject33);

var spBoxLeftTagStyles = (0, _emotionCss.css)(_templateObject34);

var spBoxLeftTextStyles = (0, _emotionCss.css)(_templateObject35);

var spBoxLeftTextLargeStyles = (0, _emotionCss.css)(_templateObject13);

var spBoxRightStyles = (0, _emotionCss.css)(_templateObject36);

var spBoxRightTopStyles = (0, _emotionCss.css)(_templateObject37);

var spBoxRightTagStyles = (0, _emotionCss.css)(_templateObject38);

var spBoxRightUniversityInfoStyles = (0, _emotionCss.css)(_templateObject39);

var spBoxRightUniversityLinkStyles = (0, _emotionCss.css)(_templateObject40);

var spBoxRightLinkStyles = (0, _emotionCss.css)(_templateObject20);

var spBoxRightTitleStyles = (0, _emotionCss.css)(_templateObject19);

var spFoundingPlanTextStyles = (0, _emotionCss.css)(_templateObject21);

var spBoxRightBottomStyles = (0, _emotionCss.css)(_templateObject41);

var spBoxRightBottomDescriptionStyles = (0, _emotionCss.css)(_templateObject42);

var spBoxButtonListStyles = (0, _emotionCss.css)(_templateObject43);

var spPamphletButtonBoxStyles = (0, _emotionCss.css)(_templateObject44);

var spPamphletButtonStyles = (0, _emotionCss.css)(_templateObject45);

var spApplicationButtonStyles = (0, _emotionCss.css)(_templateObject46);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var spUnsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject47);

var linkTagStyles = (0, _emotionCss.css)(_templateObject48);

},{"@emotion/css":7}],116:[function(require,module,exports){
/**
 * [27卒PR枠] PC/SP PR枠 進路トップ / 学問詳細 用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding-block: 16px;\n  text-align: left;\n  margin-top: 20px !important;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding-block: 16px;\n  text-align: left;\n  margin-top: 20px !important;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  max-width: 680px;\n'], ['\n  margin: 0 auto;\n  max-width: 680px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 220px);\n'], ['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 220px);\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  line-height: 1.5;\n'], ['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  line-height: 1.5;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #808d96;\n  margin-top: 8px;\n'], ['\n  color: #808d96;\n  margin-top: 8px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  width: 220px;\n  height: 150px;\n'], ['\n  width: 220px;\n  height: 150px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  border-radius: 4px 0 0 4px;\n  width: 220px;\n  height: 150px;\n'], ['\n  border-radius: 4px 0 0 4px;\n  width: 220px;\n  height: 150px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-block;\n  padding: 2px 8px;\n  margin-right: 8px;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n  margin-block: 32px;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: left;\n  margin-block: 32px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 8px auto 0;\n  width: 100%;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 4px 8px;\n  width: calc(100% - 142px);\n'], ['\n  box-sizing: border-box;\n  padding: 4px 8px;\n  width: calc(100% - 142px);\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow: hidden;\n'], ['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow: hidden;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 4px;\n'], ['\n  color: #808d96;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 4px;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  height: 95px;\n'], ['\n  height: 95px;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  border-radius: 4px 0 0 4px;\n  height: 95px;\n'], ['\n  border-radius: 4px 0 0 4px;\n  height: 95px;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.3;\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n  background-color:  #3EC1BD;\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  margin-right: 4px;\n  height: 19px;\n'], ['\n  background-color:  #3EC1BD;\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: #FFF;\n  display: inline-flex;\n  font-size: 10px;\n  align-items: center;\n  padding: 2px 8px;\n  margin-right: 4px;\n  height: 19px;\n']),
    _templateObject23 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n'], ['\n  margin-inline: unset !important;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

/**
 * @description カセット「おすすめの学校情報」DOM生成
 * @param {array} gakkoInfoList - PR枠掲載大学情報リスト
 * @param {boolean} [isSp = false] - SP判定
 * @returns {string} - カセット「おすすめの学校情報」枠コンポーネントのHTML DOM文字列
 */
var recommendSchoolInfo = function recommendSchoolInfo(gakkoInfoList) {
  var isSp = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  var cassetteHtml = '';

  gakkoInfoList.forEach(function (gakkoInfoItem, index) {
    cassetteHtml += __createCassetteHtml(gakkoInfoItem, isSp, index + 1);
  });

  return isSp ? '\n    <div class="' + spStyles + '">\n      <div>\n        <div class="' + spTextStyles + '">\n          <p class="' + spUnsetMarginInlineStyles + '"><span class="' + spIconStyles + '">PR</span>おすすめの学校情報</p>\n        </div>\n        <div class="' + spListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ' : '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <p><span class="' + iconStyles + '">PR</span>おすすめの学校情報</p>\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット「おすすめの学校情報」パターンのバナーの単体HTMLフォーマット生成
 * @param {object} gakkoInfoItem - 学校情報オブジェクト
 * @param {boolean} [isSp = false] - SP判定
 * @param {number} order - 表示順位
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(gakkoInfoItem, isSp, order) {
  if (isSp === undefined) isSp = false;
  var gakkoCd = gakkoInfoItem.gakkoCd;
  var gakkoPhoto = gakkoInfoItem.gakkoPhoto;
  var gakkoNm = gakkoInfoItem.gakkoNm;
  var todofukenRnm = gakkoInfoItem.todofukenRnm;
  var koshuNm = gakkoInfoItem.koshuNm;

  var NO_IMAGE = "/images/assets/dummy/noImage.png";

  // TODO: HTMLはそれぞれ別ファイルに分離する
  return isSp ? '\n    <div class="' + spItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="/gakko/' + gakkoCd + '/"\n        class="' + spLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + spImageBlockStyles + '">\n          <img class="' + spImageStyles + '" src="' + (gakkoPhoto ? gakkoPhoto : NO_IMAGE) + '" alt="' + gakkoNm + '" height="95" width="142">\n        </div>\n        <div class="' + spInfoStyles + '">\n          <div class="' + spNameStyles + '">' + gakkoNm + '</div>\n          <div class="' + spOtherInfoStyles + '">' + koshuNm + '／' + todofukenRnm + '</div>\n        </div>\n      </a>\n    </div>\n  ' : '\n    <div class="' + prAreaItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="/gakko/' + gakkoCd + '/"\n        class="' + prAreaLinkStyles + ' js-pr-clickLog"\n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n      >\n        <div class="' + prAreaImageBlockStyles + '">\n          <img class="' + prAreaImageStyles + '" src="' + (gakkoPhoto ? gakkoPhoto : NO_IMAGE) + '" alt="' + gakkoNm + '" height="150" width="220">\n        </div>\n        <div class="' + prAreaInfoStyles + '">\n          <div class="' + prAreaNameStyles + '">' + gakkoNm + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + koshuNm + '／' + todofukenRnm + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.recommendSchoolInfo = recommendSchoolInfo;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject2);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaItemStyles = (0, _emotionCss.css)(_templateObject4);

var prAreaLinkStyles = (0, _emotionCss.css)(_templateObject5);

var prAreaInfoStyles = (0, _emotionCss.css)(_templateObject6);

var prAreaNameStyles = (0, _emotionCss.css)(_templateObject7);

var prAreaOtherInfoStyles = (0, _emotionCss.css)(_templateObject8);

var prAreaImageBlockStyles = (0, _emotionCss.css)(_templateObject9);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject10);

var textStyles = (0, _emotionCss.css)(_templateObject11);

var iconStyles = (0, _emotionCss.css)(_templateObject12);

/*---- SP CSS定義 ----*/
var spStyles = (0, _emotionCss.css)(_templateObject13);

var spListStyles = (0, _emotionCss.css)(_templateObject3);

var spItemStyles = (0, _emotionCss.css)(_templateObject14);

var spLinkStyles = (0, _emotionCss.css)(_templateObject15);

var spInfoStyles = (0, _emotionCss.css)(_templateObject16);

var spNameStyles = (0, _emotionCss.css)(_templateObject17);

var spOtherInfoStyles = (0, _emotionCss.css)(_templateObject18);

var spImageBlockStyles = (0, _emotionCss.css)(_templateObject19);

var spImageStyles = (0, _emotionCss.css)(_templateObject20);

var spTextStyles = (0, _emotionCss.css)(_templateObject21);

var spIconStyles = (0, _emotionCss.css)(_templateObject22);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var spUnsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject23);

},{"@emotion/css":7}],117:[function(require,module,exports){
/**
 * [27卒PR枠] PR枠 仕事詳細(なるには)用
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n\n  ', ' {\n    max-width: 960px;\n    margin: 40px auto;\n  };\n\n  ', ' {\n    margin: 24px 16px;\n    padding: 16px;\n  };\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n\n  ', ' {\n    max-width: 960px;\n    margin: 40px auto;\n  };\n\n  ', ' {\n    margin: 24px 16px;\n    padding: 16px;\n  };\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n\n  ', ' {\n    max-width: 928px;\n    padding: 16px;\n  };\n'], ['\n  margin: 0 auto;\n\n  ', ' {\n    max-width: 928px;\n    padding: 16px;\n  };\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 8px;\n\n  ', ' {\n    flex-direction: column;\n  };\n'], ['\n  display: flex;\n  margin-top: 8px;\n\n  ', ' {\n    flex-direction: column;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n\n  ', ' {\n    border-radius: 6px;\n    max-width: 50%;\n\n    &:nth-child(even) {\n      margin-left: 16px;\n    };\n  };\n\n  ', ' {\n    border-radius: 2px;\n    margin: 8px auto 0;\n\n    &:first-child {\n      margin-top: 0 !important;\n    };\n  };\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n\n  ', ' {\n    border-radius: 6px;\n    max-width: 50%;\n\n    &:nth-child(even) {\n      margin-left: 16px;\n    };\n  };\n\n  ', ' {\n    border-radius: 2px;\n    margin: 8px auto 0;\n\n    &:first-child {\n      margin-top: 0 !important;\n    };\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n'], ['\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    width: calc(100% - 220px);\n  };\n\n  ', ' {\n    padding: 4px 8px;\n    width: calc(100% - 142px);\n  };\n'], ['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    width: calc(100% - 220px);\n  };\n\n  ', ' {\n    padding: 4px 8px;\n    width: calc(100% - 142px);\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n\n  ', ' {\n    font-size: 16px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n'], ['\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n\n  ', ' {\n    font-size: 16px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #808d96;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ', ' {\n    font-size: 14px;\n    margin-top: 8px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    margin-top: 4px;\n  };\n'], ['\n  color: #808d96;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ', ' {\n    font-size: 14px;\n    margin-top: 8px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    margin-top: 4px;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  overflow: hidden;\n\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n'], ['\n  overflow: hidden;\n\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n'], ['\n  ', ' {\n    width: 220px;\n    height: 150px;\n  };\n\n  ', ' {\n    width: 142px;\n    height: 95px;\n  };\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  font-weight: 700;\n  padding: 2px 8px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  ', ' {\n    font-size: 12px;\n    margin-right: 8px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 10px;\n    margin-right: 4px;\n    line-height: 1.3;\n  };\n'], ['\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  font-weight: 700;\n  padding: 2px 8px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  ', ' {\n    font-size: 12px;\n    margin-right: 8px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 10px;\n    margin-right: 4px;\n    line-height: 1.3;\n  };\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description カセット「おすすめの学校情報」DOM生成
 * @param {array} gakkoInfoList - PR枠掲載学校情報リスト
 * @returns {string} - カセット「おすすめの学校情報」枠コンポーネントのHTML DOM文字列
 */
var cassetteGakkoInfoList = function cassetteGakkoInfoList(gakkoInfoList) {

  var cassetteHtml = '';

  gakkoInfoList.forEach(function (university, index) {
    cassetteHtml += __createCassetteHtml(university, index + 1);
  });

  return '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <span class="' + iconStyles + '">PR</span>おすすめの学校情報\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット「おすすめの学校情報」パターンのバナーの単体HTMLフォーマット生成
 * @param {object} universityInfo - 大学情報
 * @param {number} order - 表示順位
 * @returns {string} - 「おすすめの学校情報」単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(universityInfo, order) {
  var gakkoCd = universityInfo.gakkoCd;
  var gakkoPhoto = universityInfo.gakkoPhoto;
  var gakkoNm = universityInfo.gakkoNm;
  var todofukenRnm = universityInfo.todofukenRnm;
  var koshuNm = universityInfo.koshuNm;

  var linkUrl = '/gakko/' + gakkoCd + '/';
  var NO_IMAGE = "/images/assets/dummy/noImage.png";

  return '\n    <div class="' + prAreaItemStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a\n        href="' + linkUrl + '"\n        class="' + prAreaLinkStyles + ' js-pr-clickLog" \n        target="_blank"\n        data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '""\n      >\n        <div class="' + prAreaImageBlockStyles + '">\n          <img class="' + prAreaImageStyles + '" src="' + (gakkoPhoto ? gakkoPhoto : NO_IMAGE) + '" alt="' + gakkoNm + '" height="150" width="220">\n        </div>\n        <div class="' + prAreaInfoStyles + '">\n          <div class="' + prAreaNameStyles + '">' + gakkoNm + '</div>\n          <div class="' + prAreaOtherInfoStyles + '">' + koshuNm + '／' + todofukenRnm + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.cassetteGakkoInfoList = cassetteGakkoInfoList;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaItemStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaLinkStyles = (0, _emotionCss.css)(_templateObject5, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaInfoStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaNameStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaOtherInfoStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaImageBlockStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaImageStyles = (0, _emotionCss.css)(_templateObject10, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var textStyles = (0, _emotionCss.css)(_templateObject11);

var iconStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],118:[function(require,module,exports){
/**
 * [27卒PR枠] PR枠 OC一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n'], ['\n  color: #24243F;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  height: 19px;\n  padding: 2px 8px;\n  margin-right: 8px;\n'], ['\n  align-items: center;\n  background-color:  #3EC1BD;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #FFF;\n  display: inline-flex;\n  height: 19px;\n  padding: 2px 8px;\n  margin-right: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  padding: 16px 0;\n\n  ', ' {\n    max-width: 960px;\n  };\n\n  ', ' {\n    max-width: 400px;\n    padding: 16px;\n  };\n\n  @media (min-width: 768px) and (max-width: 960px) {\n    padding: 16px 32px;\n  }\n'], ['\n  margin: 0 auto;\n  padding: 16px 0;\n\n  ', ' {\n    max-width: 960px;\n  };\n\n  ', ' {\n    max-width: 400px;\n    padding: 16px;\n  };\n\n  @media (min-width: 768px) and (max-width: 960px) {\n    padding: 16px 32px;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  gap: 24px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  gap: 24px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 8px;\n\n  ', ' {\n    padding-left: 0;\n  };\n'], ['\n  background-color: #fff;\n  border-radius: 8px;\n\n  ', ' {\n    padding-left: 0;\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-shadow: 0px 2px 6px 0px #00000024;\n  border-radius: 8px;\n  color: #333;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ', ' {\n    display: flex;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    display: block;\n    box-sizing: content-box;\n  };\n\n'], ['\n  box-shadow: 0px 2px 6px 0px #00000024;\n  border-radius: 8px;\n  color: #333;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ', ' {\n    display: flex;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    display: block;\n    box-sizing: content-box;\n  };\n\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  position: relative;\n\n  ', ' {\n    height: 208px;\n    width: 312px;\n  };\n\n  ', ' {\n    height: 100%;\n    width: calc(100% + 2px);\n    padding-top: 66.6666%;\n    transition: height .2s;\n    border-radius: 6px 6px 0 0;\n  };\n'], ['\n  overflow: hidden;\n  position: relative;\n\n  ', ' {\n    height: 208px;\n    width: 312px;\n  };\n\n  ', ' {\n    height: 100%;\n    width: calc(100% + 2px);\n    padding-top: 66.6666%;\n    transition: height .2s;\n    border-radius: 6px 6px 0 0;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  height: auto;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n\n  ', ' {\n    left: 50%;\n  };\n\n  ', ' {\n    left: calc(50% - 1px);\n    transition: .2s;\n  };\n'], ['\n  height: auto;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n\n  ', ' {\n    left: 50%;\n  };\n\n  ', ' {\n    left: calc(50% - 1px);\n    transition: .2s;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    height: 208px;\n    width: calc(100% - 312px);\n    position: relative;\n  };\n\n  ', ' {\n    overflow: hidden;\n    padding: 8px 16px 16px;\n    margin: 0;\n    border: 0;\n    outline: 0;\n    font-size: 100%;\n    vertical-align: baseline;\n  };\n'], ['\n  box-sizing: border-box;\n\n  ', ' {\n    padding: 16px;\n    height: 208px;\n    width: calc(100% - 312px);\n    position: relative;\n  };\n\n  ', ' {\n    overflow: hidden;\n    padding: 8px 16px 16px;\n    margin: 0;\n    border: 0;\n    outline: 0;\n    font-size: 100%;\n    vertical-align: baseline;\n  };\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-weight: 700;\n  margin-bottom: 4px;\n\n  ', ' {\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n'], ['\n  color: #808d96;\n  font-weight: 700;\n  margin-bottom: 4px;\n\n  ', ' {\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #043f94;\n  display: block;\n  font-weight: 700;\n  margin-bottom: 8px;\n\n  ', ' {\n    font-size: 18px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n'], ['\n  color: #043f94;\n  display: block;\n  font-weight: 700;\n  margin-bottom: 8px;\n\n  ', ' {\n    font-size: 18px;\n    line-height: 1.5;\n  };\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.3;\n  };\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  color: #333;\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 4px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    margin-bottom: 8px;\n  };\n'], ['\n  color: #333;\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 4px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    margin-bottom: 8px;\n  };\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  color: #808d96;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n'], ['\n  color: #808d96;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: #f6f8f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-around;\n  padding: 8px 4px;\n\n  ', ' {\n    height: 34px;\n    bottom: 16px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    margin-inline: 15px;\n    margin-top: 10px\n  };\n\n  ', ' {\n    height: 39px;\n    margin-top: 16px\n  };\n'], ['\n  align-items: center;\n  background-color: #f6f8f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-around;\n  padding: 8px 4px;\n\n  ', ' {\n    height: 34px;\n    bottom: 16px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    margin-inline: 15px;\n    margin-top: 10px\n  };\n\n  ', ' {\n    height: 39px;\n    margin-top: 16px\n  };\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  line-height: 1;\n\n  ', ' {\n    margin-left: 10px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n\n  ', ' {\n    margin-left: 6px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n'], ['\n  line-height: 1;\n\n  ', ' {\n    margin-left: 10px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n\n  ', ' {\n    margin-left: 6px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  };\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n'], ['\n  align-items: center;\n  display: flex;\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  color: #424e56;\n  font-family: StudySapuriNumber !important;\n  font-size: 20px;\n'], ['\n  color: #424e56;\n  font-family: StudySapuriNumber !important;\n  font-size: 20px;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 700;\n  margin-left: 2px;\n'], ['\n  color: ', ';\n  font-weight: 700;\n  margin-left: 2px;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  margin-left: 2px;\n'], ['\n  margin-left: 2px;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n'], ['\n  margin-inline: unset !important;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description OC一覧用PRカセットDOM生成
 * @param {array} ocListData - PR枠に表示する情報
 * @returns {string} - OC一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var cassetteOpenCampusList = function cassetteOpenCampusList(ocListData) {

  var cassetteHtml = '';

  ocListData.forEach(function (cassetteItem, index) {
    cassetteHtml += __createCassetteHtml(cassetteItem, index + 1);
  });

  return '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <p class="' + unsetMarginInlineStyles + '"><span class="' + iconStyles + '">PR</span></p>\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description OC検索一覧用PR枠 単体HTMLフォーマット生成
 * @param {object} openCampusList - PR枠カセット情報
 * @param {number} order - 表示順位
 * @returns {string} - 単体HTMLのDOM文字列
 */
var __createCassetteHtml = function __createCassetteHtml(openCampusList, order) {
  var productCd = openCampusList.productCd;
  var gakkoCd = openCampusList.gakkoCd;
  var gakkoNm = openCampusList.gakkoNm;
  var orgCd = openCampusList.orgCd;
  var orgNm = openCampusList.orgNm;
  var locationCityNm = openCampusList.locationCityNm;
  var eventTitle = openCampusList.eventTitle;
  var ocBunyaPcImage = openCampusList.ocBunyaPcImage;
  var bunyaCatch = openCampusList.bunyaCatch;
  var kaisaiDateList = openCampusList.kaisaiDateList;

  var kaisaiDateListHtml = __createKaisaiDateListHtml(kaisaiDateList);

  var linkUrl = '/gakko/' + gakkoCd + '/openCampus/gakubugakka/' + orgCd + '/?ocsfProductCd=' + productCd;

  return '\n    <div class="' + ocCassetteStyles + ' js-pr-isInView" data-pr-inview-log="' + trace_p + '_PRcassette_imp_' + order + '_' + gakkoCd + '">\n      <a href="' + linkUrl + '" class="' + ocLinkStyles + ' js-pr-clickLog" target="_blank" data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '">\n        <div class="' + ocImageWrapperStyles + '">\n          <img\n            src="' + __createOcImage(ocBunyaPcImage) + '"\n            class="' + ocImageStyles + '"\n            alt="' + __createOcTitle(eventTitle) + '"\n            height="241"\n            width="363"\n          >\n        </div>\n        <div class="' + ocContentsWrapperStyles + '">\n          <div class="' + ocContentsLabelStyles + '">' + gakkoNm + ' ' + (orgNm ? orgNm : "") + '</div>\n          <p class="' + ocContentsTitleStyles + ' ' + unsetMarginInlineStyles + '">' + __createOcTitle(eventTitle) + '</p>\n          <p class="' + ocContentsCatchTextStyles + ' ' + unsetMarginInlineStyles + '">' + __createBunyaCatch(bunyaCatch, orgNm) + '</p>\n          ' + (locationCityNm && locationCityNm.trim() !== '' ? '<div class="' + ocContentsLocationCityStyles + '">' + locationCityNm + '</div>' : '') + '\n          ' + (kaisaiDateList.length > 0 ? '<ul class="' + ocDateUnOrderListStyles + '">' + kaisaiDateListHtml + '</ul>' : '') + '\n        </div>\n      </a>\n    </div>\n  ';
};

/**
 * @private
 * @description 開催日の一覧がまとまったstringを、日付ごとのHTMLに分割する関数
 * @param {Array<string>} kaisaiDateList - PR枠カセット情報
 * @returns {string} - 単体HTMLのDOM文字列
 */
var __createKaisaiDateListHtml = function __createKaisaiDateListHtml(kaisaiDateList) {

  var arrayKaisaiDateList = kaisaiDateList.map(function (item) {
    return item.trim();
  });
  var limitDateCount = 5;

  var kaisaiDateHtml = '';

  arrayKaisaiDateList.slice(0, limitDateCount).forEach(function (kaisaiDateItem, index) {
    var _getMonthDayAndDayOfWeek = (0, _modulesPrAreaUtilities_prAreaUtilities.getMonthDayAndDayOfWeek)(kaisaiDateItem);

    var monthDay = _getMonthDayAndDayOfWeek.monthDay;
    var dayOfWeek = _getMonthDayAndDayOfWeek.dayOfWeek;

    if (index === 4) {
      kaisaiDateHtml += '\n        <li class="' + ocDateListItemStyles + '">\n          <span class="' + ocDateMoreStyles + '">…</span>\n        </li>\n      ';
      return;
    }

    kaisaiDateHtml += '\n      <li class="' + ocDateListItemStyles + '">\n        <span class="' + ocDateSetStyles + '">\n          <span class="' + ocDateStyles + '">' + monthDay + '</span>\n          <span class="' + ocDateDayOfWeekStyles(dayOfWeek) + '">' + dayOfWeek + '</span>\n        </span>\n      </li>\n    ';
  });

  return kaisaiDateHtml;
};

/**
 * @private
 * @description OC画像のsrc値を生成する関数
 * @param {string|null} ocBunyaPcImage - APIから返される画像パス。空の場合はNoImage画像を指定する。
 * @returns {string} 表示する画像パス
 */
var __createOcImage = function __createOcImage(ocBunyaPcImage) {
  // ocBunyaPcImageが文字列かつ空白を除いた値が空でない場合はAPIから送られた画像パス値を指定する
  // それ以外の場合はNoImage画像を使用
  return typeof ocBunyaPcImage === 'string' && ocBunyaPcImage.trim() !== '' ? ocBunyaPcImage : '/images/open_campus/oc_bunya_cassette_no_image.svg';
};

/**
 * @private
 * @description OC画像のalt値を生成する関数
 * @param {string | null} eventTitle - APIから返されるイベントタイトル。空の場合は固定文言(オープンキャンパス)を指定する。
 * @returns {string} - alt属性に設定する文字列
 */
var __createOcTitle = function __createOcTitle(eventTitle) {
  return typeof eventTitle === 'string' && eventTitle.trim() !== '' ? eventTitle : 'オープンキャンパス';
};

/**
 * @private
 * @description OC画像のキャッチ文言を生成する関数
 * @param {string | null} bunyaCatch - APIから返されるキャッチ文言。null/空文字/空白のみ固定文言に切り替える。
 * @param {string | null} orgNm - APIから返される学部名。null/空文字/空白のみ固定文言に切り替える。
 * @returns {string} - キャッチ箇所に指定する文字列
 */
var __createBunyaCatch = function __createBunyaCatch(bunyaCatch, orgNm) {
  // bunyaCatchが非空判定ならそのまま返す
  if (typeof bunyaCatch === 'string' && bunyaCatch.trim() !== '') {
    return bunyaCatch;
  }
  // orgNmが非空なら学部名を入れる、空なら名称なしの固定文言
  var orgName = typeof orgNm === 'string' && orgNm.trim() !== '' ? orgNm.trim() : '';
  return orgNm ? orgName + 'のオープンキャンパス情報です。' : 'オープンキャンパス情報です。';
};

exports.cassetteOpenCampusList = cassetteOpenCampusList;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject);

var textStyles = (0, _emotionCss.css)(_templateObject2);

var iconStyles = (0, _emotionCss.css)(_templateObject3);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject5);

var ocCassetteStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN);

// box-shadowのopacity: 0.14
var ocLinkStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocImageWrapperStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocImageStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsWrapperStyles = (0, _emotionCss.css)(_templateObject10, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsLabelStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsTitleStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsCatchTextStyles = (0, _emotionCss.css)(_templateObject13, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocContentsLocationCityStyles = (0, _emotionCss.css)(_templateObject14, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocDateUnOrderListStyles = (0, _emotionCss.css)(_templateObject15, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocDateListItemStyles = (0, _emotionCss.css)(_templateObject16, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var ocDateSetStyles = (0, _emotionCss.css)(_templateObject17);

var ocDateStyles = (0, _emotionCss.css)(_templateObject18);

var ocDateDayOfWeekStyles = function ocDateDayOfWeekStyles(dayOfWeek) {
  return (0, _emotionCss.css)(_templateObject19, (0, _modulesPrAreaUtilities_prAreaUtilities.getDayOfWeekBackgroundColor)(dayOfWeek));
};

var ocDateMoreStyles = (0, _emotionCss.css)(_templateObject20);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var unsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject21);

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],119:[function(require,module,exports){
/**
 * [27卒PR枠] PR枠 学校検索一覧画面用コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n'], ['\n  background-color: #E7F6FF;\n  box-sizing: border-box;\n  text-align: left;\n  margin-bottom: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-weight: 700;\n'], ['\n  color: #24243F;\n  font-weight: 700;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  line-height: 1.5;\n  padding: 2px 8px;\n\n  ', ' {\n    font-size: 14px;\n    height: 21px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    height: 18px;\n  };\n'], ['\n  align-items: center;\n  border-radius: 4px;\n  background-color:  #3EC1BD;\n  color: #FFF;\n  display: inline-flex;\n  line-height: 1.5;\n  padding: 2px 8px;\n\n  ', ' {\n    font-size: 14px;\n    height: 21px;\n  };\n\n  ', ' {\n    font-size: 12px;\n    height: 18px;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  padding-block: 16px;\n\n  ', ' {\n    max-width: 960px;\n    padding-inline: 32px;\n  };\n\n  ', ' {\n    padding-inline: 8px;\n  };\n'], ['\n  margin: 0 auto;\n  padding-block: 16px;\n\n  ', ' {\n    max-width: 960px;\n    padding-inline: 32px;\n  };\n\n  ', ' {\n    padding-inline: 8px;\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-inline: unset !important;\n'], ['\n  margin-inline: unset !important;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../modules/prAreaUtilities/_prAreaUtilities');

var _modulesCreateCassetteHtml_createCassetteHtml = require('./modules/createCassetteHtml/_createCassetteHtml');

/**
 * @description 学校検索一覧用PRカセットDOM生成
 * @param {array} searchIntegrationList - 統合検索リストの情報
 * @returns {string} - 学校検索一覧用PRカセット枠コンポーネントのHTML DOM文字列
 */
var cassetteSearchIntegrationList = function cassetteSearchIntegrationList(searchIntegrationList) {
  var cassetteHtml = '';

  searchIntegrationList.forEach(function (searchIntegrationItem, index) {
    cassetteHtml += (0, _modulesCreateCassetteHtml_createCassetteHtml.createCassetteHtml)(searchIntegrationItem, index + 1);
  });

  return '\n    <div class="' + prAreaStyles + '">\n      <div class="' + prAreaWrapperStyles + '">\n        <div class="' + textStyles + '">\n          <p class="' + unsetMarginInlineStyles + '"><span class="' + iconStyles + '">PR</span></p>\n        </div>\n        <div class="' + prAreaListStyles + '">\n          ' + cassetteHtml + '\n        </div>\n      </div>\n    </div>\n  ';
};

exports.cassetteSearchIntegrationList = cassetteSearchIntegrationList;

/*---- CSS定義 ----*/
var prAreaStyles = (0, _emotionCss.css)(_templateObject);

var textStyles = (0, _emotionCss.css)(_templateObject2);

var iconStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaWrapperStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var prAreaListStyles = (0, _emotionCss.css)(_templateObject5);

// 後続で読み込まれる #contents に対するスタイルに対応するため
var unsetMarginInlineStyles = (0, _emotionCss.css)(_templateObject6);

},{"../../../../modules/prAreaUtilities/_prAreaUtilities":134,"./modules/createCassetteHtml/_createCassetteHtml":120,"@emotion/css":7}],120:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  overflow: hidden;\n  border-top: 2px solid #0b41a0;\n  border-bottom: 1px solid #e1e8eA;\n\n  ", " {\n    border-left: 1px solid #e1e8eA;\n    border-right: 1px solid #e1e8eA;\n  };\n"], ["\n  position: relative;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  overflow: hidden;\n  border-top: 2px solid #0b41a0;\n  border-bottom: 1px solid #e1e8eA;\n\n  ", " {\n    border-left: 1px solid #e1e8eA;\n    border-right: 1px solid #e1e8eA;\n  };\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n\n  ", " {\n    padding: 16px 16px 24px;\n  };\n\n  ", " {\n    padding: 16px;\n  };\n"], ["\n\n  ", " {\n    padding: 16px 16px 24px;\n  };\n\n  ", " {\n    padding: 16px;\n  };\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesCreateCourseAccordionBlock_createCourseAccordionBlock = require("./modules/createCourseAccordionBlock/_createCourseAccordionBlock");

var _modulesCreateEmpathyContentsBlock_createEmpathyContentsBlock = require("./modules/createEmpathyContentsBlock/_createEmpathyContentsBlock");

var _modulesCreateOpenCampusBlock_createOpenCampusBlock = require("./modules/createOpenCampusBlock/_createOpenCampusBlock");

var _modulesCreateUniversityBlock_createUniversityBlock = require("./modules/createUniversityBlock/_createUniversityBlock");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 単体HTMLフォーマット生成
 * @param {object} searchIntegrationItem - PR枠カセットのアイテム情報
 * @param {number} order - 表示順位 
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createCassetteHtml = function createCassetteHtml(searchIntegrationItem, order) {
  var gakkoCd = searchIntegrationItem.gakkoCd;
  var empathyContentsList = searchIntegrationItem.empathyContentsList;

  var universityBlock = (0, _modulesCreateUniversityBlock_createUniversityBlock.createUniversityBlock)(searchIntegrationItem, order);
  var courseAccordionBlock = (0, _modulesCreateCourseAccordionBlock_createCourseAccordionBlock.createCourseAccordionBlock)(searchIntegrationItem, order, gakkoCd);
  var empathyContentsBlock = (0, _modulesCreateEmpathyContentsBlock_createEmpathyContentsBlock.createEmpathyContentsBlock)(empathyContentsList, order, gakkoCd);
  var openCampusBlock = (0, _modulesCreateOpenCampusBlock_createOpenCampusBlock.createOpenCampusBlock)(searchIntegrationItem, order);

  return "\n    <li class=\"" + searchResultsListItemStyles + " prarea__searchResults__item searchResults__item js-pr-isInView js-cassetteInView\" data-gakkocd=\"" + gakkoCd + "\" data-pr-inview-log=\"" + trace_p + "_PRcassette_imp_" + order + "_" + gakkoCd + "\">\n      <div class=\"" + searchResultsUniversityBlockStyles + "\">\n        " + universityBlock + "\n        " + courseAccordionBlock + "\n        " + empathyContentsBlock + "\n        " + openCampusBlock + "\n      </div>\n    </li>\n  ";
};

exports.createCassetteHtml = createCassetteHtml;

var searchResultsListItemStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN);

var searchResultsUniversityBlockStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"./modules/createCourseAccordionBlock/_createCourseAccordionBlock":121,"./modules/createEmpathyContentsBlock/_createEmpathyContentsBlock":125,"./modules/createOpenCampusBlock/_createOpenCampusBlock":126,"./modules/createUniversityBlock/_createUniversityBlock":128,"@emotion/css":7}],121:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  font-size: 10px;\n  color: #808d96;\n  margin-top: 24px;\n  border-left: 4px solid #afb8be;\n  padding-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n  };\n"], ["\n  font-size: 10px;\n  color: #808d96;\n  margin-top: 24px;\n  border-left: 4px solid #afb8be;\n  padding-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n  };\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  background-color: #E7F6FF;\n  color: #808d96;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-block: 4px;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    width: fit-content;\n    font-size: 14px;\n  };\n"], ["\n  background-color: #E7F6FF;\n  color: #808d96;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-block: 4px;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    width: fit-content;\n    font-size: 14px;\n  };\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  color: #808d96;\n  display: inline-block;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 2px;\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n};\n"], ["\n  color: #808d96;\n  display: inline-block;\n  font-weight: 300;\n  line-height: 1.5;\n  margin-top: 2px;\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n};\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n  border-radius: 8px 8px 0 0;\n\n  &:not(:has(+ .prarea__searchResults__moreLink)) {\n    border-radius: 8px;\n  }\n\n  & > .prarea__searchResults__gakkaItem:first-of-type {\n    border-top: none;\n  }\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"], ["\n  background-color: #f8f9f9;\n  border-radius: 8px 8px 0 0;\n\n  &:not(:has(+ .prarea__searchResults__moreLink)) {\n    border-radius: 8px;\n  }\n\n  & > .prarea__searchResults__gakkaItem:first-of-type {\n    border-top: none;\n  }\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n  border-radius: 0 0 8px 8px;\n  text-align: center;\n"], ["\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n  border-radius: 0 0 8px 8px;\n  text-align: center;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  border-top: none;\n  display: block;\n  font-weight: 700;\n  text-align: center;\n  color: #808d96;\n  text-decoration: none;\n  line-height: 1.5;\n  padding: 8px;\n  position: relative;\n\n  &::after {\n    content: '';\n    display: inline-block;\n    width: 13px;\n    height: 9px;\n    background: url(/images/responsive/Text_Sub/arrow_textSub_base.svg) no-repeat center;\n    transform: rotate(180deg);\n    margin-left: 4px;\n  };\n\n  &.is-open::after {\n    transform: rotate(0);\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 12px;\n  };\n"], ["\n  border-top: none;\n  display: block;\n  font-weight: 700;\n  text-align: center;\n  color: #808d96;\n  text-decoration: none;\n  line-height: 1.5;\n  padding: 8px;\n  position: relative;\n\n  &::after {\n    content: '';\n    display: inline-block;\n    width: 13px;\n    height: 9px;\n    background: url(/images/responsive/Text_Sub/arrow_textSub_base.svg) no-repeat center;\n    transform: rotate(180deg);\n    margin-left: 4px;\n  };\n\n  &.is-open::after {\n    transform: rotate(0);\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 12px;\n  };\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

var _modulesCreateUpperOrgList_createUpperOrgList = require("./modules/createUpperOrgList/_createUpperOrgList");

/**
 * @description 学校検索一覧用PR枠 目指せる学部・学科・コースの一覧アコーディオンHTMLを生成する
 * @param {object} searchIntegrationItem - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @param {string} gakkoCd - pr枠専用代表学校コード
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createCourseAccordionBlock = function createCourseAccordionBlock(searchIntegrationItem, order, gakkoCd) {
  var upperOrgList = searchIntegrationItem.upperOrgList;
  var lowerOrgList = searchIntegrationItem.lowerOrgList;
  var searchBunnyaNm = searchIntegrationItem.searchBunnyaNm;

  var upperOrgListHtml = (0, _modulesCreateUpperOrgList_createUpperOrgList.createUpperOrgList)(upperOrgList, lowerOrgList, order, gakkoCd, searchBunnyaNm);

  //Orgが存在しない場合トルツメ
  if (upperOrgList.length === 0 && lowerOrgList.length === 0) return '';

  return "\n    <h3 class=\"" + searchResultsH3Styles + "\">\n      " + __settingBunnya(searchBunnyaNm) + "\n    </h3>\n    " + __settingSearchResults(upperOrgList, lowerOrgList, upperOrgListHtml) + "\n  ";
};

/**
 * @description 検索一覧カセット「学部・学科・コース」リストDOM条件分岐関数
 * @param {Array} upperOrgList - upperOrgリスト
 * @param {Array} lowerOrgList - lowerOrgリスト
 * @param {string} upperOrgListHtml - upperOrgで作成されたHTML DOM
 * @returns {string} - 条件分岐によってDOMの表示制限
 */
var __settingSearchResults = function __settingSearchResults(upperOrgList, lowerOrgList, upperOrgListHtml) {

  if (upperOrgList.length === 0) {
    //upperOrg -「X」 , lowerOrg -「X」 パターン
    if (lowerOrgList.length === 0) return "";

    //upperOrg -「X」 , lowerOrg -「O」 パターン
    return "\n    <div>\n      " + __settingGakkaList(lowerOrgList) + "\n    </div>\n    ";
  } else {
    //button条件分岐 - lowerOrgが1個以上存在する or upperOrgが4個以上存在する
    var buttonActive = lowerOrgList.length >= 1 || upperOrgList.length >= 4;

    //upperOrg -「O」パターン
    return "\n    <ul class=\"" + searchResultsGakkoListStyles + " prarea__searchResults__gakkaList\">" + upperOrgListHtml + "</ul>\n    " + __settingMoreButton(buttonActive) + "\n    ";
  }
};

/**
 * @description upperOrgが存在しないが、lowerOrgが存在する場合表示する「その他学部・学科・コース」List DOMを作成する関数
 * @param {Array} lowerOrgList - 描画に必要な情報
 * @returns {string} - 「その他学科・学部・コース」リストDOM
 */
var __settingGakkaList = function __settingGakkaList(lowerOrgList) {
  var gakkaListDOM = "";
  var invisibleFlag = false;

  lowerOrgList.forEach(function (lowerOrg, index) {
    if (index === 3) {
      gakkaListDOM += "<a href=\"javascript:void(0);\" onclick=\"var s2=s_gi(s_account);s2.tl(this,'o','Ssearch_result_list_next_more')\" data-more-gakubugakka-text=\"trigger\">続きを見る</a>";
      gakkaListDOM += "<div data-more-gakubugakka-text=\"target\" style=\"display: none;\">";
      invisibleFlag = true;
    }
    gakkaListDOM += "\n    <span class=\"searchResults__gakkaTextItem\">\n      " + lowerOrg.ownHierarchyNm + "\n    </span>\n    ";
  });
  if (invisibleFlag === true) gakkaListDOM += "</div>";

  return gakkaListDOM;
};

/**
 * @description 「もっと学部・学科・コースを見る」ボタンを作成する関数
 * @param {boolean} isActive - ボタン表示値
 * @returns {string} - ボタンDOM
 */
var __settingMoreButton = function __settingMoreButton(isActive) {
  if (isActive) {
    return "\n    <div class=\"" + searchResultsMoreLinkStyles + " prarea__searchResults__moreLink\">\n      <a\n        href=\"javascript:void(0);\"\n        prarea-data-more-gakubugakka=\"trigger\"\n        data-logId=\"Ssearch_result_list_base_more\"\n        class=\"" + searchResultsMoreLinkTextStyles + "\">もっと学部・学科・コースを見る\n      </a>\n    </div>\n    ";
  } else {
    return "";
  }
};

/**
 * @description 学校検索一覧用PR枠 目指せる学部・学科・コースの一覧アコーディオンHTMLを生成する
 * @param {string} searchBunnyaNm - 表示分野
 * @returns {string} - 分野HTML DOM
 */
var __settingBunnya = function __settingBunnya(searchBunnyaNm) {
  var defaultBunnaya = "学部・学科・コース";

  if (searchBunnyaNm) {
    defaultBunnaya = "を目指せる" + defaultBunnaya;
    return "\n      <p class=\"" + searchResultsHeadingTextLargeStyles + "\">" + searchBunnyaNm + "</p>\n      <p class=\"" + searchResultsHeadingTextStyles + "\">" + defaultBunnaya + "</p>\n    ";
  } else {
    return "<p class=\"" + searchResultsHeadingTextStyles + "\">" + defaultBunnaya + "</p>";
  }
};

exports.createCourseAccordionBlock = createCourseAccordionBlock;

/** CSS定義 */
var searchResultsH3Styles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsHeadingTextLargeStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsHeadingTextStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsGakkoListStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreLinkStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsMoreLinkTextStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"./modules/createUpperOrgList/_createUpperOrgList":122,"@emotion/css":7}],122:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modulesCreateLowerOrgList_createLowerOrgList = require("./modules/createLowerOrgList/_createLowerOrgList");

var _modulesCreateUpperOrgItem_createUpperOrgItem = require("./modules/createUpperOrgItem/_createUpperOrgItem");

/**
 * @description 学校検索一覧用PR枠 目指せる学科・学部・コースのリストHTMLを生成する
 * @param {array} upperOrgList - 描画に必要なオブジェクトの配列
 * @param {array} lowerOrgList - 描画に必要な下部のオブジェクトの配列
 * @param {number} order - 表示順位 
 * @param {string} gakkoCd - pr枠専用代表学校コード
 * @param {string} hitText - 分野ヒットテキスト
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createUpperOrgList = function createUpperOrgList(upperOrgList, lowerOrgList, order, gakkoCd, hitText) {

  // 4件以上データがある場合、「もっと見る」押下でのみ表示させる領域に描画する
  var alwaysVisibleItems = upperOrgList.slice(0, 3);
  var moreItems = upperOrgList.slice(3);

  var upperOrgListHtml = '';

  alwaysVisibleItems.forEach(function (item) {
    upperOrgListHtml += (0, _modulesCreateUpperOrgItem_createUpperOrgItem.createUpperOrgItem)(item, order, gakkoCd, hitText);
  });

  // もっと見る押下時に表示されるHTMLの作成
  var moreOrgListHtml = '';
  if (moreItems.length) {
    moreItems.forEach(function (item) {
      moreOrgListHtml += (0, _modulesCreateUpperOrgItem_createUpperOrgItem.createUpperOrgItem)(item, order, gakkoCd, hitText);
    });
  };

  // その他の学部・学科・コース一覧欄の作成
  var lowerOrgListHtml = (0, _modulesCreateLowerOrgList_createLowerOrgList.createLowerOrgList)(lowerOrgList, order, gakkoCd, hitText);

  upperOrgListHtml += "\n    <li>\n      <ul prarea-data-more-gakubugakka=\"target\" style=\"display: none\">\n        " + moreOrgListHtml + "\n        " + lowerOrgListHtml + "\n      </ul>\n    </li>\n  ";

  return upperOrgListHtml;
};

exports.createUpperOrgList = createUpperOrgList;

},{"./modules/createLowerOrgList/_createLowerOrgList":123,"./modules/createUpperOrgItem/_createUpperOrgItem":124}],123:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n"], ["\n  background-color: #f8f9f9;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  padding: 8px;\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n"], ["\n  padding: 8px;\n  background-color: #f8f9f9;\n  border-top: 1px solid #d3d4d4;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n  color: #808d96;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  margin-bottom: 4px;\n  color: #808d96;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline;\n  padding-right: 1px;\n  color: #808d96;\n\n  & + & {\n    padding-left: 5px;\n    line-height: 14px;\n    border-left: 1px solid #808d96;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  display: inline;\n  padding-right: 1px;\n  color: #808d96;\n\n  & + & {\n    padding-left: 5px;\n    line-height: 14px;\n    border-left: 1px solid #808d96;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  color: #0b41a0;\n  text-decoration: none;\n"], ["\n  color: #0b41a0;\n  text-decoration: none;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: #808D96;\n"], ["\n  color: #808D96;\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 もっと見る押下時の最下部に表示されるHTMLを生成する
 * @param {array} lowerOrgList - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @param {string} clickGakkoCd - pr枠専用代表学校コード
 * @param {string} hitText - 検索分野
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createLowerOrgList = function createLowerOrgList(lowerOrgList, order, clickGakkoCd, hitText) {

  if (!lowerOrgList.length) return "";

  var userBecomeJob = hitText;

  var lowerOrgListHtml = '';

  var wrappingAnker = function wrappingAnker(targetHtml, gakkoCd, ownHierarchyOrgCd, gakubuGakkaSankakuFlag) {
    if (gakubuGakkaSankakuFlag === 1) {
      return "\n        <a href=\"/gakko/" + gakkoCd + "/gakubugakka/" + ownHierarchyOrgCd + "/\" \n        class=\"" + searchResultsMoreItemLinkStyles + " js-pr-clickLog\" \n        data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + clickGakkoCd + "\"\n        target=\"_blank\"\n        >" + targetHtml + "</a>\n      ";
    } else {
      return "\n        <a class=\"" + searchResultsMoreItemNoLinkStyles + "\">" + targetHtml + "</a>\n      ";
    }
  };

  lowerOrgList.forEach(function (lowerOrgItem) {
    var gakkoCd = lowerOrgItem.gakkoCd;
    var ownHierarchyOrgCd = lowerOrgItem.ownHierarchyOrgCd;
    var ownHierarchyNm = lowerOrgItem.ownHierarchyNm;
    var ownHierarchyShinzosetsuComment = lowerOrgItem.ownHierarchyShinzosetsuComment;
    var gakubuGakkaSankakuFlag = lowerOrgItem.gakubuGakkaSankakuFlag;

    var mainText = [ownHierarchyNm, ownHierarchyShinzosetsuComment].join(' ');

    lowerOrgListHtml += "\n      <dd class=\"" + searchResultsMoreItemDdStyles + "\">\n        " + (gakkoCd && ownHierarchyOrgCd ? wrappingAnker(mainText, gakkoCd, ownHierarchyOrgCd, gakubuGakkaSankakuFlag) : mainText) + "\n      </dd>\n    ";
  });

  return "\n    <div class=\"" + searchResultsMoreListStyles + "\">\n      <dl class=\"" + searchResultsMoreItemDlStyles + "\">\n        <dt class=\"" + searchResultsMoreItemDtStyles + "\">" + (userBecomeJob ? userBecomeJob + "を目指せる" : "") + "<b>その他の</b>学部・学科・コース一覧</dt>\n        " + lowerOrgListHtml + "\n      </dl>\n    </div>\n  ";
};

exports.createLowerOrgList = createLowerOrgList;

/** CSS定義 */
var searchResultsMoreListStyles = (0, _emotionCss.css)(_templateObject);

var searchResultsMoreItemDlStyles = (0, _emotionCss.css)(_templateObject2);

var searchResultsMoreItemDtStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreItemDdStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreItemLinkStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsMoreItemNoLinkStyles = (0, _emotionCss.css)(_templateObject6);

},{"../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],124:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  border-top: 1px solid #d3d4d4;\n  box-sizing: border-box;\n  list-style: none outside none;\n\n  ", " {\n    min-height: 53px;\n  };\n\n  ", " {\n    min-height: 42px;\n  };\n"], ["\n  border-top: 1px solid #d3d4d4;\n  box-sizing: border-box;\n  list-style: none outside none;\n\n  ", " {\n    min-height: 53px;\n  };\n\n  ", " {\n    min-height: 42px;\n  };\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  text-decoration: none;\n  color: #0b41a0;\n\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    right: 8px;\n  };\n\n  ", " {\n    padding: 16px 8px;\n\n    &::after {\n      top: calc(50% - 9px);\n      width: 12px;\n      height: 18px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_2xl.svg) no-repeat center;\n    };\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 12px 8px 12px 12px;\n\n    &::after {\n      top: calc(50% - 6px);\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    };\n  };\n"], ["\n  position: relative;\n  display: block;\n  text-decoration: none;\n  color: #0b41a0;\n\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    right: 8px;\n  };\n\n  ", " {\n    padding: 16px 8px;\n\n    &::after {\n      top: calc(50% - 9px);\n      width: 12px;\n      height: 18px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_2xl.svg) no-repeat center;\n    };\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 12px 8px 12px 12px;\n\n    &::after {\n      top: calc(50% - 6px);\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    };\n  };\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  gap: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n  margin-right: 16px;\n"], ["\n  display: flex;\n  overflow: hidden;\n  gap: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n  margin-right: 16px;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n"], ["\n  display: flex;\n  gap: 8px;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: #0b41a0;\n  font-weight: 700;\n  line-height: 1.3;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    font-size: 14px;\n  };\n"], ["\n  color: #0b41a0;\n  font-weight: 700;\n  line-height: 1.3;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    font-size: 14px;\n  };\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  margin-left: 0;\n  overflow: hidden;\n  line-height: 14px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  margin-left: 0;\n  overflow: hidden;\n  line-height: 14px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  background-color: #E7F6FF;\n  padding-block: 2px;\n"], ["\n  background-color: #E7F6FF;\n  padding-block: 2px;\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  color: #24243F;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n"], ["\n  overflow: hidden;\n  color: #24243F;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 1.5;\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 目指せる学科・学部・コースの各要素のHTMLを生成する
 * @param {object} upperOrgItem - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @param {string} clickGakkoCd - pr枠専用代表学校コード
 * @param {string} hitText - 分野ヒットテキスト
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createUpperOrgItem = function createUpperOrgItem(upperOrgItem, order, clickGakkoCd, hitText) {
  var gakkoCd = upperOrgItem.gakkoCd;
  var ownHierarchyNm = upperOrgItem.ownHierarchyNm;
  var ownHierarchyOrgCd = upperOrgItem.ownHierarchyOrgCd;
  var shigotoNm = upperOrgItem.shigotoNm;
  var gakumonNm = upperOrgItem.gakumonNm;
  var shikakuNm = upperOrgItem.shikakuNm;
  var paymentYear = upperOrgItem.paymentYear;
  var paymentComment = upperOrgItem.paymentComment;

  var linkUrl = "/gakko/" + gakkoCd + "/gakubugakka/" + ownHierarchyOrgCd + "/";

  return "\n    <li class=\"" + searchResultsGakkaListItemStyles + " prarea__searchResults__gakkaItem js-cassetteGakkaName\">\n      <a href=\"" + linkUrl + "\" \n      class=\"" + searchResultsGakkaLinkStyles + " js-pr-clickLog\" \n      data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + clickGakkoCd + "\"\n      target=\"_blank\">\n        <div class=\"" + searchResultsGakkaItemBoxStyles + "\">\n          <div class=\"" + searchResultsGakkaItemNameWrapperStyles + "\">\n            <h4 class=\"" + searchResultsGakkaItemH4Styles + "\">\n              <span class=\"" + searchResultsGakkaItemNameStyles + "\">" + ownHierarchyNm + "</span>\n            </h4>\n          </div>\n\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n              " + __settingWords(shigotoNm, hitText) + "\n            </span>\n          </span>\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n            " + __settingWords(gakumonNm, hitText) + "\n            </span>\n          </span>\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n            " + __settingWords(shikakuNm, hitText) + "\n            </span>\n          </span>\n          <span class=\"prarea__searchResults__content searchResults__content\">\n            <span class=\"prarea__searchResults__word " + searchResultsContentStyles + "\">\n              <span class=\"" + searchResultsWordStyles + "\">初年度納入金：" + paymentYear + "年度納入金(予定) " + paymentComment + "万円</span>\n            </span>\n          </span>\n        </div>\n      </a>\n    </li>\n  ";
};

/**
 * @description HITテキスト検査
 * @param {array} words 表示テキスト
 * @param {string} hitText ヒットテキスト
 * @returns {string} HTMLObject を返す - 基本テキストスタイルDOM、HITテキストスタイルDOM
 */
var __settingWords = function __settingWords(words, hitText) {
  var result = "";
  if (!words) return result;

  words.forEach(function (word, index, array) {
    word === hitText ? result += "\n      <span class=\"is-match " + searchResultsHitTextStyles + " " + searchResultsWordStyles + "\">" + word + "</span>\n    " : result += "\n      <span class=\"" + searchResultsWordStyles + "\">" + word + "</span>\n    ";

    if (index < array.length - 1) {
      result += "\n        <span class=\"" + searchResultsWordStyles + "\">、</span>\n      ";
    }
  });

  return result;
};

exports.createUpperOrgItem = createUpperOrgItem;

/** CSS定義 */
var searchResultsGakkaListItemStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsGakkaLinkStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsGakkaItemBoxStyles = (0, _emotionCss.css)(_templateObject3);

var searchResultsGakkaItemNameWrapperStyles = (0, _emotionCss.css)(_templateObject4);

var searchResultsGakkaItemH4Styles = (0, _emotionCss.css)(_templateObject5);

var searchResultsGakkaItemNameStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsContentStyles = (0, _emotionCss.css)(_templateObject7);

var searchResultsHitTextStyles = (0, _emotionCss.css)(_templateObject8);

var searchResultsWordStyles = (0, _emotionCss.css)(_templateObject9);

},{"../../../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],125:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 学校検索一覧 在校生・卒業生・先生の声エリア生成関数
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 24px;\n'], ['\n  margin-top: 24px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n'], ['\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n'], ['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-weight: 300;\n  line-height: 1.5;\n\n  ', ' {\n    font-size: 14px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n'], ['\n  color: #24243F;\n  font-weight: 300;\n  line-height: 1.5;\n\n  ', ' {\n    font-size: 14px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: #0B41A0;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n'], ['\n  color: #0B41A0;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5;\n  -webkit-tap-highlight-color:rgba(0,0,0,0);\n  cursor: pointer;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n\n  ', ' {\n    margin: 16px auto 0;\n  };\n\n  ', ' {\n    margin: 8px auto 0;\n  };\n'], ['\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n\n  ', ' {\n    margin: 16px auto 0;\n  };\n\n  ', ' {\n    margin: 8px auto 0;\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n\n  ', ' {\n    padding: 8px;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    align-items: center;\n    padding: 4px;\n  };\n'], ['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n      text-decoration: none;\n    }\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n\n  ', ' {\n    padding: 8px;\n  };\n\n  ', ' {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    align-items: center;\n    padding: 4px;\n  };\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n\n  ', ' {\n    position: relative;\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    position: relative;\n    width: 86px;\n    height: 58px;\n  };\n'], ['\n\n  ', ' {\n    position: relative;\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    position: relative;\n    width: 86px;\n    height: 58px;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n\n  ', ' {\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    width: 86px;\n    height: 58px;\n  };\n'], ['\n  border-radius: 4px;\n\n  ', ' {\n    width: 120px;\n    height: 80px;\n  };\n\n  ', ' {\n    width: 86px;\n    height: 58px;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  bottom: 0;\n  border-radius: 0 4px 0 4px;\n  color: #FFF;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-block: 2px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ', ' {\n    font-size: 12px;\n    height: 20px;\n    padding-inline: 10px;\n  };\n\n  ', ' {\n    font-size: 10px;\n    height: 16px;\n    padding-inline: 8px;\n  };\n'], ['\n  background-color: ', ';\n  bottom: 0;\n  border-radius: 0 4px 0 4px;\n  color: #FFF;\n  display: inline;\n  font-weight: 700;\n  line-height: 1.5;\n  padding-block: 2px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ', ' {\n    font-size: 12px;\n    height: 20px;\n    padding-inline: 10px;\n  };\n\n  ', ' {\n    font-size: 10px;\n    height: 16px;\n    padding-inline: 8px;\n  };\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n\n  ', ' {\n    padding-inline: 8px;\n  };\n\n  ', ' {\n    padding-inline: 4px;\n  };\n'], ['\n  box-sizing: border-box;\n\n  ', ' {\n    padding-inline: 8px;\n  };\n\n  ', ' {\n    padding-inline: 4px;\n  };\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n'], ['\n  color: #0b41a0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 12px;\n  };\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  color: #808d96;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n'], ['\n  color: #808d96;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  margin: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ', ' {\n    font-size: 12px;\n  };\n\n  ', ' {\n    font-size: 10px;\n  };\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../../../../../modules/prAreaUtilities/_prAreaUtilities');

/**
 * @description 学校検索一覧用PR枠 在校生・卒業生・先生の声エリア
 * @param {array} empathyContentsList - 描画用の共感リスト
 * @param {number} order - 表示順位 
 * @param {string} gakkoCd - pr枠専用代表学校コード
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createEmpathyContentsBlock = function createEmpathyContentsBlock(empathyContentsList, order, gakkoCd) {

  if (!empathyContentsList.length) return '';

  var _empathyContentsList$0 = empathyContentsList[0];
  var kyokanType = _empathyContentsList$0.kyokanType;
  var totalCount = _empathyContentsList$0.totalCount;
  var imagePath = _empathyContentsList$0.imagePath;
  var mainCatch = _empathyContentsList$0.mainCatch;
  var course = _empathyContentsList$0.course;
  var jobName = _empathyContentsList$0.jobName;
  var teacherName = _empathyContentsList$0.teacherName;
  var kyokanContentUrl = _empathyContentsList$0.kyokanContentUrl;
  var moreUrl = _empathyContentsList$0.moreUrl;

  var _getEmpathyContentsInfo = (0, _modulesPrAreaUtilities_prAreaUtilities.getEmpathyContentsInfo)(kyokanType);

  var empathyBackgroundColor = _getEmpathyContentsInfo.empathyBackgroundColor;
  var empathyContentString = _getEmpathyContentsInfo.empathyContentString;

  var getMainCatch = function getMainCatch(kyokanType) {
    var createHtml = function createHtml(content) {
      return '<div class="' + searchResultKyokanOtherInfoStyles + '">' + content + '</div>';
    };

    if (kyokanType === '2' && teacherName) {
      return createHtml(teacherName);
    };

    if (kyokanType === '3' && jobName) {
      return createHtml(jobName);
    };

    return '';
  };

  var mainCatchHtml = getMainCatch(kyokanType);

  return '\n    <div class="' + searchResultKyokanContentStyles + '">\n      <div class="' + searchResultKyokanFieldStyles + '">\n        <span class="' + searchResultKyokanTitleStyles + '">在校生・卒業生・先生の声\n          <span class="' + searchResultKyokanTitleCountStyles + '">(' + totalCount + '件)</span>\n        </span>\n        <a\n          href="' + moreUrl + '"\n          class="' + searchResultMoreLinkStyles + ' js-pr-clickLog" \n          data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n          target="_blank"\n        >\n          もっと見る\n        </a>\n      </div>\n\n      <div class="' + searchResultKyokanStyles + '">\n        <a\n          href="' + kyokanContentUrl + '"\n          class="' + searchResultKyokanLinkStyles + ' js-pr-clickLog" \n          data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n          target="_blank"\n        >\n          <div class="' + searchResultKyokanImageBlockStyles + '">\n            <img class="' + searchResultKyokanImageStyles + '" src="' + imagePath + '" alt="' + course + '" width="86" height="58">\n            <span class="' + searchResultKyokanCategoryStyles(empathyBackgroundColor) + '">' + empathyContentString + '</span>\n          </div>\n          <div class="' + searchResultKyokanInfoStyles + '">\n            <div class="' + searchResultKyokanNameStyles + '">' + mainCatch + '</div>\n            <div class="' + searchResultKyokanOtherInfoStyles + '">' + course + '</div>\n            ' + mainCatchHtml + '\n          </div>\n        </a>\n      </div>\n    </div>\n  ';
};

exports.createEmpathyContentsBlock = createEmpathyContentsBlock;

/** CSS定義 */
var searchResultKyokanContentStyles = (0, _emotionCss.css)(_templateObject);

var searchResultKyokanFieldStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanTitleStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanTitleCountStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultMoreLinkStyles = (0, _emotionCss.css)(_templateObject5, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanLinkStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanImageBlockStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanImageStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanCategoryStyles = function searchResultKyokanCategoryStyles(bgColor) {
  return (0, _emotionCss.css)(_templateObject10, bgColor, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);
};

var searchResultKyokanInfoStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanNameStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultKyokanOtherInfoStyles = (0, _emotionCss.css)(_templateObject13, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],126:[function(require,module,exports){
/**
 * [27卒PR枠] PC PR枠 学校検索一覧 OC導線カセット生成関数
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n\n  ', ' {\n    margin-top: 24px;\n  };\n\n  ', ' {\n    margin-top: 16px;\n  };\n'], ['\n  position: relative;\n\n  ', ' {\n    margin-top: 24px;\n  };\n\n  ', ' {\n    margin-top: 16px;\n  };\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n'], ['\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  ', ' {\n    margin-bottom: 16px;\n    gap: 8px;\n  };\n\n  ', ' {\n    margin-bottom: 8px;\n    gap: 4px;\n  };\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n'], ['\n  color: #24243F;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  flex: 1;\n\n  ', ' {\n    font-size: 16px;\n  };\n\n  ', ' {\n    font-size: 14px;\n  };\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: #0B41A0;\n  text-align: right;\n  font-style: normal;\n  font-weight: 700;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n'], ['\n  color: #0B41A0;\n  text-align: right;\n  font-style: normal;\n  font-weight: 700;\n\n  &::after {\n    content: \'\';\n    display: inline-flex;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ', ' {\n    font-size: 14px;\n    line-height: 1.5;\n\n    &::after {\n      width: 8px;\n      height: 12px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_lg.svg) no-repeat center;\n    }\n  };\n\n  ', ' {\n    font-size: 12px;\n    line-height: 1.3;\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      width: 7px;\n      height: 10px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_base.svg) no-repeat center;\n    }\n  };\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n\n  & .swiper-button-disabled {\n    display: none;\n  };\n'], ['\n  position: relative;\n  width: 100%;\n\n  & .swiper-button-disabled {\n    display: none;\n  };\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  z-index: 1;\n\n  ', ' {\n    margin-inline: 24px;\n  };\n\n  ', ' {\n    margin-inline: 20px;\n  };\n'], ['\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  z-index: 1;\n\n  ', ' {\n    margin-inline: 24px;\n  };\n\n  ', ' {\n    margin-inline: 20px;\n  };\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform, -webkit-transform;\n  box-sizing: content-box;\n\n  transform: translate3d(0px, 0, 0)\n  transition-timing-function: ease-out;\n'], ['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform, -webkit-transform;\n  box-sizing: content-box;\n\n  transform: translate3d(0px, 0, 0)\n  transition-timing-function: ease-out;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  top: calc(50% - 16px);\n  margin-top: 0;\n  background-color: #AFB8BE;\n  border-radius: 24px;\n  opacity: 0.6;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.3;\n      text-decoration: none;\n    }\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: calc(50% - 9px);\n    left: calc(50% - 6px);\n    width: 12px;\n    height: 19px;\n    background: url(/images/responsive/Bg_White/arrow_bgWhite_base.svg) no-repeat center;\n  };\n\n  ', ' {\n    width: 40px;\n    height: 40px;\n  };\n\n  ', ' {\n    width: 32px;\n    height: 32px;\n\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n'], ['\n  top: calc(50% - 16px);\n  margin-top: 0;\n  background-color: #AFB8BE;\n  border-radius: 24px;\n  opacity: 0.6;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.3;\n      text-decoration: none;\n    }\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: calc(50% - 9px);\n    left: calc(50% - 6px);\n    width: 12px;\n    height: 19px;\n    background: url(/images/responsive/Bg_White/arrow_bgWhite_base.svg) no-repeat center;\n  };\n\n  ', ' {\n    width: 40px;\n    height: 40px;\n  };\n\n  ', ' {\n    width: 32px;\n    height: 32px;\n\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n  };\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  ', ';\n\n  &::after {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n\n  ', ' {\n    left: 0;\n  };\n\n  ', ' {\n    left: -12px;\n  };\n'], ['\n  ', ';\n\n  &::after {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n\n  ', ' {\n    left: 0;\n  };\n\n  ', ' {\n    left: -12px;\n  };\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  ', ';\n\n  ', ' {\n    right: 0;\n  };\n\n  ', ' {\n    right: -12px;\n  };\n'], ['\n  ', ';\n\n  ', ' {\n    right: 0;\n  };\n\n  ', ' {\n    right: -12px;\n  };\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _modulesPrAreaUtilities_prAreaUtilities = require('../../../../../../../../modules/prAreaUtilities/_prAreaUtilities');

var _modulesCreateCampusItem_createCampusItem = require('./modules/createCampusItem/_createCampusItem');

/**
 * @description 学校検索一覧用PR枠 OC導線カセット
 * @param {object} searchIntegrationItem - 描画用のOCリスト
 * @param {number} order - 表示順位 
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createOpenCampusBlock = function createOpenCampusBlock(searchIntegrationItem, order) {
  var gakkoCd = searchIntegrationItem.gakkoCd;
  var ocBunyaCassetteDtoList = searchIntegrationItem.ocBunyaCassetteDtoList;

  var moreLinkUrl = '/gakko/' + gakkoCd + '/openCampus/';

  var ocListHtml = '';

  //OCデータ0件時トルツメ
  if (!ocBunyaCassetteDtoList || ocBunyaCassetteDtoList.length === 0) return '';

  ocBunyaCassetteDtoList.forEach(function (ocBunyaCassetteDtoItem) {
    ocListHtml += (0, _modulesCreateCampusItem_createCampusItem.createCampusItem)(ocBunyaCassetteDtoItem, order);
  });

  return '\n    <div class="' + searchResultsOcHeadStyles + '">\n      <div class="' + searchResultsOcFieldStyles + '">\n        <p class="' + searchResultsOcTitleStyles + '">オープンキャンパス</p>\n        <a\n          href="' + moreLinkUrl + '"\n          onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Slist_f_All_SGopelLink\')"\n          class="' + searchResultsMoreLinkStyles + ' js-pr-clickLog" \n          target="_blank"\n          data-pr-click-log="' + trace_p + '_PRcassette_click_' + order + '_' + gakkoCd + '"\n        >\n          もっと見る\n        </a>\n      </div>\n\n      <div class="' + searchResultsOcCarouselWrapperStyles + ' js-prSearchOc-swiper">\n        <div class="' + searchResultsOcCarouselStyles + ' swiper-container">\n          <ul\n            class="' + searchResultsOcUlStyles + ' swiper-wrapper"\n           >\n            ' + ocListHtml + '\n          </ul>\n        </div>\n\n        <div tabindex="0" role="button" aria-label="Previous slide"\n          class="swiper-button-prev ' + searchResultsOcCarouselPrevStyles + '">\n        </div>\n        <div tabindex="0" role="button" aria-label="Next slide"\n          class="swiper-button-next ' + searchResultsOcCarouselNextStyles + '">\n        </div>\n      </div>\n    </div>\n  ';
};

exports.createOpenCampusBlock = createOpenCampusBlock;

/** CSS定義 */
var searchResultsOcHeadStyles = (0, _emotionCss.css)(_templateObject, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcFieldStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcTitleStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsMoreLinkStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcCarouselWrapperStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsOcCarouselStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcUlStyles = (0, _emotionCss.css)(_templateObject7);

var searchResultsOcCarouselBaseButtonStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcCarouselPrevStyles = (0, _emotionCss.css)(_templateObject9, searchResultsOcCarouselBaseButtonStyles, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcCarouselNextStyles = (0, _emotionCss.css)(_templateObject10, searchResultsOcCarouselBaseButtonStyles, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"./modules/createCampusItem/_createCampusItem":127,"@emotion/css":7}],127:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n"], ["\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    padding: 8px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 4px 8px 4px 4px;\n  };\n"], ["\n  background-color: #f8f9f9;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    padding: 8px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    padding: 4px 8px 4px 4px;\n  };\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    gap: 8px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"], ["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    gap: 8px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  border-radius: 4px;\n\n  ", " {\n    width: 120px;\n    height: 80px;\n  };\n\n  ", " {\n    width: 87px;\n    height: 58px;\n  };\n"], ["\n  border-radius: 4px;\n\n  ", " {\n    width: 120px;\n    height: 80px;\n  };\n\n  ", " {\n    width: 87px;\n    height: 58px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  display: grid;\n\n"], ["\n  display: grid;\n\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 16px;\n    line-height: 1.3;\n  };\n\n  ", " {\n    font-size: 12px;\n    line-height: 1.5;\n  };\n"], ["\n  color: #0b41a0;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 16px;\n    line-height: 1.3;\n  };\n\n  ", " {\n    font-size: 12px;\n    line-height: 1.5;\n  };\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  color: #808d96;\n  display: flex;\n  font-weight: 700;\n  justify-content: space-between;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  color: #808d96;\n  display: flex;\n  font-weight: 700;\n  justify-content: space-between;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  display: inline;\n  overflow: hidden;\n  padding-right: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"], ["\n  display: inline;\n  overflow: hidden;\n  padding-right: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", " {\n    font-size: 12px;\n  };\n\n  ", " {\n    font-size: 10px;\n  };\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  color: #24243F;\n  font-family: StudySapuriNumber !important;\n  white-space: nowrap;\n\n  background-color: #FFF;\n  bottom: 0;\n  border-radius: 0px 4px 0px 0px;\n  box-sizing: border-box;\n  display: inline;\n  font-weight: 300;\n  line-height: 1.5;\n  padding: 2px 4px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ", " {\n    bottom: 8px;\n    font-size: 14px;\n    height: 21px;\n    left: 8px;\n    padding: 2px 4px;\n  };\n\n  ", " {\n    bottom: 4px;\n    font-size: 12px;\n    height: 19px;\n    left: 4px;\n    padding: 4px;\n  };\n"], ["\n  color: #24243F;\n  font-family: StudySapuriNumber !important;\n  white-space: nowrap;\n\n  background-color: #FFF;\n  bottom: 0;\n  border-radius: 0px 4px 0px 0px;\n  box-sizing: border-box;\n  display: inline;\n  font-weight: 300;\n  line-height: 1.5;\n  padding: 2px 4px;\n  position: absolute;\n  text-align: center;\n  left: 0;\n\n  ", " {\n    bottom: 8px;\n    font-size: 14px;\n    height: 21px;\n    left: 8px;\n    padding: 2px 4px;\n  };\n\n  ", " {\n    bottom: 4px;\n    font-size: 12px;\n    height: 19px;\n    left: 4px;\n    padding: 4px;\n  };\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n\n  ", " {\n    font-size: 10px;\n  };\n\n  ", " {\n    font-size: 8px;\n  };\n"], ["\n  color: ", ";\n  font-weight: 700;\n\n  ", " {\n    font-size: 10px;\n  };\n\n  ", " {\n    font-size: 8px;\n  };\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  color: #24243F;\n  font-size: 8px;\n  font-weight: 700;\n  line-height: 1.5;\n\n  ", " {\n    margin-left: 4px;\n  };\n\n  ", " {\n    margin-left: 2px;\n  };\n"], ["\n  color: #24243F;\n  font-size: 8px;\n  font-weight: 700;\n  line-height: 1.5;\n\n  ", " {\n    margin-left: 4px;\n  };\n\n  ", " {\n    margin-left: 2px;\n  };\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用 PR枠 スワイプ対象の OpenCampus HTMLを生成する
 * @param {object} ocBunyaCassetteDtoItem - 描画に必要なOCオブジェクト情報
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createCampusItem = function createCampusItem(ocBunyaCassetteDtoItem, order) {
  var productCd = ocBunyaCassetteDtoItem.productCd;
  var gakkoCd = ocBunyaCassetteDtoItem.gakkoCd;
  var orgCd = ocBunyaCassetteDtoItem.orgCd;
  var eventTitle = ocBunyaCassetteDtoItem.eventTitle;
  var ocBunyaPcImage = ocBunyaCassetteDtoItem.ocBunyaPcImage;
  var kaisaiDateList = ocBunyaCassetteDtoItem.kaisaiDateList;

  var linkUrl = "/gakko/" + gakkoCd + "/openCampus/gakubugakka/" + orgCd + "/?ocsfProductCd=" + productCd;

  return "\n    <li class=\"" + searchResultsOcItemStyles + " swiper-slide\">\n      <a\n        href=\"" + linkUrl + "\"\n        class=\"" + searchResultsOcLinkStyles + " js-pr-clickLog\" \n        target=\"_blank\"\n        data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + gakkoCd + "\"\n      >\n        <div class=\"" + searchResultsOcHeadStyles + "\">\n          <div class=\"" + searchResultsOcThumbnailAreaStyles + "\">\n            <img\n              src=\"" + __createOcImage(ocBunyaPcImage) + "\"\n              alt=\"" + __createOcTitle(eventTitle) + "\"\n              class=\"" + searchResultsOcThumbnailStyles + "\"\n              width=\"86\"\n              height=\"58\"\n            >\n            " + __createCasseteDateHtml(kaisaiDateList) + "\n          </div>\n          <div class=\"" + searchResultsOcMainStyles + "\">\n            <p class=\"" + searchResultsOcEventTitleStyles + "\">" + __createOcTitle(eventTitle) + "</p>\n          </div>\n        </div>\n      </a>\n    </li>\n  ";
};

/**
 * @private
 * @description OC開催日生成関数
 * @param {Array | undefined | ''} kaisaiDateList - OC開催配列
 * @returns {string} - PR枠カセット開催日HTML DOM
 */
var __createCasseteDateHtml = function __createCasseteDateHtml(kaisaiDateList) {
  if (!kaisaiDateList) return '';

  var kaisaiFirstDate = kaisaiDateList[0].trim();
  // 開催日は1つのみ掲示し、2つ以上の場合それらは「他」とする
  var kaisaiOtherDateHtml = kaisaiDateList.length > 1 ? "<span class=\"" + searchResultsOcOtherStyles + "\">他</span>" : '';

  var _getMonthDayAndDayOfWeek = (0, _modulesPrAreaUtilities_prAreaUtilities.getMonthDayAndDayOfWeek)(kaisaiFirstDate);

  var monthDay = _getMonthDayAndDayOfWeek.monthDay;
  var dayOfWeek = _getMonthDayAndDayOfWeek.dayOfWeek;

  var kaisaiDateHtml = "\n    <div class=\"" + searchResultsOcKaisaiDateStyles + "\">\n      " + monthDay + "\n      <span class=\"" + searchResultsOcDayOfWeekStyles(dayOfWeek) + "\">" + dayOfWeek + "</span>\n      " + kaisaiOtherDateHtml + "\n    </div>\n  ";

  return kaisaiDateHtml;
};

/**
 * @private
 * @description OC画像のsrc値を生成する関数
 * @param {string|null} ocBunyaPcImage - APIから返される画像パス。空の場合はNoImage画像を指定する。
 * @returns {string} 表示する画像パス
 */
var __createOcImage = function __createOcImage(ocBunyaPcImage) {
  // ocBunyaPcImageが文字列かつ空白を除いた値が空でない場合はAPIから送られた画像パス値を指定する
  // それ以外の場合はNoImage画像を使用
  return typeof ocBunyaPcImage === 'string' && ocBunyaPcImage.trim() !== '' ? ocBunyaPcImage : '/images/open_campus/oc_bunya_cassette_no_image.svg';
};

/**
 * @private
 * @description OC画像のalt値を生成する関数
 * @param {string | null} eventTitle - APIから返されるイベントタイトル。空の場合は固定文言(オープンキャンパス)を指定する。
 * @returns {string} - alt属性に設定する文字列
 */
var __createOcTitle = function __createOcTitle(eventTitle) {
  return typeof eventTitle === 'string' && eventTitle.trim() !== '' ? eventTitle : 'オープンキャンパス';
};

exports.createCampusItem = createCampusItem;

/** CSS定義 */
var searchResultsOcItemStyles = (0, _emotionCss.css)(_templateObject);

var searchResultsOcLinkStyles = (0, _emotionCss.css)(_templateObject2, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcHeadStyles = (0, _emotionCss.css)(_templateObject3, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcThumbnailAreaStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcThumbnailStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcMainStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsOcEventTitleStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcSubBoxStyles = (0, _emotionCss.css)(_templateObject7, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcBunyaCatchStyles = (0, _emotionCss.css)(_templateObject8, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcKaisaiDateStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsOcDayOfWeekStyles = function searchResultsOcDayOfWeekStyles(dayOfWeek) {
  return (0, _emotionCss.css)(_templateObject10, (0, _modulesPrAreaUtilities_prAreaUtilities.getDayOfWeekBackgroundColor)(dayOfWeek), _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);
};

var searchResultsOcOtherStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

},{"../../../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n"], ["\n  display: block;\n  text-decoration: none;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  color: #0b41a0;\n  line-height: 1.3;\n\n  ", " {\n    font-size: 32px;\n  };\n\n  ", " {\n    font-size: 20px;\n  };\n"], ["\n  font-weight: 700;\n  color: #0b41a0;\n  line-height: 1.3;\n\n  ", " {\n    font-size: 32px;\n  };\n\n  ", " {\n    font-size: 20px;\n  };\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  padding-top: 8px;\n  border-top: 1px solid #d3d4d4;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n"], ["\n  padding-top: 8px;\n  border-top: 1px solid #d3d4d4;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 2px 8px;\n  color: #3ec1bd;\n  line-height: 1.5;\n  text-align: center;\n  border: 1px solid #3ec1bd;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  ", " {\n    font-size: 14px;\n    height: 25px;\n  };\n\n  ", " {\n    font-size: 12px;\n    height: 22px;\n  };\n"], ["\n  display: inline-block;\n  padding: 2px 8px;\n  color: #3ec1bd;\n  line-height: 1.5;\n  text-align: center;\n  border: 1px solid #3ec1bd;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  ", " {\n    font-size: 14px;\n    height: 25px;\n  };\n\n  ", " {\n    font-size: 12px;\n    height: 22px;\n  };\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  padding-bottom: 1px;\n  border: 0 none;\n"], ["\n  width: 12px;\n  height: 12px;\n  padding-bottom: 1px;\n  border: 0 none;\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  padding-left: 4px;\n  line-height: 1.5;\n  color: #24243F;\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n"], ["\n  padding-left: 4px;\n  line-height: 1.5;\n  color: #24243F;\n\n  ", " {\n    font-size: 14px;\n  };\n\n  ", " {\n    font-size: 12px;\n  };\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"], ["\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n  };\n\n  ", " {\n    margin-top: 8px;\n  };\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n  overflow-y: hidden;\n\n  ", " {\n    gap: 16px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n  overflow-y: hidden;\n\n  ", " {\n    gap: 16px;\n  };\n\n  ", " {\n    gap: 4px;\n  };\n"]),
    _templateObject12 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n\n  ", " {\n    aspect-ratio: 220 / 148;\n    max-width: 220px;\n  };\n\n  ", " {\n    aspect-ratio: 82 / 56;\n    max-width: 181px;\n  };\n"], ["\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n\n  ", " {\n    aspect-ratio: 220 / 148;\n    max-width: 220px;\n  };\n\n  ", " {\n    aspect-ratio: 82 / 56;\n    max-width: 181px;\n  };\n"]),
    _templateObject13 = _taggedTemplateLiteral(["\n  color: #24243F;\n  line-height: 1.5;\n  overflow-wrap: break-word;\n\n  ", " {\n    margin-top: 16px;\n    font-size: 14px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    font-size: 12px;\n  };\n"], ["\n  color: #24243F;\n  line-height: 1.5;\n  overflow-wrap: break-word;\n\n  ", " {\n    margin-top: 16px;\n    font-size: 14px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    font-size: 12px;\n  };\n"]),
    _templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n    gap: 16px;\n    height: 50px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    gap: 8px;\n    height: 48px;\n  };\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n\n  ", " {\n    margin-top: 16px;\n    gap: 16px;\n    height: 50px;\n  };\n\n  ", " {\n    margin-top: 8px;\n    gap: 8px;\n    height: 48px;\n  };\n"]),
    _templateObject15 = _taggedTemplateLiteral(["\n  width: 50%;\n  &:only-child {\n    width: 100%\n  }\n"], ["\n  width: 50%;\n  &:only-child {\n    width: 100%\n  }\n"]),
    _templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  background-color: #FF8700;\n  border-radius: 4px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 14px;\n  };\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  background-color: #FF8700;\n  border-radius: 4px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n    font-size: 14px;\n  };\n"]),
    _templateObject17 = _taggedTemplateLiteral(["\n  width: 50%;\n  transition: width .1s ease, top .1s ease;\n\n  &:only-child {\n    width: 100%\n  }\n\n  &.is-added {\n    color: #AFB8BE;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.3;\n\n    .searchResults__buttons__cart {\n      border: 1px solid #D3D4D4;\n\n      &::after {\n        content: '追加済み';\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: none;\n        color: #AFB8BE;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 1.3;\n      };\n\n      @media (hover: hover) {\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n    }\n  };\n"], ["\n  width: 50%;\n  transition: width .1s ease, top .1s ease;\n\n  &:only-child {\n    width: 100%\n  }\n\n  &.is-added {\n    color: #AFB8BE;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.3;\n\n    .searchResults__buttons__cart {\n      border: 1px solid #D3D4D4;\n\n      &::after {\n        content: '追加済み';\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: none;\n        color: #AFB8BE;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 1.3;\n      };\n\n      @media (hover: hover) {\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n    }\n  };\n"]),
    _templateObject18 = _taggedTemplateLiteral(["\n  display: block;\n  height: 100%;\n  background-color: #ffffff;\n  border: 1px solid #0ca5e6;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  &::after {\n    content: '';\n    display: block;\n    height: 100%;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n\n    &::after {\n      background: url(/images/s/addList_searchList_medium.svg) no-repeat center center;\n    }\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      background: url(/images/s/addList_searchList.svg) no-repeat center center;\n    }\n  };\n"], ["\n  display: block;\n  height: 100%;\n  background-color: #ffffff;\n  border: 1px solid #0ca5e6;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  &::after {\n    content: '';\n    display: block;\n    height: 100%;\n  };\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ", " {\n    font-size: 16px;\n\n    &::after {\n      background: url(/images/s/addList_searchList_medium.svg) no-repeat center center;\n    }\n  };\n\n  ", " {\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\n    cursor: pointer;\n\n    &::after {\n      background: url(/images/s/addList_searchList.svg) no-repeat center center;\n    }\n  };\n"]),
    _templateObject19 = _taggedTemplateLiteral(["\n  padding-bottom: 8px;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  padding-bottom: 8px;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"]);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require("@emotion/css");

var _modulesPrAreaUtilities_prAreaUtilities = require("../../../../../../../../modules/prAreaUtilities/_prAreaUtilities");

/**
 * @description 学校検索一覧用PR枠 大学情報やパンフ・リスト追加などのHTMLを生成するエリア
 * @param {object} searchIntegrationItem - 描画に必要な情報
 * @param {number} order - 表示順位 
 * @returns {string} - 単体HTMLのDOM文字列
 */
var createUniversityBlock = function createUniversityBlock(searchIntegrationItem, order) {
  var gakkoCd = searchIntegrationItem.gakkoCd;
  var gakkoNm = searchIntegrationItem.gakkoNm;
  var gakkoPhoto = searchIntegrationItem.gakkoPhoto;
  var rootProductCd = searchIntegrationItem.rootProductCd;
  var tokuchoImage1 = searchIntegrationItem.tokuchoImage1;
  var tokuchoImage2 = searchIntegrationItem.tokuchoImage2;
  var tokuchoImage3 = searchIntegrationItem.tokuchoImage3;
  var koshuNm = searchIntegrationItem.koshuNm;
  var todofukenRnm = searchIntegrationItem.todofukenRnm;
  var gakkoHowKomidashi = searchIntegrationItem.gakkoHowKomidashi;
  var guideTokuchoNm1 = searchIntegrationItem.guideTokuchoNm1;
  var guideTokuchoNm2 = searchIntegrationItem.guideTokuchoNm2;
  var guideTokuchoNm3 = searchIntegrationItem.guideTokuchoNm3;
  var pamphFlag = searchIntegrationItem.pamphFlag;
  var ikkatsuFlag = searchIntegrationItem.ikkatsuFlag;

  var linkUrl = "/gakko/" + gakkoCd + "/";
  var getPamphletUrl = "/smp2/shiryoSeikyu/entry/input?shiryoShubetsu=01&seikyuShubetsu=0&yuryoDispFlag=1&gakkoCd=" + gakkoCd + "&pCd=LS0000000028";
  var isFlagTrue = function isFlagTrue(value) {
    return Number(value) === 1;
  };
  var tokuchoPhotos = [tokuchoImage1, tokuchoImage2, tokuchoImage3];
  var guideTokuchoNm = [guideTokuchoNm1, guideTokuchoNm2, guideTokuchoNm3];

  var guideTokuchoHtml = '';
  guideTokuchoNm.filter(Boolean).forEach(function (item) {
    guideTokuchoHtml += "\n      <span class=\"" + searchResultsFeatureTagItemStyles + "\">" + item + "</span>\n    ";
  });

  /**
   * @description 検索一覧ボタンの表示時下記の4パターンを対応する関数
   * ① - 「パンプをもらう」ボタン[有]
   * ② - 「資料請求カート」ボタン[有]
   * ③ - 「パンプをもらう」、「資料請求カート」ボタン両方[有]
   * ④ - ボタン[無]
   * @param {boolean} refinedPamphFlag パンプボタン存在有無
   * @param {boolean} refinedIkkatsuFlag パンプボタン存在有無
   * @returns {string} - 単体HTMLのDOM文字列
   */
  var createButtonAreaHtml = function createButtonAreaHtml(refinedPamphFlag, refinedIkkatsuFlag) {
    if (!refinedPamphFlag && !refinedIkkatsuFlag) return '';

    var pamphletButton = refinedPamphFlag ? "\n      <div class=\"" + searchResultsButtonLeftStyles + "\">\n        <a\n          href=\"" + getPamphletUrl + "\"\n          class=\"" + searchResultsPamphletButtonStyles + " js-pr-clickLog\"\n          target=\"_blank\"\n          data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + gakkoCd + "\"\n        >\n          パンフをもらう\n        </a>\n      </div>\n    " : '';

    var cartButton = refinedIkkatsuFlag ? "\n      <div class=\"" + searchResultsButtonRightStyles + " js-cassetteCarts\" data-cart=\"button\">\n        <a href=\"javascript:void(0);\" class=\"" + searchResultsAddCartButtonStyles + " searchResults__buttons__cart\" data-action=\"addCartOnly\" data-rootProductCd=\"" + rootProductCd + "\" data-school=\"" + gakkoCd + "\"></a>\n      </div>\n    " : '';

    return "\n      <div class=\"" + searchResultsButtonsStyles + "\">\n        " + pamphletButton + "\n        " + cartButton + "\n      </div>\n    ";
  };

  /**
   * @description
   * 学校画像エリア（検索一覧）の HTML 文字列を生成します。
   *
   * - 学校のメイン画像（`gakkoPhoto`）と、特徴画像（`tokuchoPhotos` = 最大3件）をまとめて表示する領域の DOM を返します。
   * - `gakkoPhoto` は左側の専用スロットに 1枚表示し、`tokuchoPhotos` はその右側に **与えられた順序のまま** 並べます。
   * - 画像が1枚も存在しない場合は **空文字** を返します（何も描画しません）。
   *
   * @param {string | null | undefined} gakkoPhoto
   *   学校のメイン画像 URL。未指定／空文字／`null`／`undefined` のいずれかの場合は表示しません。
   *
   * @param {(string | null | undefined)[]} tokuchoPhotos
   *   特徴画像の URL 配列（最大3件想定）。
   *   falsy（`null`/`undefined`/空文字 など）は自動でスキップされます。
   *   **配列の順序は維持** され、その順序で右側に並びます。
   *
   * @returns {string}
   *   生成された画像表示エリアの HTML 文字列。
   *   `gakkoPhoto` と `tokuchoPhotos` の **どちらも有効な画像がない** 場合は空文字（`''`）を返します。
   */
  var createSchoolImageAreaHtml = function createSchoolImageAreaHtml(gakkoPhoto, tokuchoPhotos) {

    var schoolImages = [gakkoPhoto].concat(_toConsumableArray(tokuchoPhotos));

    if (schoolImages.every(function (schoolImage) {
      return !schoolImage;
    })) {
      return "";
    }

    var tokuchoHtml = '';
    tokuchoPhotos.filter(Boolean).forEach(function (item) {
      tokuchoHtml += "\n        <div>\n          <img\n            src=\"" + item + "\" alt=\"" + gakkoNm + "\" width=\"117\" height=\"80\"\n            class=\"" + searchResultsSchoolImageStyles + "\"\n          >\n        </div>\n      ";
    });

    var gakkoImageHtml = gakkoPhoto ? "\n      <div>\n        <img\n          src=\"" + gakkoPhoto + "\" alt=\"" + gakkoNm + "\" width=\"85\" height=\"58\"\n          class=\"" + searchResultsSchoolImageStyles + "\"\n        >\n      </div>\n    " : '';

    return "\n      <div class=\"" + searchResultsSchoolImageAreaStyles + "\">\n        <div class=\"" + searchResultsSchoolImageAreaContentsStyles + "\">\n          " + gakkoImageHtml + "\n          " + tokuchoHtml + "\n        </div>\n      </div>      \n    ";
  };

  var buttonAreaBlock = createButtonAreaHtml(isFlagTrue(pamphFlag), isFlagTrue(ikkatsuFlag));

  /**
   * お気に入り登録導線の場合 searchList.js からDOM修正を行っているため既存DOMクラスで定義
   */
  return "\n    <div>\n      <a href=\"" + linkUrl + "\" target=\"_blank\" class=\"" + searchResultsSchoolLinkStyles + " js-pr-clickLog\" data-pr-click-log=\"" + trace_p + "_PRcassette_click_" + order + "_" + gakkoCd + "\">\n        <div class=\"" + searchResultsInfoStyles + "\">\n          <div class=\"" + searchResultsInfoMainStyles + "\">\n            <div class=\"" + searchResultInfoFavoriteStyles + "\">\n              <h2 class=\"" + searchResultsInfoSchoolNameStyles + "\">" + gakkoNm + "</h2>\n              <button class=\"searchResults__item__favoriteButton js-favorite__click\" style=\"visibility: hidden;\">\n                <div class=\"searchResults__item__container js-favorite__container\">\n                  <img class=\"searchResults__item__favorite__heart js-favorite__heart js-favorite__clickheart js-isPr\" src=\"\" alt=\"お気に入り\" width=\"20\" height=\"18\" />\n                </div>\n              </button>\n            </div>\n            \n\n            <div class=\"" + searchResultsFeatureTagStyles + "\">\n              " + guideTokuchoHtml + "\n            </div>\n\n            <div class=\"" + searchResultsNyushiInfoStyles + "\">\n              <img class=\"" + searchResultsIconStyles + "\" src=\"/images/s/searchList_school_icon.svg\" alt=\"" + gakkoNm + "\" width=\"13\" height=\"13\">\n              <span class=\"" + searchResultsSchoolTypeStyles + "\">" + koshuNm + "／" + todofukenRnm + "</span>\n            </div>\n\n            " + createSchoolImageAreaHtml(gakkoPhoto, tokuchoPhotos) + "\n\n          </div>\n        </div>\n      </a>\n    </div>\n\n    <p class=\"" + searchResultsSchoolTextStyles + "\">" + gakkoHowKomidashi + "</p>\n    " + buttonAreaBlock + "\n  ";
};

exports.createUniversityBlock = createUniversityBlock;

/** CSS定義 */
var searchResultsSchoolLinkStyles = (0, _emotionCss.css)(_templateObject);

var searchResultsInfoStyles = (0, _emotionCss.css)(_templateObject2);

var searchResultsInfoMainStyles = (0, _emotionCss.css)(_templateObject3);

var searchResultsInfoSchoolNameStyles = (0, _emotionCss.css)(_templateObject4, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsFeatureTagStyles = (0, _emotionCss.css)(_templateObject5);

var searchResultsFeatureTagItemStyles = (0, _emotionCss.css)(_templateObject6, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsNyushiInfoStyles = (0, _emotionCss.css)(_templateObject7);

var searchResultsIconStyles = (0, _emotionCss.css)(_templateObject8);

var searchResultsSchoolTypeStyles = (0, _emotionCss.css)(_templateObject9, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolImageAreaStyles = (0, _emotionCss.css)(_templateObject10, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolImageAreaContentsStyles = (0, _emotionCss.css)(_templateObject11, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolImageStyles = (0, _emotionCss.css)(_templateObject12, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsSchoolTextStyles = (0, _emotionCss.css)(_templateObject13, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultsButtonsStyles = (0, _emotionCss.css)(_templateObject14, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);
/**
 * @description only-child擬似クラスを使用し親要素の中で単一で残った場合Width調整
 */
var searchResultsButtonLeftStyles = (0, _emotionCss.css)(_templateObject15);

var searchResultsPamphletButtonStyles = (0, _emotionCss.css)(_templateObject16, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

/**
 * @description only-child擬似クラスを使用し親要素の中で単一で残った場合Width調整
 */
var searchResultsButtonRightStyles = (0, _emotionCss.css)(_templateObject17);

var searchResultsAddCartButtonStyles = (0, _emotionCss.css)(_templateObject18, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.PC_SCREEN, _modulesPrAreaUtilities_prAreaUtilities.MediaQuery.SP_SCREEN);

var searchResultInfoFavoriteStyles = (0, _emotionCss.css)(_templateObject19);

},{"../../../../../../../../modules/prAreaUtilities/_prAreaUtilities":134,"@emotion/css":7}],129:[function(require,module,exports){
// PR枠カセットコンポーネント群のimport
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _prAreaUtilities_prAreaUtilities = require('./prAreaUtilities/_prAreaUtilities');

var _componentsCassettesPcRecommendSchoolInfo_recommendSchoolInfo = require('../components/cassettes/pc/recommendSchoolInfo/_recommendSchoolInfo');

var _componentsCassettesPcConcernFieldEmpathyContents_concernFieldEmpathycontents = require('../components/cassettes/pc/concernFieldEmpathyContents/_concernFieldEmpathycontents');

var _componentsCassettesPcConcernFieldShinsetsu_concernFieldShinsetsu = require('../components/cassettes/pc/concernFieldShinsetsu/_concernFieldShinsetsu');

var _componentsCassettesResponsiveOpenCampusList_cassetteOpenCampusList = require('../components/cassettes/responsive/openCampusList/_cassetteOpenCampusList');

var _componentsCassettesResponsiveGakkoInfoList_cassetteGakkoInfoList = require('../components/cassettes/responsive/gakkoInfoList/_cassetteGakkoInfoList');

var _componentsCassettesResponsiveSearchIntegrationList_cassetteSearchIntegrationList = require('../components/cassettes/responsive/searchIntegrationList/_cassetteSearchIntegrationList');

var _modulesSearchListEvents_searchListEvents = require('./modules/searchListEvents/_searchListEvents');

/**
 * @description [27卒 PR枠追加] prArea関連クラス
 * @param {string} cassetteSelector - PR枠カセットDOM出力先のHTMLセレクタ名
 * @param {boolean} [isSp = false] - PC/SPで分かれている場合、SPであるかを明示する
 * @param {string} [tracePString = ''] - 画面ごとのID、読み込みタイミングの関係で未定義の場合に指定する
 */

var PrArea = (function () {
  function PrArea(_ref) {
    var cassetteSelector = _ref.cassetteSelector;
    var _ref$isSp = _ref.isSp;
    var isSp = _ref$isSp === undefined ? false : _ref$isSp;
    var _ref$tracePString = _ref.tracePString;
    var tracePString = _ref$tracePString === undefined ? '' : _ref$tracePString;

    _classCallCheck(this, PrArea);

    // 生成したPR枠カセットDOMを出力する要素取得
    this.cassetteSelector = cassetteSelector;

    // SP判定
    this.isSp = isSp;

    // pageId、(画面ごとにグローバルで設定される`trace_p`の値をそのまま使用する)
    this.pageId = tracePString !== '' ? tracePString : trace_p;

    // APIから取得した情報を格納
    this.cassetteData = [];

    // 複数PR枠判定
    this.prDivisionFlag = false;

    this.__init();
  }

  /**
   * @private
   * @description 初期処理
   */

  _createClass(PrArea, [{
    key: '__init',
    value: function __init() {
      var _this = this;

      this.__getPrArea(function () {
        // APIから取得したデータを元にPR枠カセットDOMを出力
        _this.__setCassetteDom();
      });

      // レイアウトシフト対策で決め打ちした、高さ設定用class `prAreaFirstView` を除却する
      window.addEventListener('load', function () {
        Array.prototype.forEach.call(document.getElementsByClassName('' + _this.cassetteSelector), function (targetElement) {
          targetElement.classList.remove('prAreaFirstView');
        });
      });
    }

    /**
     * @private
     * @param {function} callback - 非同期処理成功時のcallback
     * @description PR枠カセット表示 初期処理
     * path設定について
     * 本番 = '/smp/prFrame/getPrFrame'
     * Local = '/sp/smp/prFrame/getPrFrame/index.json'
     * デザイン = '/html/sp/smp/prFrame/getPrFrame'
    */
  }, {
    key: '__getPrArea',
    value: function __getPrArea(callback) {
      var _this2 = this;

      var URL = '/smp/prFrame/getPrFrame';

      var URLWithParams = URL + '?pageId=' + this.pageId;

      this.__getApiRequest(URLWithParams, function (data) {
        if (!data) return;

        _this2.result = data;
        _this2.prDivisionFlag = data.prDivisionFlag === "1" ? true : false;

        // PR枠カセット情報が取得できた場合のみcallback(画面描画処理を想定)を実行
        if (_this2.result.resultCode === 0) {
          callback();
          return;
        }
      });
    }

    /**
     * @private
     * @description PR枠カセット情報取得APIから、PR枠リストを取得
     * @param {string} url - PR枠カセット情報取得API パラメータを含める
     * @param {function} callBack - APIリクエスト正常終了時のCallback関数
     */
  }, {
    key: '__getApiRequest',
    value: function __getApiRequest(url, callBack) {
      var xhr = new XMLHttpRequest();
      var method = 'GET';

      xhr.open(method, url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          var _status = xhr.status;

          if (_status === 0 || _status >= 200 && _status < 400) {
            callBack(JSON.parse(xhr.response));
          } else {
            console.error('Api Get Error');
          }
        }
      };
      xhr.send();
    }

    /**
     * @private
     * @description PR枠カセットDOMの生成・出力
     */
  }, {
    key: '__setCassetteDom',
    value: function __setCassetteDom() {
      // pageIdを元にDOMを出し分け作成する
      var cassetteDom = this.__createCassetteHtml(this.pageId, this.result, this.prDivisionFlag);

      // PR枠カセットDOMを取得できなかった場合は終了
      if (!cassetteDom) return;

      // 生成したバナーDOMを出力
      var targetElements = document.getElementsByClassName('' + this.cassetteSelector);

      Array.prototype.forEach.call(targetElements, function (targetElement, index) {
        if (cassetteDom[index]) {
          targetElement.insertAdjacentHTML('beforeend', cassetteDom[index]);
        }
      });

      // PR枠は非同期で読み込まれるため、漏れないように生成したDOMにイベントを付与しておく
      if (this.pageId === _prAreaUtilities_prAreaUtilities.PAGE_ID.S_LIST_F_ALL || this.pageId === _prAreaUtilities_prAreaUtilities.PAGE_ID.LIST_F_ALL) {
        (0, _modulesSearchListEvents_searchListEvents.searchListEvents)();
      };
    }
  }, {
    key: '__createCassetteHtml',

    /**
     * @private
     * @description 各種PR枠カセットHTMLの生成
     * @param {object} pageId - ページID(trace_p)
     * @param {object} data - カセットに描画するデータ情報(this.resultが渡される想定)
     * @param {boolean} prDivisionFlag - 1画面毎に複数PR枠があるかを判定
     * @returns {Array} - PR枠カセットHTML DOM配列
     */
    value: function __createCassetteHtml(pageId, data, prDivisionFlag) {
      var gakkoInfoList = data.gakkoInfoList;
      var empathyContentsList = data.empathyContentsList;
      var shinzosetsuList = data.shinzosetsuList;
      var openCampusList = data.openCampusList;
      var searchIntegrationList = data.searchIntegrationList;

      // PR枠カセットタイプに基づきHTMLを出し分けるう
      switch (pageId) {
        // 進路トップ・学問詳細
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.TOP01:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_TOP01:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.GKUSYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_GKUSYO:
          return gakkoInfoList.length ? this.__adapterCreateCassets(_componentsCassettesPcRecommendSchoolInfo_recommendSchoolInfo.recommendSchoolInfo, gakkoInfoList, this.isSp, prDivisionFlag) : '';

        // 共感一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.KYOKAN_TOP:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_KYOKAN_TOP:
          return empathyContentsList.length ? this.__adapterCreateCassets(_componentsCassettesPcConcernFieldEmpathyContents_concernFieldEmpathycontents.concernFieldEmpathyContents, empathyContentsList, this.isSp, prDivisionFlag) : '';

        // 新増設一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.NEW_F_LIST:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_NEW_F_LIST:
          return shinzosetsuList.length ? this.__adapterCreateCassets(_componentsCassettesPcConcernFieldShinsetsu_concernFieldShinsetsu.concernFieldShinsetsu, shinzosetsuList, this.isSp, prDivisionFlag) : '';

        // OC検索一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_GAKKO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_GAKKO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_LIST:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_LIST:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_DAI:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_DAI:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_SEN:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_SEN:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_RYU:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_RYU:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.OP_SCL:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_OP_SCL:
          return openCampusList.length ? this.__adapterCreateCassets(_componentsCassettesResponsiveOpenCampusList_cassetteOpenCampusList.cassetteOpenCampusList, openCampusList, this.isSp, prDivisionFlag) : '';

        // 進路詳細(なるには)
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.SHISYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_SHISYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.QUOSYO:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_QUOSYO:
          return gakkoInfoList.length ? this.__adapterCreateCassets(_componentsCassettesResponsiveGakkoInfoList_cassetteGakkoInfoList.cassetteGakkoInfoList, gakkoInfoList, this.isSp, prDivisionFlag) : '';

        // 学校検索一覧
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.LIST_F_ALL:
        case _prAreaUtilities_prAreaUtilities.PAGE_ID.S_LIST_F_ALL:
          return searchIntegrationList.length ? this.__adapterCreateCassets(_componentsCassettesResponsiveSearchIntegrationList_cassetteSearchIntegrationList.cassetteSearchIntegrationList, searchIntegrationList, this.isSp, prDivisionFlag) : '';

        default:
          return '';
      }
    }

    /**
     * @private
     * @description 各種PR枠カセットHTMLの生成
     * @param {function} callback - カセット毎生成関数
     * @param {Array} cassetteList - カセット情報配列
     * @param {boolean} isSp - SP判定結果
     * @param {boolean} prDivisionFlag - 複数PR枠存在判定結果 Default = false
     * @returns {Array} - PR枠カセットHTML DOM配列化
     */
  }, {
    key: '__adapterCreateCassets',
    value: function __adapterCreateCassets(callback, cassetteList, isSp) {
      var prDivisionFlag = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      var resultCassetsArray = [];

      if (prDivisionFlag) {

        cassetteList.forEach(function (cassette) {
          resultCassetsArray.push(callback([cassette], isSp));
        });

        return resultCassetsArray;
      } else {
        resultCassetsArray.push(callback(cassetteList, isSp));

        return resultCassetsArray;
      }
    }
  }]);

  return PrArea;
})();

exports.PrArea = PrArea;
;

},{"../components/cassettes/pc/concernFieldEmpathyContents/_concernFieldEmpathycontents":114,"../components/cassettes/pc/concernFieldShinsetsu/_concernFieldShinsetsu":115,"../components/cassettes/pc/recommendSchoolInfo/_recommendSchoolInfo":116,"../components/cassettes/responsive/gakkoInfoList/_cassetteGakkoInfoList":117,"../components/cassettes/responsive/openCampusList/_cassetteOpenCampusList":118,"../components/cassettes/responsive/searchIntegrationList/_cassetteSearchIntegrationList":119,"./modules/searchListEvents/_searchListEvents":130,"./prAreaUtilities/_prAreaUtilities":134}],130:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _modulesAccordionSlideEvent_accordionSlideEventJs = require('./modules/accordionSlideEvent/_accordionSlideEvent.js');

var _modulesAddSwiperEvents_addSwiperEventsJs = require('./modules/addSwiperEvents/_addSwiperEvents.js');

var _modulesChangeItemOnClickTabEvent_changeItemOnClickTabEventJs = require('./modules/changeItemOnClickTabEvent/_changeItemOnClickTabEvent.js');

/**
 * 検索一覧画面用PR枠で生成されたDOMに付与するイベント群
 */
var searchListEvents = function searchListEvents() {
  (0, _modulesAddSwiperEvents_addSwiperEventsJs.addSwiperEvents)();
  (0, _modulesAccordionSlideEvent_accordionSlideEventJs.accordionSlideEvent)();
  (0, _modulesChangeItemOnClickTabEvent_changeItemOnClickTabEventJs.changeItemOnClickTabEvent)();
};

exports.searchListEvents = searchListEvents;

},{"./modules/accordionSlideEvent/_accordionSlideEvent.js":131,"./modules/addSwiperEvents/_addSwiperEvents.js":132,"./modules/changeItemOnClickTabEvent/_changeItemOnClickTabEvent.js":133}],131:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var accordionSlideEvent = function accordionSlideEvent() {
  return (0, _jquery2['default'])(function () {
    // 検索結果カセットアコーディオン開閉
    (0, _jquery2['default'])('[prarea-data-more-gakubugakka="trigger"]').on('click', function () {
      var logId = (0, _jquery2['default'])(this).attr('data-logId'),
          s2 = s_gi(s_account),
          $target = (0, _jquery2['default'])(this).closest('.prarea__searchResults__item').find('[prarea-data-more-gakubugakka="target"]');
      if ((0, _jquery2['default'])(this).hasClass('is-open')) {
        (0, _jquery2['default'])(this).removeClass('is-open');
        (0, _jquery2['default'])(this).text('もっと学部・学科・コースを見る');
        $target.slideUp(0, function () {});
        var $schoolCassette = (0, _jquery2['default'])(this).closest('.prarea__searchResults__item');
        (0, _jquery2['default'])('html,body').animate({
          scrollTop: $schoolCassette.offset().top
        }, 0);
      } else {
        s2.tl((0, _jquery2['default'])(this), 'o', logId);
        (0, _jquery2['default'])(this).addClass('is-open');
        (0, _jquery2['default'])(this).text('閉じる');
        $target.slideDown(function () {});
      }
    });

    // 検索結果カセット学部学科テキストを開く
    (0, _jquery2['default'])('[prarea-data-more-gakubugakka-text="trigger"]').on('click', function () {
      var $target = (0, _jquery2['default'])(this).next('[prarea-data-more-gakubugakka-text="target"]');

      $target.animate({
        width: 'show'
      }, 'slow');
      $target.children().unwrap();
      (0, _jquery2['default'])(this).remove();
    });

    //続きを見る押下で隠れている項目を表示
    (0, _jquery2['default'])('.js-prarea__searchResults__bunya__more-text').on('click', function () {
      (0, _jquery2['default'])(this).closest('.prarea__searchResults__bunya__text-container').find('.prarea__searchResults__bunya__text-hidden').slideToggle('fast');
      (0, _jquery2['default'])(this).toggleClass('is-open');
    });
  });
};

exports.accordionSlideEvent = accordionSlideEvent;

},{"jquery":97}],132:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

var addSwiperEvents = function addSwiperEvents() {
  return (0, _jquery2['default'])(function () {
    // OC swiperの処理
    (0, _jquery2['default'])('.js-prSearchOc-swiper').each(function () {
      var swiperContainer = (0, _jquery2['default'])(this).find('.swiper-container');
      new _swiper2['default'](swiperContainer[0], {
        slidesPerView: 'auto',
        freeMode: true,
        loop: false,
        autoplay: false,
        pagination: {
          el: (0, _jquery2['default'])(this).find('.swiper-pagination'),
          dynamicBullets: true,
          dynamicMainBullets: 3
        },
        navigation: {
          nextEl: (0, _jquery2['default'])(this).find('.swiper-button-next'),
          prevEl: (0, _jquery2['default'])(this).find('.swiper-button-prev')
        }
      });
    });
  });
};

exports.addSwiperEvents = addSwiperEvents;

},{"jquery":97,"swiper":100}],133:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var changeItemOnClickTabEvent = function changeItemOnClickTabEvent() {
  return (0, _jquery2['default'])(function () {
    // 初期表示
    var $tab = (0, _jquery2['default'])('.searchResults__tabName');
    (0, _jquery2['default'])('.prarea__searchResults__content').hide();

    (0, _jquery2['default'])(window).on('load resize', function () {
      // sessionStorageに表示項目データがある時は、表示切替タブのis-activeを付け替える
      if ('sessionStorage' in window && window.sessionStorage !== null) {
        var val = sessionStorage.getItem('sss_searchPanelActiveTab');
        if (val !== null) {
          $tab.eq(val).trigger('click.notSendLog');
          // sessionStorageの表示項目データを削除
          sessionStorage.removeItem('sss_searchPanelActiveTab');
        }
      }
      // 選択項目配下の内容を表示
      $tab.each(function (_, obj) {
        if ((0, _jquery2['default'])(obj).hasClass('is-active')) {
          (0, _jquery2['default'])(obj).trigger('click.notSendLog');
        }
      });

      // 学部学科未購入のみの場合、項目表示切替タブを削除
      if (!(0, _jquery2['default'])('.prarea__searchResults__gakkaList').length) {
        (0, _jquery2['default'])('.prarea__searchResults__tabsWrap').remove();
      }
    });

    // タブで表示項目切り替え
    $tab.on('click.notSendLog', function (event) {

      var $this = (0, _jquery2['default'])(event.target),
          logId = $this.attr('data-logId'),
          s2 = s_gi(s_account);

      // クリックログ送信
      if (event.namespace !== 'notSendLog') {
        if (!$this.hasClass('is-active')) {
          s2.tl($this, 'o', logId);
        }
      }

      var index = $tab.index($this);
      $tab.removeClass('is-active');
      $this.addClass('is-active');

      (0, _jquery2['default'])('.prarea__searchResults__gakkaList > li').each(function (_, obj) {
        var value = obj.className.match('prarea__searchResults__gakkaItem');
        if (value) {
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).hide();
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).eq(index).show();
          // 検索軸以外の小分類ハイライトを削除
          if (index !== flagAxis) {
            (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).eq(index).find('.prarea__searchResults__word').removeClass('is-match');
          }
        }
      });

      // 「もっと学部・学科・コースを見る」配下の項目表示
      (0, _jquery2['default'])('.prarea__searchResults__gakkaList > li > ul > li').each(function (_, obj) {
        var value = obj.className.match('prarea__searchResults__gakkaItem');
        if (value) {
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).hide();
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.prarea__searchResults__content')).eq(index).show();
        }
      });

      event.preventDefault();
    });
  });
};

exports.changeItemOnClickTabEvent = changeItemOnClickTabEvent;

},{"jquery":97}],134:[function(require,module,exports){
/**
 * [27卒 PR枠追加] PR枠 定数・汎用関数管理用JS
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const_mediaQuery = require("./const/_mediaQuery");

var _const_pageId = require("./const/_pageId");

var _modules_getDayOfWeekBackgroundColor = require("./modules/_getDayOfWeekBackgroundColor");

var _modules_getEmpathyContentsInfo = require("./modules/_getEmpathyContentsInfo");

var _modules_getMonthDayAndDayOfWeek = require("./modules/_getMonthDayAndDayOfWeek");

exports.getDayOfWeekBackgroundColor = _modules_getDayOfWeekBackgroundColor.getDayOfWeekBackgroundColor;
exports.
// TODO: 暫定でexportしているが、getEmpathyContentsInfoにまとめる予定
getEmpathyContentsBackgroundColor = _modules_getEmpathyContentsInfo.getEmpathyContentsBackgroundColor;
exports.getEmpathyContentsInfo = _modules_getEmpathyContentsInfo.getEmpathyContentsInfo;
exports.getMonthDayAndDayOfWeek = _modules_getMonthDayAndDayOfWeek.getMonthDayAndDayOfWeek;
exports.MediaQuery = _const_mediaQuery.MediaQuery;
exports.PAGE_ID = _const_pageId.PAGE_ID;

},{"./const/_mediaQuery":137,"./const/_pageId":138,"./modules/_getDayOfWeekBackgroundColor":139,"./modules/_getEmpathyContentsInfo":140,"./modules/_getMonthDayAndDayOfWeek":141}],135:[function(require,module,exports){
// OC一覧などで使用される、曜日ごと背景色
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var DAY_OF_WEEK_BACKGROUND_COLOR = {
  SATURDAY: '#61a2ed', // 土
  SUNDAY: '#de30ca', // 日
  DEFAULT: '#808d96' };

// 通常
exports.DAY_OF_WEEK_BACKGROUND_COLOR = DAY_OF_WEEK_BACKGROUND_COLOR;

},{}],136:[function(require,module,exports){
// 共感エリア用 ラベル背景色
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var EMPATHY_CONTENTS_BACKGROUND_COLOR = {
  LESSON: '#6036e0', // 授業
  SENSEI: '#199b7b', // 先生・教授
  CAMPUS: '#ff4b4b', // 在校生
  SENPAI: '#1565d9' // 卒業後
};

exports.EMPATHY_CONTENTS_BACKGROUND_COLOR = EMPATHY_CONTENTS_BACKGROUND_COLOR;

},{}],137:[function(require,module,exports){
// レスポンシブ対応画面用
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SP_SCREEN_WIDTH = 767;
var PC_SCREEN_WIDTH = 768;

var MediaQuery = {
  SP_SCREEN: "@media screen and (max-width: " + SP_SCREEN_WIDTH + "px)",
  PC_SCREEN: "@media screen and (min-width: " + PC_SCREEN_WIDTH + "px)"
};

exports.MediaQuery = MediaQuery;

/**
 * 【使用方法】
 * レスポンシブ対応が必要な画面のcss定義において、必要に応じて以下のように使用すると便利です。
 * ---------------------------
 * const sampleStyles = css`
*   height: 20px
*
*   ${MediaQuery.PC_SCREEN} {
*    font-size: 14px;
*    margin: 8px;
*   };
*
*   ${MediaQuery.SP_SCREEN} {
*    font-size: 12px;
*    margin: 4px;
*   };
* `;
* ---------------------------
* PC・SP両方でスタイルが当たる場合、記述時こそ手間はかかりますが、
* それぞれに記述することで、検証ツールでの確認の際に打ち消し線が現れなくなるため今後の確認が容易になります。
* 本ファイルからの import を忘れないように！
*
*/

},{}],138:[function(require,module,exports){
// 画面ID (画面htmlごとに定義しているグローバル変数`trace_p`の値)
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var PAGE_ID = {
  TOP01: 'Top01', // 進路トップ(PC)
  S_TOP01: 'STop01', // 進路トップ(SP)

  SHISYO: 'SHISYO', // 進路詳細(なるには)(PC)
  S_SHISYO: 'SShisyo', // 進路詳細(なるには)(SP)
  QUOSYO: 'QUOSYO', // 進路詳細（とるには）(PC)
  S_QUOSYO: 'SQuosyo', // 進路詳細（とるには）(SP)

  LIST_F_ALL: 'list_f_All', // 学校検索一覧(PC)
  S_LIST_F_ALL: 'Slist_f_All', // 学校検索一覧(SP)

  OP_GAKKO: 'OpGakko', // OC検索一覧　見学会_検索結果（エリア）見学会_検索結果（学校名）(PC)
  S_OP_GAKKO: 'SOpGakko', // OC検索一覧　見学会_検索結果（エリア）見学会_検索結果（学校名）(SP)
  OP_LIST: 'Oplist', // 見学会_検索結果(月,日)(PC)
  S_OP_LIST: 'SOplist', // 見学会_検索結果(月,日)(SP)
  OP_DAI: 'OpDai', // 見学会_検索結果（大短）(PC)
  S_OP_DAI: 'SOpDai', // 見学会_検索結果（大短）(SP)
  OP_SEN: 'OpSen', // 見学会_検索結果（専各）(PC)
  S_OP_SEN: 'SOpSen', // 見学会_検索結果（専各）(SP)
  OP_RYU: 'OpRyu', // 見学会_検索結果（留学）(PC)
  S_OP_RYU: 'SOpRyu', // 見学会_検索結果（留学）(SP)
  OP_SCL: 'OpScl', // 見学会_検索結果（その他教育機関）(PC)
  S_OP_SCL: 'SOpScl', // 見学会_検索結果（その他教育機関）(SP)

  NEW_F_LIST: 'Newflist', // 新増設一覧(PC)
  S_NEW_F_LIST: 'Snewflist', // 新増設一覧(SP)

  KYOKAN_TOP: 'KyokanTop', // 共感一覧(PC)
  S_KYOKAN_TOP: 'SKyokanTop', // 共感一覧(SP)

  GKUSYO: 'GKUSYO', // 学問詳細(PC)
  S_GKUSYO: 'Sgkusyo' };

// 学問詳細(SP)
exports.PAGE_ID = PAGE_ID;

},{}],139:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _const_dayOfWeekBackgroundColor = require("../const/_dayOfWeekBackgroundColor");

/**
 * @description OC一覧PR枠用 開催日の曜日に付与する背景色を取得する関数
 * @param {string} dayOfWeek - 曜日文字列(短縮系)
 * @return {string} 曜日に応じた背景色文字列
 */
var getDayOfWeekBackgroundColor = function getDayOfWeekBackgroundColor(dayOfWeek) {
  switch (dayOfWeek) {
    case '土':
      return _const_dayOfWeekBackgroundColor.DAY_OF_WEEK_BACKGROUND_COLOR.SATURDAY;
    case '日':
      return _const_dayOfWeekBackgroundColor.DAY_OF_WEEK_BACKGROUND_COLOR.SUNDAY;
    default:
      return _const_dayOfWeekBackgroundColor.DAY_OF_WEEK_BACKGROUND_COLOR.DEFAULT;
  }
};

exports.getDayOfWeekBackgroundColor = getDayOfWeekBackgroundColor;

},{"../const/_dayOfWeekBackgroundColor":135}],140:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const_empathyContentsBackgroundColor = require("../const/_empathyContentsBackgroundColor");

/**
 * @description 共感一覧用PR枠コンテンツの表示に必要な情報を、企業タイプごとに出しわけてまとめて返却する関数
 * @param {string} kyokan_type - `planningType`とも。企業タイプ
 * @return {object} 背景色、対応URL文字列、コンテンツ文字列などのオブジェクト
 */
var getEmpathyContentsInfo = function getEmpathyContentsInfo(kyokan_type) {
  return {
    "empathyBackgroundColor": getEmpathyContentsBackgroundColor(kyokan_type),
    "empathyContentUrlString": getContentTypeUrlString(kyokan_type),
    "empathyContentString": getContentString(kyokan_type)
  };
};

// TODO: response値準拠の実装に変える。
// 共感一覧画面のresponse値が定まっていないため併記している。
var getEmpathyContentsBackgroundColor = function getEmpathyContentsBackgroundColor(kyokan_type) {
  switch (kyokan_type) {
    case '1':
    case '在校生':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.CAMPUS;
    case '2':
    case '先生・教授':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.SENSEI;
    case '3':
    case '卒業後':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.SENPAI;
    case '4':
    case '授業':
      return _const_empathyContentsBackgroundColor.EMPATHY_CONTENTS_BACKGROUND_COLOR.LESSON;
    default:
      return '#fff';
  }
};

var getContentTypeUrlString = function getContentTypeUrlString(kyokan_type) {
  switch (kyokan_type) {
    case '1':
      // 在校生
      return 'campusLife';
    case '2':
      // 先生・教授
      return 'sensei';
    case '3':
      // 卒業生（先輩の仕事）
      return 'senpaiShigoto';
    case '4': // 授業
    default:
      return 'kokishin';
  };
};

var getContentString = function getContentString(kyokan_type) {
  switch (kyokan_type) {
    case '1':
      return '在校生';
    case '2':
      return '先生・教授';
    case '3':
      return '卒業生';
    case '4':
      return '授業';
    default:
      return '';
  };
};

// getEmpathyContentsBackgroundColor はAPIレスポンスの形式がfixし次第 exportから外す予定( getEmpathyContentsInfo に統合する )
exports.getEmpathyContentsInfo = getEmpathyContentsInfo;
exports.getEmpathyContentsBackgroundColor = getEmpathyContentsBackgroundColor;

},{"../const/_empathyContentsBackgroundColor":136}],141:[function(require,module,exports){
/**
 * @description `yymmdd` 形式の文字列 (例: 250331) から、日付と曜日を返却する
 * @param {string} dateString - 日付文字列
 * @return {object} 日付と曜日のオブジェクト
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getMonthDayAndDayOfWeek = function getMonthDayAndDayOfWeek(dateString) {

  var year = dateString.substring(0, 4);
  var month = parseInt(dateString.substring(4, 6), 10);
  var day = parseInt(dateString.substring(6, 8), 10);

  var dateObject = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
  var monthDayString = month + '/' + day;

  var options = {
    weekday: 'short',
    timeZone: 'Asia/Tokyo'
  };

  var dayOfWeek = dateObject.toLocaleDateString('ja-JP', options);

  return {
    monthDay: monthDayString,
    dayOfWeek: dayOfWeek
  };
};

exports.getMonthDayAndDayOfWeek = getMonthDayAndDayOfWeek;

},{}],142:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 38, stdin */\n.button[data-v-158bc8ba] {\n  display: block;\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding: 15px 16px;\n  color: #0ca5e6;\n  border: 1px solid;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  box-sizing: border-box;\n  cursor: pointer; }\n  /* line 53, stdin */\n  .button.is-small[data-v-158bc8ba] {\n    font-size: 14px;\n    border-radius: 4px;\n    line-height: 1;\n    font-weight: 700;\n    max-width: none; }\n  /* line 60, stdin */\n  .button.is-gray[data-v-158bc8ba] {\n    color: #808d96;\n    border: 1px solid #D3D4D4; }\n    @media (hover: hover) {\n      /* line 64, stdin */\n      .button.is-gray[data-v-158bc8ba]:hover {\n        opacity: 0.7; } }\n  /* line 69, stdin */\n  .button.is-bgWhite[data-v-158bc8ba] {\n    background-color: #ffffff; }")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    href: {
      type: String,
      required: false
    },
    modifierList: {
      type: Array,
      required: false
    }
  },
  computed: {
    classList: function classList() {
      if (!this.modifierList) return;
      return this.modifierList.map(function (modifier) {
        return modifier;
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",class:_vm.classList,attrs:{"href":_vm.href}},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-158bc8ba"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-158bc8ba", __vue__options__)
  } else {
    hotAPI.rerender("data-v-158bc8ba", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = showFavoriteToast;

var _component_sendClickLog = require("../../component/_sendClickLog");

function showFavoriteToast() {
  var snackbarHtml = "\n    <div class=\"favorite__snackbar js-favoriteSnackbar\">\n      <p class=\"favorite__snackbarText\">お気に入りに登録しました</p>\n      <div class=\"favorite__close\">\n        <a href=\"/smp2/quipMember/favorite/top/?favoriteSchool=hide\" class=\"favorite__snackbarTextLink js-snackbarTextLink\">マイページを見る</a>\n        <img src=\"/images/s/closeModal.png\" alt=\"\" class=\"favorite__close__img js-closeButton\" width=\"12\" height=\"12\">\n      </div>\n    </div>\n  ";

  var snackbarElement = document.querySelector(".js-favoriteSnackbar");
  var IS_DISPLAY = "isDisplay";

  // 初回のみ要素を作成
  if (!snackbarElement) {
    // トーストを挿入するターゲット要素を取得
    var targetElement = document.querySelector("#sindex");
    if (!targetElement) return;

    targetElement.insertAdjacentHTML("beforebegin", snackbarHtml);

    // 新たに作成されたスナックバー要素を再取得
    snackbarElement = document.querySelector(".js-favoriteSnackbar");
    // 下部吸着が表示されている場合は、トーストが被らないように調整する
    var displayFooterCart = document.querySelector(".js-fixFooterCart");
    if (displayFooterCart.classList.contains("is-show")) {
      snackbarElement.classList.add('favorite__snackbar--bottom80');
    }

    // マイページを見るを押下してクリックログを送信する
    var snackbarTextLinkElement = snackbarElement.querySelector(".js-snackbarTextLink");
    if (snackbarTextLinkElement) {
      snackbarTextLinkElement.addEventListener("click", function () {
        (0, _component_sendClickLog.sendLog)(window.s, 'SFavoriteRegisterToast_member_mypage_click_Slist_f_All');
      });
    }

    // バツボタンを押して消す処理
    var closeButtonElement = snackbarElement.querySelector(".js-closeButton");
    if (closeButtonElement) {
      closeButtonElement.addEventListener("click", function () {
        (0, _component_sendClickLog.sendLog)(window.s, 'SFavoriteRegisterToast_member_close_click_Slist_f_All');
        snackbarElement.classList.remove(IS_DISPLAY);
      });
    }
  }

  (0, _component_sendClickLog.sendLog)(window.s, 'SFavoriteRegisterToast_member_imp_Slist_f_All');

  // 少し時間を置いて画面にインさせる
  setTimeout(function () {
    snackbarElement.classList.add(IS_DISPLAY);
  }, 500);

  //表示アニメーション時間1秒 + 静止時間3秒で自動で消える
  setTimeout(function () {
    snackbarElement.classList.remove(IS_DISPLAY);
  }, 4000);
}

module.exports = exports["default"];

},{"../../component/_sendClickLog":111}],144:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 42, stdin */\n.menuListButton[data-v-0d42bdc0] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  padding: 16px 12px;\n  color: #24243F;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.5;\n  box-sizing: border-box;\n  position: relative; }\n  /* line 55, stdin */\n  .menuListButton[data-v-0d42bdc0]::after {\n    content: '';\n    position: absolute;\n    top: calc(50% - 8px);\n    display: inline-block;\n    right: 12px;\n    width: 11px;\n    height: 16px;\n    background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_xl.svg) no-repeat center; }\n  /* line 65, stdin */\n  .menuListButton.is-active[data-v-0d42bdc0] {\n    color: #0b41a0; }\n  /* line 68, stdin */\n  .menuListButton.is-nothing[data-v-0d42bdc0] {\n    color: #AFB8BE;\n    pointer-events: none; }\n    /* line 71, stdin */\n    .menuListButton.is-nothing[data-v-0d42bdc0]::after {\n      background: url(/images/responsive/Text_Disabled/arrow_textDisabled_lg.svg) no-repeat center; }\n  /* line 75, stdin */\n  .menuListButton.is-accordion[data-v-0d42bdc0] {\n    position: relative;\n    padding-right: 50px; }\n    /* line 78, stdin */\n    .menuListButton.is-accordion[data-v-0d42bdc0]::after {\n      content: '';\n      position: absolute;\n      top: calc(50% - 8px);\n      display: inline-block;\n      right: 12px;\n      width: 11px;\n      height: 16px;\n      background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_xl.svg) no-repeat center;\n      transition: .2s ease-in-out;\n      transform: rotate(90deg); }\n    /* line 90, stdin */\n    .menuListButton.is-accordion.is-accordion-open[data-v-0d42bdc0]::after {\n      transform: rotate(270deg); }\n  @media (hover: hover) {\n    /* line 95, stdin */\n    .menuListButton[data-v-0d42bdc0]:hover {\n      color: #0ca5e6;\n      text-decoration: underline; } }\n\n/* line 101, stdin */\n.activeLabel[data-v-0d42bdc0] {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  height: 20px;\n  margin-right: 27px;\n  padding: 2px 8px;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  border-radius: 4px;\n  background-color: #0b41a0; }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    href: {
      type: String,
      required: false
    },
    modifierList: {
      type: Array,
      required: false
    }
  },
  computed: {
    classList: function classList() {
      if (!this.modifierList) return;
      return this.modifierList.map(function (modifier) {
        return modifier;
      });
    },
    isActive: function isActive() {
      return this.classList.includes('is-active') || this.classList.includes('is-accordion-open');
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menuListButton",class:_vm.classList,attrs:{"href":_vm.href}},[_vm._t("default"),_vm._v(" "),(_vm.isActive)?_c('span',{staticClass:"activeLabel"},[_vm._v("選択中")]):_vm._e()],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-0d42bdc0"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d42bdc0", __vue__options__)
  } else {
    hotAPI.rerender("data-v-0d42bdc0", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],145:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 13, stdin */\n.menuListItem[data-v-0ba98bfe] {\n  border-bottom: 1px solid #E1E8EA; }")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menuListItem"},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-0ba98bfe"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ba98bfe", __vue__options__)
  } else {
    hotAPI.rerender("data-v-0ba98bfe", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = favoriteFlowline;

var _component_sendClickLog = require("../../component/_sendClickLog");

function favoriteFlowline(resultCode) {
  // トースト要素を作成
  var toastContainer = document.createElement("div");
  toastContainer.className = "popup__fukidashi__container";

  //トーストのDOM作成
  toastContainer.innerHTML = "\n    <div class=\"fukidashi__container js-fukidashi__container\" style=\"display: none;\">\n      <div class=\"fukidashi\">\n        <div class=\"fukidashi__header\">\n          <div class=\"fukidashi__textarea\">\n            <p class=\"fukidashi__text\">お気に入りはマイページトップから確認できます</p>\n            <div class=\"fukidashi__error js-fukidashi__error\" style=\"display: none;\">\n              <img class=\"fukidashi__errorimg\" src=\"/images/s/info.png\" alt=\"エラー情報のアイコン\" width=\"12\" height=\"12\" />\n              <p class=\"fukidashi__texterror\">\n                お気に入りの登録に問題がありました。マイページトップで内容を確認してください。\n              </p>\n            </div>\n          </div>\n          <button type=\"button\" class=\"fukidashi__header__close js-fukidashi__header__close\">\n            <img src=\"/images/s/closeModal.png\" alt=\"トースト閉じる\" width=\"12\" height=\"12\" />\n          </button>\n        </div>\n      </div>\n    </div>\n  ";

  document.body.appendChild(toastContainer);

  init(resultCode);
}

function init(resultCode) {
  var targetArray = [0, 1, 2];
  var fukidashiFlag = targetArray.includes(resultCode);
  if (fukidashiFlag) {
    updateFukidashiVisibleState(resultCode);
  }
}

// 吹き出しの表示・非表示を切り替える関数
function updateFukidashiVisibleState(resultCode) {
  var fukidashiContainerEl = document.querySelector('.js-fukidashi__container');
  var fukidashiErrorEl = document.querySelector('.js-fukidashi__error');
  var fukidashiHeaderCloseEl = document.querySelector('.js-fukidashi__header__close');

  var elementArray = [fukidashiContainerEl, fukidashiErrorEl, fukidashiHeaderCloseEl];
  var areAllTruthy = elementArray.every(function (value) {
    return Boolean(value);
  });

  // 一つでも要素が存在しない場合、処理を終了する
  if (!areAllTruthy) return;

  // 吹き出しを表示する
  fukidashiContainerEl.style.display = 'block';

  // 処理結果が「失敗: 1」または、「登録上限数超過あり: 2」の場合、「マイページ案内」吹き出し（エラーメッセージあり）を表示する
  if (resultCode === 1 || resultCode === 2) {
    fukidashiErrorEl.style.display = 'flex';
  }

  sendLogFukidashiVisible(resultCode, fukidashiContainerEl, fukidashiErrorEl);

  clickFukidashiCloseButton(fukidashiContainerEl, fukidashiHeaderCloseEl);
}

// 吹き出しの表示ログを送信する関数
function sendLogFukidashiVisible(resultCode, fukidashiContainerEl, fukidashiErrorEl) {
  if (resultCode === 0) {
    // 進路トップヘッダ吹き出し表出時
    (0, _component_sendClickLog.sendLog)(fukidashiContainerEl, 'SFavoriteBalloon_member_imp_STop01');
  } else if (resultCode === 1 || resultCode === 2) {
    // 進路トップヘッダ吹き出しエラー表出時
    (0, _component_sendClickLog.sendLog)(fukidashiErrorEl, 'SFavoriteBalloon_member_Error_STop01');
  }
}

// 吹き出しのクローズボタンをクリックした場合、以下の処理を実行する
function clickFukidashiCloseButton(fukidashiContainerEl, fukidashiHeaderCloseEl) {
  fukidashiHeaderCloseEl.addEventListener('click', function () {
    // 吹き出しを非表示にする
    fukidashiContainerEl.style.display = 'none';
    // クローズボタン押下時、クリックログを送信する
    (0, _component_sendClickLog.sendLog)(fukidashiContainerEl, 'SFavoriteBalloon_member_close_click_STop01');
  });
}
module.exports = exports["default"];

},{"../../component/_sendClickLog":111}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = showPopup;

var _sendClickLog = require('../_sendClickLog');

/**
 * ログイン状態とお気に入り学校のレスポンス内容に基づいてポップアップメッセージを表示
 *
 * @param {int} loginStatus - ユーザーのログイン状態。会員は0、非会員は1
 * @param {Object} setFavoriteGakkoResponse - お気に入り学校登録API(/smp2/quipMember/favorite/setFavoriteGakko)からのレスポンスデータ
 * @param {HTMLElement} targetElement - ポップアップの位置を基準にするターゲット要素
 *
 * @returns {void}
 *
 */

function showPopup(loginStatus, setFavoriteGakkoResponse, targetElement) {
  var isPrArea = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

  // ポップアップ要素を作成
  var popupContainer = document.createElement("div");
  popupContainer.className = "popup js-popup";

  // ポップアップの内容を設定
  var limitMessage = "";
  var memberMessage = "";
  var url = "/smp2/quipMember/auth/organicSignIn/";
  var buttonText = "ログイン・会員登録";
  var openLogName = ""; // ポップアップ表示時
  var closeLogName = ""; // ポップアップ×ボタン押下時
  var clickLogName = ""; // ポップアップ内ボタン押下時

  if (loginStatus === 0) {
    // 会員
    if (setFavoriteGakkoResponse.resultCode === 3) {
      limitMessage = "これ以上、お気に入りに登録できません";
      memberMessage = "お気に入りの登録上限は30校です";
      buttonText = "マイページを見る";
      url = "/smp2/quipMember/favorite/top/?favoriteSchool=hide";
      openLogName = "SFavoriteLimitBalloon_member_imp_Slist_f_All";
      closeLogName = "SFavoriteLimitBalloon_member_close_click_Slist_f_All";
      clickLogName = "SFavoriteLimitBalloon_member_mypage_click_Slist_f_All";
    }
  } else {
    // 非会員
    if (setFavoriteGakkoResponse.resultCode === 3) {
      limitMessage = "これ以上、お気に入りに登録できません";
      memberMessage = "ゲストユーザーの登録上限は2校です";
      openLogName = "SFavoriteLimitBalloon_nonmember_imp_Slist_f_All";
      closeLogName = "SFavoriteLimitBalloon_nonmember_close_click_Slist_f_All";
      clickLogName = "SFavoriteLimitBalloon_nonmember_login_click_Slist_f_All";
    } else if (setFavoriteGakkoResponse.resultCode === 1) {
      limitMessage = "ログイン・会員登録すると<br>お気に入りの編集が出来ます";
      openLogName = "SFavoriteEditBalloon_nonmember_imp_Slist_f_All";
      closeLogName = "SFavoriteEditBalloon_nonmember_close_click_Slist_f_All";
      clickLogName = "SFavoriteEditBalloon_nonmember_login_click_Slist_f_All";
    } else if (setFavoriteGakkoResponse.resultCode === 0) {
      openLogName = "SFavoriteRegisterBalloon_nonmember_imp_Slist_f_All";
      closeLogName = "SFavoriteRegisterBalloon_nonmember_close_click_Slist_f_All";
      clickLogName = "SFavoriteRegisterBalloon_nonmember_login_click_Slist_f_All";
    }
  }

  // ポップアップのDOM作成
  popupContainer.innerHTML = "\n    <div class=\"popup__block" + (isPrArea ? "--prArea" : "") + "\">\n      <div class=\"popup__head\">\n        <button type=\"button\" class=\"popup__closeButton js-closeButton\">\n          <img src=\"/images/s/closeModal.png\" alt=\"ポップアップ閉じるボタン\" width=\"12\" height=\"12\" />\n        </button>\n      </div>\n      <div class=\"popup__contents\">\n        <div class=\"popup__contents__wrap\">\n          " + (setFavoriteGakkoResponse.resultCode === 3 ? "<p class=\"popup__contents__limitMessage\">" + limitMessage + "</p>" : setFavoriteGakkoResponse.resultCode === 1 ? "<p class=\"popup__contents__donelimitMessage\">" + limitMessage + "</p>" : setFavoriteGakkoResponse.resultCode === 0 ? "" : "") + "\n          " + (memberMessage ? "<p class=\"popup__contents__memberMessage\">" + memberMessage + "</p>" : "") + "\n          " + (loginStatus === 0 ? "<div class=\"popup__contents__textBlock\">\n                  <p class=\"popup__contents__text\">すでに追加している学校を解除してから、<br>再度お気に入りへ追加してください。<br>マイページから編集ができます。</p>\n                </div>" : "<div class=\"popup__contents__textMediaBlock\">\n                  <div class=\"popup__contents__mainTextWrap\">\n                    <div class=\"popup__contents__textbox\">\n                      <img src=\"/images/s/nonMemberLine_left.png\" alt=\"\" class=\"popup__image\" width=\"12\" height=\"14\">\n                      <p class=\"popup__contents__textHead\">ログイン・会員登録をして</p>\n                      <img src=\"/images/s/nonMemberLine_right.png\" alt=\"\" class=\"popup__image\" width=\"12\" height=\"14\">\n                    </div>\n                    <p class=\"popup__contents__textHead\"><span class=\"popup__contents__textHead popup__contents__textHead--blue\">マイページ機能</span>を使ってみよう！</p>\n                  </div>\n                  <img src=\"/images/s/nonMember_favorite.png\" class=\"popup__contents__image\" width=\"222\" height=\"94\">\n                </div>") + "\n          " + (loginStatus === 1 ? "<div class=\"popup__contents__subTextWrap\">\n                  <p class=\"popup__contents__subText\">※</p>\n                  <p class=\"popup__contents__subText\">登録したお気に入りはログイン・会員登録後マイ<br>ページで確認できます</p>\n                </div>" : "") + "\n          <div class=\"popup__linkWrap\">\n            <a href=\"" + url + "\" class=\"popup__link js-popupLink\">" + buttonText + "</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  ";

  document.body.appendChild(popupContainer);
  // 通常学校カセットとレコメンド学校カセットのdom構造が違うため要素の取得が以下のようにしている
  var targetPoint = targetElement.querySelector(".js-favorite__container") || targetElement;

  // ポップアップの位置を更新する関数
  var updateToastPosition = function updateToastPosition() {
    var rect = targetPoint.getBoundingClientRect();
    // トーストの位置をハートの下に設定
    popupContainer.style.position = "absolute";
    popupContainer.style.top = rect.bottom + window.scrollY + 18 + "px";
  };

  // 初期位置の設定
  updateToastPosition();

  // リサイズ時にポップアップの位置を再計算
  window.addEventListener('resize', updateToastPosition);

  // ポップアップが閉じられた際にボタンを再度有効にする
  var closeButton = popupContainer.querySelector(".js-closeButton");
  closeButton.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    popupContainer.remove(); // ポップアップを削除
    targetElement.style.pointerEvents = 'auto'; // ボタンを再度有効にする
    (0, _sendClickLog.sendLog)(toastButton, closeLogName);
  });

  // ポップアップ内のボタン
  var toastButton = popupContainer.querySelector(".js-popupLink");
  toastButton.addEventListener("click", function (event) {
    event.preventDefault();
    (0, _sendClickLog.sendLog)(toastButton, clickLogName);
    window.location.href = toastButton.href;
  });

  // ポップアップが表示されている間、ボタンを無効にする
  targetElement.style.pointerEvents = 'none';
  (0, _sendClickLog.sendLog)(popupContainer, openLogName);
}

module.exports = exports["default"];

},{"../_sendClickLog":111}],148:[function(require,module,exports){
/**
 * 【案件】feat 97882 検索一覧画面カセット改修
 * 【ブランチ】feat-97882-検索一覧画面カセット改修
 * 【ファイル派生元】reset_html/design_html/webapp_src/js/assets/component/sp/_s_addCart.js
 * 【ファイル作成コミットID】bb7dc20bb58bf24e30b200244caf50e255002562
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

exports['default'] = (0, _jquery2['default'])(function () {
  var canRequest = true;

  /**
   * @desc 特定のDOMの高さを返す関数
   */
  var getOffsetHeight = function getOffsetHeight(selector) {
    var element = document.querySelector(selector);
    if (!element) return null;
    var height = element.offsetHeight;
    return height > 0 ? height : null;
  };

  /**
   * @desc 画面下に吸着するボタンの分、footerにpaddingを追加する関数
   */
  var footerStyleChange = function footerStyleChange() {
    var fixedFooterCartHeight = getOffsetHeight('.js-fixFooterCartHeight') || getOffsetHeight('.fixFooterCart');
    if (!fixedFooterCartHeight) return;

    var footer = document.querySelector('footer');
    footer.style.paddingBottom = fixedFooterCartHeight + 'px';
  };

  window.addEventListener('load', function () {
    footerStyleChange();
  });

  (0, _jquery2['default'])('[data-action="addMatometeList"]').bind("click", function () {

    var rootProductCd = this.getAttribute('data-rootProductCd');
    var timerId = setInterval(function () {
      if (canRequest) {
        clearInterval(timerId);
      }
      addMatometeList(rootProductCd);
    }, 1000);
    return false;
  });

  function addMatometeList(rootProductCd) {
    if (!canRequest) {
      return;
    }
    canRequest = false;
    _jquery2['default'].ajax({
      url: '/smp2/cart/addList/' + rootProductCd,
      dataType: 'json'
    }).done(function (data) {

      if (data.status) {
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').show();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').empty();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').html('まとめてリストに追加しました');

        if ('sessionStorage' in window && window.sessionStorage !== null) {
          var num = sessionStorage.getItem('matomete_list_count');
          var cnt = data.productClipSize;
          if (num == null || num != cnt) {
            var s2 = s_gi(s_account);
            s2.linkTrackVars = 'eVar27';
            s2.eVar27 = cnt;
            s2.tl(true, 'o', 'まとめてカウント');
            try {
              sessionStorage.setItem('matomete_list_count', cnt);
            } catch (err) {}
          }
        }
      } else if (data.hasLink) {
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').show();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リストに追加できる学校の上限は20件です。<br/>不要な学校をリストから削除して再度追加してください。');
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
      } else {
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').hide();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リスト追加に失敗しました。<br/>少し時間をおいて再度追加してください。');
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
      }

      setTimeout(function () {
        canRequest = true;
      }, 1000);
    }).fail(function () {
      (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
      (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').hide();
      (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リスト追加に失敗しました。<br/>少し時間をおいて再度追加してください。');
      setTimeout(function () {
        canRequest = true;
      }, 1000);
    });
    return false;
  }

  /**
   *学校TOP画像切替確認ログ
  */
  (0, _jquery2['default'])(function () {
    window.shingakunet = window.shingakunet || {};
    window.shingakunet.mainImageSlideFlg = false;
    //学校TOP_A画面ログ要件用イベント(左)
    (0, _jquery2['default'])('.imagegalleryAreaTop').find('.coda-nav-left').find('a').click(function () {
      if (!window.shingakunet.mainImageSlideFlg) {
        try {
          var s2 = s_gi(s_account);
          s2.tl(this, 'o', 'SGtop_main_image_slide');
        } catch (ex) {}
        window.shingakunet.mainImageSlideFlg = true;
      }
    });
    //学校TOP_A画面ログ要件用イベント(右)
    (0, _jquery2['default'])('.imagegalleryAreaTop').find('.coda-nav-right').find('a').click(function () {
      if (!window.shingakunet.mainImageSlideFlg) {
        try {
          var s2 = s_gi(s_account);
          s2.tl(this, 'o', 'SGtop_main_image_slide');
        } catch (ex) {}
        window.shingakunet.mainImageSlideFlg = true;
      }
    });
  });

  /**
   * ENH_2017_008 まとめてリスト追加ボタンUI改善
   */

  (0, _jquery2['default'])(function () {

    var cartOpenFlag = false;

    var addCart = function addCart(rootProductCd, $target) {
      if (!canRequest) {
        return;
      }
      canRequest = false;
      _jquery2['default'].ajax({
        url: '/smp2/cart/addList/' + rootProductCd,
        dataType: 'json'
      }).done(function (data) {
        var errorFlag = false;

        if (data.status) {

          // 共通ヘッダから現在のリスト件数を取得
          var $badge = (0, _jquery2['default'])('.topheaderRight--block--badge--count'),
              addCount = !$badge.length || $badge.text() === '' ? 1 : Number($badge.text()) + 1;

          if (!cartOpenFlag) {
            (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').show();
            (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').empty();
            (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').html('まとめてリストに追加しました');

            // 追加成功時は追加済みボタンに切り替える
            (0, _jquery2['default'])('[data-action="addCart"]').addClass('is-added');
            (0, _jquery2['default'])('[data-action="addCart"]').find('.i-addList').addClass('is-added');
            (0, _jquery2['default'])('[data-action="addCart"]').find('.m-button--slim').addClass('is-added');
            (0, _jquery2['default'])('[data-action="addCart"]').find('.m-button--otherHeader').addClass('is-added');

            // 追加成功時にフッターの吸着を（緑）に切り替える
            (0, _jquery2['default'])('.fixFooterCart__buttonFree').addClass('is-added');
            (0, _jquery2['default'])('.fixFooterCart__buttonCommon').addClass('is-added');
            (0, _jquery2['default'])('.fixFooterCart__badge').text(addCount);

            // 共通ヘッダのリスト件数を更新
            (0, _jquery2['default'])('.topheaderRight--block--badge').show();
            (0, _jquery2['default'])('.topheaderRight--block--badge--count').text(addCount);
          }

          if ('sessionStorage' in window && window.sessionStorage !== null) {
            var num = sessionStorage.getItem('matomete_list_count');
            var cnt = data.productClipSize;
            if (num == null || num != cnt) {
              var s2 = s_gi(s_account);
              s2.linkTrackVars = 'eVar27';
              s2.eVar27 = cnt;
              s2.tl(true, 'o', 'まとめてカウント');
              try {
                sessionStorage.setItem('matomete_list_count', cnt);
              } catch (err) {}
            }
          }
        } else if (data.hasLink) {
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').show();
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リストに追加できる学校の上限は20件です。<br/>不要な学校をリストから削除して再度追加してください。');
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
        } else {
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').hide();
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リスト追加に失敗しました。<br/>少し時間をおいて再度追加してください。');
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
        }

        setTimeout(function () {
          canRequest = true;
        }, 1000);
      }).fail(function () {
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').hide();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リスト追加に失敗しました。<br/>少し時間をおいて再度追加してください。');

        setTimeout(function () {
          canRequest = true;
        }, 1000);
      });

      return false;
    };
    // 一部アクションボタンはJSで複製されているため、liveでイベントをバインドする
    (0, _jquery2['default'])(document).on("click", '[data-action="addCart"]', function () {

      // 共通ヘッダから現在のリスト件数を取得
      var $badge = (0, _jquery2['default'])('.topheaderRight--block--badge--count'),
          addCount = !$badge.length || $badge.text() === '' ? 1 : Number($badge.text()) + 1;

      // 追加ボタン押下時にフッターの吸着を（緑）に切り替える
      (0, _jquery2['default'])('.fixFooterCart__buttonFree').addClass('is-added');
      (0, _jquery2['default'])('.fixFooterCart').attr('data-type', 'gakkoFooterFix').fadeIn();
      (0, _jquery2['default'])('.fixFooterCart__buttonFree.is-added').find('.fixFooterCart__badge').addClass('fixFooterCart__badge--anime');

      // 追加済みボタンが押下された場合、リスト件数を増加させない
      if ((0, _jquery2['default'])(this).hasClass('is-added')) {
        addCount = Number($badge.text());
      }

      (0, _jquery2['default'])('.fixFooterCart__badge').text(addCount);

      var logId = (0, _jquery2['default'])(this).attr('data-logId'),
          s2 = s_gi(s_account),
          $kosyaSeikyuBtnE = (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']");

      // ENH_2018_002 まとめて資料請求リスト訴求強化
      if ($kosyaSeikyuBtnE.length) {
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_BTN']").show();
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']").hide();
      };

      if ((0, _jquery2['default'])(this).find('.i-addList').hasClass('is-added')) {
        // 追加済みボタンが押下された場合はログ送信のみ行う
        s2.tl((0, _jquery2['default'])(this), 'o', logId + '_zumi');

        return false;
      } else {
        // ログ送信
        s2.tl((0, _jquery2['default'])(this), 'o', logId);
      }

      var rootProductCd = (0, _jquery2['default'])(this).attr('data-rootProductCd'),
          timerId = setInterval(function () {
        if (canRequest) {
          clearInterval(timerId);
        }
        addCart(rootProductCd);
      }, 1000);

      return false;
    });
  });

  /**
   * ENH_2018_001 まとめて資料請求リスト訴求強化
   */

  (0, _jquery2['default'])(function () {
    var cartOpenFlag = false;

    var addCart = function addCart(rootProductCd, $target) {
      if (!canRequest) {
        return;
      }
      canRequest = false;
      _jquery2['default'].ajax({
        url: '/smp2/cart/addList/' + rootProductCd,
        dataType: 'json'
      }).done(function (data) {
        var errorFlag = false;

        if (data.status) {
          // 共通ヘッダから現在のリスト件数を取得
          var $badge = (0, _jquery2['default'])('.topheaderRight--block--badge--count'),
              addCount = !$badge.length || $badge.text() === '' ? 1 : Number($badge.text()) + 1,
              gakkoCd = $target.attr('data-school');

          if (!cartOpenFlag) {
            (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').show();
            (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').empty();
            (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').html('まとめてリストに追加しました');

            // 追加成功時は追加済みボタンに切り替える
            $target.closest('[data-cart="button"]').addClass('is-added');

            // 押下したボタンと同一の学校CDを持つボタンがあれば同時に切り替える
            (0, _jquery2['default'])('[data-school=' + gakkoCd + ']').closest('[data-cart="button"]').addClass('is-added');

            // フッターの吸着の表示／非表示の制御下から外す
            (0, _jquery2['default'])('.fixFooterCart').attr('data-type', 'gakkoFooterFix');
            (0, _jquery2['default'])('.fixFooterCart').show();

            // フッターの吸着を表示させる
            (0, _jquery2['default'])('.fixFooterCart__buttonCommon').addClass('is-added');
            (0, _jquery2['default'])('.fixFooterCart').addClass('is-show');
            (0, _jquery2['default'])('.fixFooterCart__badge').text(addCount);

            // フッター吸着後にfooter要素へ高さを追加
            footerStyleChange();

            // 共通ヘッダのリスト件数を更新
            (0, _jquery2['default'])('.topheaderRight--block--badge').show();
            (0, _jquery2['default'])('.topheaderRight--block--badge--count').text(addCount);
          }

          if ('sessionStorage' in window && window.sessionStorage !== null) {
            var num = sessionStorage.getItem('matomete_list_count');
            var cnt = data.productClipSize;
            if (num == null || num != cnt) {
              var s2 = s_gi(s_account);
              s2.linkTrackVars = 'eVar27';
              s2.eVar27 = cnt;
              s2.tl(true, 'o', 'まとめてカウント');
              try {
                sessionStorage.setItem('matomete_list_count', cnt);
              } catch (err) {}
            }
          }

          // B・Dパターンの場合はリストに遷移
          if (cartOpenFlag) {
            location.href = '/smp2/cart/list';
          }
        } else if (data.hasLink) {
          errorFlag = true;

          (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').show();
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リストに追加できる学校の上限は20件です。<br/>不要な学校をリストから削除して再度追加してください。');
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
        } else {
          errorFlag = true;

          (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').hide();
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リスト追加に失敗しました。<br/>少し時間をおいて再度追加してください。');
          (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
        }

        if (!cartOpenFlag || errorFlag) {
          setTimeout(function () {
            canRequest = true;
          }, 1000);
        } else {
          setTimeout(function () {
            canRequest = true;
          }, 1000);
        }
      }).fail(function () {
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__info"]').empty();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__link"]').hide();
        (0, _jquery2['default'])('[data-type="fixHeaderAlert__error"]').html('リスト追加に失敗しました。<br/>少し時間をおいて再度追加してください。');

        setTimeout(function () {
          canRequest = true;
        }, 1000);
      });

      return false;
    };

    // 一部アクションボタンはJSで複製されているため、liveでイベントをバインドする
    (0, _jquery2['default'])(document).on("click", '[data-action="addCartOnly"], [data-action="addCartAndOpen"]', function () {
      var action = (0, _jquery2['default'])(this).attr('data-action'),
          logId = (0, _jquery2['default'])(this).attr('data-logId'),
          s2 = s_gi(s_account),
          $kosyaSeikyuBtnE = (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']");

      if (action === 'addCartAndOpen') {
        cartOpenFlag = true;
      }

      // 追加時のボタンアニメーション
      (0, _jquery2['default'])(document).ajaxComplete(function () {
        var $footerCartBtnBadge = (0, _jquery2['default'])('.fixFooterCart__buttonCommon.is-added').find('.fixFooterCart__badge');
        $footerCartBtnBadge.addClass('fixFooterCart__badge--anime');
        $footerCartBtnBadge.on('animationend', function (e) {
          (0, _jquery2['default'])(e.target).removeClass('fixFooterCart__badge--anime');
        });
      });

      // ENH_2018_002 まとめて資料請求リスト訴求強化
      if ($kosyaSeikyuBtnE.length) {
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_BTN']").show();
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']").hide();
      };

      // 追加済みボタンを押した場合
      if ((0, _jquery2['default'])(this).closest('[data-cart="button"]').hasClass('is-added')) {

        var $target = (0, _jquery2['default'])(this).closest('[data-type="footerButton"]');
        // 緑色ボタン（＝吸着かつ追加済みボタンの場合）
        if ($target.length != 0) {
          s2.tl((0, _jquery2['default'])(this), 'o', logId + '_zumi');
          location.href = '/smp2/cart/list';
        }
        // 灰色ボタン（＝中段にあるボタンかつ追加済みの場合）
        else {
            s2.tl((0, _jquery2['default'])(this), 'o', logId + '_zumi');
          }
        // 追加済みボタンが押下された場合は以降の処理を行わない
        return false;
      }
      // 追加ボタンを押した場合
      else {
          s2.tl((0, _jquery2['default'])(this), 'o', logId);
        }

      var $_self = (0, _jquery2['default'])(this),
          rootProductCd = (0, _jquery2['default'])(this).attr('data-rootProductCd'),
          timerId = setInterval(function () {
        if (canRequest) {
          clearInterval(timerId);
        }
        addCart(rootProductCd, $_self);
      });

      return false;
    });

    // ENH_2018_002 まとめて資料請求リスト訴求強化
    if ((0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']").length) {
      var url = (0, _jquery2['default'])('.l-footerFix.hide a').eq(0).attr('href');
      (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']").attr("href", url);
    }
  });

  // bfcache対策
  // まとめてリスト追加ボタンが表出する場合のみ

  if (window.browserBackEnableFlag != null && window.browserBackEnableFlag) {
    window.onunload = function () {};
    window.onpageshow = function (e) {
      if (e.persisted) {
        window.location.reload();
      }
    };
  }
});
module.exports = exports['default'];

},{"jquery":97}],149:[function(require,module,exports){
/**
 * 案件:27卒レスポンシブ対応
 * 本件でテレメールと願書ボタンは削除となるが、工数の兼ね合いでFE側、開発側共に既存仕様からコードの修正を行わないこととなった。（API自体の変更は行わず、レスポンスデータでテレメール、願書が表示する条件のデータが返却されない想定）
 * そのため、下記コード上ではテレメールと願書ボタンに関する記述は一部残ったままとなっています。削除を行う際は必ず開発側とAPIのレスポンスデータについて会話の上対応してください。
 * 
 * 案件:【アクション】ENH_SP_検索一覧個社TOP_お気に入り登録導線追加
 * ファイル派生元:reset_html/design_html/webapp_src/js/assets/component/sp/_s_asyncRecommend.js
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _this2 = this;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

// APIのレスポンスを受け取るグローバル変数
var gakkoRecommendsResponse = {};

// APIからデータを取得し、オブザーバーを設定する
var initGakkoRecommend = function initGakkoRecommend() {
  var _ret, _ret2;

  return regeneratorRuntime.async(function initGakkoRecommend$(context$1$0) {
    var _this = this;

    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.prev = 0;
        context$1$0.next = 3;
        return regeneratorRuntime.awrap((function callee$1$0() {
          var gakkoCds, htmlArray, jsGakkoRecommends;
          return regeneratorRuntime.async(function callee$1$0$(context$2$0) {
            while (1) switch (context$2$0.prev = context$2$0.next) {
              case 0:
                context$2$0.next = 2;
                return regeneratorRuntime.awrap(fetchGetGakkoRecommends());

              case 2:
                if (!(!gakkoRecommendsResponse || gakkoRecommendsResponse.recommendGakkoInfoList.length === 0)) {
                  context$2$0.next = 4;
                  break;
                }

                return context$2$0.abrupt('return', {
                  v: undefined
                });

              case 4:
                gakkoCds = gakkoRecommendsResponse.recommendGakkoInfoList.map(function (gakko) {
                  return gakko.gakkoCd;
                });
                htmlArray = createHTML(gakkoRecommendsResponse);
                jsGakkoRecommends = document.querySelectorAll('.js-gakkoRecommendItem');

                if (jsGakkoRecommends) {
                  context$2$0.next = 9;
                  break;
                }

                return context$2$0.abrupt('return', {
                  v: undefined
                });

              case 9:
                jsGakkoRecommends.forEach(function (target, index) {
                  setGakkoHtmlToScreen(htmlArray[index], target);
                  if (index === 0) {
                    target.classList.add('inview-log', 'js-isInViewRecommend');
                    target.dataset.inviewLog = 'Slist_recommend_displayed';
                  }
                  target.setAttribute("data-index", index + 1);
                  gakkoCds.forEach(function (gakkoCd, gakkoCdIndex) {
                    if (index === gakkoCdIndex) {
                      target.setAttribute("data-gakkocd", gakkoCd);
                    }
                  });
                  target.classList.add("js-cassetteInView");
                  target.classList.remove('searchResults__item__loadingArea');
                });
                cartModule();

              case 11:
              case 'end':
                return context$2$0.stop();
            }
          }, null, _this);
        })());

      case 3:
        _ret = context$1$0.sent;

        if (!(typeof _ret === 'object')) {
          context$1$0.next = 6;
          break;
        }

        return context$1$0.abrupt('return', _ret.v);

      case 6:
        context$1$0.next = 13;
        break;

      case 8:
        context$1$0.prev = 8;
        context$1$0.t0 = context$1$0['catch'](0);

        _ret2 = (function () {
          //エラー用のhtmlを表示する
          var errorHtml = createErrorHTML();
          var jsGakkoRecommends = document.querySelectorAll('.js-gakkoRecommendItem');
          if (!jsGakkoRecommends) return {
              v: undefined
            };
          jsGakkoRecommends.forEach(function (target) {
            setGakkoHtmlToScreen(errorHtml, target);
          });
        })();

        if (!(typeof _ret2 === 'object')) {
          context$1$0.next = 13;
          break;
        }

        return context$1$0.abrupt('return', _ret2.v);

      case 13:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this2, [[0, 8]]);
};

// APIから学校レコメンドのデータを取得
var fetchGetGakkoRecommends = function fetchGetGakkoRecommends() {
  var apiUrl, recommendDispGakkoCdList, params, response;
  return regeneratorRuntime.async(function fetchGetGakkoRecommends$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        apiUrl = '/searchList/recommendGakkoInfo/';
        recommendDispGakkoCdList = window.recommendDispGakkoCdList;
        params = {
          recommendDispGakkoCdList: recommendDispGakkoCdList
        };
        context$1$0.next = 5;
        return regeneratorRuntime.awrap(fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(params)
        }));

      case 5:
        response = context$1$0.sent;

        if (response.ok) {
          context$1$0.next = 8;
          break;
        }

        throw new Error('API response not OK');

      case 8:
        context$1$0.next = 10;
        return regeneratorRuntime.awrap(response.json());

      case 10:
        gakkoRecommendsResponse = context$1$0.sent;

      case 11:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this2);
};

// APIから取得した情報からhtmlを作成する
var createHTML = function createHTML(gakkoRecommendsResponse) {
  var htmlArray = [];
  var gakkoRecommends = gakkoRecommendsResponse.recommendGakkoInfoList;
  gakkoRecommends.forEach(function (gakkoRecommend) {
    var html = '';
    if (gakkoRecommend.teleFlag) {
      html = htmlGenerators.wrapperHTML(htmlGenerators.createSchoolHeaderHTML(gakkoRecommend), htmlGenerators.createTeleBtnHTML(gakkoRecommend), htmlGenerators.createSchoolTextHTML(gakkoRecommend));
    } else {
      html = htmlGenerators.wrapperHTML(htmlGenerators.createSchoolHeaderHTML(gakkoRecommend), htmlGenerators.createPamphGanshoBtnHTML(htmlGenerators.createPamphBtnHTML(gakkoRecommend), htmlGenerators.createShiryoBtnHTML(gakkoRecommend)), htmlGenerators.createSchoolTextHTML(gakkoRecommend));
    }
    htmlArray.push(html);
  });
  return htmlArray;
};

// 各学校のレコメンドを生成するための関数群
var htmlGenerators = {
  // カセット内の情報を合わせたhtmlを生成するラッパー関数
  wrapperHTML: function wrapperHTML(createSchoolHeaderHTML, createActionBtnHTML, createSchoolTextHTML) {
    return '\n      <div class="searchResults__schoolBlock searchResults__schoolBlock--recomend">\n        ' + (createSchoolHeaderHTML || '') + '\n        ' + (createSchoolTextHTML || '') + '\n        ' + (createActionBtnHTML || '') + '\n      </div>\n    ';
  },

  // カセット上部の学校情報作成
  createSchoolHeaderHTML: function createSchoolHeaderHTML(gakkoRecommend) {
    return '\n    <div class="searchResults__schoolHeader">\n      <a href="/gakko/' + gakkoRecommend.gakkoCd + '/" onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Slist_f_All_absorb_Gtop\');clickRecommendProp49(\'' + gakkoRecommend.gakkoCd + '\');" class="searchResults__item__schoolLink">\n        <div class="searchResults__item__schoolInfo">\n          <div class="searchResults__item__schoolInfo__left">\n            <div class="searchResults__item__favorite">\n              <h2 class="searchResults__item__schoolName">' + gakkoRecommend.gakkoNm + '</h2>\n              <button class="searchResultsrecom__item__container js-favorite__container js-favorite__click" style="visibility: hidden;">\n                <img class="searchResults__item__favorite__heart js-favorite__heart js-favorite__clickheart" src="/images/s/s_icon_nofavorite.png" alt="お気に入り" width="20" height="18" />\n              </button>\n            </div>\n            <div class="searchResults__item__nyushiInfo">\n              <img class="searchResults__item__icon" src="/images/s/searchList_school_icon.svg" alt="" srcset="">\n              <div class="searchResults__item__textWrap">\n                ' + (gakkoRecommend.shinsetsuComment ? '<p class="searchResults__item__schoolType">' + gakkoRecommend.shinsetsuComment + '</p>' : '') + '\n                ' + (gakkoRecommend.semmonshokuKbnNm ? '<p class="searchResults__item__schoolType">' + gakkoRecommend.semmonshokuKbnNm + '／' + gakkoRecommend.koshuNm + '／' + gakkoRecommend.todofukenRnm + '</p>' : '<p class="searchResults__item__schoolType">' + gakkoRecommend.koshuNm + '／' + gakkoRecommend.todofukenRnm + '</p>') + '\n              </div>\n            </div>\n            ' + (gakkoRecommend.gakkoPhoto ? '\n            <div class="searchResults__item__schoolImgArea">\n              <div class="searchResults__item__schoolImgAreaContents">\n                <div class="searchResults__item__schoolImgAreaContentsItem">\n                  ' + (gakkoRecommend.gakkoPhoto ? '<img src="' + gakkoRecommend.gakkoPhoto + '" data-src="' + gakkoRecommend.gakkoPhoto + '" alt="" width="85" height="58" class="searchResults__item__schoolTopImg">' : '') + '\n                </div>\n              </div>\n            </div>' : '') + '\n          </div> \n        </div>\n      </a>\n    </div>\n  ';
  },

  // テレメールが無い時のアクションボタン作成
  createPamphGanshoBtnHTML: function createPamphGanshoBtnHTML(createPamphBtnHTML, createShiryoBtnHTML) {
    // ボタン要素が１つもない場合は、div毎削除する
    if (!createPamphBtnHTML && !createShiryoBtnHTML) {
      return '';
    }

    var buttonCount = (createPamphBtnHTML ? 1 : 0) + (createShiryoBtnHTML ? 1 : 0);
    var buttonClass = buttonCount === 1 ? 'searchResults__buttons searchResults__buttons--one' : 'searchResults__buttons';
    // ボタン要素が１つもない場合は、div毎削除する
    return '\n      <div class="' + buttonClass + '">\n        ' + (createPamphBtnHTML || '') + '\n        ' + (createShiryoBtnHTML || '') + '\n      </div>\n    ';
  },

  // テレメールがある時のアクションボタン
  createTeleBtnHTML: function createTeleBtnHTML(gakkoRecommend) {
    return '\n    <div class="searchResults__buttons">\n      <div class="searchResults__buttons__left">\n        <a href="/smp2/telemail/info/' + gakkoRecommend.gakkoCd + '" class="disBk" onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Ssearch_result_list_' + (gakkoRecommend.isYuryoGakko ? "base" : "next") + '\');clickRecommendProp49(\'' + gakkoRecommend.gakkoCd + '\');">パンフ・願書<br>をもらう</a>\n      </div>\n    </div>\n  ';
  },

  //パンフボタン
  createPamphBtnHTML: function createPamphBtnHTML(gakkoRecommend) {
    return gakkoRecommend.pamphFlag ? '\n      <div class="searchResults__buttons__left">\n        <a href="/smp2/shiryoSeikyu/entry/input?shiryoShubetsu=01&seikyuShubetsu=0&yuryoDispFlag=1&gakkoCd=' + gakkoRecommend.gakkoCd + '&pCd=' + gakkoRecommend.pCd + '" class="searchResults__buttons__panf" onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Ssearch_result_list_' + (gakkoRecommend.isYuryoGakko ? "base" : "next") + '_panf\');clickRecommendProp49(\'' + gakkoRecommend.gakkoCd + '\');">\n          <div class="searchResults__buttons__text">\n            パンフをもらう\n          </div>\n        </a>\n      </div>\n    ' : '';
  },

  // 願書ボタン
  createGanshoBtnHTML: function createGanshoBtnHTML(gakkoRecommend) {
    return gakkoRecommend.ganshoFlag ? '\n      <div class="searchResults__buttons__left">\n        <a href="/smp2/shiryoSeikyu/entry/input?shiryoShubetsu=02&seikyuShubetsu=0&yuryoDispFlag=1&gakkoCd=' + gakkoRecommend.gakkoCd + '&pCd=' + gakkoRecommend.pCd + '" onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Ssearch_result_list_' + (gakkoRecommend.isYuryoGakko ? "base" : "next") + '_gansho\');clickRecommendProp49(\'' + gakkoRecommend.gakkoCd + '\');">\n          <div class="searchResults__buttons__left__inner">\n            <span>願書をもらう</span>\n          </div>\n        </a>\n      </div>\n    ' : '';
  },

  // 資料請求ボタン
  createShiryoBtnHTML: function createShiryoBtnHTML(gakkoRecommend) {
    // 通常校かつテレメールがないかつパンフまたは願書がある場合は資料カートボタンを表示する
    return gakkoRecommend.isRegularGakko && !gakkoRecommend.teleFlag && (gakkoRecommend.pamphFlag || gakkoRecommend.ganshoFlag) ? '\n      <div class="searchResults__buttons__right">\n        <a href="#" class="searchResults__buttons__cart" data-action="addCartOnly" data-school="' + gakkoRecommend.gakkoCd + '" data-rootproductcd="' + gakkoRecommend.rootProductCd + '" onclick="var s2=s_gi(s_account);s2.tl(this,\'o\',\'Slist_f_All_absorb_cart\');clickRecommendProp49(\'' + gakkoRecommend.gakkoCd + '\');"></a>\n      </div>\n    ' : '';
  },

  // 学校コメント
  createSchoolTextHTML: function createSchoolTextHTML(gakkoRecommend) {
    return gakkoRecommend.gakkoHowKomidashi ? '\n    <p class="searchResults__item__schoolText">' + gakkoRecommend.gakkoHowKomidashi + '</p>\n    ' : '';
  }
};

// エラー表示のhtmlを生成
var createErrorHTML = function createErrorHTML() {
  return '\n  <div class="searchResults__item__loadingError">\n    コンテンツを読み込めませんでした。<br>\n    再度ページを読み込んでください。\n  </div>';
};

// 生成されたHTMLを画面の適切な位置に挿入
var setGakkoHtmlToScreen = function setGakkoHtmlToScreen(html, targetElement) {
  targetElement.innerHTML = html;
};

// カート処理 "/component/sp/_s_cartNumber.js"を転記
var cartModule = function cartModule() {
  return _jquery2['default'].ajax({
    url: '/smp2/cart/clipList',
    type: 'POST',
    dataType: 'json'
  }).done(function (data) {
    // ここにデータを処理するコードを記述します
    var $footerCart = (0, _jquery2['default'])('.fixFooterCart');
    var $kosyaSeikyuBtnE = (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']");

    if (data.data.length >= 1) {
      (0, _jquery2['default'])('.topheaderRight--block--badge').show();
      (0, _jquery2['default'])('.topheaderRight--block--badge--count').text(data.data.length);

      // ENH_2018_001 まとめて資料請求リスト訴求強化
      if ($footerCart.length) {
        // 個社下のアクションボタンの吸着を消す
        (0, _jquery2['default'])('.l-footerFix').addClass('hide').removeAttr('data-type');

        // フッターの吸着の表示／非表示の制御下から外す
        $footerCart.attr('data-type', 'gakkoFooterFix');
        $footerCart.removeAttr('style');

        // フッターの吸着を表示させる
        $footerCart.find('.fixFooterCart__button, .fixFooterCart__buttonFree').addClass('is-added');
        $footerCart.addClass('is-show');
        $footerCart.find('.fixFooterCart__badge').text(data.data.length);
      }

      // ENH_2018_002 まとめて資料請求リスト訴求強化
      if ($kosyaSeikyuBtnE.length) {
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_BTN']").show();
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']").hide();
      }
    } else {
      // ENH_2018_001 まとめて資料請求リスト訴求強化
      if ($footerCart.length) {
        var pamphUrl = $footerCart.attr('data-pamph'),
            ganshoUrl = $footerCart.attr('data-gansho'),
            telemailUrl = $footerCart.attr('data-telemail');

        if (telemailUrl !== '' || pamphUrl === '' && ganshoUrl === '' && telemailUrl === '') {
          // テレメール校 or パンフ、願書、テレメールいずれも持たない学校の場合は新デザインの吸着を消す
          $footerCart.removeClass('is-show').removeAttr('style').removeAttr('data-type');
        } else {
          // 個社下のアクションボタンの吸着を消す
          (0, _jquery2['default'])('.l-footerFix').addClass('hide').removeAttr('style').removeAttr('data-type');
        }
      }
      // ENH_2018_002 まとめて資料請求リスト訴求強化
      if ($kosyaSeikyuBtnE.length) {
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_BTN']").hide();
        (0, _jquery2['default'])("[data-btn-name='SMATOME_2018_02_E_BTN']").show();
      }
    }

    //まとめてリスト追加ボタンの表示制御をレスポンスデータと付き合わせて行う
    //追加済みの学校は、リスト追加ボタンを追加済みボタンに切り替える
    (0, _jquery2['default'])('[data-action="addMatometeListOpen"]').each(function () {
      if (_jquery2['default'].inArray(this.getAttribute('data-school'), data.data) !== -1) {
        //追加完了ボタン
        (0, _jquery2['default'])(this).find('.addList--default').addClass('addList--marked').removeClass('addList--default');
      }
      (0, _jquery2['default'])(this).parent().css('visibility', 'visible');
    });

    // ENH_2017_008 まとめてリスト追加ボタンUI改善
    // 追加済みの学校は、まとめてリスト追加ボタンを追加済みボタンに切り替える
    (0, _jquery2['default'])('[data-action="addCart"]').each(function () {
      if (_jquery2['default'].inArray(this.getAttribute('data-school'), data.data) !== -1) {
        //追加完了ボタン
        (0, _jquery2['default'])(this).addClass('is-added');
        (0, _jquery2['default'])(this).find('.i-addList').addClass('is-added');
        (0, _jquery2['default'])(this).find('.m-button--slim').addClass('is-added');
        (0, _jquery2['default'])(this).find('.m-button--otherHeader').addClass('is-added');
      }
    });

    // ENH_2018_001 まとめて資料請求リスト訴求強化
    (0, _jquery2['default'])('[data-action="addCartOnly"], [data-action="addCartAndOpen"]').each(function () {
      var gakkoCd = (0, _jquery2['default'])(this).attr('data-school');

      if (_jquery2['default'].inArray(gakkoCd, data.data) !== -1) {
        //追加完了ボタン
        (0, _jquery2['default'])(this).closest('[data-cart="button"]').addClass('is-added');
        (0, _jquery2['default'])('[data-school="' + gakkoCd + '"]').closest('[data-cart="button"]').addClass('is-added');
      }
    });

    if ('sessionStorage' in window && window.sessionStorage !== null) {
      var num = sessionStorage.getItem('matomete_list_count');
      var cnt = data.data.length;
      if (num == null || num != cnt) {
        var s2 = s_gi(s_account);
        s2.linkTrackVars = 'eVar27';
        s2.eVar27 = cnt;
        s2.tl(true, 'o', 'まとめてカウント');
        try {
          sessionStorage.setItem('matomete_list_count', cnt);
        } catch (err) {}
      }
    }
  }).fail(function () {
    // エラー時の処理を記述します
    var $footerCart = (0, _jquery2['default'])('.fixFooterCart');

    if ($footerCart.length) {
      var telemailUrl = $footerCart.attr('data-telemail');

      if (telemailUrl !== '') {
        // テレメール校の場合は新デザインの吸着を消す
        $footerCart.removeClass('is-show').removeAttr('style').removeAttr('data-type');
      } else {
        // 個社下のアクションボタンの吸着を消す
        (0, _jquery2['default'])('.l-footerFix').addClass('hide').removeAttr('style').removeAttr('data-type');
      }
    }
  });
};

exports.initGakkoRecommend = initGakkoRecommend;

// レスポンスデータからhtmlを作成

// APIリクエストに必要なデータを取得（"recommendDispGakkoCdList"はvmで定義）

},{"jquery":97}],150:[function(require,module,exports){
'use strict';

var $ = require('jquery');

$(function () {
	var cartNumberInterval = window.setInterval(function () {
		// 非同期処理直列化 ajaxFlagはグローバル変数で、非同期処理実行判定フラグとして用いている
		if (!window.ajaxFlag) return;
		window.ajaxFlag = false;
		$.ajax({
			url: '/smp2/cart/clipList',
			type: 'POST',
			dataType: 'json'
		}).done(function (data) {
			var $footerCart = $('.fixFooterCart');
			var $kosyaSeikyuBtnE = $("[data-btn-name='SMATOME_2018_02_E_BTN']");

			if (data.data.length >= 1) {
				$('.topheaderRight--block--badge').show();
				$('.topheaderRight--block--badge--count').text(data.data.length);

				// ENH_2018_001 まとめて資料請求リスト訴求強化
				if ($footerCart.length) {
					// 個社下のアクションボタンの吸着を消す
					$('.l-footerFix').addClass('hide').removeAttr('data-type');

					// フッターの吸着の表示／非表示の制御下から外す
					$footerCart.attr('data-type', 'gakkoFooterFix');
					$footerCart.removeAttr('style');

					// フッターの吸着を表示させる
					$footerCart.find('.fixFooterCart__button, .fixFooterCart__buttonFree').addClass('is-added');
					$footerCart.addClass('is-show');
					$footerCart.find('.fixFooterCart__badge').text(data.data.length);
				}

				// ENH_2018_002 まとめて資料請求リスト訴求強化
				if ($kosyaSeikyuBtnE.length) {
					$("[data-btn-name='SMATOME_2018_02_BTN']").show();
					$("[data-btn-name='SMATOME_2018_02_E_BTN']").hide();
				}
			} else {
				// ENH_2018_001 まとめて資料請求リスト訴求強化
				if ($footerCart.length) {
					var pamphUrl = $footerCart.attr('data-pamph'),
					    ganshoUrl = $footerCart.attr('data-gansho'),
					    telemailUrl = $footerCart.attr('data-telemail');

					if (telemailUrl !== '' || pamphUrl === '' && ganshoUrl === '' && telemailUrl === '') {
						// テレメール校 or パンフ、願書、テレメールいずれも持たない学校の場合は新デザインの吸着を消す
						$footerCart.removeClass('is-show').removeAttr('style').removeAttr('data-type');
					} else {
						// 個社下のアクションボタンの吸着を消す
						$('.l-footerFix').addClass('hide').removeAttr('style').removeAttr('data-type');
					}
				}
				// ENH_2018_002 まとめて資料請求リスト訴求強化
				if ($kosyaSeikyuBtnE.length) {
					$("[data-btn-name='SMATOME_2018_02_BTN']").hide();
					$("[data-btn-name='SMATOME_2018_02_E_BTN']").show();
				}
			}

			//まとめてリスト追加ボタンの表示制御をレスポンスデータと付き合わせて行う
			//追加済みの学校は、リスト追加ボタンを追加済みボタンに切り替える
			$('[data-action="addMatometeListOpen"]').each(function () {
				if ($.inArray(this.getAttribute('data-school'), data.data) !== -1) {
					//追加完了ボタン
					$(this).find('.addList--default').addClass('addList--marked').removeClass('addList--default');
				}
				$(this).parent().css('visibility', 'visible');
			});

			// ENH_2017_008 まとめてリスト追加ボタンUI改善
			// 追加済みの学校は、まとめてリスト追加ボタンを追加済みボタンに切り替える
			$('[data-action="addCart"]').each(function () {
				if ($.inArray(this.getAttribute('data-school'), data.data) !== -1) {
					//追加完了ボタン
					$(this).addClass('is-added');
					$(this).find('.i-addList').addClass('is-added');
					$(this).find('.m-button--slim').addClass('is-added');
					$(this).find('.m-button--otherHeader').addClass('is-added');
				}
			});

			// ENH_2018_001 まとめて資料請求リスト訴求強化
			$('[data-action="addCartOnly"], [data-action="addCartAndOpen"]').each(function () {
				var gakkoCd = $(this).attr('data-school');

				if ($.inArray(gakkoCd, data.data) !== -1) {
					//追加完了ボタン
					$(this).closest('[data-cart="button"]').addClass('is-added');
					$('[data-school="' + gakkoCd + '"]').closest('[data-cart="button"]').addClass('is-added');
				}
			});

			if ('sessionStorage' in window && window.sessionStorage !== null) {
				var num = sessionStorage.getItem('matomete_list_count');
				var cnt = data.data.length;
				if (num == null || num != cnt) {
					var s2 = s_gi(s_account);
					s2.linkTrackVars = 'eVar27';
					s2.eVar27 = cnt;
					s2.tl(true, 'o', 'まとめてカウント');
					try {
						sessionStorage.setItem('matomete_list_count', cnt);
					} catch (err) {}
				}
			}
		}).fail(function () {
			// リクエストがエラーになった場合
			var $footerCart = $('.fixFooterCart');

			if ($footerCart.length) {
				var telemailUrl = $footerCart.attr('data-telemail');

				if (telemailUrl !== '') {
					// テレメール校の場合は新デザインの吸着を消す
					$footerCart.removeClass('is-show').removeAttr('style').removeAttr('data-type');
				} else {
					// 個社下のアクションボタンの吸着を消す
					$('.l-footerFix').addClass('hide').removeAttr('style').removeAttr('data-type');
				}
			}
		}).always(function () {
			window.ajaxFlag = true;
		});
		// 非同期処理直列化 ajax実行完了したら繰り返し処理を解除する
		window.clearInterval(cartNumberInterval);
	}, 500);
});

},{"jquery":97}],151:[function(require,module,exports){
// #88790[21RM][エンハンス]【UIUX】カート追加済み再来訪（SP）
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = ready;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _cartRevisitBalloonBalloonVue = require('./cartRevisitBalloon/Balloon.vue');

var _cartRevisitBalloonBalloonVue2 = _interopRequireDefault(_cartRevisitBalloonBalloonVue);

function ready(fn) {
  if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(function () {
  // カート追加済み離脱フラグがtrue以外の場合は何もしない
  if ('sessionStorage' in window && window.sessionStorage !== null) {
    if (sessionStorage.getItem('isRevisitTarget') !== 'true') {
      return;
    }
  }

  // 再来訪吹き出し表示用のDOMが存在しない場合は何もしない
  var targetDom = document.getElementById('cartRevisitBalloon');
  if (!targetDom) return;

  new _vue2['default']({
    el: '#cartRevisitBalloon',
    render: function render(h) {
      return h(_cartRevisitBalloonBalloonVue2['default']);
    }
  });
});
module.exports = exports['default'];

},{"./cartRevisitBalloon/Balloon.vue":160,"vue":102}],152:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _this = this;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var fetchJsonFromUrl = function fetchJsonFromUrl(url) {
  var response;
  return regeneratorRuntime.async(function fetchJsonFromUrl$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.prev = 0;
        context$1$0.next = 3;
        return regeneratorRuntime.awrap(_axios2['default'].get(url));

      case 3:
        response = context$1$0.sent;
        return context$1$0.abrupt('return', response.data);

      case 7:
        context$1$0.prev = 7;
        context$1$0.t0 = context$1$0['catch'](0);
        return context$1$0.abrupt('return', null);

      case 10:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this, [[0, 7]]);
};

var updateCampaignBanner = function updateCampaignBanner(data, campaignBannerElement, campaignBannerReward, campaignBannerRewardAmount) {
  if (!data.campaign) {
    campaignBannerElement.remove();
  } else {
    var rewardAmountFormatted = data.rewardAmount.toLocaleString();

    campaignBannerReward.textContent = data.reward;
    campaignBannerRewardAmount.textContent = rewardAmountFormatted;

    return data.campaignNum;
  }
};

var calculateAndUpdateBannerCount = function calculateAndUpdateBannerCount(data, campaignMaxNum, campaignBannerCount) {
  var campaignTotalNum = campaignMaxNum - data.gakkoCount;
  if (campaignTotalNum < 0) {
    campaignTotalNum = 0;
  }
  campaignBannerCount.textContent = campaignTotalNum;
};

var mutationCallback = function mutationCallback(mutationsList, fetchAndUpdateCampaignBanner) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var mutation = _step.value;

      if (mutation.type === 'childList') {
        fetchAndUpdateCampaignBanner();
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var startObservingCartChanges = function startObservingCartChanges(cartCount, fetchAndUpdateCampaignBanner) {
  if (window.recommendCampaignParam == null) {
    return;
  }
  var observer = new MutationObserver(function (mutationsList) {
    mutationCallback(mutationsList, fetchAndUpdateCampaignBanner);
  });
  var config = {
    childList: true
  };
  observer.observe(cartCount, config);
};

exports['default'] = function callee$0$0() {
  var cartCount, campaignBannerElement, campaignBannerCount, campaignBannerReward, campaignBannerRewardAmount, fetchAndUpdateCampaignBanner, campaignBannerInterval;
  return regeneratorRuntime.async(function callee$0$0$(context$1$0) {
    var _this2 = this;

    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        cartCount = document.querySelector('.fixFooterCart__badge');
        campaignBannerElement = document.querySelector('.js-campaignBannerElement');
        campaignBannerCount = document.querySelector('.js-campaignBannerText');
        campaignBannerReward = document.querySelector('.js-campaignBannerReward');
        campaignBannerRewardAmount = document.querySelector('.js-campaignBannerRewardAmount');

        fetchAndUpdateCampaignBanner = function fetchAndUpdateCampaignBanner() {
          var campaignData, campaignMaxNum, campaignTargetData;
          return regeneratorRuntime.async(function fetchAndUpdateCampaignBanner$(context$2$0) {
            while (1) switch (context$2$0.prev = context$2$0.next) {
              case 0:
                context$2$0.prev = 0;
                context$2$0.next = 3;
                return regeneratorRuntime.awrap(fetchJsonFromUrl('/rnet/js/campaign_param.json'));

              case 3:
                campaignData = context$2$0.sent;
                campaignMaxNum = updateCampaignBanner(campaignData, campaignBannerElement, campaignBannerReward, campaignBannerRewardAmount);
                context$2$0.next = 7;
                return regeneratorRuntime.awrap(fetchJsonFromUrl('/smp/cart/campaignGakkoCount/'));

              case 7:
                campaignTargetData = context$2$0.sent;

                calculateAndUpdateBannerCount(campaignTargetData, campaignMaxNum, campaignBannerCount);
                // キャンペーンバナーの表示設定
                campaignBannerElement.style.display = 'flex';
                context$2$0.next = 15;
                break;

              case 12:
                context$2$0.prev = 12;
                context$2$0.t0 = context$2$0['catch'](0);

                // キャンペーンバナーの表示設定
                // エラーの時は非表示
                campaignBannerElement.style.display = 'none';

              case 15:
                context$2$0.prev = 15;

                window.ajaxFlag = true;
                return context$2$0.finish(15);

              case 18:
              case 'end':
                return context$2$0.stop();
            }
          }, null, _this2, [[0, 12, 15, 18]]);
        };

        campaignBannerInterval = window.setInterval(function callee$1$0() {
          return regeneratorRuntime.async(function callee$1$0$(context$2$0) {
            while (1) switch (context$2$0.prev = context$2$0.next) {
              case 0:
                if (window.ajaxFlag) {
                  context$2$0.next = 2;
                  break;
                }

                return context$2$0.abrupt('return');

              case 2:
                window.ajaxFlag = false;
                context$2$0.next = 5;
                return regeneratorRuntime.awrap(fetchAndUpdateCampaignBanner());

              case 5:
                window.ajaxFlag = true;
                window.clearInterval(campaignBannerInterval);

              case 7:
              case 'end':
                return context$2$0.stop();
            }
          }, null, _this2);
        }, 500);

        startObservingCartChanges(cartCount, fetchAndUpdateCampaignBanner);

      case 8:
      case 'end':
        return context$1$0.stop();
    }
  }, null, this);
};

module.exports = exports['default'];

// 資料請求カートのカウントの要素を取得

// キャンペーンバナーを特定する要素を取得

// キャンペーンバナーのカウントの要素を取得

// キャンペーンバナーの景品（図書カード）の要素を取得

// キャンペーンバナーの金額（○○円）の要素を取得

// キャンペーンバナーJsonを取得

// カート内のキャンペーン対象となっている学校数を取得

},{"axios":30}],153:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _this = this;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _sendClickLog = require('../_sendClickLog');

var _frontendSrcJsContents_getLoginStatus = require('../../../../../../frontend/src/js/contents/_getLoginStatus');

var _assetsComponentSp_favoriteFlowline = require('../../../assets/component/sp/_favoriteFlowline');

var _assetsComponentSp_favoriteFlowline2 = _interopRequireDefault(_assetsComponentSp_favoriteFlowline);

var IS_SHOW = 'is-show';
var STORAGE_KEY = 'fe-1950-favoriteRecomFlag';

var pageIds = ['STop01', 'Slist_f_All', 'Sgkusyo', 'SShisyo', 'SBuncon'];
var targetPageId = trace_p;
var favoriteGakkoSetResult = null;

exports['default'] = function callee$0$0() {
  var fetchFavoriteGakkoSetResult;
  return regeneratorRuntime.async(function callee$0$0$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        fetchFavoriteGakkoSetResult = function fetchFavoriteGakkoSetResult() {
          var response, favoriteGakkoSetResultData;
          return regeneratorRuntime.async(function fetchFavoriteGakkoSetResult$(context$2$0) {
            while (1) switch (context$2$0.prev = context$2$0.next) {
              case 0:
                context$2$0.prev = 0;
                context$2$0.next = 3;
                return regeneratorRuntime.awrap(fetch('/smp2/quipMember/favorite/getFavoriteGakkoSetResult/'));

              case 3:
                response = context$2$0.sent;
                context$2$0.next = 6;
                return regeneratorRuntime.awrap(response.json());

              case 6:
                favoriteGakkoSetResultData = context$2$0.sent;

                if (!(favoriteGakkoSetResultData.resultCode === 3)) {
                  context$2$0.next = 11;
                  break;
                }

                return context$2$0.abrupt('return', null);

              case 11:
                return context$2$0.abrupt('return', favoriteGakkoSetResultData);

              case 12:
                context$2$0.next = 17;
                break;

              case 14:
                context$2$0.prev = 14;
                context$2$0.t0 = context$2$0['catch'](0);
                return context$2$0.abrupt('return', null);

              case 17:
              case 'end':
                return context$2$0.stop();
            }
          }, null, this, [[0, 14]]);
        };

        if (pageIds.includes(targetPageId)) {
          context$1$0.next = 3;
          break;
        }

        return context$1$0.abrupt('return');

      case 3:
        if (!(targetPageId === 'STop01')) {
          context$1$0.next = 11;
          break;
        }

        context$1$0.next = 6;
        return regeneratorRuntime.awrap(fetchFavoriteGakkoSetResult());

      case 6:
        favoriteGakkoSetResult = context$1$0.sent;

        if (!(!favoriteGakkoSetResult && sessionStorage.getItem(STORAGE_KEY) === 'true')) {
          context$1$0.next = 9;
          break;
        }

        return context$1$0.abrupt('return');

      case 9:
        context$1$0.next = 13;
        break;

      case 11:
        if (!(sessionStorage.getItem(STORAGE_KEY) === 'true')) {
          context$1$0.next = 13;
          break;
        }

        return context$1$0.abrupt('return');

      case 13:

        (0, _frontendSrcJsContents_getLoginStatus.getLoginStatus)(false, function (loginStatus) {
          if (loginStatus === 0) {
            var _ret = (function () {
              // レコメンド訴求吹き出し表示処理
              var showHeaderRecommend = function showHeaderRecommend() {
                // 閲覧履歴吹き出しorカート履歴吹き出しが表出していた場合はレコメンド吹き出しは表出しない。
                // 閲覧履歴吹き出しorカート履歴吹き出しの表出制御は別ファイルで非同期処理で行っている都合上、このタイミングで条件分岐を入れる。
                var cartBalloonPopup = document.querySelector('.c-cartBalloon');
                if (historyPopup && historyPopup.classList.contains('is-show')) return;
                if (cartBalloonPopup) return;

                // 進路トップでは、更にお気に入り登録吹き出しが表示されていた場合はレコメンド吹き出しは表出しない。
                var favoriteToast = document.querySelector('.js-fukidashi__container');
                if (targetPageId === 'STop01' && favoriteToast) return;

                var headerRecommend = document.querySelector('.js-headerRecommend');
                var headerRecommendCloseButton = document.querySelector('.js-headerRecommendCloseButton');

                if (headerRecommend) {
                  headerRecommend.classList.add(IS_SHOW);
                  sessionStorage.setItem(STORAGE_KEY, 'true');
                  (0, _sendClickLog.sendLog)(headerRecommend, 'SRecommendBalloon_imp_' + targetPageId);

                  headerRecommendCloseButton.addEventListener('click', function () {
                    headerRecommend.classList.remove(IS_SHOW);
                    (0, _sendClickLog.sendLog)(headerRecommendCloseButton, 'SRecommendBalloon_close_' + targetPageId);
                  });
                }
              };

              var checkAndExecuteFavoriteFlowline = function checkAndExecuteFavoriteFlowline(favoriteGakkoSetResult) {
                // 検索一覧画面でお気に入り登録している場合お気に入り登録導線の関数を実行させる
                if (favoriteGakkoSetResult) {
                  (0, _assetsComponentSp_favoriteFlowline2['default'])(favoriteGakkoSetResult.resultCode);
                }
                // マイページレコメンド吹き出しが1度表示されてればリターン
                if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;
                fetchAndShowHeaderRecommend();
              };

              // レコメンド訴求吹き出し表示確認
              var fetchAndShowHeaderRecommend = function fetchAndShowHeaderRecommend() {
                _axios2['default'].get('/smp2/quipMember/favorite/recomFlag').then(function (response) {
                  if (!response) throw Error;
                  if (!response.data) throw Error;
                  if (response.data.resultCode === 0 && response.data.updateFlag === 1) {
                    showHeaderRecommend();
                  }
                })['catch'](function () {
                  // エラー時は何もしない
                });
              };

              // カート吹き出し表示確認
              var createBalloonAndShowRecommend = function createBalloonAndShowRecommend() {
                _axios2['default'].get('/smp2/cart/createBalloon').then(function (response) {
                  if (!response) throw Error;
                  if (!response.data) throw Error;
                  if (response.data.balloon.length) return;

                  // 検索一覧画面でお気に入り登録している場合お気に入り登録導線の関数を実行させる
                  if (favoriteGakkoSetResult) {
                    (0, _assetsComponentSp_favoriteFlowline2['default'])(favoriteGakkoSetResult.resultCode);
                  }
                  // マイページレコメンド吹き出しが1度表示されてればリターン
                  if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;

                  return _axios2['default'].get('/smp2/quipMember/favorite/recomFlag');
                }).then(function (response) {
                  if (!response) throw Error;
                  if (!response.data) throw Error;
                  if (response.data.resultCode === 0 && response.data.updateFlag === 1) {
                    showHeaderRecommend();
                  }
                })['catch'](function () {
                  // エラー時は何もしない
                });
              };
              // '[data-popup="show"]'はvm側で出しわけ制御がされており閲覧履歴がある場合のみ取得可能。（カート履歴を表示する場合は表示されない）
              var historyPopup = document.querySelector('[data-popup="show"]');
              var isSessionStorageAvailable = 'sessionStorage' in window && window.sessionStorage !== null;

              if (historyPopup) {
                if (isSessionStorageAvailable) {
                  // 閲覧履歴吹き出しの表示有無を管理しているセッションを取得
                  var popupFlag = sessionStorage.getItem('smpTop_is-popup');
                  var historyPopupShowFlag = historyPopup.classList.contains('is-show');
                  if (popupFlag == null || popupFlag === '0' || historyPopupShowFlag) return {
                      v: undefined
                    };
                  checkAndExecuteFavoriteFlowline(favoriteGakkoSetResult);
                } else {
                  checkAndExecuteFavoriteFlowline(favoriteGakkoSetResult);
                }
              } else {
                // サイト離脱有無を管理しているセッションを取得
                if (isSessionStorageAvailable && sessionStorage.getItem('isRevisitTarget') !== 'true') {
                  // 検索一覧画面でお気に入り登録している場合お気に入り登録導線の関数を実行させる
                  checkAndExecuteFavoriteFlowline(favoriteGakkoSetResult);
                } else {
                  // カート吹き出しの表示有無を管理しているセッションを取得
                  if (isSessionStorageAvailable && sessionStorage.getItem('isCartBalloonShowed') !== 'true') {
                    createBalloonAndShowRecommend();
                  } else {
                    checkAndExecuteFavoriteFlowline(favoriteGakkoSetResult);
                  }
                }
              }
            })();

            if (typeof _ret === 'object') return _ret.v;
          }
        });

        // お気に入り本登録結果を取得する関数

      case 14:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this);
};

module.exports = exports['default'];

// 対象ページでなければリターン

// 検索一覧画面でお気に入り登録していない且つマイページレコメンド吹き出しが1度表示されてればリターン

// マイページレコメンド吹き出しが1度表示されてればリターン

// 登録なしの場合はnullを返す

// APIエラー時はnullを返す

},{"../../../../../../frontend/src/js/contents/_getLoginStatus":172,"../../../assets/component/sp/_favoriteFlowline":146,"../_sendClickLog":111,"axios":30}],154:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var STORAGE_KEY = 'isRevisitTarget';

var revisitFlagSetting = (function () {
  /**
   * @description カートに追加した状態で進路サイトを離脱したかどうかのフラグ制御処理
   */

  function revisitFlagSetting() {
    _classCallCheck(this, revisitFlagSetting);

    this.revisitFlagHandler();
  }

  /**
   * @description カート件数取得API処理
   */

  _createClass(revisitFlagSetting, [{
    key: 'requestClipList',
    value: function requestClipList() {
      return new Promise(function (resolve, reject) {
        var requestClipListInterval = window.setInterval(function () {
          // 非同期処理直列化 ajaxFlagはグローバル変数で、非同期処理実行判定フラグとして用いている
          if (!window.ajaxFlag) return;
          window.ajaxFlag = false;
          var httpRequest = new XMLHttpRequest();
          httpRequest.open('POST', '/smp2/cart/clipList', false);
          httpRequest.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
          httpRequest.onload = function () {
            if (httpRequest.status >= 200 && httpRequest.status < 300) {
              resolve(httpRequest.response);
            } else {
              reject(httpRequest.statusText);
            }
          };
          httpRequest.onerror = function () {
            return reject(httpRequest.statusText);
          };
          httpRequest.onloadend = function () {
            window.ajaxFlag = true;
          };
          httpRequest.send();
          // 非同期処理直列化 ajax実行完了したら繰り返し処理を解除する
          window.clearInterval(requestClipListInterval);
        }, 500);
      });
    }

    /**
     * @description カートに追加した状態で離脱したかどうかのフラグ設定
     */
  }, {
    key: 'revisitFlagHandler',
    value: function revisitFlagHandler() {
      // テスト対象外の場合は何もしない
      if (!this.isTargetTestId()) return;

      if ('sessionStorage' in window && window.sessionStorage !== null) {
        // Session Storageにカート追加済み離脱フラグが存在しない場合、フラグを設定する
        if (!sessionStorage.getItem(STORAGE_KEY)) {
          this.setRevisitFlag();
        }
      }
    }

    /**
     * @description 対象のテストIDか判定（SCBalloon_01がBか）
     */
  }, {
    key: 'isTargetTestId',
    value: function isTargetTestId() {
      return window.isSCBalloonTestB || false;;
    }

    /**
     * @description Session Storageのカート追加済み離脱フラグ設定処理
     */
  }, {
    key: 'setRevisitFlag',
    value: function setRevisitFlag() {
      sessionStorage.setItem(STORAGE_KEY, 'false');

      // カート件数が1件以上の場合、カート追加済み離脱フラグが存在しない場合をtrueに設定
      this.requestClipList().then(function (data) {
        var clipList = JSON.parse(data);
        if (clipList.data.length) {
          sessionStorage.setItem(STORAGE_KEY, 'true');
        }
      })['catch'](function (error) {
        console.error(error);
      });
    }
  }]);

  return revisitFlagSetting;
})();

exports['default'] = revisitFlagSetting;
module.exports = exports['default'];

},{}],155:[function(require,module,exports){
/**
 * 【案件】feat 97882 検索一覧画面カセット改修
 * 【ブランチ】feat-97882-検索一覧画面カセット改修
 * Slist23=AB両パターンで読み込む
 */

// 検索カセットの外枠のクラス名を追加
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var casetteTarget = '.js-cassetteInViewLog';
// クリックログ用の(アカウント)変数を宣言(sを既に、スクロール用に使用中のため)
var s = s_gi(s_account);

var cassetteInView = function cassetteInView() {
  // 検索カセットの外枠の要素を取得
  var scrollTargetElements = document.querySelectorAll(casetteTarget);

  if (scrollTargetElements.length) {
    (function () {
      // オプション設定
      var options = {
        rootMargin: '0px',
        threshold: 0
      };
      // 要素が画面に入ったときの処理
      var inViewCallback = function inViewCallback(scrollTargetElements) {
        scrollTargetElements.forEach(function (scrollTargetElement) {
          if (!scrollTargetElement.isIntersecting) return;
          // 検索カセットの外枠の要素からdata-index(カセット順位)を取得
          var cassetteIndex = scrollTargetElement.target.dataset.index;
          // 検索カセットの外枠の要素からdata-gakkoCd(学校CD)を取得
          var cassetteGakkoCd = scrollTargetElement.target.dataset.gakkocd;
          // ログテキストを追加
          var cassetteInViewLog = 'slist_f_all_SCcassette_imp_' + cassetteIndex + '_' + cassetteGakkoCd;
          if (!s) return;
          // スクロール時、検索カセット外枠部分が画面に表示された時、ログを送信
          s.tl(scrollTargetElement.target, 'o', cassetteInViewLog);
          // 一度inViewログを飛ばしたら、監視をやめる
          observer.unobserve(scrollTargetElement.target);
        });
      };

      // IntersectionObserverを呼ぶ
      var observer = new IntersectionObserver(inViewCallback, options);
      scrollTargetElements.forEach(function (target) {
        observer.observe(target);
      });
    })();
  }
};

var cassetteClicks = function cassetteClicks() {
  // 検索カセットの学校名、画像の要素を取得
  var casetteGakkoNameAndImages = document.querySelectorAll('.js-cassetteGakkoNameAndImages');
  // 検索カセットの学科の要素を取得
  var casetteGakkaNames = document.querySelectorAll('.js-cassetteGakkaName');
  // 検索カセットのパンフをもらうの要素を取得
  var casettePanphs = document.querySelectorAll('.js-cassettePanph');
  // 検索カセットの願書の要素を取得
  var casetteGanshos = document.querySelectorAll('.js-cassetteGansho');
  // 検索カセットの(テレメール)パンフ・願書をもらうの要素を取得
  var casetteTelemails = document.querySelectorAll('.js-cassetteTelemail');
  // 検索カセットのカートに追加するの要素を取得
  var casetteCarts = document.querySelectorAll('.js-cassetteCarts');
  // 検索カセットのこの学校のオープンキャンパス情報を見る(もっと見る)の要素を取得
  var casetteOcContents = document.querySelectorAll('.js-cassetteOcContents');

  // 学校名、画像部分をクリック時、ログを送信
  casetteGakkoNameAndImages.forEach(function (casetteGakkoNameAndImage) {
    casetteGakkoNameAndImage.addEventListener('click', function (gakkoNameAndImage) {
      var gakkoNameAndImages = gakkoNameAndImage.target.closest(casetteTarget);
      var cassetteIndexInGakkoNameAndImages = gakkoNameAndImages.dataset.index;
      var cassetteGakkoCdInGakkoNameAndImages = gakkoNameAndImages.dataset.gakkocd;
      var cassetteClickGakkoNameAndImagesLog = 'slist_f_all_SCcassette_main_click_' + cassetteIndexInGakkoNameAndImages + '_' + cassetteGakkoCdInGakkoNameAndImages;

      s.tl(gakkoNameAndImage.target, 'o', cassetteClickGakkoNameAndImagesLog);
    });
  });

  // 学科部分をクリック時、ログを送信
  casetteGakkaNames.forEach(function (casetteGakkaName) {
    casetteGakkaName.addEventListener('click', function (gakkaName) {
      var gakkaNames = gakkaName.target.closest(casetteTarget);
      var cassetteIndexInGakkaName = gakkaNames.dataset.index;
      var cassetteGakkoCdInGakkaName = gakkaNames.dataset.gakkocd;
      var cassetteClickGakkaNameLog = 'slist_f_all_SCcassette_gakka_click_' + cassetteIndexInGakkaName + '_' + cassetteGakkoCdInGakkaName;

      s.tl(gakkaName.target, 'o', cassetteClickGakkaNameLog);
    });
  });

  // パンフをもらう部分をクリック時、ログを送信
  casettePanphs.forEach(function (casettePanph) {
    casettePanph.addEventListener('click', function (panph) {
      var panphs = panph.target.closest(casetteTarget);
      var cassetteIndexInPanph = panphs.dataset.index;
      var cassetteGakkoCdInPanph = panphs.dataset.gakkocd;
      var cassetteClickPanphLog = 'slist_f_all_SCcassette_panf_click_' + cassetteIndexInPanph + '_' + cassetteGakkoCdInPanph;

      s.tl(panph.target, 'o', cassetteClickPanphLog);
    });
  });

  // 願書部分をクリック時、ログを送信
  casetteGanshos.forEach(function (casetteGansho) {
    casetteGansho.addEventListener('click', function (gansho) {
      var ganshos = gansho.target.closest(casetteTarget);
      var cassetteIndexInGansho = ganshos.dataset.index;
      var cassetteGakkoCdInGansho = ganshos.dataset.gakkocd;
      var cassetteClickGanshoLog = 'slist_f_all_SCcassette_gansho_click_' + cassetteIndexInGansho + '_' + cassetteGakkoCdInGansho;

      s.tl(gansho.target, 'o', cassetteClickGanshoLog);
    });
  });

  // (テレメール)パンフ・願書をもらう部分をクリック時、ログを送信
  casetteTelemails.forEach(function (casetteTelemail) {
    casetteTelemail.addEventListener('click', function (telemail) {
      var telemails = telemail.target.closest(casetteTarget);
      var cassetteIndexInTelemail = telemails.dataset.index;
      var cassetteGakkoCdInTelemail = telemails.dataset.gakkocd;
      var cassetteClickTelemailLog = 'slist_f_all_SCcassette_panfAndGansho_click_' + cassetteIndexInTelemail + '_' + cassetteGakkoCdInTelemail;

      s.tl(telemail.target, 'o', cassetteClickTelemailLog);
    });
  });

  // カートに追加する部分をクリック時、ログを送信
  casetteCarts.forEach(function (casetteCart) {
    casetteCart.addEventListener('click', function (cart) {
      var carts = cart.target.closest(casetteTarget);
      var cassetteIndexInCarts = carts.dataset.index;
      var cassetteGakkoCdInCarts = carts.dataset.gakkocd;
      var cassetteClickCartsLog = 'slist_f_all_SCcassette_cartAdd_click_' + cassetteIndexInCarts + '_' + cassetteGakkoCdInCarts;

      s.tl(cart.target, 'o', cassetteClickCartsLog);
    });
  });

  // この学校のオープンキャンパス情報を見る(もっと見る)部分をクリック時、ログを送信
  casetteOcContents.forEach(function (casetteOcContent) {
    casetteOcContent.addEventListener('click', function (ocContent) {
      var ocContents = ocContent.target.closest(casetteTarget);
      var cassetteIndexInOcContents = ocContents.dataset.index;
      var cassetteGakkoCdInOcContents = ocContents.dataset.gakkocd;
      var cassetteClickOcContentsLog = 'slist_f_all_SCcassette_ocAll_click_' + cassetteIndexInOcContents + '_' + cassetteGakkoCdInOcContents;

      s.tl(ocContent.target, 'o', cassetteClickOcContentsLog);
    });
  });
};

exports.cassetteInView = cassetteInView;
exports.cassetteClicks = cassetteClicks;

},{}],156:[function(require,module,exports){
// _s_searchListPanel_integration.jsをベースに作成
// レスポンシブデザイン用のファイル
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _s_searchPanelsBunya_responsiveVue = require('./_s_searchPanelsBunya_responsive.vue');

var _s_searchPanelsBunya_responsiveVue2 = _interopRequireDefault(_s_searchPanelsBunya_responsiveVue);

var _slidePanelResponsiveModulesSlidePanelTemplateVue = require('./slidePanel/responsive/modules/SlidePanelTemplate.vue');

var _slidePanelResponsiveModulesSlidePanelTemplateVue2 = _interopRequireDefault(_slidePanelResponsiveModulesSlidePanelTemplateVue);

var _slidePanelResponsiveModulesSearchPanelFixedBottomVue = require('./slidePanel/responsive/modules/SearchPanelFixedBottom.vue');

var _slidePanelResponsiveModulesSearchPanelFixedBottomVue2 = _interopRequireDefault(_slidePanelResponsiveModulesSearchPanelFixedBottomVue);

var THIS_URL = location.href;
var PANEL_HEADER_HEIGHT = 67;
var s2 = typeof s_gi === 'function' && s_account ? s_gi(s_account) : null;

var slidePanelState = {
  bunyaL: false,
  bunyaS: false,
  detail: false,
  shikugunRailway: false,
  shikugun: false,
  railwayParent: false,
  railway: false,
  koshu: false,
  ninzu: false,
  payment: false,
  tokucho: false
};

var formatEventName = function formatEventName(eventName) {
  var formattedEventName = eventName.split('').map(function (str, index) {
    if (index === 0) return str.toUpperCase();
    return str;
  }).join('');
  return formattedEventName;
};

var vm = new _vue2['default']({
  el: '#app',
  data: {
    currentScroll: '',
    initialSelectedBunyaSize: '',
    openedAccordions: [],
    bunyaTabList: [{
      id: 'shigoto',
      name: '仕事'
    }, {
      id: 'gakumon',
      name: '学問'
    }, {
      id: 'shikaku',
      name: '資格'
    }, {
      id: 'gakubukeito',
      name: '学部'
    }],
    currentBunyaId: 'shigoto',
    currentBunyaName: '仕事',
    currentBunyaDetail: 'すべて',
    currentShikakuSh: '',
    currentBunyaIdTemp: '',
    currentBunyaDetailTemp: '',
    currentShikakuShTemp: '',
    // 現在選択中の分野タブ名。パネル取得の条件分岐や画像パス生成に使用
    selectedBunyaTab: 'shigoto',
    // 選択中の分野大分類コード。配下の中・小分類情報取得ロジックのパラメータなどに使用
    selectedBunyaCdL: '',
    // 選択中の大分類名。小分類パネルのヘッダー表示用
    selectedBunyaName: '',
    // 選択中の中分類キー。件数取得やオブジェクト内のフィルターに使用
    selectedBunyaKeyM: '',
    // 選択中の大分類キー。件数取得やオブジェクト内のフィルターに使用
    selectedBunyaKeyS: '',
    // 分野パネル初期状態のバックアップ用オブジェクト
    selectedBunyaPanelBk: {
      selectedBunyaTab: '',
      initialSelectedBunyaSize: '',
      selectedBunyaName: '',
      selectedBunyaCdL: '',
      selectedBunyaKeyM: '',
      selectedBunyaKeyS: '',
      currentBunyaId: '',
      currentBunyaIdTemp: '',
      currentBunyaDetailTemp: '',
      openedAccordions: []
    },
    // パネル開閉状態の管理
    slidePanelState: slidePanelState,
    bunyaListM: {
      shigoto: {},
      gakumon: {},
      shikaku: {},
      gakubu: {}
    },
    bunyaListS: {
      shigoto: {},
      shikaku: {}
    },
    // 入力データ
    commonAjaxSendFlag: false,
    shikugunAjaxSendFlag: false,
    railwayAjaxSendFlag: false,
    countAjaxSendFlag: false,
    // 仕事パネル
    isShigotoSelected: false,
    shigotoLDispList: [],
    shigotoMDispList: [],
    shigotoSDispList: [],
    selectedShigotoL: {
      nm: '',
      cd: ''
    },
    selectedShigotoM: {
      nm: '',
      cd: ''
    },
    // 学問パネル
    isGakumonSelected: false,
    gakumonLDispList: [],
    gakumonSDispList: [],
    // 学部系統パネル
    isGakubuKeitouSelected: false,
    gbkDispList: [],
    selectedGakumonL: {
      nm: '',
      cd: ''
    },
    // 資格パネル
    isShikakuSelected: false,
    shikakuLDispList: [],
    shikakuMDispList: [],
    shikakuSDispList: [],
    shikakuShDispList: [],
    selectedShikakuL: {
      nm: '',
      cd: ''
    },
    selectedShikakuM: {
      nm: '',
      cd: ''
    },
    selectedShikakuS: {
      nm: '',
      cd: ''
    },
    // 校種パネル
    ksDispList: [],
    selectedKoshuNm: 'すべて',
    isKoshuAllSelected: true,
    isInitKoshuAllSelected: true,
    // 市区郡・路線パネル
    isAreaSelected: false,
    isFirstLabel: true,
    selectedAreaRailwayNms: [],
    isAreaAllSelected: false,
    isInitAreaAllSelected: true,
    // 市区郡パネル
    isSkgCountAreaReady: false,
    isSkgSelectRefresh: true,
    isSttCountAreaReady: false,
    tdfk2AreaMst: {},
    selectedSkgObj: {
      'areaSelected': {},
      'tdfkSelected': {}
    },
    // 路線パネル
    rw2ArwkMst: {},
    sttDispList: [],
    isAllSttSelectFlag: false,
    rwAreaObjSelected: {},
    rwAreaObjTempSelected: {},
    rwKbnObjSelected: {},
    isSttSelectRefresh: true,
    rwKbnSelected: '001',
    selectedSttObj: {
      'areaSelected': '',
      'rwKbnSelected': {},
      'rwSelected': {}
    },
    hasRwKbn: {
      '001': false,
      '002': false,
      '003': false
    },
    rwKbnMst: ['001', '002', '003'],
    // 定員数パネル
    capDispList: [],
    selectedCapNm: 'すべて',
    isCapAllSelected: true,
    isInitCapAllSelected: true,
    // 初年度納入金パネル
    payDispList: [],
    selectedPayNm: 'すべて',
    isPayAllSelected: true,
    isInitPayAllSelected: true,
    // 特長パネル
    tkDispList: [],
    checkedTokuchoList: [],
    isTokuchoAllChecked: false,
    isTokuchoAllSelected: true,
    selectedTokuchoNms: [],
    isInitTokuchoAllSelected: true,
    isInitCheckedTokuchoList: [],
    // パネルマスタデータ
    capList: [],
    gbkList: [],
    glList: [],
    jlList: [],
    ksList: [],
    payList: [],
    qlList: [],
    qshList: [],
    skgList: [],
    sttList: [],
    tkList: [],
    // 選択済みパラメータ(ベース選択値)
    selectedLists: {
      glList: [],
      capList: [],
      gbkList: [],
      jlList: [],
      ksList: [],
      payList: [],
      qlList: [],
      qshList: [],
      skgList: [],
      sttList: [],
      tkList: []
    },
    // 選択済みパラメータ（分野一時保存領域）
    selectedBunnyaTempLists: {
      glList: [],
      gbkList: [],
      jlList: [],
      qlList: [],
      qshList: []
    },
    // 選択済みパラメータ（バックアップ）
    selectedBkLists: {
      glList: [],
      capList: [],
      gbkList: [],
      jlList: [],
      ksList: [],
      payList: [],
      qlList: [],
      qshList: [],
      skgList: [],
      sttList: [],
      tkList: []
    },
    transition_name: 'show-next',
    displayContents: 'sindex',
    bunyaParentId: '#sindex-panelBunnyaParent',
    detailParentId: '#sindex-panelDetailParent',
    joinParentId: '#sindex-panelJoinParent',
    isJoinPanelLoaded: false,
    isSttScrolled: false,
    isSkgScrolled: false,
    isInitSttTab: false,
    isFirstModal: false //複数モーダルを開いている時はtrue
  },
  watch: {
    /**
     * @desc this.slidePanelStateの変更を監視し、詳細パネルを閉じた際に選択状況をリセット
     * @param {object} newVal - slidePanelState変更後の値
     * @param {object} oldVal - slidePanelState変更前の値
     */
    slidePanelState: function slidePanelState(newVal, oldVal) {
      if (oldVal.detail && !newVal.detail) {
        this.restoreBunyaPanelInfo();
        this.restoreSearchPanelSetting();
      }
    },
    isPanelOpened: function isPanelOpened() {
      this.bodyFixedChange();
    },
    // 非同期のファイル更新監視
    glList: function glList() {
      this.setDispList(this.glList, this.gakumonLDispList);
    },
    jlList: function jlList() {
      this.setDispList(this.jlList, this.shigotoLDispList);
    },
    qlList: function qlList() {
      this.setDispList(this.qlList, this.shikakuLDispList);
    },
    qshList: function qshList() {
      var _this = this;

      this.shikakuShDispList.push({
        qshCd: 'all',
        qshNm: 'すべて',
        count: 0
      });
      this.qshList.forEach(function (targetObj, index) {
        var addObj = Object.assign({}, targetObj);
        addObj.count = 0;
        if (addObj.qshCd === '1') {
          addObj.qshNm = '取得できる';
        } else if (addObj.qshCd === '2') {
          addObj.qshNm = '受験資格を取得できる';
        } else {
          addObj.qshNm = '取得を目標としている';
        }
        _this.shikakuShDispList.push(addObj);
      });
    },
    gbkList: function gbkList() {
      this.setDispList(this.gbkList, this.gbkDispList);
    },
    capList: function capList() {
      this.setDispList(this.capList, this.capDispList);
    },
    payList: function payList() {
      this.setDispList(this.payList, this.payDispList);
    },
    ksList: function ksList() {
      this.setDispList(this.ksList, this.ksDispList);
    },
    tkList: function tkList() {
      this.setDispList(this.tkList, this.tkDispList);
    },
    isSkgCountAreaReady: function isSkgCountAreaReady() {
      // 市区郡マスタ作成
      this.setTdfkAreaMst();
      // 選択情報を内部データに変換
      this.convertSkgSelectData();
      // チェック状態初期化
      this.initSkgCheck();
      // データ、カウント数更新
      this.updateSkgAreaDispList();
    },
    isSttCountAreaReady: function isSttCountAreaReady() {
      // 市区郡マスタ作成
      this.setRw2ArwkMst();
      this.identificationArea();
      // 選択情報を内部データに変換
      this.convertSttSelectData();
      // エリア情報更新
      this.updateSttAreaDispList();
    }
  },
  // コンポーネント定義
  components: {
    BunyaPanels: _s_searchPanelsBunya_responsiveVue2['default'],
    SlidePanelTemplate: _slidePanelResponsiveModulesSlidePanelTemplateVue2['default'],
    SearchPanelFixedBottom: _slidePanelResponsiveModulesSearchPanelFixedBottomVue2['default']
  },
  // インスタンス生成後の処理を定義
  created: function created() {
    var _this2 = this;

    var bunyaCdList = [{ key: 'jl', id: 'shigoto', name: '仕事' }, { key: 'gl', id: 'gakumon', name: '学問' }, { key: 'ql', id: 'shikaku', name: '資格' }, { key: 'gbk', id: 'gakubu', name: '学部' }];
    var selectedBunya = bunyaCdList.find(function (bunyaCd) {
      return (0, _jquery2['default'])('#' + bunyaCd.key).val() !== '';
    });
    if (selectedBunya) {
      this.selectedBunyaTab = selectedBunya.id;
      this.currentBunyaName = selectedBunya.name;
      var $bunyaDetail = (0, _jquery2['default'])('#js-panelInnerBunyaDetail');
      this.currentBunyaDetail = $bunyaDetail ? $bunyaDetail.text().trim() : '';
    }

    window.addEventListener('popstate', function () {
      _this2.initHistory();

      //エリアの場合パネルを遷移させるため初期モーダル状態をヒストリ化する必要がある
      if (history.state && history.state.isFirstModal !== undefined) {
        _this2.isFirstModal = history.state.isFirstModal;
      }
    });
  },
  // インスタンスマウント後の処理を定義
  mounted: function mounted() {
    var _this3 = this;

    // 初期化処理
    // 分野初期化
    var bunnyaMsts = {
      jlList: ['jl', 'jm', 'js'],
      qlList: ['ql', 'qm', 'qs'],
      qshList: ['qCd'],
      glList: ['gl', 'gs'],
      gbkList: ['gbk']
    };
    Object.keys(bunnyaMsts).forEach(function (key) {
      bunnyaMsts[key].forEach(function (bunnyaKey) {
        var bunnyaValue = (0, _jquery2['default'])('#' + bunnyaKey).val();
        if (bunnyaValue !== '') {
          _this3.selectedLists[key].push({
            name: bunnyaKey,
            value: bunnyaValue
          });
        }
      });
    });
    if (this.selectedLists.glList.length > 0) {
      this.isGakumonSelected = true;
    } else if (this.selectedLists.qlList.length > 0) {
      this.isShikakuSelected = true;
    } else if (this.selectedLists.jlList.length > 0) {
      this.isShigotoSelected = true;
    } else if (this.selectedLists.gbkList.length > 0) {
      this.isGakubuKeitouSelected = true;
    }

    // 分野パネル内の初期化
    this.initHistory();
    var selectedTabId = this.selectedBunyaTab === 'gakubu' ? 'gakubukeito' : this.selectedBunyaTab;
    var isBunyaOpen = this.slidePanelState.bunyaL || this.slidePanelState.bunyaS;

    // 分野変更ボタンのショートカット設定
    var selectedKeyList = [{
      keyL: 'jl',
      keyM: 'jm',
      keyS: 'js',
      bunya: 'Shigoto'
    }, {
      keyL: 'gl',
      keyM: '',
      keyS: 'gs',
      bunya: 'Gakumon'
    }, {
      keyL: 'ql',
      keyM: 'qm',
      keyS: 'qs',
      bunya: 'Shikaku'
    }, {
      keyL: 'qsh',
      keyM: '',
      keyS: '',
      bunya: 'Shikaku'
    }, {
      keyL: 'gbk',
      keyM: '',
      keyS: '',
      bunya: 'GakubuKeitou'
    }];

    // 初期パネルを大に設定。これより以下の各条件次第で変更
    this.initialSelectedBunyaSize = 'bunyaL';

    var selectedInfo = selectedKeyList.find(function (item) {
      return _this3.selectedLists[item.keyL + 'List'].length > 0;
    });

    // 分野以外のパネルを初期表示している場合
    if (this.isPanelOpened && !isBunyaOpen) {
      this.getCommonSearchMst(function () {
        var excludeList = ['bunyaL', 'bunyaS', 'detail'];
        var initPanelList = Object.keys(_this3.slidePanelState).filter(function (key) {
          return _this3.slidePanelState[key] && excludeList.indexOf(key) === -1;
        });
        initPanelList.forEach(function (panel) {
          var eventKey = panel.split('').map(function (str, index) {
            return index === 0 ? str.toUpperCase() : str;
          }).join('');
          var eventName = 'openPanel' + eventKey;
          _this3[eventName]('isMounted');
        });
        _this3.saveSelectedInfo();
        _this3.getAllCount();
      });
    }

    if (isBunyaOpen || selectedInfo) {

      if (selectedTabId !== 'shigoto') {
        // 仕事以外を選択時の分野タブ初期表示調整
        this.tabChange(selectedTabId);
      }

      this.getCommonSearchMst(function () {

        // 以下、絞り込みありの際の処理
        if (selectedInfo) {
          (function () {
            var selectedDetailList = _this3.selectedLists[selectedInfo.keyL + 'List'];

            // 大項目「すべて」以上が選択されている場合
            if (selectedDetailList.length > 0) {
              if (_this3.selectedBunyaTab !== 'gakubukeito') {
                _this3.initialSelectedBunyaSize = 'bunyaS';
              }
              var targetListL = _this3[selectedInfo.keyL + 'List'];
              var selectedLindex = targetListL.findIndex(function (item) {
                return item[selectedInfo.keyL + 'Cd'] === selectedDetailList[0].value;
              });
              if (selectedLindex !== -1) {
                var selectedLItem = targetListL[selectedLindex];
                var selectedBunya = selectedInfo.bunya;
                var selectedLnm = selectedLItem[selectedInfo.keyL + 'Nm'];
                var selectedLcd = selectedLItem[selectedInfo.keyL + 'Cd'];
                var setItemParam = {
                  eventName: selectedBunya !== 'GakubuKeitou' ? 'set' + selectedBunya + 'LItem' : null,
                  selected: {
                    bunyaName: selectedLnm,
                    cd: selectedLcd
                  }
                };
                var isGbk = selectedInfo.keyL === 'gbk';
                var shortCut = isGbk ? null : 'shortCut';
                _this3.setItem(setItemParam, shortCut);
              }
            }

            // 中項目「すべて」以上が選択されている場合
            if (selectedDetailList.length > 1) {
              var selectedMcd = selectedDetailList[1].value;
              if (selectedMcd) {
                _this3.openedAccordions.push(selectedMcd);
                _this3.getCountDispS(selectedMcd);
              }
            }
          })();
        }

        _this3.getAllCount();
      });
    }

    // 詳細条件初期化
    // 定員初期化
    var initMinCapa = (0, _jquery2['default'])('#minCapa').val(),
        initMaxCapa = (0, _jquery2['default'])('#maxCapa').val();

    if (initMinCapa !== '' || initMaxCapa !== '') {
      this.selectedLists.capList.push({
        name: 'minCapa',
        value: initMinCapa
      });
      if (initMaxCapa !== '') {
        this.selectedLists.capList.push({
          name: 'maxCapa',
          value: initMaxCapa
        });
      }
      this.selectedCapNm = vmInput.initCapaNm;
      this.isInitCapAllSelected = false;
      this.isCapAllSelected = false;
    }
    // 初年度納入金初期化
    var initMinPay = (0, _jquery2['default'])('#minPay').val(),
        initMaxPay = (0, _jquery2['default'])('#maxPay').val();

    if (initMinPay !== '' || initMaxPay !== '') {
      this.selectedLists.payList.push({
        name: 'minPay',
        value: initMinPay
      });
      if (initMaxPay !== '') {
        this.selectedLists.payList.push({
          name: 'maxPay',
          value: initMaxPay
        });
      }
      this.selectedPayNm = vmInput.initPayNm;
      this.isInitPayAllSelected = false;
      this.isPayAllSelected = false;
    }
    // 特長初期化
    //チェックリスト初期化
    var $initTokuchos = (0, _jquery2['default'])('input[name="tokucho"]'),
        tokuchoArray = [];

    if ($initTokuchos.length > 0) {
      $initTokuchos.each(function () {
        tokuchoArray.push((0, _jquery2['default'])(this).val());
      });
      this.checkedTokuchoList = tokuchoArray;
      this.isInitCheckedTokuchoList = tokuchoArray.concat();
      tokuchoArray.forEach(function (tokuchoCd) {
        var addParamObj = undefined;
        addParamObj = {
          name: 'tokucho',
          value: tokuchoCd
        };
        _this3.selectedLists.tkList.push(addParamObj);
      });

      this.selectedTokuchoNms = [vmInput.initTkNm];
      this.isTokuchoAllSelected = false;
      this.isInitTokuchoAllSelected = false;
    }
    // 校種初期化
    var initKoshuL = (0, _jquery2['default'])('#koshuL').val(),
        initKoshuM0 = (0, _jquery2['default'])('#koshuM0').val(),
        initKoshuM1 = (0, _jquery2['default'])('#koshuM1').val();

    if (initKoshuL !== '') {
      var addObj = {
        name: 'koshuL',
        value: initKoshuL
      };

      this.selectedKoshuNm = vmInput.initKsNm;
      this.isKoshuAllSelected = false;
      this.isInitKoshuAllSelected = false;
      this.selectedLists.ksList.push(addObj);
    } else if (initKoshuM0 !== '' || initKoshuM1 !== '') {
      var _selectedLists$ksList;

      var addObjs = [{
        name: 'koshuM',
        value: initKoshuM0
      }, {
        name: 'koshuM',
        value: initKoshuM1
      }],
          fliteredAddObjs = addObjs.filter(function (addObj) {
        return addObj.value !== '';
      });

      this.selectedKoshuNm = vmInput.initKsNm;
      this.isKoshuAllSelected = false;
      this.isInitKoshuAllSelected = false;
      (_selectedLists$ksList = this.selectedLists.ksList).push.apply(_selectedLists$ksList, _toConsumableArray(fliteredAddObjs));
    }
    // 市区郡・路線パネル初期化
    var initAf = (0, _jquery2['default'])('#af').val();
    this.selectedAreaRailwayNms.push(vmInput.initAreaNm);
    if (initAf === '2') {
      this.initSkgParam();
    }
    if (initAf === '1') {
      this.initSttParam();
    }
    if (this.selectedLists.sttList.length > 0 || this.selectedLists.skgList.length > 0) {
      this.isInitAreaAllSelected = false;
    }
    // 学部タブの出しわけ制御
    // 通常遷移時は学部タブを非表示、URL直内で遷移してきた場合（URLパラメータに"gbk"が存在する）は表示
    var currentUrl = window.location.href;
    if (!currentUrl.includes("gbk")) {
      this.bunyaTabList = this.bunyaTabList.filter(function (item) {
        return item.id !== 'gakubukeito';
      });
    }
  },
  // フィルタ群を定義
  filters: {
    convertSex: function convertSex(val) {
      if (val === '') {
        return '';
      }
      return val === '1' ? '男性' : '女性';
    },
    formatCount: function formatCount(value) {
      if (value === undefined) {
        value = 0;
      }
      return '（' + value + '件）';
    },
    formatTokuchoNm: function formatTokuchoNm(tkArray) {
      if (tkArray.length === 0) {
        return 'すべて';
      }
      return tkArray.join('、');
    },
    checkOptProp: function checkOptProp(prop) {
      return !(prop === undefined || prop === null || prop === '' || prop === false);
    }
  },
  // 算出プロパティを定義
  computed: {
    isPanelOpened: function isPanelOpened() {
      var _this4 = this;

      return Object.keys(this.slidePanelState).some(function (panel) {
        return _this4.slidePanelState[panel];
      });
    },
    allCount: function allCount() {
      // 学部系統の取得が一番早いので、この「すべて」のカウントを利用する
      var gbkList = this.gbkDispList;
      return gbkList.length ? gbkList[0].count : 0;
    },
    bunyaList: function bunyaList() {
      return {
        shigotoL: this.shigotoLDispList,
        shigotoM: this.shigotoMDispList,
        shigotoS: this.shigotoSDispList,
        gakumonL: this.gakumonLDispList,
        gakumonS: this.gakumonSDispList,
        gbk: this.gbkDispList,
        shikakuL: this.shikakuLDispList,
        shikakuM: this.shikakuMDispList,
        shikakuS: this.shikakuSDispList,
        shikakuSh: this.shikakuShDispList
      };
    },
    selectedSummaryNm: function selectedSummaryNm() {
      var summaryNmArray = [];
      summaryNmArray.push(this.panelInnerSelectedBunya);
      if (this.isAreaAllSelected) {
        summaryNmArray.push('エリア・路線すべて');
      } else {
        summaryNmArray.push.apply(summaryNmArray, _toConsumableArray(this.selectedAreaRailwayNms));
      }
      if (this.isKoshuAllSelected) {
        summaryNmArray.push('校種すべて');
      } else {
        summaryNmArray.push(this.selectedKoshuNm);
      }
      if (this.isCapAllSelected) {
        summaryNmArray.push('定員すべて');
      } else {
        summaryNmArray.push(this.selectedCapNm);
      }
      if (this.isPayAllSelected) {
        summaryNmArray.push('初年度納入金すべて');
      } else {
        summaryNmArray.push(this.selectedPayNm);
      }
      if (this.isTokuchoAllSelected) {
        summaryNmArray.push('特長すべて');
      } else {
        summaryNmArray.push.apply(summaryNmArray, _toConsumableArray(this.selectedTokuchoNms));
      }
      return summaryNmArray.join(' | ');
    },
    skgAllAreaListCount: function skgAllAreaListCount() {
      var testArray = [];

      testArray = this.skgList.filter(function (areaObj) {
        return areaObj.count !== undefined && areaObj.count > 0 && areaObj.areaCd !== 'all';
      });
      return testArray.length;
    },
    isSkgPanelSelected: function isSkgPanelSelected() {
      return this.selectedLists.skgList.length > 0;
    },
    isSttPanelSelected: function isSttPanelSelected() {
      return this.selectedLists.sttList.length > 0;
    },
    buttonImageClassName: function buttonImageClassName() {
      return 'searchPanel__item__col--' + (this.currentBunyaIdTemp || this.currentBunyaId);
    },
    panelInnerSelectedBunya: function panelInnerSelectedBunya() {
      var bunyaName = this.panelInnerBunyaName;
      var bunyaDetail = this.panelInnerBunyaDetail === '分野' ? 'すべて' : this.panelInnerBunyaDetail;
      return bunyaName + ':' + bunyaDetail;
    },
    panelInnerBunyaName: function panelInnerBunyaName() {
      return this.currentBunyaNameTemp || this.currentBunyaName;
    },
    panelInnerBunyaDetail: function panelInnerBunyaDetail() {
      return this.currentBunyaDetailTemp || this.currentBunyaDetail;
    },
    /**
     * @desc submitModeの管理。詳細→分野パネル→分野選択時に即submitさせないため
     */
    isSubmitMode: function isSubmitMode() {
      var state = this.slidePanelState;
      var isBunyaOpened = state.bunyaL || state.bunyaS;
      var isDetailOpened = state.detail;
      return !(isDetailOpened && isBunyaOpened);
    },
    selectedBunyaCds: function selectedBunyaCds() {
      var _this5 = this;

      var targetBunyaKeys = ['gbkList', 'glList', 'jlList', 'qlList'];
      var selectedKey = Object.keys(this.selectedLists).find(function (key) {
        return _this5.selectedLists[key].length > 0 && targetBunyaKeys.indexOf(key) !== -1;
      });
      var selectedArray = [];
      if (selectedKey && this.selectedLists[selectedKey].length === 0) return selectedArray;
      selectedArray = Object.assign(selectedArray, this.selectedLists[selectedKey]);
      selectedArray = selectedArray.map(function (obj) {
        return obj.value;
      });

      //資格種別「すべて」選択時のみの処理
      var isQshAll = selectedKey === 'qlList' && selectedArray.length === 3 && this.selectedLists.qshList.length === 0;
      if (isQshAll) {
        selectedArray = [].concat(_toConsumableArray(selectedArray), ['sh_all']);
      }

      if (this.currentShikakuShTemp) {
        selectedArray = [].concat(_toConsumableArray(selectedArray), [this.currentShikakuShTemp]);
      }
      return selectedArray;
    },
    currentBunyaNameTemp: function currentBunyaNameTemp() {
      var bunyaMapping = {
        'shigoto': '仕事',
        'gakumon': '学問',
        'shikaku': '資格',
        'gakubukeito': '学部'
      };
      return bunyaMapping[this.currentBunyaIdTemp] || this.currentBunyaName;
    }
  },
  // メソッド群を定義
  methods: {
    /**
     * @desc ブラウザが持つhistoryを元にパネル状況を復元
     */
    initHistory: function initHistory() {
      var state = history.state || {};
      var slideState = state.hasOwnProperty('slidePanelState') ? state.slidePanelState : {};
      var selectedLists = state.hasOwnProperty('selectedLists') ? state.selectedLists : null;
      var bunyaTab = state.hasOwnProperty('bunyaTab') ? state.bunyaTab : null;

      var panelStateObject = {};
      Object.keys(this.slidePanelState).forEach(function (key) {
        panelStateObject[key] = slideState.hasOwnProperty(key) ? slideState[key] : false;
      });

      this.slidePanelState = Object.assign({}, this.slidePanelState, panelStateObject);
      if (selectedLists) {
        this.selectedLists = Object.assign({}, this.selectedLists, selectedLists);
      }
      if (bunyaTab) {
        this.selectedBunyaTab = bunyaTab;
        this.currentBunyaId = bunyaTab;
        this.tabChange(bunyaTab);
      }
    },
    /**
     * @desc 詳細パネル→エリア・路線パネル内の選択項目へのスクロール位置合わせ用フラグを解除。falseの時だけ位置を調整する
     * @param {string} releaseTarget - isSkgScrolled, isSttScrolledを指定
     */
    scrollRelease: function scrollRelease(releaseTarget) {
      this[releaseTarget] = false;
    },
    /**
     * @desc 分野パネル内のアコーディオン開閉状態を変更
     * @param {string} cd - 開閉したいアコーディオンの分野コード。渡したコードを配列からtoggleする
     */
    toggleAccordion: function toggleAccordion(cd) {
      if (this.openedAccordions.indexOf(cd) === -1) {
        this.openedAccordions = [].concat(_toConsumableArray(this.openedAccordions), [cd]);
      } else {
        this.openedAccordions = this.openedAccordions.filter(function (acdCd) {
          return acdCd !== cd;
        });
      }
    },
    /**
     * @desc 分野パネル状態変更。小パネを閉じ、大パネを開く。
     */
    goToPanelL: function goToPanelL() {
      this.changePanelState('bunyaL', true);
      this.changePanelState('bunyaS', false);
      this.pushState({
        bunyaL: true,
        bunyaS: false
      });
    },
    /**
     * @desc 分野小分類の件数取得。渡した小分類コードを元に件数をアップデート
     * @param {string} dispInfo - 中分類の分野コード
     */
    getCountDispS: function getCountDispS(dispInfo) {
      if (this.selectedBunyaTab === 'gakubukeito' || this.selectedBunyaTab === 'gakumon') return;
      var eventNameKey = formatEventName(this.selectedBunyaTab);
      this['update' + eventNameKey + 'SDispList'](this.selectedBunyaCdL, dispInfo);
    },
    /**
     * @desc 小分類リスト更新（学問は中分類）
     * @param {array} data - APIで取得した件数を含む配列
     * @param {string} cd - 分野絞り込み用のコード
     * @param {string} bunya - 学問のみ階層を調整するために分野種別を渡す
     * @param {string} selectedCd - 現在選択中の分野コード
     */
    updateCountSList: function updateCountSList(data, cd, bunya, selectedCd) {
      var _this6 = this;

      // 学問のみ階層が少し違うので微調整
      var isGakumon = bunya === 'gakumon';

      var bunyaArray = [];
      var listCopy = isGakumon ? JSON.parse(JSON.stringify(this.bunyaListM)) : JSON.parse(JSON.stringify(this.bunyaListS));
      data.map(function (d, index) {
        var bunyaObject = listCopy[bunya][cd][index];
        bunyaObject.count = d.SearchPanelCount;
        bunyaObject.isSelected = bunyaObject[_this6.selectedBunyaKeyS + 'Cd'] === selectedCd;
        bunyaArray = [].concat(_toConsumableArray(bunyaArray), [bunyaObject]);
      });
      listCopy[bunya][cd] = bunyaArray;

      if (isGakumon) {
        this.bunyaListM = Object.assign({}, this.bunyaListM, listCopy);
      } else {
        this.bunyaListS = Object.assign({}, this.bunyaListS, listCopy);
      }
    },
    /**
     * @desc 分野中分類のリスト更新
     * @param {array} data - APIで取得した件数を含む配列
     * @param {string} cd - 分野絞り込み用のコード
     * @param {string} bunya - アルファベット表記の分野種別
     * @param {string} selectedCd - 現在選択中の分野コード
     */
    updateCountMList: function updateCountMList(data, cd, bunya, selectedCd) {
      var _this7 = this;

      var bunyaArray = [];
      var listCopy = JSON.parse(JSON.stringify(this.bunyaListM));
      data.map(function (d, index) {
        var bunyaObject = listCopy[bunya][cd][index];
        bunyaObject.count = d.SearchPanelCount;
        bunyaObject.isSelected = bunyaObject[_this7.selectedBunyaKeyM + 'Cd'] === selectedCd;
        bunyaArray = [].concat(_toConsumableArray(bunyaArray), [bunyaObject]);
      });
      listCopy[bunya][cd] = bunyaArray;

      this.bunyaListM = Object.assign({}, this.bunyaListM, listCopy);
    },
    /**
     * @desc 分野中・小分類パネルのアップデート
     * @param {string} keyM - 中分類キー（例：jm, qm）
     * @param {string} keyS - 小分類キー（例：js, qs）
     */
    updateBunyaPanels: function updateBunyaPanels(keyM, keyS) {
      var _this8 = this;

      this.selectedBunyaKeyM = keyM;
      this.selectedBunyaKeyS = keyS;

      // 学問だけ中文類がないので処理が異なる
      var isGakumon = keyM === 'gl';
      var bunyaSize = isGakumon ? 'S' : 'M';

      var jlCdObject = {};
      Object.assign(jlCdObject, this.bunyaListM);

      var tempDispList = [];
      Object.assign(tempDispList, this['' + this.selectedBunyaTab + bunyaSize + 'DispList']);
      jlCdObject[this.selectedBunyaTab][this.selectedBunyaCdL] = tempDispList;

      this.bunyaListM = Object.assign({}, this.bunyaListM, jlCdObject);
      if (isGakumon) return;

      var jsCdObject = JSON.parse(JSON.stringify(this.bunyaListS));

      this.bunyaListM[this.selectedBunyaTab][this.selectedBunyaCdL].map(function (bunyaM) {
        if (bunyaM[keyM + 'Cd'] === 'all') return;
        var bunyaArray = [];
        bunyaM[keyS + 'List'].map(function (bunyaS, index) {
          var _objS;

          var objArrayM = jsCdObject[_this8.selectedBunyaTab][bunyaM[keyM + 'Cd']] || [];
          var objM = objArrayM[index] || {};
          var count = objM && objM.hasOwnProperty('count') ? objM.count : 0;
          var objS = (_objS = {
            isSelected: bunyaS.isSelected
          }, _defineProperty(_objS, keyS + 'Cd', bunyaS[keyS + 'Cd']), _defineProperty(_objS, keyS + 'Nm', bunyaS[keyS + 'Nm']), _defineProperty(_objS, 'count', count), _objS);
          bunyaArray = [].concat(_toConsumableArray(bunyaArray), [objS]);
        });
        jsCdObject[_this8.selectedBunyaTab][bunyaM[keyM + 'Cd']] = bunyaArray;
      });
      this.bunyaListS = Object.assign({}, this.bunyaListS, jsCdObject);
    },
    /**
     * @desc 分野中分類リストのアップデート
     */
    updateMDispList: function updateMDispList() {
      var eventNameKey = formatEventName(this.selectedBunyaTab);
      if (eventNameKey === 'Gakubukeito') return;

      // 学問の時は中文類(M)不要
      var isGakumon = eventNameKey === 'Gakumon';
      var bunyaSize = isGakumon ? 'S' : 'M';

      this['update' + eventNameKey + bunyaSize + 'DispList'](this.selectedBunyaCdL);
    },
    /**
     * @desc 分野大分類選択
     * @param {object} setInfo - 選択した大分類情報を含むオブジェクト
     * @param {any} shortCut - 分野パネルショートカットを有効にするならnullかfalse以外を渡す
     */
    setItem: function setItem(setInfo) {
      var shortCut = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      this.currentBunyaId = this.selectedBunyaTab;
      this.selectedBunyaCdL = setInfo.selected.cd;
      this.selectedBunyaName = setInfo.selected.bunyaName;
      if (setInfo.eventName) {
        this[setInfo.eventName](setInfo.selected.cd);
      }
      var isAll = setInfo.selected.cd === 'all';
      var hasNotChild = isAll || setInfo.eventName === 'setGakubuKeitouItem' || setInfo.eventName === null;
      if (hasNotChild) {
        this.currentBunyaDetailTemp = setInfo.selected.bunyaName;
        this.currentBunyaIdTemp = isAll ? 'shigoto' : this.selectedBunyaTab;
        this.initialSelectedBunyaSize = 'bunyaL';
        return;
      }
      if (shortCut) {
        this.initialSelectedBunyaSize = 'bunyaS';
        return;
      }
      // 分野項目の中大分類を選択したときは「前画面に戻る」ボタンを活性化
      this.isFirstModal = false;
      //  中・小パネルへ遷移
      this.changePanelState('bunyaS', true);
      this.pushState({
        bunyaL: true,
        bunyaS: true
      });
    },
    /**
     * @desc 分野小分類選択
     * @param {object} bunyaObject - 選択した小分類情報を持つオブジェクト
     */
    setItemS: function setItemS(bunyaObject) {
      var isSh = this.selectedBunyaTab === 'shikaku' && bunyaObject.sCd !== 'all';
      if (!this.isSubmitMode && !isSh) {
        this.initialSelectedBunyaSize = 'bunyaS';
        this.currentBunyaDetailTemp = bunyaObject.sNm;
        this.currentBunyaIdTemp = this.selectedBunyaTab;
      }
      var eventNameKey = formatEventName(this.selectedBunyaTab);
      this['set' + eventNameKey + 'SItem'](bunyaObject.mCd, bunyaObject.sCd, bunyaObject.sNm);
      if (isSh) {
        var shList = Object.assign([], this.shikakuShDispList);
        var newShList = shList.map(function (sh) {
          sh.qsCd = bunyaObject.sCd;
          return sh;
        });
        this.shikakuShDispList = newShList;
      }
    },
    /**
     * @desc 中分類全てを選択
     * @param {object} obj - 選択した中分類情報を持つオブジェクト
     */
    clickAllM: function clickAllM(obj) {
      if (!this.isSubmitMode) {
        this.initialSelectedBunyaSize = 'bunyaS';
        this.currentBunyaDetailTemp = obj.nm;
        this.currentBunyaIdTemp = this.selectedBunyaTab;
      }
      if (obj.isGakumon) {
        this.setGakumonSItem(obj.cd);
      } else {
        var eventNameKey = formatEventName(this.selectedBunyaTab);
        this['set' + eventNameKey + 'MItem'](this.selectedBunyaCdL, 'all');
      }
    },
    /**
     * @desc 分野タブの切り替え
     * @param {string} tabID - 分野タブ名をアルファベットで渡す
     */
    tabChange: function tabChange(tabID) {
      this.clearSelectedLists(this.selectedBunnyaTempLists);
      this.selectedBunyaTab = tabID;
    },
    /**
     * スライドパネル展開
     * @param {string} panelID - slidePanelStateに含まれるパネルID
     * @param {boolean} firstModalFlag - 一つ目のモーダルかどうかのフラグ
     */
    openPanel: function openPanel(panelID, firstModalFlag) {
      if (firstModalFlag) {
        this.isFirstModal = true;
      } else {
        this.isFirstModal = false;
      }
      this.changePanelState(panelID, true);
      this.pushPanelState();
      var searchPanelModal = document.querySelector('.searchPanelModal');
      searchPanelModal.style.display = 'block';
    },
    /**
     * @desc 引数で渡したパネル以外を全て閉じる
     * @param {string} panelID - slidePanelStateに含まれるパネルID
     */
    openPanelAugOnly: function openPanelAugOnly(panelID) {
      var _this9 = this;

      Object.keys(slidePanelState).forEach(function (key) {
        _this9.changePanelState(key, key === panelID);
      });
      this.pushPanelState();
    },
    /**
     * @desc 詳細パネル展開
     */
    openPanelDetail: function openPanelDetail(firstModalFlag) {
      this.saveBunyaPanelInfo();
      this.getCommonSearchMst();
      this.saveSelectedInfo();
      var searchPanelModal = document.querySelector('.searchPanelModal');
      searchPanelModal.style.display = 'block';
      this.openPanel('detail', firstModalFlag);
    },
    /**
     * @desc 市区郡パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     */
    openPanelShikugun: function openPanelShikugun() {
      var isMounted = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      this.updateSkgAreaDispList();
      this.getShikugunSearchMst();
      if (isMounted) return;
      this.openPanel('shikugun');
    },
    /**
     * @desc 路線パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     */
    openPanelRailwayParent: function openPanelRailwayParent() {
      var isMounted = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      this.getRailwaySearchMst();
      if (isMounted) return;
      this.openPanel('railwayParent');
    },
    /**
     * @desc 路線詳細パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     */
    openPanelRailway: function openPanelRailway(areaObj) {
      if (typeof areaObj !== 'object' && areaObj === 'isMounted') {
        this.changePanelState('railway', false);
        return;
      }
      // 「すべて」以外は路線の詳細パネルを設定
      this.updateSttRwKbnDisp(areaObj, '001', 'isInit');
      if (areaObj.areaCd === 'all') {
        this.formSubmit(true);
      } else {
        this.openPanel('railway');
      }
    },
    /**
     * @desc 校種パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     * @param {boolean} firstModalFlag - 一つ目のモーダルかどうかのフラグ
     */
    openPanelKoshu: function openPanelKoshu(isMounted, firstModalFlag) {
      if (isMounted === undefined) isMounted = null;

      this.updateKsDispList();
      if (isMounted) return;
      this.openPanel('koshu', firstModalFlag);
    },
    /**
     * @desc 校種パネル展開とそれに伴う情報の取得（校種パネルを親画面から直接展開する）
     */
    openPanelKoshuDirect: function openPanelKoshuDirect(firstModalFlag) {
      var _this10 = this;

      if (this.commonAjaxSendFlag) {
        this.openPanelKoshu(undefined, firstModalFlag);
      } else {
        this.getCommonSearchMst(function (firstModalFlag) {
          //$watchしているksListの反映を待つために非同期にする
          setTimeout(_this10.openPanelKoshu(undefined, true), 0);
        });
      }
      var searchPanelModal = document.querySelector('.searchPanelModal');
      searchPanelModal.style.display = 'block';
    },
    /**
     * @desc 募集人数パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     */
    openPanelNinzu: function openPanelNinzu() {
      var isMounted = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      this.updateCapDispList();
      if (isMounted) return;
      this.openPanel('ninzu');
    },
    /**
     * @desc 納入金パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     */
    openPanelPayment: function openPanelPayment() {
      var isMounted = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      this.updatePayDispList();
      if (isMounted) return;
      this.openPanel('payment');
    },
    /**
     * @desc 特徴パネル展開とそれに伴う情報の取得
     * @param {any} isMounted - mounted時に実行の際はこのフラグを持たせる。null以外なら指定のパネルを開く
     */
    openPanelTokucho: function openPanelTokucho() {
      var isMounted = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

      this.updateTkDispList();
      if (isMounted) return;
      this.openPanel('tokucho');
    },
    /**
     * @desc 分野パネル選択状況のバックアップをselectedBunyaPanelBkに保存
     */
    saveBunyaPanelInfo: function saveBunyaPanelInfo() {
      var _this11 = this;

      var panelBkObj = Object.assign({}, this.selectedBunyaPanelBk);
      Object.keys(panelBkObj).forEach(function (key) {
        panelBkObj[key] = _this11[key];
      });
      this.selectedBunyaPanelBk = panelBkObj;
    },
    /**
     * @desc 詳細パネルを閉じた際にselectedBunyaPanelBkから分野情報のバックアップをdataに戻す
     */
    restoreBunyaPanelInfo: function restoreBunyaPanelInfo() {
      var _this12 = this;

      var panelBkObj = Object.assign({}, this.selectedBunyaPanelBk);
      Object.keys(panelBkObj).forEach(function (key) {
        _this12[key] = panelBkObj[key];
      });
    },
    /**
     * @desc 詳細パネルを閉じる
     */
    closePanelDetail: function closePanelDetail() {
      var _this13 = this;

      this.sendLog('Ssearch_result_panel_back');
      Object.keys(slidePanelState).forEach(function (key) {
        _this13.changePanelState(key, false);
      });
      var searchPanelModal = document.querySelector('.searchPanelModal');
      searchPanelModal.style.display = 'none';
      this.pushPanelState();
    },
    /**
     * @desc 分野パネルの展開
     */
    openPanelBunya: function openPanelBunya(firstModalFlag) {
      var _this14 = this;

      var searchPanelModal = document.querySelector('.searchPanelModal');
      searchPanelModal.style.display = 'block';
      this.getCommonSearchMst(function () {
        _this14.getAllCount();
      }, 'reInit');
      this.openPanel(this.initialSelectedBunyaSize, firstModalFlag);
    },
    /**
     * @desc 詳細パネルから分野パネルを展開
     */
    openPanelBunyaFromDetail: function openPanelBunyaFromDetail() {
      var _this15 = this;

      this.openPanelBunya();
      if (this.initialSelectedBunyaSize === 'bunyaS') {
        this.updateMDispList();
      }
      this.openedAccordions.forEach(function (cd) {
        _this15.getCountDispS(cd);
      });
    },
    /**
     * @desc 指定のパネルを開閉
     * @param {string} type - slidePanelStateに含まれるパネル種別
     * @param {boolean} isActive - true/falseで指定のパネルを開閉
     */
    changePanelState: function changePanelState(type, isActive) {
      var slidePanelStateObj = JSON.parse(JSON.stringify(this.slidePanelState));
      slidePanelStateObj[type] = isActive;
      this.slidePanelState = Object.assign({}, this.slidePanelState, slidePanelStateObj);
    },
    /**
     * @desc 現在のパネル開閉状態をpushStateする
     */
    pushPanelState: function pushPanelState() {
      var slidePanelStateObj = Object.assign({}, this.slidePanelState);
      this.pushState(slidePanelStateObj);
    },
    /**
     * @desc 受け取ったオブジェクトを元にhistoryへpush
     * @param {object} newSlidePanelState - pushしたい情報を含めたオブジェクト
     */
    pushState: function pushState(newSlidePanelState) {
      var currentSlidePanelState = Object.assign({}, this.slidePanelState);
      Object.keys(newSlidePanelState).forEach(function (key) {
        currentSlidePanelState[key] = newSlidePanelState[key];
      });
      history.pushState({
        slidePanelState: currentSlidePanelState,
        isFirstModal: this.isFirstModal
      }, null, THIS_URL);
    },
    /**
     * @desc 現在のstateを書き換える
     * @param {object} slidePanelState - スライドパネル状態のオブジェクト
     * @param {object} selectedLists - 分野・詳細の選択状況
     * @param {string} bunyaTab - 選択中の分野タブ
     */
    replaceState: function replaceState(slidePanelState, selectedLists, bunyaTab) {
      history.replaceState({ slidePanelState: slidePanelState, selectedLists: selectedLists, bunyaTab: bunyaTab }, null, THIS_URL);
    },
    /**
     * @desc ブラウザバックしつつログも飛ばす
     */
    prevAction: function prevAction() {
      this.sendLog('Ssearch_result_panel_back');
      history.back();
    },
    closeAction: function closeAction() {
      // 検索パネルのモーダルすべて閉じる
      var modalBgElement = document.querySelector('.searchPanelModal');
      modalBgElement.style.display = 'none';
      this.changePanelState('bunyaL', false);
      this.changePanelState('bunyaS', false);
    },
    /**
     * @desc 画面全体のスクロール固定/解除
     */
    bodyFixedChange: function bodyFixedChange() {
      var body = document.body;
      if (this.isPanelOpened) {
        var scrollTop = (0, _jquery2['default'])(window).scrollTop();
        this.currentScroll = scrollTop;
        body.style.position = 'fixed';
        body.style.width = '100%';
        body.style.height = '100%';
        body.style.top = '-' + this.currentScroll + 'px';
      } else {
        body.removeAttribute('style');
        (0, _jquery2['default'])('html, body').animate({ scrollTop: this.currentScroll }, 0);
      }
    },
    /**
     * @desc 分野・詳細の選択を一括解除
     * @param {object} selectedLists - 選択状態オブジェクト
     */
    clearSelectedLists: function clearSelectedLists(selectedLists) {
      Object.keys(selectedLists).forEach(function (key) {
        selectedLists[key].splice(0);
      });
    },
    /*---------------------------------------------------------------
     * [ENN_2019_008] SP 一覧絞り込み改善 分野＋詳細条件パネルのリセット対応
     *---------------------------------------------------------------*/
    /**
     * @desc 分野＋詳細条件リセット
     */
    clearAllSearch: function clearAllSearch() {
      // クリア時のヒット件数API実行中の場合、多重処理防止のため何もしない
      if (this.countAjaxSendFlag) {
        return false;
      }

      // ログ送信
      this.sendLog('Ssearch_result_panel_refine_reset');

      this.clearSelectedLists(this.selectedBunnyaTempLists);
      this.clearSelectedLists(this.selectedLists);

      this.currentBunyaIdTemp = 'shigoto';
      this.currentBunyaDetailTemp = 'すべて';

      this.selectedBunyaTab = 'shigoto';
      this.initialSelectedBunyaSize = 'bunyaL';
      this.openedAccordions = [];
      this.selectedBunyaCdL = '';
      this.selectedBunyaKeyM = '';
      this.selectedBunyaKeyS = '';

      this.isGakumonSelected = false;
      this.isShikakuSelected = false;
      this.isShigotoSelected = false;
      this.isGakubuKeitouSelected = false;

      this.isKoshuAllSelected = true;
      this.selectedKoshuNm = 'すべて';
      this.selectedAreaRailwayNms = ['すべて'];
      this.isSkgSelectRefresh = true;
      this.isSttSelectRefresh = true;
      this.isSttCountAreaReady = false;
      this.isAreaAllSelected = true;
      this.isCapAllSelected = true;
      this.selectedCapNm = 'すべて';
      this.isPayAllSelected = true;
      this.selectedPayNm = 'すべて';
      this.checkedTokuchoList.splice(0);
      this.isTokuchoAllChecked = false;
      this.isTokuchoAllSelected = true;
      this.selectedTokuchoNms.splice(0);
      this.selectedTokuchoNms.push('すべて');
      this.getDetailCount();

      this.resetSelectedSkg();
      this.resetSelectedStt();
    },
    /**
     * @desc パラメータを内部データへと変換
     */
    convertSkgSelectData: function convertSkgSelectData() {
      var _this16 = this;

      // 初期化
      this.selectedSkgObj.areaSelected = {};
      this.selectedSkgObj.tdfkSelected = {};
      // 変換
      this.selectedLists.skgList.forEach(function (skgsObj) {
        // エリアだった場合
        if (skgsObj.name === 'area') {
          _this16.selectedSkgObj.areaSelected[skgsObj.value] = ['all'];
        }
        // 都道府県だった場合
        else if (skgsObj.name === 'tdfk') {
            var areaCd = _this16.tdfk2AreaMst[skgsObj.value];

            _this16.selectedSkgObj.tdfkSelected[skgsObj.value] = ['all'];
            if (_this16.selectedSkgObj.areaSelected[areaCd] === undefined) {
              _this16.selectedSkgObj.areaSelected[areaCd] = [];
            }
            _this16.selectedSkgObj.areaSelected[areaCd].push(skgsObj.value);
          }
          // 市区郡だった場合
          else {
              var areaCd = undefined,
                  tdfkCd = undefined;

              tdfkCd = skgsObj.value.slice(0, 2).toString();
              areaCd = _this16.tdfk2AreaMst[tdfkCd];
              if (_this16.selectedSkgObj.tdfkSelected[tdfkCd] === undefined) {
                _this16.selectedSkgObj.tdfkSelected[tdfkCd] = [];
              }
              _this16.selectedSkgObj.tdfkSelected[tdfkCd].push(skgsObj.value);
              if (_this16.selectedSkgObj.areaSelected[areaCd] === undefined) {
                _this16.selectedSkgObj.areaSelected[areaCd] = [];
              }
              _this16.selectedSkgObj.areaSelected[areaCd].push(tdfkCd);
            }
      });
      vm.$forceUpdate();
    },
    /**
     * @desc パラメータを内部データへと変換
     */
    convertSttSelectData: function convertSttSelectData() {
      var _this17 = this;

      if (!this.isSttCountAreaReady) {
        return;
      }
      // 初期化
      this.selectedSttObj.rwKbnSelected = {};
      this.selectedSttObj.rwSelected = {};
      // 変換
      this.selectedLists.sttList.forEach(function (sttsObj) {
        // エリアだった場合
        if (sttsObj.name === 'area') {
          _this17.rwKbnMst.forEach(function (kbnKey) {
            var arwk = sttsObj.value + kbnKey;
            _this17.selectedSttObj.rwKbnSelected[arwk] = ['all'];
          });
        }
        // 路線区分だった場合
        else if (sttsObj.name === 'arkc') {
            _this17.selectedSttObj.rwKbnSelected[sttsObj.value] = ['all'];
          }
          // 路線だった場合
          else if (sttsObj.name === 'rwc') {
              var arwk = '';

              _this17.selectedSttObj.rwSelected[sttsObj.value] = ['all'];
              arwk = _this17.rw2ArwkMst[sttsObj.value];
              if (_this17.selectedSttObj.rwKbnSelected[arwk] == undefined) {
                _this17.selectedSttObj.rwKbnSelected[arwk] = [];
              }
              _this17.selectedSttObj.rwKbnSelected[arwk].push(sttsObj.value);
            }
            // 駅だった場合
            else {
                var railwayStationCd = sttsObj.value,
                    railwayCd = railwayStationCd.slice(0, -5),
                    stationCd = railwayStationCd.slice(-5),
                    awrkCd = _this17.rw2ArwkMst[railwayCd];

                if (_this17.selectedSttObj.rwSelected[railwayCd] === undefined) {
                  _this17.selectedSttObj.rwSelected[railwayCd] = [];
                }
                _this17.selectedSttObj.rwSelected[railwayCd].push(stationCd);
                if (_this17.selectedSttObj.rwKbnSelected[awrkCd] == undefined) {
                  _this17.selectedSttObj.rwKbnSelected[awrkCd] = [];
                }
                _this17.selectedSttObj.rwKbnSelected[awrkCd].push(awrkCd);
              }
      });
      vm.$forceUpdate();
    },
    /**
     * @desc 特長選択時処理
     */
    checkTokucho: function checkTokucho() {
      this.isTokuchoAllChecked = this.checkedTokuchoList.length === this.getExcludeFirstItem(this.tkDispList).length;
    },
    /**
     * @desc 特長全選択時処理
     */
    checkAllTokucho: function checkAllTokucho() {
      var _this18 = this;

      // 選択リスト初期化
      this.checkedTokuchoList.splice(0);
      if (!this.isTokuchoAllChecked) {
        this.getExcludeFirstItem(this.tkDispList).forEach(function (tokucho) {
          _this18.checkedTokuchoList.push(tokucho.tkCd);
        });
      }
      this.isTokuchoAllChecked = !this.isTokuchoAllChecked;
    },
    /**
     * @desc 市区郡すべてチェック処理
     */
    checkSkgAll: function checkSkgAll() {
      var _this19 = this;

      // 都道府県配下の市区郡操作
      this.skgList.checkAreaList.splice(0);
      if (this.skgList.isCheckAreaAll) {
        this.getExcludeFirstItem(this.skgList).forEach(function (areaObj) {
          if (areaObj.count === 0) {
            return;
          }
          // エリア全部にチェック入れる。
          _this19.skgList.checkAreaList.push(areaObj.areaCd);
          // 配下の全都道府県・市区郡にチェックを入れる
          areaObj.isCheckTdfkAll = true;
          if (areaObj.todofukenList !== null) {
            areaObj.todofukenList.forEach(function (tdfkObj) {
              if (tdfkObj.todofukenCd === 'all') {
                return;
              }
              areaObj.checkTdfkList.push(tdfkObj.todofukenCd);
              tdfkObj.isCheckSkgAll = true;
              if (tdfkObj.shikugunLList === null) {
                return;
              }
              tdfkObj.shikugunLList.forEach(function (skgObj) {
                if (skgObj.count === 0 || skgObj.count === undefined || skgObj.shikugunLCd === 'all') {
                  return;
                }
                tdfkObj.checkSkgList.push(skgObj.shikugunLCd);
              });
            });
          }
        });
      } else {
        this.getExcludeFirstItem(this.skgList).forEach(function (areaObj) {
          // 配下の全都道府県・市区郡を初期化
          areaObj.isCheckTdfkAll = false;
          areaObj.checkTdfkList.splice(0);
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.todofukenCd === 'all') {
              return;
            }
            tdfkObj.isCheckSkgAll = false;
            tdfkObj.checkSkgList.splice(0);
          });
        });
        vm.$forceUpdate();
      }
    },
    /**
     * @desc 該当エリア内の都道府県すべてチェック処理
     * @param {object} areaObj - エリア名やエリアコードを持つオブジェクト
     * @param {object} event - チェックボックスのevent
     */
    checkSkgAreaAll: function checkSkgAreaAll(areaObj, event) {
      // 都道府県チェック処理
      areaObj.checkTdfkList.splice(0);
      if (event.target.checked) {
        // 配下の全都道府県・市区郡にチェックを入れる
        areaObj.isCheckTdfkAll = true;
        if (areaObj.todofukenList !== null) {
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.todofukenCd === 'all') {
              return;
            }
            areaObj.checkTdfkList.push(tdfkObj.todofukenCd);
            tdfkObj.isCheckSkgAll = true;
            if (tdfkObj.shikugunLList === null) {
              return;
            }
            tdfkObj.shikugunLList.forEach(function (skgObj) {
              if (skgObj.count === 0 || skgObj.count === undefined || skgObj.shikugunLCd === 'all') {
                return;
              }
              tdfkObj.checkSkgList.push(skgObj.shikugunLCd);
            });
          });
        }
      } else {
        // 配下の全都道府県・市区郡を初期化
        areaObj.isCheckTdfkAll = false;
        areaObj.checkTdfkList.splice(0);
        areaObj.todofukenList.forEach(function (tdfkObj) {
          if (tdfkObj.todofukenCd === 'all') {
            return;
          }
          tdfkObj.isCheckSkgAll = false;
          tdfkObj.checkSkgList.splice(0);
        });
      }
      // エリアチェック処理
      this.skgList.isCheckAreaAll = this.skgList.checkAreaList.length === this.skgList.maxCount;
      vm.$forceUpdate();
    },
    /**
     * @desc 都道府県内の「市区郡すべて」チェック処理
     * @param {object} areaObj - エリア名やエリアコードを持つオブジェクト
     * @param {object} tdfkObj - 都道府県名や都道府県コードを持つオブジェクト
     * @param {object} event - チェックボックスのevent
     */
    checkSkgTdfkAll: function checkSkgTdfkAll(areaObj, tdfkObj, event) {
      // チェック処理
      tdfkObj.checkSkgList.splice(0);
      if (event.target.checked) {
        // 配下の全市区郡にチェックを入れる
        tdfkObj.isCheckSkgAll = true;
        if (tdfkObj.shikugunLList !== null) {
          tdfkObj.shikugunLList.forEach(function (skgObj) {
            if (skgObj.count === 0 || skgObj.count === null || skgObj.shikugunLCd === 'all') {
              return;
            }
            tdfkObj.checkSkgList.push(skgObj.shikugunLCd);
          });
        }
      } else {
        // 配下の全市区郡を初期化
        tdfkObj.isCheckSkgAll = false;
      }
      // 都道府県チェック処理
      this.skgList.checkAreaList = this.skgList.checkAreaList.filter(function (areaCd) {
        return areaCd !== areaObj.areaCd;
      });
      areaObj.isCheckTdfkAll = areaObj.maxCount === areaObj.checkTdfkList.length;
      if (areaObj.isCheckTdfkAll) {
        this.skgList.checkAreaList.push(areaObj.areaCd);
      }
      // エリアチェック処理
      this.skgList.isCheckAreaAll = this.skgList.checkAreaList.length === this.skgList.maxCount;
      vm.$forceUpdate();
    },
    /**
     * @desc 市区郡チェック処理
     * @param {object} areaObj - エリア名やエリアコードを持つオブジェクト
     * @param {object} tdfkObj - 都道府県名や都道府県コードを持つオブジェクト
     */
    checkSkg: function checkSkg(areaObj, tdfkObj) {
      areaObj.checkTdfkList = areaObj.checkTdfkList.filter(function (tdfkCd) {
        return tdfkCd !== tdfkObj.todofukenCd;
      });
      tdfkObj.isCheckSkgAll = tdfkObj.maxCount === tdfkObj.checkSkgList.length;
      if (tdfkObj.isCheckSkgAll) {
        areaObj.checkTdfkList.push(tdfkObj.todofukenCd);
      }
      // 都道府県チェック処理
      this.skgList.checkAreaList = this.skgList.checkAreaList.filter(function (areaCd) {
        return areaCd !== areaObj.areaCd;
      });
      areaObj.isCheckTdfkAll = areaObj.maxCount === areaObj.checkTdfkList.length;
      if (areaObj.isCheckTdfkAll) {
        this.skgList.checkAreaList.push(areaObj.areaCd);
      }
      // エリアチェック処理
      this.skgList.isCheckAreaAll = this.skgList.checkAreaList.length === this.skgList.maxCount;
      vm.$forceUpdate();
    },
    /**
     * @desc 路線区分「すべて」チェック処理
     * @param {object} event - チェックボックスのevent
     */
    checkSttRwKbn: function checkSttRwKbn(event) {
      var _this20 = this;

      if (event.target.checked) {
        if (this.rwKbnObjSelected.railwayList === null) {
          return;
        }
        this.rwKbnObjSelected.isCheckRwAll = true;
        this.rwKbnObjSelected.railwayList.forEach(function (rwObj) {
          // 配下の駅にチェックを入れる
          _this20.rwKbnObjSelected.checkRwList.push(rwObj.railwayCd);
          rwObj.isCheckSttAll = true;
          if (rwObj.stationList === null) {
            return;
          }
          rwObj.stationList.forEach(function (sttObj) {
            if (sttObj.count === 0 || sttObj.count === null || sttObj.stationCd === 'all') {
              return;
            }
            rwObj.checkSttList.push(sttObj.stationCd);
          });
        });
      } else {
        // 配下の駅を初期化
        if (this.rwKbnObjSelected.railwayList === null) {
          return;
        }
        this.rwKbnObjSelected.isCheckRwAll = false;
        this.rwKbnObjSelected.checkRwList.splice(0);
        this.rwKbnObjSelected.railwayList.forEach(function (rwObj) {
          if (rwObj.railwayCd === 'all' || rwObj.stationList === null) {
            return;
          }
          // 配下の駅にチェックを入れる
          rwObj.checkSttList.splice(0);
          rwObj.isCheckSttAll = false;
        });
      }
      vm.$forceUpdate();
    },
    /**
     * @desc 路線は以下のすべての駅チェック処理
     * @param {object} rwObj - 路線名や路線コードなどを持つオブジェクト
     * @param {object} event - チェックボックスのevent
     */
    checkSttRw: function checkSttRw(rwObj, event) {
      rwObj.checkSttList.splice(0);
      if (event.target.checked) {
        // 配下の駅にチェックを入れる
        rwObj.isCheckSttAll = true;
        if (rwObj.stationList !== null) {
          rwObj.stationList.forEach(function (sttObj) {
            if (sttObj.count === 0 || sttObj.count === null || sttObj.stationCd === 'all') {
              return;
            }
            rwObj.checkSttList.push(sttObj.stationCd);
          });
        }
      } else {
        // 配下の駅を初期化
        rwObj.isCheckSttAll = false;
      }
      // 路線区分チェック処理
      this.rwKbnObjSelected.isCheckRwAll = this.rwKbnObjSelected.maxCount === this.rwKbnObjSelected.checkRwList.length;
      vm.$forceUpdate();
    },
    /**
     * @desc 駅チェック処理
     * @param {object} rwObj - 路線名や路線コードなどを持つオブジェクト
     */
    checkStt: function checkStt(rwObj) {
      this.rwKbnObjSelected.checkRwList = this.rwKbnObjSelected.checkRwList.filter(function (rwCd) {
        return rwCd !== rwObj.railwayCd;
      });
      rwObj.isCheckSttAll = rwObj.maxCount === rwObj.checkSttList.length;
      if (rwObj.isCheckSttAll) {
        this.rwKbnObjSelected.checkRwList.push(rwObj.railwayCd);
      }
      // 路線チェック処理
      this.rwKbnObjSelected.isCheckRwAll = this.rwKbnObjSelected.maxCount === this.rwKbnObjSelected.checkRwList.length;
      vm.$forceUpdate();
    },
    /**
     * @desc 検索パネル検索実行処理
     * @param {boolean} referDetailPanelState - 詳細パネル展開の有無により、submit処理を分岐させるためのフラグ
     */
    formSubmit: function formSubmit() {
      var _this21 = this;

      var referDetailPanelState = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      // 詳細パネル展開時はsubmitしない
      if (referDetailPanelState && this.slidePanelState.detail) {
        this.getDetailCount();
        this.selectDetail();
        return;
      }
      // 現在のフォーム情報を削除
      var $form = (0, _jquery2['default'])('#searchForm');
      $form.find('input').each(function () {
        (0, _jquery2['default'])(this).remove();
      });
      Object.keys(this.selectedLists).forEach(function (listKey) {
        var targetList = _this21.selectedLists[listKey];
        targetList.forEach(function (param) {
          if (param.value === 'all') return;
          if (param !== {} || param !== []) {
            $form.append('<input type="hidden" name="' + param.name + '" value="' + param.value + '" />');
          }
        });
      });
      if (this.selectedLists.skgList.length > 0) {
        $form.append('<input type="hidden" name="af" value="2" />');
      } else if (this.selectedLists.sttList.length > 0) {
        $form.append('<input type="hidden" name="af" value="1" />');
      }
      this.replaceState(this.slidePanelState, this.selectedLists, this.selectedBunyaTab);
      $form.append();
      $form.submit();
    },
    /**
     * @desc 市区郡・路線パネル名称フォーマット
     * @param {array} areaArray 選択中の市区郡・路線パネル名称のリスト
     */
    formatAreaNm: function formatAreaNm(areaArray) {
      if (this.isAreaAllSelected) {
        return 'すべて';
      }
      return areaArray.join('、');
    },
    getListMaxCount: function getListMaxCount(list) {
      var filteredArray = [],
          ALL_NUM = 1;
      filteredArray = list.filter(function (item) {
        return item.count !== undefined && item.count > 0;
      });
      return filteredArray.length - ALL_NUM;
    },
    getFirstItemCount: function getFirstItemCount(list) {
      if (list === undefined || null) {
        return 0;
      } else if (list.length === 0) {
        return 0;
      } else if (list[0].count === undefined) {
        return 0;
      } else {
        return list[0].count;
      }
    },
    /**
     * @desc 対象のリストから先頭1個目を削除して返す
     * @param {array} list - 整形対象のリスト
     */
    getExcludeFirstItem: function getExcludeFirstItem(list) {
      if (list === undefined || list === null) {
        return [];
      } else if (list.length === 1) {
        return list;
      }
      return list.filter(function (item, index) {
        return index > 0;
      });
    },
    /**
     * @desc 市区郡・路線以外パネルデータ取得
     * @param {function} callback - パネルデータ取得後に実行する関数
     * @param {any} reInit - 例外時はreInitにnull以外を設定し、再度Ajaxを有効にする
     */
    getCommonSearchMst: function getCommonSearchMst() {
      var _this22 = this;

      var callback = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
      var reInit = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (reInit) {
        this.commonAjaxSendFlag = false;
      }
      // 多重送信防止フラグ
      if (this.commonAjaxSendFlag) {
        return false;
      }
      this.commonAjaxSendFlag = true;
      _jquery2['default'].ajax({
        url: '/smp/searchList/searchPanelContentsForJson/',
        method: 'POST',
        traditional: true,
        dataType: 'json'
      }).then(function (data) {
        Object.keys(data).forEach(function (key) {
          if (_this22.$root[key].length === 0 && data[key] !== null) {
            _this22.$root[key] = data[key];
          }
        });
        if (!callback) return;
        callback();
      }, function (data) {
        _this22.commonAjaxSendFlag = false;
      });
    },
    /**
     * @desc 市区郡パネルデータ取得
     */
    getShikugunSearchMst: function getShikugunSearchMst() {
      var _this23 = this;

      // 多重送信防止フラグ
      if (this.shikugunAjaxSendFlag) {
        return false;
      }
      this.shikugunAjaxSendFlag = true;
      _jquery2['default'].ajax({
        url: '/smp/searchList/searchPanelContentsShikugunForJson/',
        method: 'POST',
        traditional: true,
        dataType: 'json'
      }).then(function (data) {
        Object.keys(data).forEach(function (key) {
          if (_this23.$root[key].length === 0 && data[key] !== null) {
            _this23.$root[key] = data[key];
          }
        });
        _this23.isSkgCountAreaReady = true;
      }, function (data) {
        _this23.shikugunAjaxSendFlag = false;
      });
    },
    /**
     * @desc 路線パネルデータ取得
     */
    getRailwaySearchMst: function getRailwaySearchMst() {
      var _this24 = this;

      // 多重送信防止フラグ
      if (this.railwayAjaxSendFlag) {
        return false;
      }
      this.railwayAjaxSendFlag = true;
      _jquery2['default'].ajax({
        url: '/smp/searchList/searchPanelContentsStationForJson/',
        method: 'POST',
        traditional: true,
        dataType: 'json'
      }).then(function (data) {
        Object.keys(data).forEach(function (key) {
          if (_this24.$root[key].length === 0 && data[key] !== null) {
            _this24.$root[key] = data[key];
          }
        });
        _this24.isSttCountAreaReady = true;
        _this24.railwayAjaxSendFlag = false;
      }, function (data) {
        _this24.railwayAjaxSendFlag = false;
      });
    },
    getShigotoLItem: function getShigotoLItem(jlCd) {
      return this.jlList.find(function (jlObj) {
        return jlObj.jlCd === jlCd;
      });
    },
    getShigotoMItem: function getShigotoMItem(jlCd, jmCd) {
      var jlObj = this.jlList.find(function (jlObj) {
        return jlObj.jlCd === jlCd;
      });
      return jlObj.jmList.find(function (jmObj) {
        return jmObj.jmCd === jmCd;
      });
    },
    getShikakuLItem: function getShikakuLItem(qlCd) {
      return this.qlList.find(function (qlObj) {
        return qlObj.qlCd === qlCd;
      });
    },
    getShikakuMItem: function getShikakuMItem(qlCd, qmCd) {
      var qlObj = this.qlList.find(function (qlObj) {
        return qlObj.qlCd === qlCd;
      });
      return qlObj.qmList.find(function (qmObj) {
        return qmObj.qmCd === qmCd;
      });
    },
    getGakumonLItem: function getGakumonLItem(glCd) {
      return this.glList.find(function (glObj) {
        return glObj.glCd === glCd;
      });
    },
    getGakumonSItem: function getGakumonSItem(glCd, gsCd) {
      var glObj = this.glList.find(function (glObj) {
        return glObj.glCd === glCd;
      });

      return glObj.gsList.find(function (gsObj) {
        return gsObj.gsCd === gsCd;
      });
    },
    getSkgLItem: function getSkgLItem(areaCd) {
      var areaObj = this.skgList.find(function (areaObj) {
        return areaObj.areaCd === areaCd;
      });

      return areaObj;
    },
    getSkgMItem: function getSkgMItem(todofukenCd) {
      var areaCd = this.tdfk2AreaMst[todofukenCd],
          areaObj = this.skgList.find(function (areaObj) {
        return areaObj.areaCd === areaCd;
      }),
          tdfkObj = areaObj.todofukenList.find(function (tdfkObj) {
        return tdfkObj.todofukenCd === todofukenCd;
      });
      return tdfkObj;
    },
    getSkgSItem: function getSkgSItem(sklcCd) {
      var todofukenCd = sklcCd.slice(0, 2).toString(),
          areaCd = this.tdfk2AreaMst[todofukenCd],
          areaObj = this.skgList.find(function (areaObj) {
        return areaObj.areaCd === areaCd;
      }),
          tdfkObj = areaObj.todofukenList.find(function (tdfkObj) {
        return tdfkObj.todofukenCd === todofukenCd;
      }),
          sklcObj = tdfkObj.shikugunLList.find(function (sklcObj) {
        return sklcObj.shikugunLCd === sklcCd;
      });

      return sklcObj;
    },
    getSttAreaItem: function getSttAreaItem(areaCd) {
      var areaObj = this.sttList.find(function (areaObj) {
        return areaObj.areaCd === areaCd;
      });

      return areaObj;
    },
    getSttRwKbnItem: function getSttRwKbnItem(areaObj, rwKbnCd) {
      var rwKbnObj = areaObj.railwaykbnList.find(function (rwKbnObj) {
        return rwKbnObj.railwayKbnCd === rwKbnCd;
      });

      return rwKbnObj;
    },
    getSttRwItem: function getSttRwItem(areaObj, rwCd) {
      var arwkCd = this.rw2ArwkMst[rwCd],
          rwKbCd = arwkCd.slice(2),
          rwKbnObj = this.getSttRwKbnItem(areaObj, rwKbCd),
          rwObj = rwKbnObj.railwayList.find(function (rwObj) {
        return rwObj.railwayCd === rwCd;
      });

      return rwObj;
    },
    getSttItem: function getSttItem(areaObj, sttCd) {
      var rwCd = sttCd.slice(0, -5),
          stationCd = sttCd.slice(-5),
          rwObj = this.getSttRwItem(areaObj, rwCd),
          sttObj = rwObj.stationList.find(function (sttObj) {
        return sttObj.stationCd === stationCd;
      });

      return sttObj;
    },
    /**
     * @desc 詳細パネル件数取得API呼び出し
     */
    getDetailCount: function getDetailCount() {
      var _this25 = this;

      // 多重送信防止フラグ
      if (this.countAjaxSendFlag) {
        return false;
      }

      var sendData = [];

      Object.keys(this.selectedLists).forEach(function (key) {
        if (_this25.selectedLists[key] !== []) {
          var selectedList = [];
          Object.assign(selectedList, _this25.selectedLists[key]);
          selectedList = selectedList.filter(function (obj) {
            return obj.value !== 'all';
          });
          sendData.push.apply(sendData, _toConsumableArray(selectedList));
        }
      });

      this.countAjaxSendFlag = true;
      setTimeout(function () {
        _jquery2['default'].ajax({
          url: '/smp/searchList/searchCountDetail/',
          method: 'GET',
          traditional: true,
          dataType: 'json',
          data: sendData
        }).then(function (data) {
          if (data.length) {
            (0, _jquery2['default'])({
              count: 0
            }).animate({
              count: Number(data[0].SearchPanelCount)
            }, {
              duration: 500,
              easing: 'linear',
              progress: function progress() {
                (0, _jquery2['default'])('.js-detailSearchCount').text(('0000' + Math.ceil(this.count)).slice(-4));
              }
            });
          }
          _this25.countAjaxSendFlag = false;
        }, function () {
          console.log('error');
          _this25.countAjaxSendFlag = false;
        });
      }, 200);
    },
    /**
     * @desc 分野パネル 大項目「すべて」の件数取得
     */
    getAllCount: function getAllCount() {
      this.updateShigotoLDispList();
      this.updateShikakuLDispList();
      this.updateGakumonLDispList();
      this.updateGbkDispList();
    },
    // 件数取得API呼び出し
    /**
     * @desc 件数取得APIの呼び出し
     * @param {object} sourceLists - 現在選択中の情報オブジェクト。selectedListを渡す
     * @param {array} deleteParams - sourceListsの中から削除したいキーの配列
     * @param {string} panelType - パネルの種別
     * @param {*} subParamList - サブパラメータ
     */
    getCount: function getCount(sourceLists, deleteParams, panelType, subParamList) {
      var sendData = [],
          sendLists = {},
          deferred = new _jquery2['default'].Deferred();

      sendLists = Object.assign({}, sourceLists);

      deleteParams.forEach(function (param) {
        delete sendLists[param];
      });
      // パネル種別をセット
      sendData.push({
        name: 'panelShubetsu',
        value: panelType
      });
      // サブパラメータをセット
      if (subParamList !== undefined && subParamList !== []) {
        subParamList.forEach(function (subParamObj) {
          sendData.push(subParamObj);
        });
      }
      // 空データは削除
      Object.keys(sendLists).forEach(function (key) {
        if (sendLists[key] !== []) {
          sendData.push.apply(sendData, _toConsumableArray(sendLists[key]));
        }
      });
      _jquery2['default'].ajax({
        url: '/smp/searchList/searchCount/',
        method: 'GET',
        traditional: true,
        dataType: 'json',
        data: sendData
      }).then(function (data) {
        return deferred.resolve(data);
      }, function () {
        return deferred.reject();
      });
      return deferred.promise();
    },
    /**
     * @desc 市区郡エリアすべて選択状態判定
     * @param {string} areaCd - エリアコード
     */
    hasAreaAll: function hasAreaAll(areaCd) {
      return this.selectedSkgObj.areaSelected[areaCd] == 'all';
    },
    /**
     * @desc 市区郡都道府県すべて選択状態判定
     * @param {string} tdfkCd - 都道府県コード
     */
    hasTdfkAll: function hasTdfkAll(tdfkCd) {
      var areaCd = undefined;
      areaCd = this.tdfk2AreaMst[tdfkCd];
      return this.selectedSkgObj.tdfkSelected[tdfkCd] == 'all' || this.selectedSkgObj.areaSelected[areaCd] == 'all';
    },
    /**
     * @desc 市区郡選択パラメータ変換処理
     */
    initSkgParam: function initSkgParam() {
      var $initAreas = (0, _jquery2['default'])('input[name="area"].areaParamFlag'),
          $initTdfks = (0, _jquery2['default'])('input[name="tdfk"].areaParamFlag'),
          $initSklcs = (0, _jquery2['default'])('input[name="sklc"].areaParamFlag'),
          selectedSkgList = this.selectedLists.skgList;
      $initAreas.each(function () {
        var addParamObj = undefined;
        addParamObj = {
          name: 'area',
          value: (0, _jquery2['default'])(this).val()
        };
        selectedSkgList.push(addParamObj);
      });
      $initTdfks.each(function () {
        var addParamObj = undefined;
        addParamObj = {
          name: 'tdfk',
          value: (0, _jquery2['default'])(this).val()
        };
        selectedSkgList.push(addParamObj);
      });
      $initSklcs.each(function () {
        var addParamObj = undefined;
        addParamObj = {
          name: 'sklc',
          value: (0, _jquery2['default'])(this).val()
        };
        selectedSkgList.push(addParamObj);
      });
    },
    /**
     * @desc 市区郡選択パラメータ変換処理
     */
    initSttParam: function initSttParam() {
      var $initAreas = (0, _jquery2['default'])('input[name="area"].areaParamFlag'),
          $initArkcs = (0, _jquery2['default'])('input[name="arkc"].areaParamFlag'),
          $initRwcs = (0, _jquery2['default'])('input[name="rwc"].areaParamFlag'),
          $initRwscs = (0, _jquery2['default'])('input[name="rwsc"].areaParamFlag'),
          selectedSttList = this.selectedLists.sttList;

      $initAreas.each(function (index, element) {
        var addParamObj = undefined,
            areaCd = (0, _jquery2['default'])(element).val();
        addParamObj = {
          name: 'area',
          value: areaCd
        };
        selectedSttList.push(addParamObj);
      });
      $initArkcs.each(function (index, element) {
        var addParamObj = undefined,
            awrkCd = (0, _jquery2['default'])(element).val();
        addParamObj = {
          name: 'arkc',
          value: awrkCd
        };
        selectedSttList.push(addParamObj);
      });
      $initRwcs.each(function (index, element) {
        var addParamObj = undefined,
            rwCd = (0, _jquery2['default'])(element).val();
        addParamObj = {
          name: 'rwc',
          value: rwCd
        };
        selectedSttList.push(addParamObj);
      });
      $initRwscs.each(function (index, element) {
        var addParamObj = undefined,
            rwsCd = (0, _jquery2['default'])(element).val();
        addParamObj = {
          name: 'rwsc',
          value: rwsCd
        };
        selectedSttList.push(addParamObj);
      });
    },
    /**
     * @desc 市区郡チェック状態：初期化処理
     */
    initSkgCheck: function initSkgCheck() {
      var _this26 = this;

      this.skgList.checkAreaList = [];
      this.skgList.isCheckAreaAll = false;
      this.skgList.forEach(function (areaObj) {
        if (areaObj.todofukenList === null || areaObj.areaCd === 'all') {
          return;
        }
        var areaSelected = _this26.selectedSkgObj.areaSelected[areaObj.areaCd];

        areaObj.checkTdfkList = [];
        areaObj.isCheckTdfkAll = false;
        if (areaSelected == 'all') {
          // エリア全選択の時
          areaObj.isCheckTdfkAll = true;
          _this26.skgList.checkAreaList.push(areaObj.areaCd);
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.todofukenCd === 'all') {
              return;
            }
            tdfkObj.checkSkgList = [];
            areaObj.checkTdfkList.push(tdfkObj.todofukenCd);
            tdfkObj.isCheckSkgAll = true;
          });
        } else if (areaSelected === undefined || areaSelected === []) {
          // エリア非選択時
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.shikugunLList === null) {
              return;
            }
            tdfkObj.isCheckSkgAll = false;
            tdfkObj.checkSkgList = [];
          });
        } else {
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.todofukenCd === 'all') {
              return;
            }
            tdfkObj.isCheckSkgAll = false;
            tdfkObj.checkSkgList = [];
            var tdfkSelected = _this26.selectedSkgObj.tdfkSelected[tdfkObj.todofukenCd];

            if (tdfkSelected == 'all') {
              tdfkObj.isCheckSkgAll = true;
              areaObj.checkTdfkList.push(tdfkObj.todofukenCd);
            } else if (!(tdfkSelected === undefined || tdfkSelected === [])) {
              tdfkSelected.forEach(function (skgCd) {
                tdfkObj.checkSkgList.push(skgCd);
              });
            }
          });
        }
      });
      vm.$forceUpdate();
    },
    /**
     * @desc 路線パネルチェック状態：初期化処理
     * @param {objevt} rwKbnObj - 路線区分のオブジェクト
     */
    initSttAreaCheck: function initSttAreaCheck(rwKbnObj) {
      var _this27 = this;

      if (rwKbnObj.isCheckRwAll !== undefined && rwKbnObj.checkRwList !== undefined) {
        return;
      }
      var rwKbnCd = rwKbnObj.railwayKbnCd,
          areaCd = this.rwAreaObjSelected.areaCd,
          arwkCd = areaCd + rwKbnCd,
          rwKbnSelected = this.selectedSttObj.rwKbnSelected[arwkCd];

      rwKbnObj.isCheckRwAll = false;
      rwKbnObj.checkRwList = [];

      if (rwKbnSelected == 'all') {
        rwKbnObj.isCheckRwAll = true;
        rwKbnObj.railwayList.forEach(function (rwObj) {
          if (rwObj.railwayCd === 'all') {
            return;
          }
          rwObj.isCheckSttAll = true;
          rwObj.checkSttList = [];
        });
      } else if (rwKbnSelected === undefined || rwKbnSelected === []) {
        rwKbnObj.railwayList.forEach(function (rwObj) {
          if (rwObj.railwayCd === 'all') {
            return;
          }
          rwObj.isCheckSttAll = false;
          rwObj.checkSttList = [];
        });
      } else {
        rwKbnObj.railwayList.forEach(function (rwObj) {
          if (rwObj.railwayCd === 'all') {
            return;
          }
          rwObj.isCheckSttAll = false;
          rwObj.checkSttList = [];
          var rwSelected = _this27.selectedSttObj.rwSelected[rwObj.railwayCd];
          if (rwSelected == 'all') {
            rwObj.isCheckSttAll = true;
            rwKbnObj.checkRwList.push(rwObj.railwayCd);
          } else if (!(rwSelected === undefined || rwSelected === [])) {
            rwSelected.forEach(function (sttCd) {
              rwObj.checkSttList.push(sttCd);
            });
          }
        });
      }
      rwKbnObj.isInitialized = true;
    },
    /**
     * @desc 対象のタブの選択状況を返す
     * @param {string} tabCd - タブコード
     */
    isActiveTab: function isActiveTab(tabCd) {
      return this.rwKbnSelected === tabCd;
    },
    identificationArea: function identificationArea() {
      var areaList = [],
          arwkList = [],
          rwcList = [],
          rwscList = [];

      areaList = this.selectedLists.sttList.filter(function (param) {
        return param.name === 'area';
      });
      if (areaList.length > 0) {
        var areaCd = areaList[0].value;
        this.rwAreaObjSelected = this.getSttAreaItem(areaCd);
        this.rwAreaObjTempSelected = Object.assign({}, this.rwAreaObjSelected);
        return;
      }
      arwkList = this.selectedLists.sttList.filter(function (param) {
        return param.name === 'arkc';
      });
      if (arwkList.length > 0) {
        var arwkCd = arwkList[0].value,
            areaCd = arwkCd.slice(0, 2);
        this.rwAreaObjSelected = this.getSttAreaItem(areaCd);
        this.rwAreaObjTempSelected = Object.assign({}, this.rwAreaObjSelected);
        return;
      }
      rwcList = this.selectedLists.sttList.filter(function (param) {
        return param.name === 'rwc';
      });
      if (rwcList.length > 0) {
        var rwCd = rwcList[0].value,
            arwkCd = this.rw2ArwkMst[rwCd],
            areaCd = arwkCd.slice(0, 2);
        this.rwAreaObjSelected = this.getSttAreaItem(areaCd);
        this.rwAreaObjTempSelected = Object.assign({}, this.rwAreaObjSelected);
        return;
      }
      rwscList = this.selectedLists.sttList.filter(function (param) {
        return param.name === 'rwsc';
      });
      if (rwscList.length > 0) {
        var rwsCd = rwscList[0].value,
            rwCd = rwsCd.slice(0, -5),
            arwkCd = this.rw2ArwkMst[rwCd],
            areaCd = arwkCd.slice(0, 2);
        this.rwAreaObjSelected = this.getSttAreaItem(areaCd);
        this.rwAreaObjTempSelected = Object.assign({}, this.rwAreaObjSelected);
        return;
      }
    },
    // 校種選択情報を校種コードに変換
    koshuAdaptor: function koshuAdaptor(ksSelectedList) {
      if (ksSelectedList.length === 2) {
        return 'tandai';
      } else {
        var ksValue = ksSelectedList[0].value;
        if (ksValue === 'senkaku') {
          return '21';
        } else if (ksValue === 'school') {
          return '26';
        } else {
          return ksValue;
        }
      }
    },
    loadSelectedBunnyaInfo: function loadSelectedBunnyaInfo() {
      var _this28 = this;

      Object.keys(this.selectedBunnyaTempLists).forEach(function (key) {
        var addList = _this28.selectedBunnyaTempLists[key].concat();
        vm.$set(_this28.selectedLists, key, addList);
      });
    },
    // 選択状況を元に戻す。
    loadSelectedInfo: function loadSelectedInfo() {
      var _this29 = this;

      Object.keys(this.selectedLists).forEach(function (key) {
        var addList = _this29.selectedBkLists[key].concat();
        vm.$set(_this29.selectedLists, key, addList);
      });
      this.isSkgSelectRefresh = true;
      this.isSttSelectRefresh = true;
      this.currentBunyaIdTemp = '';
      this.currentBunyaDetailTemp = '';
      this.currentShikakuShTemp = '';
      this.railwayAjaxSendFlag = false;
      this.isSttCountAreaReady = false;

      this.resetSelectedSkg();
    },
    /**
     * @desc 路線チェック状態解除のため関連データを更新
     */
    resetSelectedStt: function resetSelectedStt() {
      this.sttList = [];
      this.rwKbnObjSelected = {};
      this.rwAreaObjSelected = {};
      this.rwAreaObjTempSelected = {};
      this.railwayAjaxSendFlag = false;
      this.isSttSelectRefresh = true;
    },
    /**
     * @desc 市区郡リストチェック状態解除のため関連データを更新
     */
    resetSelectedSkg: function resetSelectedSkg() {
      this.skgList = [];
      this.isSkgSelectRefresh = true;
      this.shikugunAjaxSendFlag = false;
      this.isSkgCountAreaReady = false;
    },
    // 詳細選択状況を元に戻す。
    loadDetailSearch: function loadDetailSearch() {
      this.clearSelectedLists(this.selectedLists);
      this.isKoshuAllSelected = this.isInitKoshuAllSelected;
      this.selectedKoshuNm = this.isInitKoshuAllSelected ? 'すべて' : vmInput.initKsNm;
      this.selectedAreaRailwayNms = this.isInitAreaAllSelected ? ['すべて'] : [vmInput.initAreaNm];
      this.isAreaAllSelected = this.isInitAreaAllSelected;
      this.isCapAllSelected = this.isInitCapAllSelected;
      this.selectedCapNm = this.isInitCapAllSelected ? 'すべて' : vmInput.initCapaNm;
      this.isPayAllSelected = this.isInitPayAllSelected;
      this.selectedPayNm = this.isInitPayAllSelected ? 'すべて' : vmInput.initPayNm;
      this.checkedTokuchoList = this.isInitCheckedTokuchoList.concat();
      this.isTokuchoAllChecked = false;
      this.isTokuchoAllSelected = this.isInitTokuchoAllSelected;
      this.selectedTokuchoNms.splice(0);
      var tokuchoTxt = this.isInitTokuchoAllSelected ? 'すべて' : vmInput.initTkNm;
      this.selectedTokuchoNms.push(tokuchoTxt);
    },
    // バックアップした選択情報を戻す
    restoreSelectedLists: function restoreSelectedLists() {
      this.loadDetailSearch();
      this.loadSelectedInfo();
    },
    saveSelectedBunnyaInfo: function saveSelectedBunnyaInfo() {
      var _this30 = this;

      Object.keys(this.selectedBunnyaTempLists).forEach(function (key) {
        var addList = _this30.selectedLists[key].concat();
        vm.$set(_this30.selectedBunnyaTempLists, key, addList);
      });
    },
    saveSelectedInfo: function saveSelectedInfo() {
      var _this31 = this;

      Object.keys(this.selectedLists).forEach(function (key) {
        var addList = _this31.selectedLists[key].concat();
        vm.$set(_this31.selectedBkLists, key, addList);
      });
      this.getDetailCount();
    },
    setGakumonLItem: function setGakumonLItem(glCd) {
      if (glCd === 'all') {
        this.clearSelectedLists(this.selectedBunnyaTempLists);
        this.loadSelectedBunnyaInfo();
        this.formSubmit(true);
      } else {
        var index = 0,
            addObj = {
          name: 'gl',
          value: glCd
        };
        vm.$set(this.selectedBunnyaTempLists.glList, index, addObj);
        this.updateMDispList();
      }
    },
    setGakumonSItem: function setGakumonSItem(gsCd) {
      if (gsCd !== 'all') {
        var index = 1,
            addObj = {
          name: 'gs',
          value: gsCd
        };
        vm.$set(this.selectedBunnyaTempLists.glList, index, addObj);
      }
      this.loadSelectedBunnyaInfo();
      this.formSubmit(true);
    },
    setShigotoLItem: function setShigotoLItem(jlCd) {
      if (jlCd === 'all') {
        this.clearSelectedLists(this.selectedBunnyaTempLists);
        this.loadSelectedBunnyaInfo();
        this.formSubmit(true);
      } else {
        var index = 0,
            addObj = {
          name: 'jl',
          value: jlCd
        };
        vm.$set(this.selectedBunnyaTempLists.jlList, index, addObj);
        this.updateMDispList();
      }
    },
    setShigotoMItem: function setShigotoMItem(jlCd, jmCd) {
      // 全てを押した場合
      if (jmCd === 'all') {
        for (var i = 2; i > 1; i--) {
          vm.$set(this.selectedBunnyaTempLists.jlList, i, {});
        }
        this.loadSelectedBunnyaInfo();
        this.formSubmit(true);
      } else {
        var index = 1,
            addObj = {
          name: 'jm',
          value: jmCd
        };

        vm.$set(this.selectedBunnyaTempLists.jlList, index, addObj);
        this.updateShigotoSDispList(jlCd, jmCd);
      }
    },
    setShigotoSItem: function setShigotoSItem(jmCd, jsCd) {
      var addObjM = {
        name: 'jm',
        value: jmCd
      };
      vm.$set(this.selectedBunnyaTempLists.jlList, 1, addObjM);
      if (jsCd !== 'all') {
        var addObjS = {
          name: 'js',
          value: jsCd
        };
        vm.$set(this.selectedBunnyaTempLists.jlList, 2, addObjS);
      }
      this.loadSelectedBunnyaInfo();
      this.formSubmit(true);
    },
    setShikakuLItem: function setShikakuLItem(qlCd) {
      if (qlCd === 'all') {
        this.clearSelectedLists(this.selectedBunnyaTempLists);
        this.loadSelectedBunnyaInfo();
        this.formSubmit(true);
      } else {
        var index = 0,
            addObj = {
          name: 'ql',
          value: qlCd
        };

        vm.$set(this.selectedBunnyaTempLists.qlList, index, addObj);
        this.updateMDispList();
      }
    },
    setShikakuMItem: function setShikakuMItem(qlCd, qmCd) {
      if (qmCd === 'all') {
        vm.$set(this.selectedBunnyaTempLists.qlList, 1, {});
        vm.$set(this.selectedBunnyaTempLists.qlList, 2, {});
        vm.$set(this.selectedBunnyaTempLists.qshList, 0, {});
        this.loadSelectedBunnyaInfo();
        this.formSubmit(true);
      } else {
        var index = 1,
            addObj = {
          name: 'qm',
          value: qmCd
        };

        vm.$set(this.selectedBunnyaTempLists.qlList, index, addObj);
        this.updateShikakuSDispList(qlCd, qmCd);
      }
    },
    setShikakuSItem: function setShikakuSItem(qmCd, qsCd, qsNm) {
      var addObjM = {
        name: 'qm',
        value: qmCd
      };
      vm.$set(this.selectedBunnyaTempLists.qlList, 1, addObjM);
      if (qsCd === 'all') {
        vm.$set(this.selectedBunnyaTempLists.qshList, 0, {});
        vm.$set(this.selectedBunnyaTempLists.qlList, 2, {});
        this.loadSelectedBunnyaInfo();
        this.formSubmit(true);
      } else {
        var addObjS = {
          name: 'qs',
          value: qsCd
        };
        vm.$set(this.selectedBunnyaTempLists.qlList, 2, addObjS);

        // アコーディオン展開済の小分類選択時もselectedShikakuMを更新する
        var shikakuL = this.bunyaListM.shikaku[this.selectedShikakuL.cd];
        var shikakuNmM = shikakuL.find(function (shikakuM) {
          return shikakuM.qmCd === qmCd;
        }).qmNm;
        var shikakuObjM = {
          cd: qmCd,
          nm: shikakuNmM
        };
        this.selectedShikakuM = Object.assign({}, this.selectedShikakuM, shikakuObjM);
        this.updateShikakuShDispList(qsCd, qsNm, qmCd);
      }
    },
    setShikakuShItem: function setShikakuShItem(qshCd) {
      if (qshCd.sh !== 'all') {
        var index = 0,
            addObj = {
          name: 'qCd',
          value: qshCd.sh
        };
        vm.$set(this.selectedBunnyaTempLists.qshList, index, addObj);
        var suffix = function suffix() {
          if (qshCd.sh === '1') {
            return 'を取得できる';
          } else if (qshCd.sh === '2') {
            return 'の受験資格を取得できる';
          } else {
            return 'の取得を目標としている';
          }
        };
        this.currentShikakuShTemp = qshCd.sh;
        this.currentBunyaDetailTemp = this.selectedShikakuS.nm + suffix();
      } else {
        // 種別すべて選択時は別途処理
        this.currentShikakuShTemp = 'sh_all';
        this.currentBunyaDetailTemp = this.selectedShikakuS.nm;
      }
      if (!this.isSubmitMode) {
        this.initialSelectedBunyaSize = 'bunyaS';
        this.currentBunyaIdTemp = 'shikaku';
      }

      this.loadSelectedBunnyaInfo();
      this.formSubmit(true);
    },
    setGakubuKeitouItem: function setGakubuKeitouItem(gbkCd) {
      if (gbkCd === 'all') {
        this.selectedBunnyaTempLists.gbkList.splice(0);
      } else {
        var index = 0,
            addObj = {
          name: 'gbk',
          value: gbkCd
        };
        vm.$set(this.selectedBunnyaTempLists.gbkList, index, addObj);
      }

      this.loadSelectedBunnyaInfo();
      this.formSubmit(true);
    },
    /**
     * @desc 選択した定員数情報を元にselectedListsを更新し、詳細パネルへ移動
     * @param {object} capObj - 定員数オブジェクト
     */
    setCapItem: function setCapItem(capObj) {
      this.selectedLists.capList.splice(0);

      if (capObj.capCd !== 'all') {
        this.selectedLists.capList.push({
          name: 'minCapa',
          value: capObj.minCapa
        });
        if (capObj.maxCapa !== null) {
          this.selectedLists.capList.push({
            name: 'maxCapa',
            value: capObj.maxCapa
          });
        }
      }
      this.selectedCapNm = capObj.capNm;
      this.isCapAllSelected = capObj.capCd === 'all';
      this.getDetailCount();
      this.selectDetail();
    },
    /**
     * @desc 選択した校種情報を元にselectedListsを更新し、詳細パネルへ移動
     * @param {object} ksObj - 校種オブジェクト
     */
    setKsItem: function setKsItem(ksObj) {
      this.selectedLists.ksList.splice(0);
      var addObj = {};

      switch (ksObj.ksCd) {
        case 'all':
          break;
        case 'daitan':
          addObj = {
            name: 'koshuL',
            value: 'daitan'
          };
          this.selectedLists.ksList.push(addObj);
          break;
        case 'tandai':
          addObj = {
            name: 'koshuM',
            value: '13'
          };
          this.selectedLists.ksList.push(addObj);
          addObj = {
            name: 'koshuM',
            value: '14'
          };
          this.selectedLists.ksList.push(addObj);
          break;
        case '21':
          addObj = {
            name: 'koshuL',
            value: 'senkaku'
          };
          this.selectedLists.ksList.push(addObj);
          break;
        case '26':
          addObj = {
            name: 'koshuL',
            value: 'school'
          };
          this.selectedLists.ksList.push(addObj);
          break;
        default:
          addObj = {
            name: 'koshuM',
            value: ksObj.ksCd
          };
          this.selectedLists.ksList.push(addObj);
          break;
      }
      this.selectedKoshuNm = ksObj.ksNm;
      this.isKoshuAllSelected = ksObj.ksCd === 'all';
      this.formSubmit(true);
    },
    /**
     * @desc 選択した入学金情報を元にselectedListsを更新し、詳細パネルへ移動
     */
    setPayItem: function setPayItem(payObj) {
      this.selectedLists.payList.splice(0);
      if (payObj.payCd !== 'all') {
        this.selectedLists.payList.push({
          name: 'minPay',
          value: payObj.minPay
        });
        if (payObj.maxPay !== null) {
          this.selectedLists.payList.push({
            name: 'maxPay',
            value: payObj.maxPay
          });
        }
      }
      this.selectedPayNm = payObj.payNm;
      this.isPayAllSelected = payObj.payCd === 'all';
      this.getDetailCount();
      this.selectDetail();
    },
    /**
     * @desc 特徴の選択状況をselectedListsに格納し、詳細パネルへ移動
     */
    setTokuchoItems: function setTokuchoItems() {
      var _this32 = this;

      var selectedNms = [],
          isSelectAllFlag = this.checkedTokuchoList.length === this.getExcludeFirstItem(this.tkDispList).length,
          isSelectNoneFlag = this.checkedTokuchoList.length === 0;

      //選択データ初期化
      this.selectedLists.tkList.splice(0);
      if (isSelectAllFlag || isSelectNoneFlag) {
        this.isTokuchoAllSelected = true;
        this.selectedTokuchoNms = [];
        if (isSelectAllFlag) {
          this.isTokuchoAllChecked = false;
          this.checkedTokuchoList = [];
        }
      } else {
        this.checkedTokuchoList.forEach(function (tkCd) {
          var targetObj = undefined,
              addParamObj = undefined;

          targetObj = _this32.tkDispList.find(function (tkObj) {
            return tkObj.tkCd === tkCd;
          });
          if (targetObj !== undefined) {
            selectedNms.push(targetObj.tkNm);
          }
          _this32.selectedTokuchoNms = selectedNms;
          _this32.isTokuchoAllSelected = false;
          addParamObj = {
            name: 'tokucho',
            value: tkCd
          };
          _this32.selectedLists.tkList.push(addParamObj);
        });
      }
      this.getDetailCount();
      this.selectDetail();
    },
    /**
     * @desc 都道府県からエリアを特定するためのマスタ作成
     */
    setTdfkAreaMst: function setTdfkAreaMst() {
      var _this33 = this;

      this.skgList.forEach(function (areaObj) {
        if (areaObj.areaCd === 'all') {
          return;
        }
        areaObj.todofukenList.forEach(function (tdfkObj) {
          if (tdfkObj.todofukenCd === 'all') {
            return;
          }
          _this33.tdfk2AreaMst[tdfkObj.todofukenCd] = areaObj.areaCd;
        });
      });
    },
    /**
     * @desc 路線からエリア・路線区分を特定するためのマスタ作成
     */
    setRw2ArwkMst: function setRw2ArwkMst() {
      var _this34 = this;

      this.sttList.forEach(function (areaObj) {
        if (areaObj.areaCd === 'all') {
          return;
        }
        var railwayList = undefined;
        areaObj.railwaykbnList.forEach(function (railwayKbnObj) {
          if (railwayKbnObj.railwayList === null) {
            return;
          }
          railwayList = railwayKbnObj.railwayList;
          railwayList.forEach(function (rwObj) {
            if (rwObj.railwayCd === 'all') {
              return;
            }
            _this34.rw2ArwkMst[rwObj.railwayCd] = areaObj.areaCd + railwayKbnObj.railwayKbnCd;
          });
        });
      });
    },
    /**
     * @desc 現在選択中の市区郡情報リストの更新。詳細パネル内の表示に使用
     */
    setSkgLabel: function setSkgLabel() {
      var _selectedAreaRailwayNms,
          _selectedAreaRailwayNms2,
          _selectedAreaRailwayNms3,
          _this35 = this;

      var areaList = [],
          tdfkList = [],
          sklcList = [];

      this.selectedLists.skgList.forEach(function (paramObj) {
        if (paramObj.name === 'area') {
          //エリア処理
          var areaObj = _this35.getSkgLItem(paramObj.value);

          areaList.push(areaObj.areaNm + 'すべて');
        } else if (paramObj.name === 'tdfk') {
          //都道府県処理
          var tdfkObj = _this35.getSkgMItem(paramObj.value);

          tdfkList.push(tdfkObj.todofukenNm + 'すべて');
        } else {
          //市区郡処理
          var sklcObj = _this35.getSkgSItem(paramObj.value);

          sklcList.push(sklcObj.shikugunLNm);
        }
      });
      this.selectedAreaRailwayNms.splice(0);
      (_selectedAreaRailwayNms = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms, areaList);
      (_selectedAreaRailwayNms2 = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms2, tdfkList);
      (_selectedAreaRailwayNms3 = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms3, sklcList);

      if (this.selectedAreaRailwayNms.length > 0) {
        this.isAreaAllSelected = false;
      } else if (this.selectedAreaRailwayNms.length === 0) {
        this.isAreaAllSelected = true;
      }
    },
    /**
     * @desc チェックされたデータをパラメータへ変換
     */
    setSkgCheckedData: function setSkgCheckedData() {
      var _this36 = this;

      // データ初期化
      this.selectedLists.skgList.splice(0);
      if (this.skgList.isCheckAreaAll) {
        this.skgList.isCheckAreaAll = false;
        this.skgList.checkAreaList.splice(0);
        this.skgList.forEach(function (areaObj) {
          if (areaObj.areaCd === 'all') {
            return;
          }
          areaObj.isCheckTdfkAll = false;
          areaObj.checkTdfkList.splice(0);
          if (areaObj.todofukenList === null) {
            return;
          }
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.todofukenCd === 'all') {
              return;
            }
            tdfkObj.isCheckSkgAll = false;
            tdfkObj.checkSkgList.splice(0);
          });
        });
        return false;
      }
      this.skgList.forEach(function (areaObj) {
        var _selectedLists$skgList;

        var selectList = [];
        if (areaObj.areaCd === 'all') {
          return;
        }
        if (areaObj.isCheckTdfkAll) {
          var sendObj = {
            name: 'area',
            value: areaObj.areaCd
          };
          _this36.selectedLists.skgList.push(sendObj);
          return;
        } else {
          if (areaObj.todofukenList === null) {
            return;
          }
          areaObj.todofukenList.forEach(function (tdfkObj) {
            if (tdfkObj.todofukenCd === 'all') {
              return;
            }
            if (tdfkObj.isCheckSkgAll) {
              var sendObj = {
                name: 'tdfk',
                value: tdfkObj.todofukenCd
              };
              _this36.selectedLists.skgList.push(sendObj);
              return;
            }
            if (tdfkObj.shikugunLList === null) {
              return;
            }
            if (!tdfkObj.checkSkgList) return;
            tdfkObj.checkSkgList.forEach(function (skgCd) {
              var sendObj = {
                name: 'sklc',
                value: skgCd
              };
              _this36.selectedLists.skgList.push(sendObj);
            });
          });
        }
        (_selectedLists$skgList = _this36.selectedLists.skgList).push.apply(_selectedLists$skgList, selectList);
      });
    },
    /**
     * @desc 現在選択中の路線情報リストの更新。詳細パネル内の表示に使用
     */
    setSttLabel: function setSttLabel() {
      var _selectedAreaRailwayNms4,
          _selectedAreaRailwayNms5,
          _selectedAreaRailwayNms6,
          _selectedAreaRailwayNms7,
          _this37 = this;

      var areaList = [],
          rwKbList = [],
          rwList = [],
          stationList = [];

      this.selectedLists.sttList.forEach(function (paramObj) {
        if (paramObj.name === 'area') {
          //エリア処理
          var areaObj = _this37.getSttAreaItem(paramObj.value);
          areaList.push(areaObj.areaNm + 'すべて');
        } else if (paramObj.name === 'arkc') {
          //路線区分処理
          var rwKbnCd = paramObj.value.slice(2),
              rwKbnObj = _this37.getSttRwKbnItem(_this37.rwAreaObjSelected, rwKbnCd);

          rwKbList.push(rwKbnObj.railwayKbnNm + 'すべて');
        } else if (paramObj.name === 'rwc') {
          //路線処理
          var rwObj = _this37.getSttRwItem(_this37.rwAreaObjSelected, paramObj.value);

          rwList.push(rwObj.railwayNm + 'すべて');
        } else if (paramObj.name === 'rwsc') {
          var sttObj = _this37.getSttItem(_this37.rwAreaObjSelected, paramObj.value);

          stationList.push(sttObj.stationNm);
        }
      });
      this.selectedAreaRailwayNms.splice(0);
      (_selectedAreaRailwayNms4 = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms4, areaList);
      (_selectedAreaRailwayNms5 = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms5, rwKbList);
      (_selectedAreaRailwayNms6 = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms6, rwList);
      (_selectedAreaRailwayNms7 = this.selectedAreaRailwayNms).push.apply(_selectedAreaRailwayNms7, stationList);

      if (this.selectedAreaRailwayNms.length > 0) {
        this.isAreaAllSelected = false;
      } else if (this.selectedAreaRailwayNms.length === 0) {
        this.isAreaAllSelected = true;
      }
    },
    /**
     * @desc 選択中の路線情報をrwAreaObjTempSelectedにセット
     */
    setSttCheckedData: function setSttCheckedData() {
      var _this38 = this;

      // データ初期化
      var arkcCounter = 0,
          selectList = [];
      this.rwAreaObjSelected.railwaykbnList.forEach(function (rwKbnObj) {
        if (rwKbnObj.isCheckRwAll) {
          var sendObj = {
            name: 'arkc',
            value: _this38.rwAreaObjSelected.areaCd + rwKbnObj.railwayKbnCd
          };
          selectList.push(sendObj);
          arkcCounter++;
          return;
        } else {
          if (rwKbnObj.railwayList === null) {
            return;
          }
          rwKbnObj.railwayList.forEach(function (rwObj) {
            if (rwObj.railwayCd === 'all') {
              return;
            }
            if (rwObj.isCheckSttAll) {
              var sendObj = {
                name: 'rwc',
                value: rwObj.railwayCd
              };
              selectList.push(sendObj);
              return;
            }
            if (rwObj.stationList === null || rwObj.checkSttList === undefined) {
              return;
            }
            rwObj.checkSttList.forEach(function (sttCd) {
              var sendObj = {
                name: 'rwsc',
                value: rwObj.railwayCd + sttCd
              };
              selectList.push(sendObj);
            });
          });
        }
      });
      if (arkcCounter === this.rwAreaObjSelected.railwaykbnList.length) {
        selectList.splice(0);
        var sendObj = {
          name: 'area',
          value: this.rwAreaObjSelected.areaCd
        };
        selectList.push(sendObj);
      }
      if (selectList.length > 0) {
        var _selectedLists$sttList;

        this.selectedLists.sttList.splice(0);
        (_selectedLists$sttList = this.selectedLists.sttList).push.apply(_selectedLists$sttList, selectList);
        this.rwAreaObjTempSelected = Object.assign({}, this.rwAreaObjSelected);
      } else if (this.rwAreaObjTempSelected !== {}) {
        this.rwAreaObjSelected = Object.assign({}, this.rwAreaObjTempSelected);
      }
    },
    /**
     * @desc 選択中の市区郡情報を検索条件にセット
     */
    setSkgItems: function setSkgItems() {
      this.setSkgCheckedData();
      this.setSkgLabel();
      this.isSkgSelectRefresh = true;
      this.selectedLists.sttList.splice(0);
      this.formSubmit(true);
    },
    /**
     * @desc 選択中の路線情報を検索条件にセット
     */
    setSttItems: function setSttItems() {
      this.setSttCheckedData();
      this.setSttLabel();
      this.isInitSttTab = false;
      this.isSttSelectRefresh = true;
      this.isSttCountAreaReady = false;
      this.selectedLists.skgList.splice(0);
      this.formSubmit(true);
    },
    /**
     * @desc パネルにデータ埋め込み
     * @param {array} data - APIで取得した件数リスト
     * @param {array} targetList - 件数更新対象のリスト
     */
    setPanelData: function setPanelData(data, targetList) {
      if (targetList === null) {
        return;
      }
      data.forEach(function (countObj, index) {
        var addObj = [];
        // 配列のコピー
        addObj = Object.assign({}, targetList[index]);
        addObj.count = countObj.SearchPanelCount;
        vm.$set(targetList, index, addObj);
      });
    },
    /**
     * @desc データソースを表示用リストに変換
     * @param {array} targetList - Vueインスタンス内でだけ使用する詳細情報リスト
     * @param {array} targetDispList - 表示用に使う詳細情報リスト
     */
    setDispList: function setDispList(targetList, targetDispList) {
      targetList.forEach(function (targetObj, index) {
        var addObj = Object.assign({}, targetObj);
        addObj.count = 0;
        targetDispList.push(addObj);
      });
    },
    /**
     * @desc 路線タブ切り替え
     * @param {string} tabCd - アクティブにしたいタブコード
     * @param {any} isScrollInit - パネル展開時スクロール位置調整用フラグ
     */
    switchRwTab: function switchRwTab(tabCd) {
      var isInitScroll = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      this.updateSttRwKbnDisp(this.rwAreaObjSelected, tabCd, isInitScroll);
    },
    /**
     * @desc 校種更新
     */
    updateKsDispList: function updateKsDispList() {
      var _this39 = this;

      this.getCount(this.selectedLists, ['ksList'], 'koshu').then(function (data) {
        data.forEach(function (countObj, index) {
          var addObj = [],
              targetIndex = undefined;
          targetIndex = _this39.ksDispList.findIndex(function (ksObj) {
            return ksObj.ksCd === countObj.SearchPanelCountCd;
          });
          // 配列のコピー
          addObj = Object.assign({}, _this39.ksDispList[targetIndex]);
          addObj.count = countObj.SearchPanelCount;
          vm.$set(_this39.ksDispList, targetIndex, addObj);
        });
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与する
      this.ksDispList.forEach(function (ksObj) {
        ksObj.isSelected = false;
        if (_this39.selectedLists.ksList.length === 0 || _this39.selectedLists.ksList[0] === {}) {
          return false;
        }
        ksObj.isSelected = ksObj.ksCd === _this39.koshuAdaptor(_this39.selectedLists.ksList);
      });
    },
    /**
     * @desc 路線エリア更新
     */
    updateSttAreaDispList: function updateSttAreaDispList() {
      var _this40 = this;

      if (!this.isSttCountAreaReady) {
        return;
      }
      // 選択要素更新(更新があった時のみ)
      if (this.isSttSelectRefresh) {
        this.convertSttSelectData();
        this.isSttSelectRefresh = false;
      }
      this.getCount(this.selectedLists, ['skgList', 'sttList'], 'railway_area').then(function (data) {
        _this40.setPanelData(data, _this40.sttList);
        // 選択状況付与
        _this40.sttList.forEach(function (areaObj) {
          areaObj.isSelected = false;
          if (_this40.rwAreaObjSelected === {}) {
            return;
          }
          areaObj.isSelected = areaObj.areaCd === _this40.rwAreaObjTempSelected.areaCd;
        });
      }, function () {
        return console.log('error');
      });
    },
    /**
     * @desc 路線区分更新
     * @param {object} areaObj - エリア情報のオブジェクト
     * @param {string} tabCd - 路線タブコード。初期値は一番左のタブ
     * @param {any} isScrollInit - パネル展開時スクロール位置調整用フラグ
     */
    updateSttRwKbnDisp: function updateSttRwKbnDisp(areaObj) {
      var _this41 = this;

      var tabCd = arguments.length <= 1 || arguments[1] === undefined ? '001' : arguments[1];
      var isScrollInit = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

      var parentData = undefined,
          targetList = [],
          sendSubParams = [],
          rwKbnObj = undefined;

      if (areaObj.areaCd === 'all') {
        this.selectedLists.sttList.splice(0);
        this.isSttSelectRefresh = true;
        this.selectedLists.skgList.splice(0);
        this.setSttLabel();
        this.getDetailCount();
        return;
      }
      this.rwKbnSelected = tabCd;
      this.rwAreaObjSelected = areaObj;
      // 路線区分があるかどうか判定
      Object.keys(this.hasRwKbn).forEach(function (key) {
        _this41.hasRwKbn[key] = false;
      });
      areaObj.railwaykbnList.forEach(function (rwKbnObj) {
        _this41.hasRwKbn[rwKbnObj.railwayKbnCd] = true;
      });
      rwKbnObj = this.getSttRwKbnItem(areaObj, this.rwKbnSelected);
      if (rwKbnObj === undefined || rwKbnObj.railwayList === null) {
        return;
      }

      if (isScrollInit && this.rwAreaObjSelected.isSelected && !this.isInitSttTab) {
        // タブの初期表示を調整
        var initKbn = this.rwAreaObjSelected.railwaykbnList.find(function (kbn) {
          return kbn.hasOwnProperty('checkRwList') && kbn.checkRwList.length > 0 || kbn.railwayList.find(function (railway) {
            if (!railway.stationList) return false;
            var isCheckedRailwayAll = _this41.selectedLists.sttList.find(function (stt) {
              return stt.value === railway.railwayCd;
            });
            return isCheckedRailwayAll || railway.stationList.find(function (station) {
              return _this41.selectedLists.sttList.find(function (stt) {
                return stt.value === station.railwayStationCd;
              });
            });
          });
        });
        var initKbnCd = initKbn ? initKbn.railwayKbnCd : '001';
        if (this.rwKbnSelected !== initKbnCd) {
          this.isInitSttTab = true;
          this.switchRwTab(initKbnCd, 'isInitScroll');
          return;
        }
      }

      this.rwKbnObjSelected = rwKbnObj;
      if (!(rwKbnObj.isInitialized === true)) {
        this.initSttAreaCheck(rwKbnObj);
      }
      parentData = {
        name: 'countArkc',
        value: areaObj.areaCd + this.rwKbnSelected
      };
      sendSubParams.push(parentData);

      this.getCount(this.selectedLists, ['skgList', 'sttList'], 'railway', sendSubParams).then(function (data) {
        data.forEach(function (countObj, index) {
          var addObj = [];
          // 配列のコピー
          addObj = Object.assign({}, rwKbnObj.railwayList[index]);
          addObj.count = countObj.SearchPanelCount;
          addObj.isOpened = false;
          vm.$set(rwKbnObj.railwayList, index, addObj);
          // 全選択されていた場合は配下の路線に全てにチェックを入れる
          if (rwKbnObj.isCheckRwAll) {
            rwKbnObj.checkRwList.splice(0);
            rwKbnObj.railwayList.forEach(function (rwObj) {
              if (rwObj.count === 0 || rwObj.count === undefined || rwObj.railwayCd === 'all') {
                return;
              }
              rwKbnObj.checkRwList.push(rwObj.railwayCd);
            });
          }
        });
        rwKbnObj.maxCount = _this41.getListMaxCount(rwKbnObj.railwayList);
        // 選択状況付与

        var arwkCd = areaObj.areaCd + rwKbnObj.railwayKbnCd,
            rwKbnSelected = _this41.selectedSttObj.rwKbnSelected[arwkCd];

        rwKbnObj.isAllSelected = false;
        if (rwKbnSelected == 'all') {
          rwKbnObj.isAllSelected = true;
          rwKbnObj.isSelected = true;
        }

        // 条件リセット後、再度詳細パネルから路線パネルへアクセスした際
        // 「路線区分すべて」のチェック状態を復元できないので別途処理
        _this41.selectedLists.sttList.forEach(function (stt) {
          if (stt.name !== 'arkc') return;
          var selectedStt = stt.value;
          var currentRwValue = _this41.rwAreaObjSelected.areaCd + rwKbnObj.railwayKbnCd;
          if (selectedStt === currentRwValue) {
            rwKbnObj.isCheckRwAll = true;
          }
        });

        rwKbnObj.railwayList.forEach(function (rwObj, index) {
          var rwSelected = _this41.selectedSttObj.rwSelected[rwObj.railwayCd];
          if (rwObj.railwayCd == 'all') {
            return;
          }
          rwObj.isSelected = false;
          rwObj.isAllSelected = false;
          if (rwKbnSelected == 'all') {
            rwObj.isSelected = true;
            rwObj.isAllSelected = true;
            return;
          }
          if (rwSelected === undefined || rwSelected === []) {
            return;
          }

          if (rwSelected == 'all') {
            rwObj.isAllSelected = true;
          }
          rwObj.isSelected = true;
          // 路線パネル展開時の初期表示設定。isSelectedがtrueならばアコーディオン展開
          rwObj.isOpened = true;
          _this41.updateSttDispList(index, isScrollInit);
        });
      }, function () {
        return console.log('error');
      });
    },
    /**
     * @desc 駅パネル更新
     * @param {number} index - railwayList内の対象index
     * @param {any} isScrollInit - パネル展開時スクロール位置調整用フラグ
     * @param {any} isToggling - 手動チェックか否かの判定用フラグ
     */
    updateSttDispList: function updateSttDispList(index) {
      var _this42 = this;

      var isScrollInit = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
      var isToggling = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

      var rwObj = this.rwKbnObjSelected.railwayList[index];

      var parentData = [],
          sendSubParams = [];

      if (rwObj.count === 0) {
        return;
      }

      // アコーディオン切り替え時はisOpenedをtoggle
      if (isToggling !== null) {
        rwObj.isOpened = !rwObj.isOpened;
      }

      // スクロール位置を調整したい場合はisScrollInitを持たせアコーディオンを開いた状態に
      if (isScrollInit !== null) {
        rwObj.isOpened = true;
      }

      // アコーディオン閉じの際は後続処理が不要なのでreturn
      if (!rwObj.isOpened) return;

      parentData = [{
        name: 'countArkc',
        value: this.rwAreaObjSelected.areaCd + this.rwKbnSelected
      }, {
        name: 'countRwc',
        value: rwObj.railwayCd
      }];
      sendSubParams.push.apply(sendSubParams, _toConsumableArray(parentData));
      this.getCount(this.selectedLists, ['skgList', 'sttList'], 'station', sendSubParams).then(function (data) {
        _this42.setPanelData(data, rwObj.stationList);
        rwObj.maxCount = _this42.getListMaxCount(rwObj.stationList);
        // 全選択されていた場合は配下の市区郡に全てにチェックを入れる
        if (rwObj.isCheckSttAll) {
          rwObj.checkSttList.splice(0);
          rwObj.stationList.forEach(function (sttObj) {
            if (sttObj.count === 0 || sttObj.count === undefined || sttObj.stationCd === 'all') {
              return;
            }
            rwObj.checkSttList.push(sttObj.stationCd);
          });
        }
        // 選択状況付与
        var arwkCd = _this42.rwAreaObjSelected.areaCd + _this42.rwKbnSelected,
            rwKbnSelected = _this42.selectedSttObj.rwKbnSelected[arwkCd],
            rwSelected = _this42.selectedSttObj.rwSelected[rwObj.railwayCd];

        rwObj.stationList.forEach(function (sttObj) {
          var sttCd = sttObj.stationCd;
          var isSelectedTemp = false;

          sttObj.isSelected = false;
          if (sttCd == 'all') {
            return;
          }
          if (rwKbnSelected == 'all' && rwSelected == undefined || rwSelected == 'all') {
            sttObj.isSelected = true;
            return;
          }
          if (rwSelected === undefined || rwSelected === []) {
            return;
          }
          rwSelected.forEach(function (sttItem) {
            if (sttItem == sttCd) {
              isSelectedTemp = true;
              return false;
            }
          });
          sttObj.isSelected = isSelectedTemp;
        });
        // 初回展開時のみスクロール位置を調整
        if (isScrollInit && !_this42.isSttScrolled) {
          _this42.$nextTick(function () {
            var $scrollTarget = (0, _jquery2['default'])('.js-sttItem.is-selected:visible:first');
            if ($scrollTarget.length === 0 || $scrollTarget.offset().top < 1) return;
            _this42.areaPanelScrollInit($scrollTarget, 'isSttScrolled');
          });
        }
      }, function () {
        return console.log('error');
      });
    },
    /**
     * @desc エリア・路線パネル選択時のスクロール位置を調整
     * @param {jQueryObject} target - スクロール位置の対象jQuery要素
     * @param {*} targetFlag - isSttScrolled等を渡す。スクロール位置初期化発火の判定に使用
     */
    areaPanelScrollInit: function areaPanelScrollInit(target, targetFlag) {
      var $wrapper = target.closest('.js-panelInner');
      $wrapper.scrollTop(0);
      // アコーディオン開閉にかかる時間分タイミングをずらす
      setTimeout(function () {
        var scrollPosition = target.offset().top - PANEL_HEADER_HEIGHT;
        $wrapper.scrollTop(scrollPosition);
      }, 150);
      this[targetFlag] = true;
    },
    /**
     * @desc 市区郡大更新
     */
    updateSkgAreaDispList: function updateSkgAreaDispList() {
      var _this43 = this;

      if (!this.isSkgCountAreaReady) {
        return false;
      }
      // 選択要素更新(更新があった時のみ)
      if (this.isSkgSelectRefresh) {
        this.convertSkgSelectData();
        this.isSkgSelectRefresh = false;
      }
      this.skgList.maxCount = 0;
      this.getCount(this.selectedLists, ['skgList', 'sttList'], 'shikugun_area').then(function (data) {
        data.forEach(function (countObj, index) {
          var addObj = [];
          addObj = Object.assign({}, _this43.skgList[index]);
          addObj.count = countObj.SearchPanelCount;
          var isOpened = addObj.hasOwnProperty('checkTdfkList') && addObj.checkTdfkList.length > 0;
          var isSelected = function isSelected() {
            if (addObj.todofukenList) {
              return addObj.todofukenList.some(function (tdfk) {
                return tdfk.hasOwnProperty('checkSkgList') && tdfk.checkSkgList.length > 0;
              });
            } else {
              return;
            }
          };
          addObj.isOpened = isOpened || isSelected();
          if (isOpened || isSelected()) {
            _this43.updateSkgTdfkDispList(addObj, 'isScrollInit', null);
          }
          _this43.$set(_this43.skgList, index, addObj);
        });
        _this43.skgList.maxCount = _this43.getListMaxCount(_this43.skgList);
      }, function () {
        return console.log('error');
      });

      // 選択状態を付与する
      this.skgList.forEach(function (areaObj) {
        areaObj.isSelected = false;
        var areaSelected = _this43.selectedSkgObj.areaSelected[areaObj.areaCd];
        areaObj.isSelected = !(areaSelected === undefined || areaSelected === []);
      });
    },
    /**
     * @desc 市区郡中更新
     * @param {object} areaObj - エリアオブジェクト
     * @param {any} isScrollInit - パネル展開時スクロール位置調整用フラグ
     * @param {any} isToggling - 手動チェックか否かの判定用フラグ
     */
    updateSkgTdfkDispList: function updateSkgTdfkDispList(areaObj) {
      var _this44 = this;

      var isScrollInit = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
      var isToggling = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

      var parentData = undefined,
          sendSubParams = [];

      if (areaObj === undefined) {
        return false;
      }

      if (isToggling !== null) {
        areaObj.isOpened = !areaObj.isOpened;
      }

      if (!isScrollInit && !areaObj.isOpened) return;

      parentData = {
        name: 'countShiArea',
        value: areaObj.areaCd
      };
      sendSubParams.push(parentData);
      areaObj.maxCount = 0;
      this.getCount(this.selectedLists, ['skgList', 'sttList'], 'shikugun_todofuken', sendSubParams).then(function (data) {
        var flagList = [];
        data.forEach(function (countObj, index) {
          var addObj = [];
          // 配列のコピー
          addObj = Object.assign({}, areaObj.todofukenList[index]);
          addObj.count = countObj.SearchPanelCount;

          var isCheckTdfkAll = areaObj.isCheckTdfkAll;

          var isSelected = addObj.hasOwnProperty('isSelected') && addObj.isSelected && !isCheckTdfkAll;
          var isOpened = isSelected && isScrollInit !== null;
          flagList = [].concat(_toConsumableArray(flagList), [isOpened]);
          addObj.isOpened = isOpened;
          if (isOpened) {
            _this44.updateSkgDispList(areaObj, addObj, 'isScrollInit', null);
          }

          vm.$set(areaObj.todofukenList, index, addObj);
        });
        areaObj.maxCount = _this44.getListMaxCount(areaObj.todofukenList);

        // 初回展開時のみスクロール位置を調整
        var hasOpened = flagList.indexOf(true) !== -1;
        if (isScrollInit && !_this44.isSkgScrolled && !hasOpened) {
          _this44.$nextTick(function () {
            var $scrollTarget = (0, _jquery2['default'])('.js-skgItem.is-selected:visible:first');
            if ($scrollTarget.length === 0 || $scrollTarget.offset().top < 1) return;
            _this44.areaPanelScrollInit($scrollTarget, 'isSkgScrolled');
          });
        }
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与する
      areaObj.todofukenList.forEach(function (tdfkObj) {
        var selectedAreaList = _this44.selectedSkgObj.areaSelected[areaObj.areaCd],
            selectedTdfkList = _this44.selectedSkgObj.tdfkSelected[tdfkObj.todofukenCd];

        if (tdfkObj.todofukenCd == 'all') {
          return;
        }
        tdfkObj.isSelected = false;
        if (selectedAreaList == 'all') {
          tdfkObj.isSelected = true;
          return;
        }
        if (selectedTdfkList === undefined || selectedTdfkList === []) {
          return;
        }
        tdfkObj.isSelected = true;
      });
    },
    /**
     * @desc 市区郡小更新
     * @param {object} areaObj - エリアオブジェクト
     * @param {object} tdfkObj - 都道府県オブジェクト
     * @param {any} isScrollInit - パネル展開時スクロール位置調整用フラグ
     * @param {any} isToggling - 手動チェックか否かの判定用フラグ
     */
    updateSkgDispList: function updateSkgDispList(areaObj, tdfkObj) {
      var _this45 = this;

      var isScrollInit = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
      var isToggling = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

      var parentData = undefined,
          sendSubParams = [];

      if (tdfkObj === undefined) {
        return false;
      }
      if (isToggling !== null) {
        tdfkObj.isOpened = !tdfkObj.isOpened;
      }
      if (!isScrollInit && !tdfkObj.isOpened) return;

      parentData = [{
        name: 'countShiArea',
        value: areaObj.areaCd
      }, {
        name: 'countTdfk',
        value: tdfkObj.todofukenCd
      }];
      sendSubParams.push.apply(sendSubParams, _toConsumableArray(parentData));
      tdfkObj.maxCount = 0;
      this.getCount(this.selectedLists, ['skgList', 'sttList'], 'shikugun', sendSubParams).then(function (data) {
        _this45.setPanelData(data, tdfkObj.shikugunLList);
        tdfkObj.maxCount = _this45.getListMaxCount(tdfkObj.shikugunLList);
        // 全選択されていた場合は配下の市区郡に全てにチェックを入れる
        if (tdfkObj.isCheckSkgAll) {
          tdfkObj.checkSkgList.splice(0);
          tdfkObj.shikugunLList.forEach(function (skgObj) {
            if (skgObj.count === 0 || skgObj.count === undefined || skgObj.shikugunLCd === 'all') {
              return;
            }
            tdfkObj.checkSkgList.push(skgObj.shikugunLCd);
          });
        }
        vm.$forceUpdate();
        // 初回展開時のみスクロール位置を調整
        if (isScrollInit && !_this45.isSkgScrolled) {
          _this45.$nextTick(function () {
            var $scrollTarget = (0, _jquery2['default'])('.js-skgItem.is-selected:visible:first');
            if ($scrollTarget.length === 0 || $scrollTarget.offset().top < 1) return;
            _this45.areaPanelScrollInit($scrollTarget, 'isSkgScrolled');
          });
        }
      }, function () {
        return console.log('error');
      });
      var selectedTdfkList = this.selectedSkgObj.tdfkSelected[tdfkObj.todofukenCd],
          selectedAreaList = this.selectedSkgObj.areaSelected[areaObj.areaCd];
      // 選択状態を付与する
      tdfkObj.shikugunLList.forEach(function (skgObj) {
        var skgCd = skgObj.shikugunLCd;
        var isSelectedTemp = false;

        skgObj.isSelected = false;
        if (skgCd == 'all') {
          return;
        }
        if (selectedAreaList == 'all' && selectedTdfkList == undefined || selectedTdfkList == 'all') {
          skgObj.isSelected = true;
          return;
        }
        if (selectedTdfkList === undefined || selectedTdfkList === []) {
          return;
        }

        selectedTdfkList.forEach(function (skgItem) {
          if (skgItem == skgCd) {
            isSelectedTemp = true;
            return false;
          }
        });
        skgObj.isSelected = isSelectedTemp;
      });
      vm.$forceUpdate();
    },
    /**
     * @desc 定員数更新
     */
    updateCapDispList: function updateCapDispList() {
      var _this46 = this;

      this.getCount(this.selectedLists, ['capList'], 'boshuninzu').then(function (data) {
        return _this46.setPanelData(data, _this46.capDispList);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与する
      this.capDispList.forEach(function (capObj) {
        capObj.isSelected = false;
        if (_this46.selectedLists.capList.length === 0 || _this46.selectedLists.capList[0] === {}) {
          return false;
        } else if (_this46.selectedLists.capList.length === 1) {
          capObj.isSelected = capObj.minCapa === _this46.selectedLists.capList[0].value;
        } else {
          capObj.isSelected = capObj.minCapa === _this46.selectedLists.capList[0].value && capObj.maxCapa === _this46.selectedLists.capList[1].value;
        }
      });
    },
    /**
     * @desc 納入金更新
     */
    updatePayDispList: function updatePayDispList() {
      var _this47 = this;

      this.getCount(this.selectedLists, ['payList'], 'payment').then(function (data) {
        return _this47.setPanelData(data, _this47.payDispList);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与する
      this.payDispList.forEach(function (payObj) {
        payObj.isSelected = false;
        if (_this47.selectedLists.payList.length === 0 || _this47.selectedLists.payList[0] === {}) {
          return false;
        } else if (_this47.selectedLists.payList.length === 1) {
          payObj.isSelected = payObj.minPay === _this47.selectedLists.payList[0].value;
        } else {
          payObj.isSelected = payObj.minPay === _this47.selectedLists.payList[0].value && payObj.maxPay === _this47.selectedLists.payList[1].value;
        }
      });
    },
    /**
     * @desc 特長更新
     */
    updateTkDispList: function updateTkDispList() {
      var _this48 = this;

      this.getCount(this.selectedLists, ['tkList'], 'tokucho').then(function (data) {
        data.forEach(function (countObj) {
          var addObj = [],
              targetIndex = undefined;
          targetIndex = _this48.tkDispList.findIndex(function (tkObj) {
            return tkObj.tkCd === countObj.SearchPanelCountCd;
          });
          // 配列のコピー
          addObj = Object.assign({}, _this48.tkDispList[targetIndex]);
          addObj.count = countObj.SearchPanelCount;
          vm.$set(_this48.tkDispList, targetIndex, addObj);
        });
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与する
      this.tkDispList.forEach(function (tkObj) {
        tkObj.isSelected = false;
        // 選択済み配列を作成
        var selectedTkCdList = _this48.selectedLists.tkList.map(function (tkObj) {
          return tkObj.value;
        });
        if (selectedTkCdList !== []) {
          tkObj.isSelected = selectedTkCdList.indexOf(tkObj.tkCd) >= 0;
        }
      });
    },
    /**
     * @desc 学問大更新
     */
    updateGakumonLDispList: function updateGakumonLDispList() {
      var _this49 = this;

      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'gakumon_l').then(function (data) {
        return _this49.setPanelData(data, _this49.gakumonLDispList);
      }, function () {
        return console.log('error');
      });
      // 選択状況を付与
      this.gakumonLDispList.forEach(function (gakumonLObj) {
        gakumonLObj.isSelected = false;
        if (_this49.selectedLists.glList.length === 0) {
          return false;
        }
        gakumonLObj.isSelected = gakumonLObj.glCd === _this49.selectedLists.glList[0].value;
      });
    },
    /**
     * @desc 学問小分類更新。項目セットとデータ更新を同時に行う
     * @param {string} glCd - 学問大分類コード
     */
    updateGakumonSDispList: function updateGakumonSDispList(glCd) {
      var _gakumonSDispList,
          _this50 = this;

      var targetObj = {},
          formatObj = {},
          targetList = [],
          parentData = undefined,
          sendSubParams = [];

      this.gakumonSDispList.splice(0);
      targetObj = this.getGakumonLItem(glCd);
      targetList = targetObj !== undefined ? targetObj.gsList : [];
      (_gakumonSDispList = this.gakumonSDispList).push.apply(_gakumonSDispList, _toConsumableArray(targetList));
      formatObj.nm = targetObj.glNm;
      formatObj.cd = targetObj.glCd;
      this.selectedGakumonL = formatObj;
      parentData = {
        name: 'countGl',
        value: targetObj.glCd
      };
      sendSubParams.push(parentData);
      var selectedBunyaTabTemp = this.currentBunyaId;
      var selectedValue = this.selectedLists.glList[1] ? this.selectedLists.glList[1].value : null;
      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'gakumon_s', sendSubParams).then(function (data) {
        return _this50.updateCountSList(data, glCd, selectedBunyaTabTemp, selectedValue);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与
      targetList.forEach(function (gsObj) {
        gsObj.isSelected = false;
        if (_this50.selectedLists.glList.length <= 1) {
          return false;
        }
        gsObj.isSelected = gsObj.gsCd === _this50.selectedLists.glList[1].value;
      });

      this.updateBunyaPanels('gl', 'gs');
    },
    // 仕事大更新
    updateShigotoLDispList: function updateShigotoLDispList() {
      var _this51 = this;

      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shigoto_l').then(function (data) {
        return _this51.setPanelData(data, _this51.shigotoLDispList);
      }, function () {
        return console.log('error');
      });
      // 選択状況を付与
      this.shigotoLDispList.forEach(function (shigotoLObj) {
        shigotoLObj.isSelected = false;
        if (_this51.selectedLists.jlList.length === 0 || _this51.selectedLists.jlList[0] === {}) {
          return false;
        }
        shigotoLObj.isSelected = shigotoLObj.jlCd === _this51.selectedLists.jlList[0].value;
      });
    },
    /**
     * @desc 仕事中分類更新。項目セットとデータ更新を同時に行う
     * @param {string} jlCd - 仕事大分類コード
     */
    updateShigotoMDispList: function updateShigotoMDispList(jlCd) {
      var _shigotoMDispList,
          _this52 = this;

      var targetObj = {},
          formatObj = {},
          targetList = [],
          parentData = undefined,
          sendSubParams = [];

      this.shigotoMDispList.splice(0);
      targetObj = this.getShigotoLItem(jlCd);
      targetList = targetObj !== undefined ? targetObj.jmList : [];
      (_shigotoMDispList = this.shigotoMDispList).push.apply(_shigotoMDispList, _toConsumableArray(targetList));
      formatObj.nm = targetObj.jlNm;
      formatObj.cd = targetObj.jlCd;
      this.selectedShigotoL = formatObj;
      parentData = {
        name: 'countJl',
        value: targetObj.jlCd
      };
      sendSubParams.push(parentData);

      var selectedBunyaTabTemp = this.currentBunyaId;
      var selectedValue = this.selectedLists.jlList[1] ? this.selectedLists.jlList[1].value : null;
      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shigoto_m', sendSubParams).then(function (data) {
        return _this52.updateCountMList(data, jlCd, 'shigoto', selectedValue);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与
      if (targetList.length > 0) {
        targetList.forEach(function (jmObj) {
          jmObj.isSelected = false;
          var isJmList = _this52.selectedLists.jlList[1] && Object.keys(_this52.selectedLists.jlList[1]).length > 0;
          if (_this52.selectedLists.jlList.length <= 1 || isJmList) {
            return false;
          }
          jmObj.isSelected = isJmList && jmObj.jmCd === _this52.selectedLists.jlList[1].value;
        });
      }
      this.updateBunyaPanels('jm', 'js');
    },
    /**
     * @desc 仕事小分類更新。項目セットとデータ更新を同時に行う
     * @param {string} jlCd - 仕事大分類コード
     * @param {string} jmCd - 仕事中分類コード
     */
    updateShigotoSDispList: function updateShigotoSDispList(jlCd, jmCd) {
      var _shigotoSDispList,
          _this53 = this;

      var targetObj = {},
          formatObj = {},
          targetList = [],
          parentData = undefined,
          sendSubParams = [];

      this.shigotoSDispList.splice(0);
      targetObj = this.getShigotoMItem(jlCd, jmCd);
      if (!targetObj) return;
      targetList = targetObj !== undefined ? targetObj.jsList : [];
      (_shigotoSDispList = this.shigotoSDispList).push.apply(_shigotoSDispList, _toConsumableArray(targetList));
      formatObj.nm = targetObj.jmNm;
      formatObj.cd = targetObj.jmCd;
      this.selectedShigotoM = formatObj;
      parentData = [{
        name: 'countJl',
        value: jlCd
      }, {
        name: 'countJm',
        value: jmCd
      }];
      sendSubParams.push.apply(sendSubParams, _toConsumableArray(parentData));
      var selectedBunyaTabTemp = this.currentBunyaId;
      var selectedValue = this.selectedLists.jlList[2] ? this.selectedLists.jlList[2].value : null;
      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shigoto_s', sendSubParams).then(function (data) {
        return _this53.updateCountSList(data, jmCd, selectedBunyaTabTemp, selectedValue);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与
      targetList.forEach(function (jsObj) {
        jsObj.isSelected = false;
        if (_this53.selectedLists.jlList.length <= 2 || _this53.selectedLists.jlList[2] === {}) {
          return false;
        }
        jsObj.isSelected = jsObj.jsCd === _this53.selectedLists.jlList[2].value;
      });
    },
    /**
     * @desc 資格大更新
     */
    updateShikakuLDispList: function updateShikakuLDispList() {
      var _this54 = this;

      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shikaku_l').then(function (data) {
        return _this54.setPanelData(data, _this54.shikakuLDispList);
      }, function () {
        return console.log('error');
      });
      // 選択状況を付与
      this.shikakuLDispList.forEach(function (shikakuLObj) {
        shikakuLObj.isSelected = false;
        if (_this54.selectedLists.qlList.length === 0 || _this54.selectedLists.qlList[0] === {}) {
          return false;
        }
        shikakuLObj.isSelected = shikakuLObj.qlCd === _this54.selectedLists.qlList[0].value;
      });
    },
    /**
     * @desc 資格中分類更新。項目セットとデータ更新を同時に行う
     * @param {string} qlCd - 資格大分類コード
     */
    updateShikakuMDispList: function updateShikakuMDispList(qlCd) {
      var _shikakuMDispList,
          _this55 = this;

      var targetObj = {},
          formatObj = {},
          targetList = [],
          parentData = undefined,
          sendSubParams = [];

      this.shikakuMDispList.splice(0);
      targetObj = this.getShikakuLItem(qlCd);
      targetList = targetObj !== undefined ? targetObj.qmList : [];
      (_shikakuMDispList = this.shikakuMDispList).push.apply(_shikakuMDispList, _toConsumableArray(targetList));
      formatObj.nm = targetObj.qlNm;
      formatObj.cd = targetObj.qlCd;
      this.selectedShikakuL = formatObj;
      parentData = {
        name: 'countQl',
        value: targetObj.qlCd
      };
      sendSubParams.push(parentData);
      var selectedBunyaTabTemp = this.currentBunyaId;
      var selectedValue = this.selectedLists.qlList[1] ? this.selectedLists.qlList[1].value : null;
      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shikaku_m', sendSubParams).then(function (data) {
        return _this55.updateCountMList(data, qlCd, 'shikaku', selectedValue);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与
      targetList.forEach(function (qmObj) {
        qmObj.isSelected = false;
        if (_this55.selectedLists.qlList.length <= 1) {
          return false;
        }
        qmObj.isSelected = qmObj.qmCd === _this55.selectedLists.qlList[1].value;
      });

      this.updateBunyaPanels('qm', 'qs');
    },
    /**
     * @desc 資格小分類更新。項目セットとデータ更新を同時に行う
     * @param {string} qlCd - 資格大分類コード
     * @param {string} qmCd - 資格中分類コード
     */
    updateShikakuSDispList: function updateShikakuSDispList(qlCd, qmCd) {
      var _shikakuSDispList,
          _this56 = this;

      var targetObj = {},
          formatObj = {},
          targetList = [],
          parentData = undefined,
          sendSubParams = [];

      this.shikakuSDispList.splice(0);
      targetObj = this.getShikakuMItem(qlCd, qmCd);
      targetList = targetObj !== undefined ? targetObj.qsList : [];
      (_shikakuSDispList = this.shikakuSDispList).push.apply(_shikakuSDispList, _toConsumableArray(targetList));
      formatObj.nm = targetObj.qmNm;
      formatObj.cd = targetObj.qmCd;
      this.selectedShikakuM = formatObj;
      parentData = [{
        name: 'countQl',
        value: qlCd
      }, {
        name: 'countQm',
        value: qmCd
      }];
      sendSubParams.push.apply(sendSubParams, _toConsumableArray(parentData));
      var selectedBunyaTabTemp = this.currentBunyaId;
      var selectedValue = this.selectedLists.qlList[2] ? this.selectedLists.qlList[2].value : null;
      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shikaku_s', sendSubParams).then(function (data) {
        return _this56.updateCountSList(data, qmCd, selectedBunyaTabTemp, selectedValue);
      }, function () {
        return console.log('error');
      });
      // 選択状態を付与
      targetList.forEach(function (qsObj) {
        qsObj.isSelected = false;
        if (_this56.selectedLists.qlList.length <= 2) {
          return false;
        }
        qsObj.isSelected = qsObj.qsCd === _this56.selectedLists.qlList[2].value;
      });
    },
    /**
     * @desc 資格種別更新
     * @param {string} qsCd - 資格小分類コード
     * @param {string} qsNm - 資格小分類名
     * @param {string} qmCd - 資格中分類コード
     */
    updateShikakuShDispList: function updateShikakuShDispList(qsCd, qsNm, qmCd) {
      var _this57 = this;

      var formatObj = {},
          parentData = undefined,
          sendSubParams = [];
      parentData = [{
        name: 'countQl',
        value: this.selectedShikakuL.cd
      }, {
        name: 'countQm',
        value: this.selectedShikakuM.cd
      }, {
        name: 'countQs',
        value: qsCd
      }];
      sendSubParams.push.apply(sendSubParams, _toConsumableArray(parentData));
      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'shikaku_shubetsu', sendSubParams).then(function (data) {
        _this57.setPanelData(data, _this57.shikakuShDispList);
        // 選択状況と親コードを付与
        var shikakuShArray = [];
        Object.assign(shikakuShArray, _this57.shikakuShDispList);
        shikakuShArray.forEach(function (shikakuShObj) {
          var isQsdSelected = false,
              isQsSelected = false;
          shikakuShObj.isSelected = false;
          shikakuShObj.qmCd = qmCd;
          if (_this57.selectedLists.qlList.length <= 2 || _this57.selectedLists.qlList[2] === {}) {
            return false;
          }
          if (_this57.selectedLists.qshList.length === 0 || _this57.selectedLists.qshList[0] === {}) {
            return false;
          }
          isQsdSelected = shikakuShObj.qshCd === _this57.selectedLists.qshList[0].value;
          isQsSelected = qsCd === _this57.selectedLists.qlList[2].value;
          shikakuShObj.isSelected = isQsSelected && isQsdSelected;
        });
        _this57.shikakuShDispList = shikakuShArray;
        formatObj.nm = qsNm;
        formatObj.cd = qsCd;
        _this57.selectedShikakuS = formatObj;
      }, function () {
        return console.log('error');
      });
    },
    /**
     * @desc 学部系統更新
     */
    updateGbkDispList: function updateGbkDispList() {
      var _this58 = this;

      this.getCount(this.selectedLists, ['jlList', 'qlList', 'glList', 'gbkList', 'qshList'], 'gakubukeito').then(function (data) {
        return _this58.setPanelData(data, _this58.gbkDispList);
      }, function () {
        return console.log('error');
      });
      // 選択状況を付与
      this.gbkDispList.forEach(function (gbkObj) {
        gbkObj.isSelected = false;
        if (_this58.selectedLists.gbkList.length === 0 || _this58.selectedLists.gbkList[0] === {}) {
          return false;
        }

        gbkObj.isSelected = gbkObj.gbkCd === _this58.selectedLists.gbkList[0].value;
      });
    },

    /**
     * @desc 検索を実行せずに分野＆詳細条件パネルを閉じる時、詳細条件設定のリストアを行う
     */
    restoreSearchPanelSetting: function restoreSearchPanelSetting() {
      // ログ送信
      this.sendLog('Ssearch_result_panel_refine_back');

      this.restoreSelectedLists();

      // 分野設定フラグと設定情報のリストア
      if (this.selectedBkLists.glList.length > 0) {
        this.isGakumonSelected = true;
      } else if (this.selectedBkLists.qlList.length > 0) {
        this.isShikakuSelected = true;
      } else if (this.selectedBkLists.jlList.length > 0) {
        this.isShigotoSelected = true;
      } else if (this.selectedBkLists.gbkList.length > 0) {
        this.isGakubuKeitouSelected = true;
      }

      this.isJoinPanelLoaded = false;
      this.rwAreaObjTempSelected = {};
    },
    /**
     * @desc 詳細条件が画面ロード時から変更されたかを判定
     */
    isSelectListUpdated: function isSelectListUpdated() {
      var listItems = ['capList', 'ksList', 'payList', 'qshList', 'skgList', 'sttList', 'tkList'];
      var length = listItems.length;
      var isUpdated = false;
      for (var i = 0; i < length; i++) {
        // value値をkeyにしてobject配列をソートした上で比較を行い、
        // 配列に格納されている順番に関わらず同じ値が設定されているかを判定できるようにする
        var selectListItems = this.selectedLists[listItems[i]].concat();
        var backupListItems = this.selectedBkLists[listItems[i]].concat();
        selectListItems.sort(this.compareValues('value'));
        backupListItems.sort(this.compareValues('value'));

        var selectListText = JSON.stringify(selectListItems);
        var backupListText = JSON.stringify(backupListItems);
        if (selectListText !== backupListText) {
          isUpdated = true;
          break;
        }
      }
      return isUpdated;
    },
    compareValues: function compareValues(key) {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          // property doesn't exist on either object
          return 0;
        }

        var varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
        var varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

        var comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return comparison;
      };
    },
    /**
     * @desc 各パネル「条件を決定」ボタン押下時、スクロール位置の解除と詳細パネルへの遷移
     */
    selectDetail: function selectDetail() {
      // パネルの速度と合わせる
      setTimeout(function () {
        (0, _jquery2['default'])('.js-panelInner').scrollTop(0);
      }, 150);

      // 一度すべてのパネルを閉じることで、ブラウザバック時に一覧へ戻れるようにする
      var slidePanelStateObj = Object.assign({}, this.slidePanelState);
      Object.keys(slidePanelStateObj).forEach(function (key) {
        slidePanelStateObj[key] = false;
      });
      this.slidePanelState = slidePanelStateObj;
      this.pushPanelState();

      // 詳細パネルのみを展開
      this.openPanelAugOnly('detail');
    },
    /**
     * @desc サイカタログ送信
     * @param {string} logID - 送信したいログID
     */
    sendLog: function sendLog(logID) {
      if (!s2) return;
      s2.tl(this, 'o', logID);
    }
  }
});

exports['default'] = vm;
module.exports = exports['default'];

},{"./_s_searchPanelsBunya_responsive.vue":157,"./slidePanel/responsive/modules/SearchPanelFixedBottom.vue":168,"./slidePanel/responsive/modules/SlidePanelTemplate.vue":169,"jquery":97,"vue":102}],157:[function(require,module,exports){
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BunyaPanelL = require('./slidePanel/responsive/BunyaPanelL.vue');

var _BunyaPanelL2 = _interopRequireDefault(_BunyaPanelL);

var _BunyaPanelS = require('./slidePanel/responsive/BunyaPanelS.vue');

var _BunyaPanelS2 = _interopRequireDefault(_BunyaPanelS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    allCount: {
      type: Number,
      required: true
    },
    openedAccordions: {
      type: Array,
      required: true
    },
    bunyaTabList: {
      type: Array,
      required: false
    },
    bunyaList: {
      type: Object,
      required: false
    },
    bunyaListM: {
      type: Object,
      required: false
    },
    bunyaListS: {
      type: Object,
      required: false
    },
    shikakuShList: {
      type: Array,
      required: false
    },
    slidePanelState: {
      type: Object,
      required: true
    },
    selectedBunyaTab: {
      type: String,
      required: true
    },
    currentBunyaId: {
      type: String,
      required: true
    },
    currentBunyaIdTemp: {
      type: String,
      required: true
    },
    selectedLists: {
      type: Object,
      required: true
    },
    selectedBunyaName: {
      type: String,
      required: true
    },
    selectedBunyaCdL: {
      type: String,
      required: true
    },
    selectedBunyaKeyM: {
      type: String,
      required: true
    },
    selectedBunyaKeyS: {
      type: String,
      required: true
    },
    selectedBunyaCds: {
      type: Array,
      required: true
    },
    submitMode: {
      type: Boolean,
      required: true
    },
    isFirstModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BunyaPanelL: _BunyaPanelL2.default,
    BunyaPanelS: _BunyaPanelS2.default
  },
  methods: {
    tabChange: function tabChange($event) {
      this.$emit('tab-change', $event);
    },
    prevAction: function prevAction() {
      this.$emit('prev');
    },
    closeAction: function closeAction() {
      this.$emit('close');
    },
    getCountS: function getCountS($event) {
      this.$emit('get-count-s', $event);
    },
    goToPanelL: function goToPanelL() {
      this.$emit('go-to-panel-l');
    },
    setItem: function setItem($event) {
      this.$emit('set-item', $event);
    },
    setItemS: function setItemS($event) {
      this.$emit('set-item-s', $event);
    },
    clickAllM: function clickAllM($event) {
      this.$emit('click-all-m', $event);
    },
    setShikakuShItem: function setShikakuShItem($event) {
      this.$emit('set-shikaku-sh-item', $event);
    },
    toggleAccordion: function toggleAccordion($event) {
      this.$emit('toggle-accordion', $event);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BunyaPanelL',{attrs:{"allCount":_vm.allCount,"bunyaTabList":_vm.bunyaTabList,"bunyaList":_vm.bunyaList,"isOpenBunyaL":_vm.slidePanelState.bunyaL,"selectedBunyaTab":_vm.selectedBunyaTab,"selectedLists":_vm.selectedLists,"selectedBunyaCds":_vm.selectedBunyaCds,"isFirstModal":_vm.isFirstModal},on:{"prev":_vm.prevAction,"close":_vm.closeAction,"tabChange":_vm.tabChange,"setItem":_vm.setItem}}),_vm._v(" "),_c('BunyaPanelS',{attrs:{"bunyaListM":_vm.bunyaListM,"bunyaListS":_vm.bunyaListS,"shikakuShList":_vm.shikakuShList,"currentBunyaId":_vm.currentBunyaId,"currentBunyaIdTemp":_vm.currentBunyaIdTemp,"selectedBunyaTab":_vm.selectedBunyaTab,"openedAccordions":_vm.openedAccordions,"isOpenBunyaS":_vm.slidePanelState.bunyaS,"isFirstModal":_vm.isFirstModal,"selectedBunyaName":_vm.selectedBunyaName,"selectedBunyaCdL":_vm.selectedBunyaCdL,"selectedBunyaKeyM":_vm.selectedBunyaKeyM,"selectedBunyaKeyS":_vm.selectedBunyaKeyS,"selectedBunyaCds":_vm.selectedBunyaCds,"submitMode":_vm.submitMode},on:{"goToPanelL":_vm.goToPanelL,"prev":_vm.prevAction,"close":_vm.closeAction,"getCountS":_vm.getCountS,"setItemS":_vm.setItemS,"clickAllM":_vm.clickAllM,"setShikakuShItem":_vm.setShikakuShItem,"toggleAccordion":_vm.toggleAccordion}})],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17d73ab8", __vue__options__)
  } else {
    hotAPI.reload("data-v-17d73ab8", __vue__options__)
  }
})()}
},{"./slidePanel/responsive/BunyaPanelL.vue":164,"./slidePanel/responsive/BunyaPanelS.vue":165,"vue":102,"vue-hot-reload-api":101}],158:[function(require,module,exports){
/**
 * 【案件】feat-98612-検索一覧_共感コンテンツ追加_SP
 * 【ブランチ】feat-98612-検索一覧_共感コンテンツ追加_SP
 * 共感コンテンツSP Cパターン(共感コンテンツ）で読み込む
 */

// APIのレスポンスを受け取るグローバル変数
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _this = this;

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var kyokanContentsResponse = [];

// 初期化関数：APIからデータを取得し、オブザーバーを設定する
var initKyokanContent = function initKyokanContent() {
  return regeneratorRuntime.async(function initKyokanContent$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.prev = 0;
        context$1$0.next = 3;
        return regeneratorRuntime.awrap(fetchGetKyokanContents());

      case 3:
        setCassettesObserver();
        context$1$0.next = 9;
        break;

      case 6:
        context$1$0.prev = 6;
        context$1$0.t0 = context$1$0['catch'](0);

        (function () {
          // エラー用のhtmlを表示する
          var errorHtml = createErrorHTML();
          var jsKyokanContents = document.querySelectorAll('.js-kyokanContent');
          jsKyokanContents.forEach(function (target) {
            setKyokanHtmlToScreen(errorHtml, target);
          });
        })();

      case 9:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this, [[0, 6]]);
};

// APIから共感コンテンツのデータを取得
var fetchGetKyokanContents = function fetchGetKyokanContents() {
  var schoolCodes, _getSearchFieldType, searchFieldMap, searchFieldType, apiUrl, searchFiledObj, response;

  return regeneratorRuntime.async(function fetchGetKyokanContents$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        schoolCodes = getSchoolCodes();
        _getSearchFieldType = getSearchFieldType();
        searchFieldMap = _getSearchFieldType.searchFieldMap;
        searchFieldType = _getSearchFieldType.searchFieldType;
        apiUrl = '/searchList/empathyContents/';
        searchFiledObj = Object.fromEntries(searchFieldMap);
        context$1$0.next = 8;
        return regeneratorRuntime.awrap(fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'school_codes': schoolCodes,
            'search_field_type': searchFieldType,
            'field_search_conditions': searchFiledObj
          })
        }));

      case 8:
        response = context$1$0.sent;

        if (response.ok) {
          context$1$0.next = 11;
          break;
        }

        throw new Error("API response not OK");

      case 11:
        context$1$0.next = 13;
        return regeneratorRuntime.awrap(response.json());

      case 13:
        kyokanContentsResponse = context$1$0.sent;

      case 14:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this);
};

// 学校コードを取得
var getSchoolCodes = function getSchoolCodes() {
  var cassetteItems = document.querySelectorAll('.js-cassetteInView');
  return [].concat(_toConsumableArray(cassetteItems)).map(function (cassette) {
    return cassette.dataset.gakkocd;
  });
};

// URLから検索フィールドのタイプを取得
var getSearchFieldType = function getSearchFieldType() {

  // 検索条件に指定された分野種別を判別する変数
  var KEY_SEARCH_FIELD_TYPE = {
    'jl': 1, // 仕事
    'jm': 1, // 仕事
    'js': 1, // 仕事
    'gl': 2, // 学問
    'gm': 2, // 学問
    'gs': 2, // 学問
    'ql': 3, // 資格
    'qm': 3, // 資格
    'qs': 3, // 資格
    'gbk': 4 };

  // 分野の検索条件を格納するMap型の変数
  // 学部系統
  var searchFieldMap = new Map(null, null);

  var url = document.location.href;
  var splitUrl = function splitUrl(url) {
    // URLを解析するための新しいURLオブジェクトを作成
    var parsedUrl = new URL(url);

    // パスを'/'で分割
    var pathParts = parsedUrl.pathname.split('/').filter(function (part) {
      return part.length > 0;
    });
    // クエリパラメータを分割
    var queryParams = Array.from(parsedUrl.searchParams).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];
      return key + '=' + value;
    });
    // パスで検索条件に指定された分野種別を表示するパターンと、
    // クエリパラメータで表示するパターンが混在しているので、両対応できるよう結合する
    return [].concat(_toConsumableArray(pathParts), _toConsumableArray(queryParams));
  };
  var arraySplitUrl = splitUrl(url);

  // 分割したURLから、分野コードを保存する
  arraySplitUrl.forEach(function (urlLocation) {
    // '/' ,'_'、'='で分割

    var _urlLocation$split = urlLocation.split(/[/_=]/);

    var _urlLocation$split2 = _slicedToArray(_urlLocation$split, 2);

    var key = _urlLocation$split2[0];
    var value = _urlLocation$split2[1];

    for (var bunyaKey in KEY_SEARCH_FIELD_TYPE) {
      if (key === bunyaKey) {
        searchFieldMap.set(key, value);
      }
    }
  });

  // 検索条件に指定された分野種別を格納する変数（未設定の場合はNULL）
  var searchFieldType = null;
  for (var key in KEY_SEARCH_FIELD_TYPE) {
    if (searchFieldMap.has(key)) {
      searchFieldType = KEY_SEARCH_FIELD_TYPE[key];
      break;
    }
  }

  return {
    searchFieldMap: searchFieldMap,
    searchFieldType: searchFieldType
  };
};

// 共通で使用する共感コンテンツのhtmlを生成
var createCommonHTML = function createCommonHTML(data) {
  return '\n  <div class="kyokanContentField">\n    <span class="kyokanContentField__title">\n      在校生・卒業生・先生の声\n    <span class="kyokanContentField__kensu">（' + data.total_count + '件）</span>\n    </span>\n    <span class="kyokanContentField__link js-kyokan_moreLink_clickLog"><a href="' + data.more_url + '" class="kyokanContentField__linkText">もっと見る</a></span>\n  </div>';
};

// 在校生のhtmlを生成
var createZaikouseiHTML = function createZaikouseiHTML(data) {
  return '\n  <div data-product_cd="' + data.product_cd + '" class="js-kyokanClickLog">\n    <a href="' + data.kyokan_content_url + '" class="kyokanCassetteField js-kyokanCassetteField">\n      <div class="kyokanCassetteField__imgArea">\n        <img src="' + data.image_path + '" alt="在校生の写真" class="kyokanCassetteField__img" min-width="99px" min-height="66px">\n        <span class="kyokanCassetteField__zaikouseiLabel">在校生</span>\n      </div>\n      <div class="kyokanCassetteField__textAreaWrap">\n        <div class="kyokanCassetteField__textArea">\n          <span class="kyokanCassetteField__titleZaikousei js-titleZaikousei">' + data.main_catch + '</span>\n          <span class="kyokanCassetteField__textZaikousei js-textZaikousei">' + data.course + '</span>\n        </div>\n      </div>\n    </a>\n  </div>';
};

// 卒業生のhtmlを生成
var createSotugyoseiHTML = function createSotugyoseiHTML(data) {
  return '\n  <div data-product_cd="' + data.product_cd + '" class="js-kyokanClickLog">\n    <a href="' + data.kyokan_content_url + '" class="kyokanCassetteField">\n      <div class="kyokanCassetteField__imgArea">\n        <img src="' + data.image_path + '" alt="卒業生の写真" class="kyokanCassetteField__img" min-width="99px" min-height="66px">\n        <span class="kyokanCassetteField__sotugyoseiLabel">卒業生</span>\n      </div>\n      <div class="kyokanCassetteField__textAreaWrap">\n        <div class="kyokanCassetteField__textArea">\n          <span class="kyokanCassetteField__titleSotugyosei">' + data.main_catch + '</span>\n          <span class="kyokanCassetteField__textSotugyosei">' + data.course + '</span>\n          <span class="kyokanCassetteField__textSotugyosei">' + data.job_name + '</span>\n        </div>\n      </div>\n    </a>\n  </div>';
};

// 先生のhtmlを生成
var createTeacherHTML = function createTeacherHTML(data) {
  return '\n  <div data-product_cd="' + data.product_cd + '" class="js-kyokanClickLog">\n    <a href="' + data.kyokan_content_url + '" class="kyokanCassetteField">\n      <div class="kyokanCassetteField__imgArea">\n        <img src="' + data.image_path + '" alt="先生の写真" class="kyokanCassetteField__img" min-width="99px" min-height="66px">\n        <span class="kyokanCassetteField__teacherLabel">先生</span>\n      </div>\n      <div class="kyokanCassetteField__textAreaWrap">\n        <div class="kyokanCassetteField__textArea">\n          <span class="kyokanCassetteField__titleTeacher">' + data.main_catch + '</span>\n          <span class="kyokanCassetteField__textTeacher">' + data.course + '</span>\n          <span class="kyokanCassetteField__textTeacher">' + data.teacher_name + '</span>\n        </div>\n      </div>\n    </a>\n  </div>';
};

// 授業のhtmlを生成
var createLessonHTML = function createLessonHTML(data) {
  return '\n  <div data-product_cd="' + data.product_cd + '" class="js-kyokanClickLog">\n    <a href="' + data.kyokan_content_url + '" class="kyokanCassetteField">\n      <div class="kyokanCassetteField__imgArea">\n        <img src="' + data.image_path + '" alt="授業の写真" class="kyokanCassetteField__img" min-width="99px" min-height="66px">\n        <span class="kyokanCassetteField__lessonLabel">授業</span>\n      </div>\n      <div class="kyokanCassetteField__textAreaWrap">\n        <div class="kyokanCassetteField__textArea">\n          <span class="kyokanCassetteField__titleLesson">' + data.main_catch + '</span>\n          <span class="kyokanCassetteField__textLesson">' + data.course + '</span>\n        </div>\n      </div>\n    </a>\n  </div>';
};

// エラー表示のhtmlを生成
var createErrorHTML = function createErrorHTML() {
  return '\n  <div class="kyokanContentField">\n    <span class="kyokanContentField__title">在校生・卒業生・先生の声</span>\n  </div>\n  <div class="kyokanCassetteError">\n    <p class="kyokanCassetteError__text">コンテンツを読み込めませんでした。</p>\n    <p class="kyokanCassetteError__text">再度ページを読み込んでください。</p>\n  </div>';
};

// APIレスポンスからHTMLを生成
var createKyokanHTML = function createKyokanHTML(data) {
  // 共通で表示するhtmlを作成
  var contentHTML = createCommonHTML(data);

  // 在校生
  if (data.kyokan_type === "1") {
    contentHTML += createZaikouseiHTML(data);
  }
  // 先生/教授
  else if (data.kyokan_type === "2") {
      contentHTML += createTeacherHTML(data);
    }
    // 卒業生
    else if (data.kyokan_type === "3") {
        contentHTML += createSotugyoseiHTML(data);
      }
      // 授業
      else if (data.kyokan_type === "4") {
          contentHTML += createLessonHTML(data);
        }
        // エラー表示
        else {
            contentHTML = createErrorHTML();
          }
  return contentHTML;
};

// 生成されたHTMLを画面の適切な位置に挿入
var setKyokanHtmlToScreen = function setKyokanHtmlToScreen(html, targetElement) {
  targetElement.innerHTML = html;
};

// クリックログの設定
var setKyokanClickLog = function setKyokanClickLog(jsKyokanContentElement) {
  // クリックログ用の変数を宣言
  var s = s_gi(s_account);

  // もっと見る要素を取得
  var moreLinkElement = jsKyokanContentElement.querySelector('.js-kyokan_moreLink_clickLog');
  if (!moreLinkElement) return;

  // 表示しているカセット順位を取得
  var cassetteIndex = jsKyokanContentElement.closest('.js-cassetteInView').dataset.index;
  // 表示している学校の学校コードを取得
  var gakkoCd = jsKyokanContentElement.closest('.js-cassetteInView').dataset.gakkocd;

  // もっと見る押下時、ログを送信する
  moreLinkElement.addEventListener('click', function (event) {
    // ログの値がslist_f_all_SCcassette_kyokanAll_click_(カセット順位)_(学校コード) になるよう生成
    var logName = 'slist_f_all_SCcassette_kyokanAll_click_' + cassetteIndex + '_' + gakkoCd;
    s.tl(event.target, 'o', logName);
  });

  // 共感コンテンツ要素を取得
  var kyokanElement = jsKyokanContentElement.querySelector('.js-kyokanClickLog');
  if (!kyokanElement) return;

  var productCd = kyokanElement.dataset.product_cd;

  // 共感コンテンツ押下時、ログを送信する
  kyokanElement.addEventListener('click', function (event) {
    // ログの値がslist_f_all_SCcassette_kyokan_(カセット順位)_(学校コード)_(共感コンテンツを一意に特定するためのID) になるよう生成
    var logName = 'slist_f_all_SCcassette_kyokan_' + cassetteIndex + '_' + gakkoCd + '_' + productCd;
    s.tl(event.target, 'o', logName);
  });
};

// 検索カセットが画面に表示されたときに、HTMLを挿入するためのオブザーバーを設定
var setCassettesObserver = function setCassettesObserver() {
  var setKyokanHTML = function setKyokanHTML(entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > 0) {
        (function () {
          var targetGakkocd = entry.target.dataset.gakkocd;
          // 画面に表示されている学校と一致するデータを取得する
          var aryKyokanData = kyokanContentsResponse.filter(function (kyokanContent) {
            return kyokanContent.school_code === targetGakkocd;
          });
          // 共感コンテンツがある時、htmlを画面に入れる
          if (aryKyokanData.length > 0) {
            var html = createKyokanHTML(aryKyokanData[0]);
            var jsKyokanContent = entry.target.querySelector('.js-kyokanContent');
            setKyokanHtmlToScreen(html, jsKyokanContent);
            // 画面に入れた共感コンテンツにログを設定する
            setKyokanClickLog(jsKyokanContent);
            // 在校生カセットの文言省略設定
            lineClampChange(jsKyokanContent);
          }
          io.unobserve(entry.target);
        })();
      }
    });
  };

  var targetElement = document.querySelectorAll(".js-cassetteInView");
  var io = new IntersectionObserver(setKyokanHTML);
  targetElement.forEach(function (target) {
    io.observe(target);
  });
};

// 在校生カセットのタイトルの行数に応じて補足テキストの省略行数を変える
var lineClampChange = function lineClampChange(jsKyokanContent) {
  var titleZaikousei = jsKyokanContent.querySelector('.js-titleZaikousei');
  var textZaikousei = jsKyokanContent.querySelector('.js-textZaikousei');
  if (titleZaikousei && textZaikousei) {
    var titleZaikouseiHeight = titleZaikousei.offsetHeight;
    if (titleZaikouseiHeight > 16) {
      textZaikousei.style.webkitLineClamp = '1';
    } else {
      textZaikousei.style.webkitLineClamp = '2';
    }
  }
};

exports.initKyokanContent = initKyokanContent;

// Mapをオブジェクトに変換

},{}],159:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

exports['default'] = (0, _jquery2['default'])(function () {

	var winWidth = window.innerWidth;

	/**
 * ページ内リンク
 */
	(0, _jquery2['default'])(document).on('click', 'a[href^="#s"]', function () {
		var isLeftMove = (0, _jquery2['default'])(this).hasClass('pgleft');
		var ptn = new RegExp(/^#sindex[0-9]*$/);
		var hrf = (0, _jquery2['default'])(this).attr('href');
		var ua = navigator.userAgent;
		if (ptn.test(hrf)) {
			if ((0, _jquery2['default'])('div.active').attr('id') == 'sindex') return false;

			(0, _jquery2['default'])('div.active').removeClass('active');
			(0, _jquery2['default'])('#sindex').addClass('active');
		} else {
			var n = hrf.indexOf("-");
			var to = hrf.substring(n + 1);
			var leftMoveVal = '';

			if (isLeftMove) {
				leftMoveVal = winWidth * 1;
			} else {
				leftMoveVal = winWidth * -1;
			}

			(0, _jquery2['default'])('body').css({
				'transition': 'margin-left 0.15s ease 0s',
				'margin-left': leftMoveVal + 'px',
				'overflow': 'hidden'
			});
			setTimeout(function () {
				(0, _jquery2['default'])('div.active').removeClass('active');
				(0, _jquery2['default'])('body').css({ 'transition': '', 'margin-left': '', 'overflow': '' });
				(0, _jquery2['default'])('#' + to).addClass('active');
			}, 150);

			return false;
		}
	});
});
module.exports = exports['default'];

},{"jquery":97}],160:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 166, stdin */\n.c-cartBalloon[data-v-918769d6] {\n  animation: fade-in 0.3s linear 0s;\n  background: #fff;\n  display: block;\n  margin: 0;\n  position: absolute;\n  top: 70px;\n  right: 10px;\n  width: calc(100vw - 20px);\n  max-width: 355px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4)); }\n  /* line 178, stdin */\n  .c-cartBalloon[data-v-918769d6]::after {\n    border: 10px solid transparent;\n    border-bottom: 16px solid #f5f5f5;\n    content: \"\";\n    display: block;\n    height: 0;\n    position: absolute;\n    top: -21px;\n    right: 9px;\n    width: 0; }\n\n/* line 191, stdin */\n.c-cartBalloon__heading[data-v-918769d6] {\n  position: relative;\n  width: 100%;\n  background: #f5f5f5;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1.4;\n  color: #333;\n  padding: 10px 30px 10px 12px;\n  box-sizing: border-box; }\n\n/* line 203, stdin */\n.c-cartBalloon__close[data-v-918769d6] {\n  color: #808d96;\n  display: block;\n  font-size: 20px;\n  font-weight: normal;\n  height: 20px;\n  line-height: 1;\n  margin-top: -10px;\n  position: absolute;\n  top: 50%;\n  right: 3px;\n  width: 20px; }\n\n/* line 217, stdin */\n.c-cartBalloon__content[data-v-918769d6] {\n  background: #fff;\n  padding: 14px 12px 24px; }\n\n/* line 222, stdin */\n.c-cartBalloon__list[data-v-918769d6] {\n  display: flex;\n  margin-bottom: 18px; }\n\n/* line 227, stdin */\n.c-cartBalloon__item[data-v-918769d6] {\n  flex-basis: 102px; }\n  @media screen and (max-width: 374px) {\n    /* line 227, stdin */\n    .c-cartBalloon__item[data-v-918769d6] {\n      flex-basis: calc((100vw - 56px) * 0.333); } }\n  /* line 234, stdin */\n  .c-cartBalloon__item[data-v-918769d6]:not(:first-child) {\n    margin-left: 12px; }\n\n/* line 239, stdin */\n.c-cartBalloon__itemPhoto[data-v-918769d6] {\n  width: 100%; }\n\n/* line 243, stdin */\n.c-cartBalloon__itemPhotoLink[data-v-918769d6] {\n  display: block;\n  line-height: 0;\n  margin-bottom: 4px; }\n\n/* line 249, stdin */\n.c-cartBalloon__itemName[data-v-918769d6] {\n  display: -webkit-box;\n  font-size: 12px;\n  line-height: 1.5;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2; }\n\n/* line 258, stdin */\n.c-cartBalloon__cartButton[data-v-918769d6] {\n  border: 1px solid #07a4e4;\n  border-radius: 3px;\n  box-sizing: border-box;\n  color: #07a4e4 !important;\n  display: block;\n  font-size: 13px;\n  font-weight: bold;\n  line-height: 1;\n  margin: 0 28px;\n  padding: 11px 12px 10px;\n  text-align: center; }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var s = window.s ? window.s : null;
var prop4 = s ? s.prop4 : '';
var s2 = typeof s_gi === 'function' && s_account ? s_gi(s_account) : null;

var API_URL = '/smp2/cart/createBalloon';
var STORAGE_KEY = 'isCartBalloonShowed';

exports.default = {
  data: function data() {
    return {
      isShowBalloonFlag: false,
      balloonInfo: null
    };
  },

  computed: {
    isShowBalloon: function isShowBalloon() {
      return this.isShowBalloonFlag;
    }
  },
  methods: {
    openCartBalloon: function openCartBalloon() {
      this.isShowBalloonFlag = true;

      this.sendLog('SCBalloon_imp_' + prop4);

      sessionStorage.setItem(STORAGE_KEY, 'true');
    },
    closeCartBalloon: function closeCartBalloon() {
      this.isShowBalloonFlag = false;
      this.sendLog('SCBalloon_close');
    },
    getGakkoUrl: function getGakkoUrl(gakkoCd) {
      return '/gakko/' + gakkoCd + '/';
    },
    getGakkoImagePath: function getGakkoImagePath(gakkoPhoto, rootProductCd) {
      var modifiedGakkoPhoto = gakkoPhoto.replace(/\.(.+)$/, '_s.$1');
      return '/school/' + rootProductCd + '/images/' + modifiedGakkoPhoto;
    },
    setBalloonInfo: function setBalloonInfo(info) {
      this.balloonInfo = info.slice(0, 3);
      if (this.balloonInfo.length) {
        this.openCartBalloon();
      }
    },
    sendLog: function sendLog(logId) {
      if (!s2) return;
      s2.tl(this, 'o', logId);
    },
    handlePageTransition: function handlePageTransition(event) {
      var url = event.currentTarget.href;
      var scParam = event.currentTarget.dataset.scparam;

      this.sendLog(scParam);

      setTimeout(function () {
        window.location.href = url;
      }, 400);
    },
    requestApi: function requestApi(url, callback) {
      var balloonInterval = window.setInterval(function () {
        if (!window.ajaxFlag) return;
        window.ajaxFlag = false;
        _axios2.default.get(url).then(function (response) {
          callback(response.data.balloon);
        }).catch(function (response) {
          console.error(response);
        }).finally(function () {
          window.ajaxFlag = true;
        });

        window.clearInterval(balloonInterval);
      }, 500);
    }
  },
  mounted: function mounted() {
    if ('sessionStorage' in window && window.sessionStorage !== null) {
      if (sessionStorage.getItem(STORAGE_KEY) !== 'true') {
        this.requestApi(API_URL, this.setBalloonInfo);
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowBalloon)?_c('div',{staticClass:"c-cartBalloon"},[_c('div',{staticClass:"c-cartBalloon__heading"},[_vm._v("\n    以前カートに追加した学校をお忘れではないですか？\n    "),_c('span',{staticClass:"c-cartBalloon__close",on:{"click":_vm.closeCartBalloon}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"c-cartBalloon__content"},[_c('ul',{staticClass:"c-cartBalloon__list"},_vm._l((_vm.balloonInfo),function(item){return _c('li',{key:item.gakkoCd,staticClass:"c-cartBalloon__item"},[_c('a',{staticClass:"c-cartBalloon__itemPhotoLink",attrs:{"href":_vm.getGakkoUrl(item.gakkoCd),"data-scparam":"SCBalloon_toSGtop"},on:{"click":function($event){$event.preventDefault();_vm.handlePageTransition($event)}}},[_c('img',{staticClass:"c-cartBalloon__itemPhoto",attrs:{"src":_vm.getGakkoImagePath(item.gakkoPhoto, item.rootProductCd),"alt":item.gakkoNm}})]),_vm._v(" "),_c('div',{staticClass:"c-cartBalloon__itemName"},[_c('a',{attrs:{"href":_vm.getGakkoUrl(item.gakkoCd),"data-scparam":"SCBalloon_toSGtop"},on:{"click":function($event){$event.preventDefault();_vm.handlePageTransition($event)}}},[_vm._v("\n            "+_vm._s(item.gakkoNm)+"\n          ")])])])})),_vm._v(" "),_c('a',{staticClass:"c-cartBalloon__cartButton",attrs:{"href":"/smp2/cart/list","data-scparam":"SCBalloon_toSMatome"},on:{"click":function($event){$event.preventDefault();_vm.handlePageTransition($event)}}},[_vm._v("\n      カートの中身を確認する\n    ")])])]):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-918769d6"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-918769d6", __vue__options__)
  } else {
    hotAPI.rerender("data-v-918769d6", __vue__options__)
  }
})()}
},{"axios":30,"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],161:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 11, stdin */\n.menuHeader[data-v-58a28162] {\n  padding: 16px;\n  background-color: #f8f9f9; }")
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuHeader"},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-58a28162"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58a28162", __vue__options__)
  } else {
    hotAPI.rerender("data-v-58a28162", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],162:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@charset \"UTF-8\";\n/* line 124, stdin */\n.menuWrap[data-v-4150e8a9] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 152px);\n  background-color: #ffffff;\n  overflow: auto;\n  box-sizing: border-box;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  /*スクロールバー非表示（Edge）*/\n  -ms-overflow-style: none;\n  /*スクロールバー非表示（Chrome・Safari）*/ }\n  /* line 139, stdin */\n  .menuWrap[data-v-4150e8a9]::-webkit-scrollbar {\n    display: none; }\n  /* line 142, stdin */\n  .menuWrap.is-active[data-v-4150e8a9] {\n    opacity: 1;\n    visibility: visible;\n    transition: .2s ease-in-out; }\n    @media (min-width: 768px) {\n      /* line 142, stdin */\n      .menuWrap.is-active[data-v-4150e8a9] {\n        transition: none;\n        height: calc(100% - 157px); } }\n\n/* line 152, stdin */\n.menuWrap__alert[data-v-4150e8a9] {\n  color: #FF6562;\n  font-size: 12px; }\n\n/* line 157, stdin */\n.menuList__count[data-v-4150e8a9] {\n  font-size: 10px;\n  font-weight: 300;\n  margin-left: 4px;\n  vertical-align: 3px; }\n\n/* line 164, stdin */\n.menuList__textWrap[data-v-4150e8a9] {\n  margin-right: 27px; }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MenuHeader = require('./MenuHeader.vue');

var _MenuHeader2 = _interopRequireDefault(_MenuHeader);

var _MenuListItem = require('../../_MenuListItem.vue');

var _MenuListItem2 = _interopRequireDefault(_MenuListItem);

var _MenuListButton = require('../../_MenuListButton.vue');

var _MenuListButton2 = _interopRequireDefault(_MenuListButton);

var _Button = require('../../_Button.vue');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var s2 = s_gi(s_account);

exports.default = {
  props: {
    allCount: {
      type: Number,
      required: true
    },
    bunyaList: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    cd: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    selectedList: {
      type: Array,
      required: true
    },
    childKey: {
      type: String,
      required: false
    },
    selectedBunyaTab: {
      type: String,
      required: true
    }
  },
  components: {
    MenuListItem: _MenuListItem2.default,
    MenuListButton: _MenuListButton2.default,
    Button: _Button2.default,
    MenuHeader: _MenuHeader2.default
  },
  methods: {
    createClassList: function createClassList(cd, count) {
      return [this.isBunyaActive(cd) ? 'is-active' : '', this.isNothing(count) ? 'is-nothing' : ''];
    },
    isBunyaActive: function isBunyaActive(cd) {
      return this.selectedList.some(function (selected) {
        return selected.value !== 'all' && selected.value === cd;
      });
    },
    isNothing: function isNothing(count) {
      return !count || count === 0;
    },
    setItem: function setItem(cd, nm) {
      s2.tl(this, 'o', 'Ssearch_result_panel_' + this.selectedBunyaTab + '_dai');
      this.$emit('setItem', {
        cd: cd,
        bunyaName: cd === 'all' ? 'すべて' : nm
      });
    },
    toggleModal: function toggleModal() {
      this.$emit('toggleModal');
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuWrap",class:{'is-active': _vm.isActive}},[(_vm.selectedBunyaTab === 'shikaku' || _vm.selectedBunyaTab === 'gakubukeito')?_c('MenuHeader',[(_vm.selectedBunyaTab === 'shikaku')?_c('div',[_c('Button',{attrs:{"modifierList":['is-small', 'is-gray', 'is-bgWhite']},nativeOn:{"click":function($event){_vm.toggleModal($event)}}},[_vm._v("\n        資格の種別と見方\n      ")])],1):_c('p',{staticClass:"menuWrap__alert"},[_vm._v("学部系統検索は大学のみ対象です。"),_c('br'),_vm._v("大学以外を設定済の場合は校種を大学に変更してください。")])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"menuList"},_vm._l((_vm.bunyaList),function(bunya){return _c('MenuListItem',{key:bunya[_vm.name]},[_c('MenuListButton',{staticClass:"menuList__button",attrs:{"modifierList":_vm.createClassList(bunya[_vm.cd], bunya.count)},nativeOn:{"click":function($event){_vm.setItem(bunya[_vm.cd], bunya[_vm.name]);}}},[_c('div',{staticClass:"menuList__textWrap"},[_vm._v("\n          "+_vm._s(bunya[_vm.name])+"\n          "),_c('span',{staticClass:"menuList__count"},[_vm._v("\n            ("+_vm._s(bunya.count)+"件)\n          ")])])])],1)}))],1)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-4150e8a9"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4150e8a9", __vue__options__)
  } else {
    hotAPI.rerender("data-v-4150e8a9", __vue__options__)
  }
})()}
},{"../../_Button.vue":142,"../../_MenuListButton.vue":144,"../../_MenuListItem.vue":145,"./MenuHeader.vue":161,"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],163:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 281, stdin */\n.menuList__count[data-v-41b38d30] {\n  font-size: 10px; }\n\n/* line 285, stdin */\n.menuLower[data-v-41b38d30] {\n  overflow: hidden; }\n\n/* line 288, stdin */\n.menuLowerList[data-v-41b38d30] {\n  border-top: 1px solid #D3D4D4;\n  background-color: #f8f9f9;\n  transition: .2s ease-in-out;\n  opacity: 0; }\n  /* line 293, stdin */\n  .menuLowerList.is-show[data-v-41b38d30] {\n    opacity: 1; }\n  @media (min-width: 768px) {\n    /* line 288, stdin */\n    .menuLowerList[data-v-41b38d30] {\n      transition: none; } }\n\n/* line 300, stdin */\n.menuLowerList__item[data-v-41b38d30] {\n  border-bottom: 1px solid #D3D4D4; }\n  /* line 302, stdin */\n  .menuLowerList__item[data-v-41b38d30]:last-child {\n    border-bottom: none; }\n\n/* line 306, stdin */\n.menuLowerList__button[data-v-41b38d30] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 16px;\n  color: #24243F;\n  font-size: 14px;\n  line-height: 1.5;\n  position: relative; }\n  /* line 316, stdin */\n  .menuLowerList__button[data-v-41b38d30]::after {\n    content: '';\n    position: absolute;\n    top: calc(50% - 8px);\n    display: inline-block;\n    right: 12px;\n    width: 11px;\n    height: 16px;\n    background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_xl.svg) no-repeat center; }\n  /* line 326, stdin */\n  .menuLowerList__button.is-active[data-v-41b38d30] {\n    color: #0b41a0;\n    font-weight: 700;\n    background-color: #e7f6ff; }\n  /* line 331, stdin */\n  .menuLowerList__button.is-disabled[data-v-41b38d30] {\n    pointer-events: none; }\n  /* line 334, stdin */\n  .menuLowerList__button.is-nothing[data-v-41b38d30] {\n    color: #AFB8BE;\n    pointer-events: none; }\n  @media (hover: hover) {\n    /* line 339, stdin */\n    .menuLowerList__button[data-v-41b38d30]:hover {\n      color: #0ca5e6;\n      text-decoration: underline; } }\n\n/* line 345, stdin */\n.menuLowerList__count[data-v-41b38d30] {\n  font-size: 10px;\n  font-weight: normal;\n  line-height: 1.5; }\n\n/* line 351, stdin */\n.menuLowerList__textWrap[data-v-41b38d30] {\n  margin-right: 27px; }\n\n/* line 355, stdin */\n.menuLowerList__activeLabel[data-v-41b38d30] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  height: 20px;\n  margin-right: 27px;\n  padding: 2px 8px;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  border-radius: 4px;\n  background-color: #0b41a0; }\n\n/* line 371, stdin */\n.menuList__count[data-v-41b38d30] {\n  vertical-align: 3px; }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MenuListItem = require('../../_MenuListItem.vue');

var _MenuListItem2 = _interopRequireDefault(_MenuListItem);

var _MenuListButton = require('../../_MenuListButton.vue');

var _MenuListButton2 = _interopRequireDefault(_MenuListButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var s2 = s_gi(s_account);

var replaceBunyaName = function replaceBunyaName(bunyaName) {
  var keywords = ['に関わる', 'に関する', 'の分野', 'の仕事', 'の資格', 'すべて'];
  var keyword = keywords.find(function (key) {
    return bunyaName.indexOf(key) !== -1;
  });
  if (keyword) {
    return bunyaName.split(keyword)[0];
  }
  return bunyaName;
};

exports.default = {
  data: function data() {
    return {
      isInitScroll: false
    };
  },

  props: {
    bunyaListM: {
      type: Object,
      required: true
    },
    bunyaListS: {
      type: Object,
      required: true
    },
    openedAccordions: {
      type: Array,
      required: true
    },
    isOpenBunyaS: {
      type: Boolean,
      required: true
    },
    currentBunyaId: {
      type: String,
      required: true
    },
    currentBunyaIdTemp: {
      type: String,
      required: true
    },
    selectedBunyaTab: {
      type: String,
      required: true
    },
    selectedBunyaCdL: {
      type: String,
      required: true
    },
    selectedBunyaKeyM: {
      type: String,
      required: true
    },
    selectedBunyaKeyS: {
      type: String,
      required: true
    },
    selectedBunyaCds: {
      type: Array,
      required: true
    }
  },
  components: {
    MenuListItem: _MenuListItem2.default,
    MenuListButton: _MenuListButton2.default
  },
  watch: {
    isOpenBunyaS: function isOpenBunyaS() {
      if (this.isInitScroll) return;
      var wrapperElement = document.querySelector('.content > .menuWrap');
      var wrapperOffset = wrapperElement.offsetTop;
      var selectedItemS = document.querySelector('.js-scroll-itemS');
      if (!selectedItemS || selectedItemS === null) return;
      var itemOffset = selectedItemS.offsetTop;
      wrapperElement.scrollTo(0, itemOffset);
      this.isInitScroll = true;
    }
  },
  methods: {
    isLink: function isLink(cd) {
      return cd === 'all';
    },
    setItem: function setItem(cd) {
      this.$emit('setItem', cd);
    },
    formatBunyaName: function formatBunyaName(bunyaName) {
      if (!bunyaName) return;
      if (bunyaName.indexOf('すべて') !== -1) return 'すべて';
      return bunyaName;
    },
    toggleAccordion: function toggleAccordion(cd) {
      if (!this.isOpen(cd)) this.getCountS(cd);
      this.$emit('toggleAccordion', cd);
    },
    getCountS: function getCountS(cd) {
      this.$emit('getCountS', cd);
    },
    setItemS: function setItemS(bunyaMcd, bunyaS) {
      s2.tl(this, 'o', 'Ssearch_result_panel_' + this.selectedBunyaTab + '_shou');
      var bunyaSNm = bunyaS[this.sCd] === 'all' ? replaceBunyaName(bunyaS[this.sNm]) : bunyaS[this.sNm];
      var obj = {
        mCd: bunyaMcd,
        sCd: bunyaS[this.sCd],
        sNm: bunyaSNm
      };
      this.$emit('setItemS', obj);
    },
    createClassItemS: function createClassItemS(count, selected) {
      return {
        'is-nothing': this.isNothing(count),
        'is-active': selected,
        'is-disabled': this.isDisabled(selected)
      };
    },
    createClassItemM: function createClassItemM(count, selected) {
      return ['is-link', this.isNothing(count) ? 'is-nothing' : '', selected ? 'is-active' : ''];
    },
    isNothing: function isNothing(count) {
      return !count || count === 0;
    },
    isDisabled: function isDisabled(isSelected) {
      return isSelected && this.selectedBunyaTab !== 'shikaku';
    },
    clickAllM: function clickAllM(mCd, mNm) {
      var bunyaName = mCd === 'all' ? replaceBunyaName(mNm) : mNm;
      var obj = {
        isGakumon: this.isGakumon,
        cd: mCd,
        nm: bunyaName
      };
      this.$emit('clickAllM', obj);
    },
    clickBunyaM: function clickBunyaM() {
      s2.tl(this, 'o', 'Ssearch_result_panel_' + this.selectedBunyaTab + '_chuu');
    },
    beforeEnter: function beforeEnter(el) {
      el.style.height = '0';
    },
    enter: function enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function leave(el) {
      el.style.height = '0';
    }
  },
  computed: {
    isGakumon: function isGakumon() {
      return this.selectedBunyaTab === 'gakumon';
    },
    isOpen: function isOpen() {
      var _this = this;

      return function (cd) {
        return _this.openedAccordions.indexOf(cd) !== -1;
      };
    },
    mNm: function mNm() {
      return this.isGakumon ? this.selectedBunyaKeyS + 'Nm' : this.selectedBunyaKeyM + 'Nm';
    },
    mCd: function mCd() {
      return this.isGakumon ? this.selectedBunyaKeyS + 'Cd' : this.selectedBunyaKeyM + 'Cd';
    },
    sNm: function sNm() {
      return this.selectedBunyaKeyS + 'Nm';
    },
    sCd: function sCd() {
      return this.selectedBunyaKeyS + 'Cd';
    },
    listM: function listM() {
      if (this.selectedBunyaTab === 'gakubukeito') return [];
      return this.bunyaListM[this.selectedBunyaTab][this.selectedBunyaCdL] || [];
    },
    listS: function listS() {
      var _this2 = this;

      return function (bunyaM) {
        if (_this2.isGakumon) return [];
        return _this2.bunyaListS[_this2.selectedBunyaTab][bunyaM[_this2.mCd]];
      };
    },
    isSelectedM: function isSelectedM() {
      var _this3 = this;

      return function (cd) {
        var isMatchBunyaId = _this3.currentBunyaIdTemp === _this3.currentBunyaId;
        return cd !== 'all' && _this3.isSelected(cd) && isMatchBunyaId;
      };
    },
    isSelectedS: function isSelectedS() {
      var _this4 = this;

      return function (bunyaMCd, bunyaS) {
        if (bunyaS[_this4.sCd] === 'all') {
          return false;
        }
        return _this4.isSelected(bunyaMCd) && _this4.isSelected(bunyaS[_this4.sCd]);
      };
    },
    isSelected: function isSelected() {
      var _this5 = this;

      return function (cd) {
        return _this5.selectedBunyaCds.indexOf(cd) !== -1;
      };
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menuList"},_vm._l((_vm.listM),function(bunyaM){return _c('MenuListItem',{key:bunyaM[_vm.mCd]},[(bunyaM[_vm.mCd] === 'all' || _vm.isGakumon)?_c('MenuListButton',{attrs:{"modifierList":_vm.createClassItemM(bunyaM.count, _vm.isSelectedM(bunyaM[_vm.mCd]))},nativeOn:{"click":function($event){_vm.clickBunyaM(); _vm.clickAllM(bunyaM[_vm.mCd], bunyaM[_vm.mNm])}}},[_c('div',{staticClass:"menuList__textWrap"},[_vm._v("\n        "+_vm._s(_vm.formatBunyaName(bunyaM[_vm.mNm]))+"\n        "),_c('span',{staticClass:"menuList__count"},[_vm._v("("+_vm._s(bunyaM.count ? bunyaM.count : 0)+"件)")])])]):_c('MenuListButton',{attrs:{"modifierList":['is-accordion', {'is-accordion-open': _vm.isOpen(bunyaM[_vm.mCd])}]},nativeOn:{"click":function($event){_vm.clickBunyaM(); _vm.toggleAccordion(bunyaM[_vm.mCd]);}}},[_c('div',{staticClass:"menuList__textWrap"},[_vm._v("\n        "+_vm._s(bunyaM[_vm.mNm])+"\n      ")])]),_vm._v(" "),(bunyaM[_vm.mCd] !== 'all' && !_vm.isGakumon)?_c('div',{staticClass:"menuLower"},[_c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen(bunyaM[_vm.mCd])),expression:"isOpen(bunyaM[mCd])"}],staticClass:"menuLowerList",class:{'is-show': _vm.isOpen(bunyaM[_vm.mCd])}},_vm._l((_vm.listS(bunyaM)),function(bunyaS){return _c('li',{key:bunyaS[_vm.sCd],staticClass:"menuLowerList__item",class:{'js-scroll-itemS': _vm.isSelectedS(bunyaM[_vm.mCd], bunyaS)}},[_c('a',{staticClass:"menuLowerList__button",class:_vm.createClassItemS(bunyaS.count, _vm.isSelectedS(bunyaM[_vm.mCd], bunyaS)),attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.setItemS(bunyaM[_vm.mCd], bunyaS)}}},[_c('div',{staticClass:"menuLowerList__textWrap"},[_vm._v("\n                "+_vm._s(_vm.formatBunyaName(bunyaS[_vm.sNm]))+"\n                "),_c('span',{staticClass:"menuLowerList__count"},[_vm._v("("+_vm._s(bunyaS.count)+"件)")])]),_vm._v(" "),(_vm.isSelectedS(bunyaM[_vm.mCd], bunyaS))?_c('span',{staticClass:"menuLowerList__activeLabel"},[_vm._v("選択中")]):_vm._e()])])}))])],1):_vm._e()],1)}))}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-41b38d30"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41b38d30", __vue__options__)
  } else {
    hotAPI.rerender("data-v-41b38d30", __vue__options__)
  }
})()}
},{"../../_MenuListButton.vue":144,"../../_MenuListItem.vue":145,"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],164:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@charset \"UTF-8\";\n/* line 234, stdin */\n.heading[data-v-6dfa3144] {\n  padding: 5px 12px;\n  background-color: #808d96;\n  font-size: 12px;\n  font-weight: 700;\n  color: #ffffff; }\n\n/* line 241, stdin */\n.tabs[data-v-6dfa3144] {\n  position: relative;\n  display: flex;\n  border-bottom: 1px solid #D3D4D4;\n  z-index: 1; }\n\n/* line 247, stdin */\n.tabs__border[data-v-6dfa3144] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  background-color: #0b41a0;\n  transition: .2s ease-in-out; }\n\n/* line 255, stdin */\n.tabs__item[data-v-6dfa3144] {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 44px;\n  border: 0;\n  padding: 0;\n  background-color: #ffffff;\n  color: #afb8be;\n  font-size: 14px;\n  line-height: 1.3;\n  transition: .2s ease-in-out;\n  cursor: pointer; }\n  /* line 269, stdin */\n  .tabs__item[data-v-6dfa3144]:focus {\n    outline: none; }\n  /* line 272, stdin */\n  .tabs__item.is-active[data-v-6dfa3144] {\n    font-weight: 700;\n    color: #0b41a0; }\n  @media (hover: hover) {\n    /* line 277, stdin */\n    .tabs__item[data-v-6dfa3144]:hover {\n      border-bottom: 1px solid #0ca5e6;\n      color: #0ca5e6; } }\n\n/* line 284, stdin */\n.shikakuAbout[data-v-6dfa3144] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 49px);\n  background-color: #ffffff;\n  overflow: auto;\n  box-sizing: border-box;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  /*スクロールバー非表示（Edge）*/\n  -ms-overflow-style: none;\n  /*スクロールバー非表示（Chrome・Safari）*/ }\n  /* line 299, stdin */\n  .shikakuAbout[data-v-6dfa3144]::-webkit-scrollbar {\n    display: none; }\n  /* line 302, stdin */\n  .shikakuAbout.is-active[data-v-6dfa3144] {\n    opacity: 1;\n    visibility: visible;\n    transition: .2s ease-in-out; }\n    @media (min-width: 768px) {\n      /* line 302, stdin */\n      .shikakuAbout.is-active[data-v-6dfa3144] {\n        transition: none; } }\n\n/* line 311, stdin */\n.shikakuAbout__contents[data-v-6dfa3144] {\n  padding: 16px 16px 32px;\n  color: #24243F; }\n\n/* line 315, stdin */\n.shikakuAbout__intro[data-v-6dfa3144] {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3; }\n  @media (min-width: 768px) {\n    /* line 315, stdin */\n    .shikakuAbout__intro[data-v-6dfa3144] {\n      font-size: 18px; } }\n\n/* line 323, stdin */\n.shikakuAboutSectionWrap[data-v-6dfa3144] {\n  margin-top: 16px;\n  padding: 16px;\n  border-radius: 6px;\n  background-color: #f8f9f9; }\n\n/* line 329, stdin */\n.shikakuAboutSection[data-v-6dfa3144] {\n  margin-top: 16px;\n  color: #24243F; }\n  /* line 332, stdin */\n  .shikakuAboutSection.is-border[data-v-6dfa3144] {\n    padding-top: 16px;\n    border-top: 1px solid #D3D4D4; }\n  /* line 336, stdin */\n  .shikakuAboutSection[data-v-6dfa3144]:first-child {\n    margin-top: 0; }\n\n/* line 340, stdin */\n.shikakuAboutSection__title[data-v-6dfa3144] {\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5; }\n  @media (min-width: 768px) {\n    /* line 340, stdin */\n    .shikakuAboutSection__title[data-v-6dfa3144] {\n      font-size: 16px; } }\n\n/* line 349, stdin */\n.shikakuAboutSection__text[data-v-6dfa3144] {\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 1.5; }\n  @media (min-width: 768px) {\n    /* line 349, stdin */\n    .shikakuAboutSection__text[data-v-6dfa3144] {\n      font-size: 14px; } }\n\n/* line 357, stdin */\n.shikakuAboutSection__note[data-v-6dfa3144] {\n  margin-top: 4px;\n  font-size: 10px;\n  line-height: 1.5;\n  color: #808d96; }\n  @media (min-width: 768px) {\n    /* line 357, stdin */\n    .shikakuAboutSection__note[data-v-6dfa3144] {\n      font-size: 12px; } }\n\n/* line 366, stdin */\n.shikakuAboutTable[data-v-6dfa3144] {\n  font-size: 12px; }\n  @media (min-width: 768px) {\n    /* line 366, stdin */\n    .shikakuAboutTable[data-v-6dfa3144] {\n      font-size: 14px; } }\n\n/* line 372, stdin */\n.shikakuAboutTable__title[data-v-6dfa3144] {\n  width: 65px;\n  text-align: start;\n  font-size: 12px; }\n  @media (min-width: 768px) {\n    /* line 372, stdin */\n    .shikakuAboutTable__title[data-v-6dfa3144] {\n      width: 76px;\n      font-size: 14px; } }\n\n/* line 381, stdin */\n.shikakuAboutTable__detail[data-v-6dfa3144] {\n  padding-left: 1em;\n  text-indent: -1em; }\n  /* line 384, stdin */\n  .shikakuAboutTable__detail[data-v-6dfa3144]::before {\n    content: '：'; }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SlidePanelTemplate = require('./modules/SlidePanelTemplate.vue');

var _SlidePanelTemplate2 = _interopRequireDefault(_SlidePanelTemplate);

var _MenuListL = require('../modules/MenuListL.vue');

var _MenuListL2 = _interopRequireDefault(_MenuListL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var s2 = s_gi(s_account);

exports.default = {
  data: function data() {
    return {
      heading: '分野から探す',
      isModalOpen: false
    };
  },

  props: {
    allCount: {
      type: Number,
      required: true
    },
    bunyaTabList: {
      type: Array,
      required: false
    },
    bunyaList: {
      type: Object,
      required: false
    },
    isOpenBunyaL: {
      type: Boolean,
      required: false
    },
    selectedBunyaTab: {
      type: String,
      required: true
    },
    selectedLists: {
      type: Object,
      required: true
    },
    selectedBunyaCds: {
      type: Array,
      required: true
    },
    isFirstModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SlidePanelTemplate: _SlidePanelTemplate2.default,
    MenuListL: _MenuListL2.default
  },
  methods: {
    toggleModal: function toggleModal() {
      this.isModalOpen = !this.isModalOpen;
    },
    isActive: function isActive(tabID) {
      var selected = this.selectedBunyaTab === 'gakubu' ? 'gakubukeito' : this.selectedBunyaTab;
      return selected === tabID;
    },
    tabChange: function tabChange(tabName, index) {
      s2.tl(this, 'o', 'Ssearch_result_panel_tab_' + tabName);
      this.$emit('tabChange', tabName);
    },
    prevAction: function prevAction() {
      if (this.isModalOpen) {
        this.isModalOpen = !this.isModalOpen;
      } else {
        this.$emit('prev');
      }
    },
    closeAction: function closeAction() {
      if (this.isModalOpen) {
        this.isModalOpen = !this.isModalOpen;
      }
      this.$emit('close');
    },
    setItem: function setItem(cdInfo) {
      var selectedInfo = {
        eventName: cdInfo.eventName
      };
      selectedInfo.selected = {
        cd: cdInfo.$event.cd,
        bunyaName: cdInfo.$event.bunyaName
      };
      this.$emit('setItem', selectedInfo);
    }
  },
  computed: {
    borderStyle: function borderStyle() {
      var tabLength = this.bunyaTabList.length;
      var width = 100 / tabLength;
      var position = width * this.selectedBunyaTabNumber;
      return {
        left: position + '%',
        width: width + '%'
      };
    },
    selectedBunyaTabNumber: function selectedBunyaTabNumber() {
      var _this = this;

      var tabIndex = this.bunyaTabList.findIndex(function (tab) {
        return tab.id === _this.selectedBunyaTab;
      });
      return tabIndex;
    },
    tabWidthStyle: function tabWidthStyle() {
      var tabLength = this.bunyaTabList.length;
      var width = 100 / tabLength;
      return { flexBasis: width + '%' };
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlidePanelTemplate',{attrs:{"heading":_vm.heading,"isOpen":_vm.isOpenBunyaL,"isModalOpen":_vm.isModalOpen,"isFirstModal":_vm.isFirstModal},on:{"prev":_vm.prevAction,"close":_vm.closeAction}},[(!_vm.isModalOpen)?_c('div',{staticClass:"tabs"},[_vm._l((_vm.bunyaTabList),function(tab,index){return _c('button',{key:tab.id,staticClass:"tabs__item",class:{'is-active': _vm.isActive(tab.id)},style:(_vm.tabWidthStyle),on:{"click":function($event){_vm.tabChange(tab.id, index)}}},[_vm._v(_vm._s(tab.name))])}),_vm._v(" "),_c('span',{staticClass:"tabs__border",style:(_vm.borderStyle)})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contents"},[_c('MenuListL',{attrs:{"allCount":_vm.allCount,"selectedBunyaTab":_vm.selectedBunyaTab,"isActive":_vm.isActive('shigoto'),"bunyaList":_vm.bunyaList.shigotoL,"selectedList":_vm.selectedLists.jlList,"childKey":"jm","name":"jlNm","cd":"jlCd"},on:{"setItem":function($event){_vm.setItem({eventName: 'setShigotoLItem', $event: $event})}}}),_vm._v(" "),_c('MenuListL',{attrs:{"allCount":_vm.allCount,"selectedBunyaTab":_vm.selectedBunyaTab,"isActive":_vm.isActive('gakumon'),"bunyaList":_vm.bunyaList.gakumonL,"selectedList":_vm.selectedLists.glList,"childKey":"gs","name":"glNm","cd":"glCd"},on:{"setItem":function($event){_vm.setItem({eventName: 'setGakumonLItem', $event: $event})}}}),_vm._v(" "),_c('MenuListL',{attrs:{"allCount":_vm.allCount,"selectedBunyaTab":_vm.selectedBunyaTab,"isActive":_vm.isActive('shikaku'),"bunyaList":_vm.bunyaList.shikakuL,"selectedList":_vm.selectedLists.qlList,"childKey":"qm","name":"qlNm","cd":"qlCd"},on:{"setItem":function($event){_vm.setItem({eventName: 'setShikakuLItem', $event: $event})},"toggleModal":_vm.toggleModal}}),_vm._v(" "),_c('MenuListL',{attrs:{"allCount":_vm.allCount,"selectedBunyaTab":_vm.selectedBunyaTab,"isActive":_vm.isActive('gakubukeito'),"bunyaList":_vm.bunyaList.gbk,"selectedList":_vm.selectedLists.gbkList,"name":"gbkNm","cd":"gbkCd"},on:{"setItem":function($event){_vm.setItem({eventName: 'setGakubuKeitouItem', $event: $event})}}}),_vm._v(" "),(_vm.selectedBunyaTab === 'shikaku')?_c('div',{staticClass:"shikakuAbout",class:{ 'is-active': _vm.isModalOpen },on:{"modalClose":_vm.toggleModal}},[_c('div',{staticClass:"shikakuAbout__contents"},[_c('p',{staticClass:"shikakuAbout__intro"},[_vm._v("スタディサプリ進路では、資格の取得方法によって3つのグループに分けています。")]),_vm._v(" "),_c('div',{staticClass:"shikakuAboutSectionWrap"},[_c('dl',{staticClass:"shikakuAboutSection"},[_c('dt',{staticClass:"shikakuAboutSection__title"},[_vm._v("取得できる資格")]),_vm._v(" "),_c('dd',{staticClass:"shikakuAboutSection__text"},[_c('p',[_vm._v("在学中に受講可能な授業を修了、もしくは、学校を卒業することで取得できる資格です。")]),_vm._v(" "),_c('p',{staticClass:"shikakuAboutSection__note"},[_vm._v("※ただし、資格を取得するために、卒業後の実務経験を必要とするものも含みます。")])])]),_vm._v(" "),_c('dl',{staticClass:"shikakuAboutSection"},[_c('dt',{staticClass:"shikakuAboutSection__title"},[_vm._v("受験資格が得られるもの")]),_vm._v(" "),_c('dd',{staticClass:"shikakuAboutSection__text"},[_c('p',[_vm._v("在学中に受講可能な授業を修了、もしくは、学校を卒業することで受験できるようになる資格です。")]),_vm._v(" "),_c('p',{staticClass:"shikakuAboutSection__note"},[_vm._v("※ただし、受験資格を取得するために、卒業後の実務経験を必要とするものも含みます。"),_c('br'),_vm._v("また、在学中に受講可能な授業を修了、もしくは、学校を卒業することで試験の一部が免除される資格も含みます。")])])]),_vm._v(" "),_c('dl',{staticClass:"shikakuAboutSection"},[_c('dt',{staticClass:"shikakuAboutSection__title"},[_vm._v("目標とする資格")]),_vm._v(" "),_c('dd',{staticClass:"shikakuAboutSection__text"},[_c('p',[_vm._v("在学中に受講可能な授業の中で習得できる知識や技術などを利用して目指せる資格です。")]),_vm._v(" "),_c('p',{staticClass:"shikakuAboutSection__note"},[_vm._v("※ただし、授業を修了するだけでなく、別途、試験または講習を受ける必要があります。")])])]),_vm._v(" "),_c('dl',{staticClass:"shikakuAboutSection is-border"},[_c('dt',{staticClass:"shikakuAboutSection__title"},[_vm._v("スタディサプリ進路で使用している、特長的な表現について")]),_vm._v(" "),_c('dd',{staticClass:"shikakuAboutSection__text"},[_c('table',{staticClass:"shikakuAboutTable"},[_c('tr',[_c('th',{staticClass:"shikakuAboutTable__title"},[_vm._v("＜国＞")]),_vm._v(" "),_c('td',{staticClass:"shikakuAboutTable__detail"},[_vm._v("国家資格")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"shikakuAboutTable__title"},[_vm._v("（Ｒ）")]),_vm._v(" "),_c('td',{staticClass:"shikakuAboutTable__detail"},[_vm._v("登録済み商標を意味するものであり、（Ｒ）の付いている資格名称が商標登録されているという意味です。")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"shikakuAboutTable__title"},[_vm._v("××【○○】")]),_vm._v(" "),_c('td',{staticClass:"shikakuAboutTable__detail"},[_vm._v("【　】内は略称もしくは、日本語名称")])])])])])])])]):_vm._e()],1)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-6dfa3144"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6dfa3144", __vue__options__)
  } else {
    hotAPI.reload("data-v-6dfa3144", __vue__options__)
  }
})()}
},{"../modules/MenuListL.vue":162,"./modules/SlidePanelTemplate.vue":169,"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],165:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@charset \"UTF-8\";\n/* line 243, stdin */\n.menuWrap[data-v-6d34e836] {\n  width: 100%;\n  padding-bottom: 74px;\n  background-color: #ffffff;\n  border-top: 1px solid #D3D4D4;\n  overflow: auto;\n  box-sizing: border-box;\n  -webkit-overflow-scrolling: touch;\n  /*スクロールバー非表示（Edge）*/\n  -ms-overflow-style: none;\n  /*スクロールバー非表示（Chrome・Safari）*/ }\n  /* line 254, stdin */\n  .menuWrap[data-v-6d34e836]::-webkit-scrollbar {\n    display: none; }\n\n/* line 258, stdin */\n.menuWrap__buttonWrap[data-v-6d34e836] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 16px;\n  border-top: 1px solid #D3D4D4;\n  background-color: #ffffff; }\n\n/* line 268, stdin */\n.menuHeader[data-v-6d34e836] {\n  text-align: center; }\n\n/* line 272, stdin */\n.shikakuDetail__head[data-v-6d34e836] {\n  padding: 16px;\n  background-color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #24243F; }\n  @media (min-width: 768px) {\n    /* line 272, stdin */\n    .shikakuDetail__head[data-v-6d34e836] {\n      font-size: 24px; } }\n\n/* line 283, stdin */\n.shikakuDetail__title[data-v-6d34e836] {\n  position: relative;\n  margin-left: 12px; }\n\n/* line 287, stdin */\n.shikakuDetail__title[data-v-6d34e836]::before {\n  content: '';\n  position: absolute;\n  left: -12px;\n  top: 0;\n  width: 4px;\n  height: 30%;\n  background-color: #0b41a0; }\n\n/* line 296, stdin */\n.shikakuDetail__title[data-v-6d34e836]::after {\n  content: '';\n  position: absolute;\n  left: -12px;\n  bottom: 0;\n  width: 4px;\n  height: 70%;\n  background-color: #0ca5e6; }\n\n/* line 305, stdin */\n.shikakuDetail__contents[data-v-6d34e836] {\n  background-color: #ffffff;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 105px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch; }\n\n/* line 314, stdin */\n.shikakuDetailList__item[data-v-6d34e836] {\n  position: relative;\n  background-color: #ffffff;\n  border-bottom: 1px solid #D3D4D4; }\n  /* line 318, stdin */\n  .shikakuDetailList__item[data-v-6d34e836]:first-child {\n    border-top: 1px solid #D3D4D4; }\n  /* line 321, stdin */\n  .shikakuDetailList__item[data-v-6d34e836]::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: calc(50% - 8px);\n    right: 16px;\n    bottom: 0;\n    width: 11px;\n    height: 16px;\n    background: url(/images/responsive/Sapuri_Blue/arrow_sapuriBlue_xl.svg) no-repeat center; }\n\n/* line 334, stdin */\n.shikakuDetailList__link[data-v-6d34e836] {\n  display: block;\n  position: relative;\n  pointer-events: auto;\n  color: #24243F;\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: #f8f9f9;\n  padding: 12px 16px; }\n  @media (hover: hover) {\n    /* line 345, stdin */\n    .shikakuDetailList__link[data-v-6d34e836]:hover {\n      color: #0ca5e6;\n      text-decoration: underline; } }\n  /* line 351, stdin */\n  .shikakuDetailList__link.is-selected[data-v-6d34e836] {\n    background-color: #e7f6ff;\n    color: #0b41a0; }\n    /* line 354, stdin */\n    .shikakuDetailList__link.is-selected[data-v-6d34e836]::after {\n      content: '選択中';\n      position: absolute;\n      right: 39px;\n      top: calc(50% - 10px);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 46px;\n      height: 20px;\n      background-color: #0b41a0;\n      border-radius: 4px;\n      font-size: 10px;\n      font-weight: 700;\n      color: #ffffff;\n      line-height: 1.5; }\n  /* line 374, stdin */\n  .shikakuDetailList__link.is-disabled .searchPanel__item__text[data-v-6d34e836] {\n    color: #AFB8BE; }\n\n/* line 380, stdin */\n.shikakuDetailList__count[data-v-6d34e836] {\n  font-size: 10px;\n  font-weight: 300; }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _SlidePanelTemplate = require('./modules/SlidePanelTemplate.vue');

var _SlidePanelTemplate2 = _interopRequireDefault(_SlidePanelTemplate);

var _MenuListS = require('../modules/MenuListS.vue');

var _MenuListS2 = _interopRequireDefault(_MenuListS);

var _MenuHeader = require('../../slidePanel/modules/MenuHeader.vue');

var _MenuHeader2 = _interopRequireDefault(_MenuHeader);

var _Button = require('../../_Button.vue');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var s2 = s_gi(s_account);

exports.default = {
  data: function data() {
    return {
      heading: '分野から探す',
      isOpenBunyaSh: false,
      shikakuShHeading: '',
      shTempObj: {
        m: '',
        s: ''
      }
    };
  },

  props: {
    openedAccordions: {
      type: Array,
      required: false
    },
    bunyaListM: {
      type: Object,
      required: false
    },
    bunyaListS: {
      type: Object,
      required: false
    },
    shikakuShList: {
      type: Array,
      required: false
    },
    currentBunyaId: {
      type: String,
      required: true
    },
    currentBunyaIdTemp: {
      type: String,
      required: true
    },
    selectedBunyaTab: {
      type: String,
      required: true
    },
    isOpenBunyaS: {
      type: Boolean,
      required: false
    },
    selectedBunyaName: {
      type: String,
      required: true
    },
    selectedBunyaCdL: {
      type: String,
      required: true
    },
    selectedBunyaKeyM: {
      type: String,
      required: true
    },
    selectedBunyaKeyS: {
      type: String,
      required: true
    },
    selectedBunyaCds: {
      type: Array,
      required: true
    },
    submitMode: {
      type: Boolean,
      required: true
    },
    isFirstModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    SlidePanelTemplate: _SlidePanelTemplate2.default,
    MenuListS: _MenuListS2.default,
    Button: _Button2.default,
    MenuHeader: _MenuHeader2.default
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('popstate', function () {
      _this.toggleShikakuShModal(false);
    });
  },

  methods: {
    prevAction: function prevAction() {
      this.$emit('prev');
    },
    closeAction: function closeAction() {
      this.$emit('close');
    },
    setItem: function setItem(cdInfo) {
      this.$emit('setItem', cdInfo);
    },
    getCountS: function getCountS(jmCd) {
      this.$emit('getCountS', jmCd);
    },
    goToPanelL: function goToPanelL() {
      s2.tl(this, 'o', 'Ssearch_result_panel_otherbunya');
      this.$emit('goToPanelL');
    },
    setItemS: function setItemS($event) {
      if ($event.sCd !== 'all' && this.selectedBunyaTab === 'shikaku') {
        this.toggleShikakuShModal();
        this.shikakuShHeading = $event.sNm;
        var tempCopy = JSON.parse((0, _stringify2.default)(this.shTempObj));
        tempCopy.m = $event.mCd;
        tempCopy.s = $event.sCd;
        this.shTempObj = (0, _assign2.default)({}, this.shTempObj, tempCopy);
      }
      this.$emit('setItemS', $event);
    },
    clickAllM: function clickAllM($event) {
      this.$emit('clickAllM', $event);
    },
    setShikakuShItem: function setShikakuShItem(cd) {
      s2.tl(this, 'o', 'Ssearch_result_panel_shikaku_shubetsu');
      var tempCopy = JSON.parse((0, _stringify2.default)(this.shTempObj));
      tempCopy.sh = cd;
      this.$emit('setShikakuShItem', tempCopy);
      if (!this.submitMode) {
        this.toggleShikakuShModal();
      }
    },
    toggleAccordion: function toggleAccordion($event) {
      this.$emit('toggleAccordion', $event);
    },
    toggleShikakuShModal: function toggleShikakuShModal() {
      var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.isOpenBunyaSh = isOpen === null ? !this.isOpenBunyaSh : isOpen;
    }
  },
  computed: {
    isBunyaListS: function isBunyaListS() {
      var currentBunyaObject = this.bunyaListM[this.selectedBunyaTab];
      if (!currentBunyaObject || !this.selectedBunyaCdL) {
        return false;
      }
      return currentBunyaObject.hasOwnProperty(this.selectedBunyaCdL);
    },
    isSelected: function isSelected() {
      var _this2 = this;

      return function (shikaku) {
        if (_this2.selectedBunyaCds.length > 3) {
          var qshCd = shikaku.qshCd === 'all' ? 'sh_' + shikaku.qshCd : shikaku.qshCd;
          var isQshSelected = _this2.selectedBunyaCds.indexOf(qshCd) !== -1;
          var isQsSelected = _this2.selectedBunyaCds.indexOf(shikaku.qsCd) !== -1;
          return isQshSelected && isQsSelected;
        } else {
          return shikaku.isSelected;
        }
      };
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlidePanelTemplate',{attrs:{"heading":_vm.selectedBunyaName,"isOpen":_vm.isOpenBunyaS,"isModalOpen":_vm.isOpenBunyaSh,"isFirstModal":_vm.isFirstModal},on:{"prev":_vm.prevAction,"close":_vm.closeAction}},[(!_vm.isOpenBunyaSh)?_c('div',{staticClass:"menuWrap"},[(_vm.isBunyaListS)?_c('MenuListS',{attrs:{"openedAccordions":_vm.openedAccordions,"bunyaListM":_vm.bunyaListM,"bunyaListS":_vm.bunyaListS,"isOpenBunyaS":_vm.isOpenBunyaS,"currentBunyaId":_vm.currentBunyaId,"currentBunyaIdTemp":_vm.currentBunyaIdTemp,"selectedBunyaTab":_vm.selectedBunyaTab,"selectedBunyaCdL":_vm.selectedBunyaCdL,"selectedBunyaKeyM":_vm.selectedBunyaKeyM,"selectedBunyaKeyS":_vm.selectedBunyaKeyS,"selectedBunyaCds":_vm.selectedBunyaCds},on:{"getCountS":_vm.getCountS,"toggleAccordion":_vm.toggleAccordion,"setItemS":_vm.setItemS,"clickAllM":_vm.clickAllM,"toggleShikakuShModal":_vm.toggleShikakuShModal}}):_c('MenuHeader',{staticClass:"menuHeader"},[_c('p',[_vm._v("リストを取得できませんでした。"),_c('br'),_vm._v("以下のボタンから分野を選択してください。")])]),_vm._v(" "),_c('div',{staticClass:"menuWrap__buttonWrap"},[_c('Button',{staticClass:"menuWrap__button",nativeOn:{"click":function($event){_vm.goToPanelL($event)}}},[_vm._v("\n        他の分野から探す\n      ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isOpenBunyaSh)?_c('div',{staticClass:"shikakuDetail",on:{"modalClose":_vm.toggleShikakuShModal}},[_c('div',{staticClass:"shikakuDetail__head"},[_c('p',{staticClass:"shikakuDetail__title"},[_vm._v(_vm._s(_vm.shikakuShHeading))])]),_vm._v(" "),_c('div',{staticClass:"shikakuDetail__contents",style:(_vm.topStyle)},[_c('ul',{staticClass:"shikakuDetailList"},_vm._l((_vm.shikakuShList),function(shikaku){return _c('li',{key:shikaku.qshCd,staticClass:"shikakuDetailList__item"},[_c('a',{staticClass:"shikakuDetailList__link",class:{'is-selected': _vm.isSelected(shikaku),'is-disabled': shikaku.count === 0},attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.setShikakuShItem(shikaku.qshCd)}}},[_c('span',{staticClass:"shikakuDetailList__text"},[_vm._v(_vm._s(shikaku.qshNm)),_c('span',{staticClass:"shikakuDetailList__count"},[_vm._v("（"+_vm._s(shikaku.count)+"件）")])])])])}))])]):_vm._e()])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-6d34e836"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d34e836", __vue__options__)
  } else {
    hotAPI.reload("data-v-6d34e836", __vue__options__)
  }
})()}
},{"../../_Button.vue":142,"../../slidePanel/modules/MenuHeader.vue":161,"../modules/MenuListS.vue":163,"./modules/SlidePanelTemplate.vue":169,"babel-runtime/core-js/json/stringify":55,"babel-runtime/core-js/object/assign":56,"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],166:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 13, stdin */\n.heading[data-v-f0e5e326] {\n  padding: 16px;\n  background-color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #24243F; }\n  @media (min-width: 768px) {\n    /* line 13, stdin */\n    .heading[data-v-f0e5e326] {\n      font-size: 24px; } }\n\n/* line 25, stdin */\n.headingText[data-v-f0e5e326] {\n  margin-left: 12px;\n  position: relative; }\n\n/* line 30, stdin */\n.headingText[data-v-f0e5e326]::before {\n  content: '';\n  position: absolute;\n  left: -12px;\n  top: 0;\n  width: 4px;\n  height: 30%;\n  background-color: #0b41a0; }\n\n/* line 40, stdin */\n.headingText[data-v-f0e5e326]::after {\n  content: '';\n  position: absolute;\n  left: -12px;\n  bottom: 0;\n  width: 4px;\n  height: 70%;\n  background-color: #0ca5e6; }")
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('div',{staticClass:"headingText"},[_vm._t("default")],2)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-f0e5e326"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f0e5e326", __vue__options__)
  } else {
    hotAPI.reload("data-v-f0e5e326", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],167:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 40, stdin */\n.buttonWrap[data-v-fc0df0ac] {\n  background: #ffffff;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #D3D4D4; }\n\n/* line 47, stdin */\n.buttonWrap--justifyEnd[data-v-fc0df0ac] {\n  justify-content: flex-end; }\n\n/* line 50, stdin */\n.button[data-v-fc0df0ac] {\n  padding: 12px 16px;\n  background: 0;\n  border: 0;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #0ca5e6; }\n  @media (hover: hover) {\n    /* line 58, stdin */\n    .button[data-v-fc0df0ac]:hover {\n      text-decoration: underline; } }\n\n/* line 63, stdin */\n.button--prev[data-v-fc0df0ac] {\n  position: relative; }\n\n/* line 66, stdin */\n.button--prev[data-v-fc0df0ac]::before {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 12px;\n  margin-right: 4px;\n  background: url(/images/responsive/Action_Blue/arrow_actionBlue_base.svg) no-repeat center;\n  transform: rotate(180deg); }")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    baseModal: {
      type: Boolean,
      default: false
    },
    isFirstModal: {
      type: Boolean,
      default: false
    },
    isModalOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFirstModalComputed: function isFirstModalComputed() {
      return this.baseModal || this.isFirstModal;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonWrap",class:{'buttonWrap--justifyEnd': _vm.isFirstModalComputed && !_vm.isModalOpen}},[(!_vm.isFirstModalComputed || _vm.isModalOpen)?_c('button',{staticClass:"button button--prev",on:{"click":function($event){_vm.$emit('prevAction')}}},[_vm._t("prevAction",[_vm._v("前画面に戻る")])],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('closeAction')}}},[_vm._t("closeAction",[_vm._v("閉じる")])],2)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-fc0df0ac"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc0df0ac", __vue__options__)
  } else {
    hotAPI.reload("data-v-fc0df0ac", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],168:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 23, stdin */\n.fixed[data-v-203c6470] {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 200;\n  transition: .2s ease-in-out;\n  transform: translateX(100%); }\n  @media (min-width: 768px) {\n    /* line 23, stdin */\n    .fixed[data-v-203c6470] {\n      transition: none; } }\n  /* line 35, stdin */\n  .fixed.is-open[data-v-203c6470] {\n    transform: translateX(0); }\n    @media (min-width: 768px) {\n      /* line 35, stdin */\n      .fixed.is-open[data-v-203c6470] {\n        right: 0;\n        bottom: 0;\n        margin: auto;\n        margin-bottom: 56px;\n        width: 480px;\n        border-radius: 0 0 16px 16px; } }")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        isOpen: {
            required: true,
            type: Boolean
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed",class:{'is-open': _vm.isOpen}},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-203c6470"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-203c6470", __vue__options__)
  } else {
    hotAPI.reload("data-v-203c6470", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],169:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@charset \"UTF-8\";\n/* line 112, stdin */\n.panelWrap[data-v-d73ff85c] {\n  transition: .2s ease-in-out;\n  transform: translateX(100%); }\n  @media (min-width: 768px) {\n    /* line 112, stdin */\n    .panelWrap[data-v-d73ff85c] {\n      transition: none; } }\n  /* line 118, stdin */\n  .panelWrap.is-open[data-v-d73ff85c] {\n    transform: translateX(0); }\n    @media (min-width: 768px) {\n      /* line 118, stdin */\n      .panelWrap.is-open[data-v-d73ff85c] {\n        transition: none;\n        overflow: hidden;\n        width: 480px;\n        max-height: calc(100% - 112px);\n        border-radius: 16px;\n        margin: auto; } }\n\n/* line 131, stdin */\n.content[data-v-d73ff85c] {\n  background-color: #f8f9f9; }\n  /* line 133, stdin */\n  .content.is-scrolling[data-v-d73ff85c] {\n    position: absolute;\n    top: 107px;\n    left: 0;\n    width: 100%;\n    height: calc(100% - 186px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    /*スクロールバー非表示（Edge）*/\n    -ms-overflow-style: none;\n    /*スクロールバー非表示（Chrome・Safari）*/ }\n    /* line 144, stdin */\n    .content.is-scrolling[data-v-d73ff85c]::-webkit-scrollbar {\n      display: none; }\n    @media (min-width: 768px) {\n      /* line 133, stdin */\n      .content.is-scrolling[data-v-d73ff85c] {\n        position: relative;\n        top: 0;\n        padding-bottom: 80px; } }\n    /* line 152, stdin */\n    .content.is-scrolling.noButton[data-v-d73ff85c] {\n      height: calc(100% - 105px); }")
;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Wrap = require('./Wrap.vue');

var _Wrap2 = _interopRequireDefault(_Wrap);

var _PrevButton = require('./PrevButton.vue');

var _PrevButton2 = _interopRequireDefault(_PrevButton);

var _Heading = require('./Heading.vue');

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var s2 = typeof s_gi === 'function' && s_account ? s_gi(s_account) : null;

exports.default = {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    heading: {
      type: String,
      required: true
    },
    isScrolling: {
      type: Boolean,
      required: false,
      default: false
    },
    isEnterButton: {
      type: Boolean,
      required: false,
      default: false
    },
    enterButtonLog: {
      type: String,
      required: false,
      default: ''
    },
    isModalOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    baseModal: {
      type: Boolean,
      required: false,
      default: false
    },
    isFirstModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    Wrap: _Wrap2.default,
    PrevButton: _PrevButton2.default,
    Heading: _Heading2.default
  },
  methods: {
    prevAction: function prevAction() {
      this.$emit('prev');
    },
    closeAction: function closeAction() {
      this.$emit('close');
    },
    clickEnter: function clickEnter() {
      this.$emit('click-enter');
      if (this.enterButtonLog && s2 !== null) {
        s2.tl(this, 'o', this.enterButtonLog);
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrap',{staticClass:"panelWrap",class:{'is-open': _vm.isOpen}},[_c('PrevButton',{attrs:{"isFirstModal":_vm.isFirstModal,"baseModal":_vm.baseModal,"isModalOpen":_vm.isModalOpen},on:{"prevAction":_vm.prevAction,"closeAction":_vm.closeAction}},[[_vm._v("前画面に戻る")],_vm._v(" "),[_vm._v("閉じる")]],2),_vm._v(" "),(!_vm.isModalOpen)?_c('Heading',[_vm._v(_vm._s(_vm.heading || '-'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content js-panelInner",class:{'is-scrolling': _vm.isScrolling, 'noButton' : !_vm.isEnterButton && !_vm.baseModal}},[_vm._t("default")],2),_vm._v(" "),(_vm.isEnterButton)?_c('section',{staticClass:"searchPanel__fixed"},[_c('div',{staticClass:"searchPanel__fixed__button--long"},[_c('a',{staticClass:"searchPanel__fixed__button--set",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.clickEnter()}}},[_vm._v("\n        条件を決定\n      ")])])]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-d73ff85c"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d73ff85c", __vue__options__)
  } else {
    hotAPI.reload("data-v-d73ff85c", __vue__options__)
  }
})()}
},{"./Heading.vue":166,"./PrevButton.vue":167,"./Wrap.vue":170,"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],170:[function(require,module,exports){
var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 11, stdin */\n.wrap[data-v-f5b97022] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #ffffff;\n  z-index: 200; }")
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-f5b97022"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f5b97022", __vue__options__)
  } else {
    hotAPI.reload("data-v-f5b97022", __vue__options__)
  }
})()}
},{"vue":102,"vue-hot-reload-api":101,"vueify/lib/insert-css":103}],171:[function(require,module,exports){
/**
 * 案件:【アクション】ENH_SP_検索一覧個社TOP_お気に入り登録導線追加
 * ファイル派生元:s_searchList_insertKoruliBanner2_requestAddition_cassette_addCpBanner_kyokanContent_performanceImprovement_asyncRecommend.js
 * Bパターン
 */

// ENH_2023_001_検索一覧画面カセット改修
// https://makepa.atlassian.net/wiki/spaces/SHINROPRDG/pages/169424613/ENH+2023+001

'use strict';

var _this2 = this;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

// fileName: slideNew.js

require('./component/sp/_s_slidePanel');

// fileName: matomete_smp.js

require('./component/sp/_s_cartNumber');

// fileName: s_addCartWithCampaignBanner

require('./component/sp/_s_addCartWithCampaignBanner');

// Vueインスタンス生成（検索カセット）

require('./component/sp/_s_searchListPanel_integration_responsive.js');

// 履歴導線追加

var _component_searchList_searchHistory = require('./component/_searchList_searchHistory');

var _component_sendClickLogJs = require('./component/_sendClickLog.js');

var _component_sendScrollLogJs = require('./component/_sendScrollLog.js');

// カート追加済み再来訪（SP）入り口フラグ設定

var _componentSp_s_revisitFlagSetting = require('./component/sp/_s_revisitFlagSetting');

var _componentSp_s_revisitFlagSetting2 = _interopRequireDefault(_componentSp_s_revisitFlagSetting);

// 検索カセットログ

var _componentSp_s_searchCasettesLog = require('./component/sp/_s_searchCasettesLog');

// キャンペーンバナー

var _componentSp_s_getCampaignData = require('./component/sp/_s_getCampaignData');

var _componentSp_s_getCampaignData2 = _interopRequireDefault(_componentSp_s_getCampaignData);

// 共感コンテンツ

var _componentSp_s_searchkyokanContent = require('./component/sp/_s_searchkyokanContent');

// 学校レコメンド

var _componentSp_s_asyncRecommend = require('./component/sp/_s_asyncRecommend');

// レコメンド訴求吹き出し

var _componentSp_s_headerRecommend = require('./component/sp/_s_headerRecommend');

var _componentSp_s_headerRecommend2 = _interopRequireDefault(_componentSp_s_headerRecommend);

//【アクション】ENH_SP_検索一覧個社TOP_お気に入り登録導線追加

var _componentSp_popupContent = require("./component/sp/_popupContent");

var _componentSp_popupContent2 = _interopRequireDefault(_componentSp_popupContent);

var _componentSp_FavoriteToast = require("./component/sp/_FavoriteToast");

var _componentSp_FavoriteToast2 = _interopRequireDefault(_componentSp_FavoriteToast);

var _frontendSrcJsContents_getLoginStatus = require("../../../../frontend/src/js/contents/_getLoginStatus");

// feat-94032-【UIUX】統合検索一覧_履歴導線追加（SP）

// 27 PR追加

var _componentPrAreaModules_prAreaJs = require('./component/prArea/modules/_prArea.js');

var _component_sendCustomScrollLogJs = require("./component/_sendCustomScrollLog.js");

// fileName: _s_bunya_component.js

var _commonConvertDate = require('./common/ConvertDate');

var _commonConvertDate2 = _interopRequireDefault(_commonConvertDate);

var _commonClickLog = require('./common/ClickLog');

var _commonClickLog2 = _interopRequireDefault(_commonClickLog);

var _commonSendLog = require('./common/SendLog');

var _commonSendLog2 = _interopRequireDefault(_commonSendLog);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

var _component_lazyLoad = require('./component/_lazyLoad');

var _component_lazyLoad2 = _interopRequireDefault(_component_lazyLoad);

// なるには全件表示

var _component_accordionButton = require('./component/_accordionButton');

var _component_accordionButton2 = _interopRequireDefault(_component_accordionButton);

// #88790[21RM][エンハンス]【UIUX】カート追加済み再来訪（SP）

require('./component/sp/_s_cartRevisitBalloon');

/** 
  * feat-94032-【UIUX】統合検索一覧_履歴導線追加（SP）
  * キャンペーンバナーの件数ロジック（カート追加時）
  * キャンペーンバナーを特定する要素があった場合、
  * 現在、カート追加されているキャンペーン対象校の数を取得
  * キャンペーン対象校の数をキャンペーンバナー内に反映
  **/

new _componentSp_s_revisitFlagSetting2['default']();window.addEventListener('DOMContentLoaded', function () {
  // 履歴導線のイベント設定処理
  (0, _component_searchList_searchHistory.setSearchHistory)();

  // クリックログ設定
  var clickLogTargets = document.querySelectorAll('.js-nyushiClickLog');
  if (clickLogTargets.length > 0) {
    (0, _component_sendClickLogJs.initClickLog)(clickLogTargets, 'clickLog');
  }

  // inViewログ設定
  var inViewLogTargets = document.querySelectorAll('.js-isInView');
  if (inViewLogTargets.length > 0) {
    (0, _component_sendScrollLogJs.initScrollLog)(s, inViewLogTargets, 'inviewLog');
  }
});

window.addEventListener('DOMContentLoaded', function () {
  var targetCassetteSelector = 'js-targetPrArea';

  new _componentPrAreaModules_prAreaJs.PrArea({ cassetteSelector: targetCassetteSelector });
  (0, _component_sendCustomScrollLogJs.observeSettingLog)(targetCassetteSelector);
});

(0, _jquery2['default'])(function () {
  // 検索結果カセットアコーディオン開閉
  (0, _jquery2['default'])('[data-more-gakubugakka="trigger"]').on('click', function () {
    var logId = (0, _jquery2['default'])(this).attr('data-logId'),
        s2 = s_gi(s_account),
        $target = (0, _jquery2['default'])(this).closest('.searchResults__item').find('[data-more-gakubugakka="target"]');
    if ((0, _jquery2['default'])(this).hasClass('is-open')) {
      (0, _jquery2['default'])(this).removeClass('is-open');
      (0, _jquery2['default'])(this).text('もっと学部・学科・コースを見る');
      $target.slideUp(0, function () {});
      var $schoolCassette = (0, _jquery2['default'])(this).closest('.searchResults__item');
      (0, _jquery2['default'])('html,body').animate({
        scrollTop: $schoolCassette.offset().top
      }, 0);
    } else {
      s2.tl((0, _jquery2['default'])(this), 'o', logId);
      (0, _jquery2['default'])(this).addClass('is-open');
      (0, _jquery2['default'])(this).text('閉じる');
      $target.slideDown(function () {});
    }
  });

  // 検索結果カセット学部学科テキストを開く
  (0, _jquery2['default'])(document).on('click', '[data-more-gakubugakka-text="trigger"]', function (e) {
    var $target = (0, _jquery2['default'])(this).next('[data-more-gakubugakka-text="target"]');

    $target.animate({
      width: 'show'
    }, 'slow');
    $target.children().unwrap();
    (0, _jquery2['default'])(this).remove();
  });

  //続きを見る押下で隠れている項目を表示
  (0, _jquery2['default'])('.js-searchResults__bunya__more-text').on('click', function () {
    (0, _jquery2['default'])(this).closest('.searchResults__bunya__text-container').find('.searchResults__bunya__text-hidden').slideToggle('fast');
    (0, _jquery2['default'])(this).toggleClass('is-open');
  });

  // 検索一覧フッターリンク
  (0, _jquery2['default'])('[data-accordion=opener]').on('click', function (event) {
    var $this = (0, _jquery2['default'])(event.target),
        s2 = s_gi(s_account),
        logId = $this.data('logid');
    $this.toggleClass('is-open');
    // アコーディオンを開いた時にクリックログを送信
    if ($this.hasClass('is-open')) {
      $this.parent().find('.searchlink__linkList').slideDown();
      s2.tl($this, 'o', logId);
    } else {
      $this.parent().find('.searchlink__linkList').slideUp();
    }
  });

  // 初期表示
  var $tab = (0, _jquery2['default'])('.searchResults__tabName');
  (0, _jquery2['default'])('.searchResults__content').hide();

  (0, _jquery2['default'])(window).on('load resize', function (event) {
    // sessionStorageに表示項目データがある時は、表示切替タブのis-activeを付け替える
    if ('sessionStorage' in window && window.sessionStorage !== null) {
      var val = sessionStorage.getItem('sss_searchPanelActiveTab');
      if (val !== null) {
        $tab.eq(val).trigger('click.notSendLog');
        // sessionStorageの表示項目データを削除
        sessionStorage.removeItem('sss_searchPanelActiveTab');
      }
    }
    // 選択項目配下の内容を表示
    $tab.each(function (index, obj) {
      if ((0, _jquery2['default'])(obj).hasClass('is-active')) {
        (0, _jquery2['default'])(obj).trigger('click.notSendLog');
      }
    });

    // 学部学科未購入のみの場合、項目表示切替タブを削除
    if (!(0, _jquery2['default'])('.searchResults__gakkaList').length) {
      (0, _jquery2['default'])('.searchResults__tabsWrap').remove();
    }
  });

  // タブで表示項目切り替え
  $tab.on('click.notSendLog', function (event) {

    var $this = (0, _jquery2['default'])(event.target),
        logId = $this.attr('data-logId'),
        s2 = s_gi(s_account);

    // クリックログ送信
    if (event.namespace !== 'notSendLog') {
      if (!$this.hasClass('is-active')) {
        s2.tl($this, 'o', logId);
      }
    }

    var index = $tab.index($this);
    $tab.removeClass('is-active');
    $this.addClass('is-active');

    (0, _jquery2['default'])('.searchResults__gakkaList > li').each(function (i, obj) {
      var value = obj.className.match('searchResults__gakkaItem');
      if (value) {
        (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.searchResults__content')).hide();
        (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.searchResults__content')).eq(index).show();
        // 検索軸以外の小分類ハイライトを削除
        if (index !== flagAxis) {
          (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.searchResults__content')).eq(index).find('.searchResults__word').removeClass('is-match');
        }
      }
    });

    // 「もっと学部・学科・コースを見る」配下の項目表示
    (0, _jquery2['default'])('.searchResults__gakkaList > li > ul > li').each(function (i, obj) {
      var value = obj.className.match('searchResults__gakkaItem');
      if (value) {
        (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.searchResults__content')).hide();
        (0, _jquery2['default'])(obj).find((0, _jquery2['default'])('.searchResults__content')).eq(index).show();
      }
    });

    event.preventDefault();
  });

  // ページャーでページ遷移する際、選択項目を維持する（仕事・学問・資格・学費）
  (0, _jquery2['default'])('.js-pagerArea').find('.js-pagerBack, .js-pagerNext, .js-pagerNumber').on('click', function () {
    $tab.each(function (index, obj) {
      // 選択項目をsessionStorageに保存
      if ((0, _jquery2['default'])(obj).hasClass('is-active')) {
        if ('sessionStorage' in window && window.sessionStorage !== null) {
          try {
            sessionStorage.setItem('sss_searchPanelActiveTab', index);
          } catch (err) {
            return false;
          }
        }
      }
    });
  });

  /*-------------------------------------------------------
   * [ENN_2019_008] SP 一覧絞り込み改善 ABテスト用 処理追加
   *-------------------------------------------------------*/
  // 上部の検索パネルを通り過ぎたら、検索パネル起動の吸着表示を行う
  var $fixedSearchItem = (0, _jquery2['default'])('.js-showPanelTrigger');
  var $window = (0, _jquery2['default'])(window);
  var isFixedPositionSet = false;
  if ($fixedSearchItem.length > 0) {
    (function () {

      var $showFixedItemTrigger = (0, _jquery2['default'])('.js-showFixedItemTrigger').eq(0);
      $window.scroll(function () {
        if (document.getElementsByClassName('js-dispPanelBar').length) {
          return false;
        }
        if ($window.scrollTop() > $showFixedItemTrigger.outerHeight() + $showFixedItemTrigger.offset().top) {
          if ($fixedSearchItem.hasClass('js-showPanelBar')) {
            // 上部検索バー吸着表示の場合
            $fixedSearchItem.slideDown(200).removeClass('is-hide');
          } else {
            // 下部検索アイコン吸着表示の場合、初期ロード処理が終わっていたら表示する
            if (isFixedPositionSet) {
              $fixedSearchItem.fadeIn(200).removeClass('is-hide');
            }
          }
        } else {
          if ($fixedSearchItem.hasClass('js-showPanelBar')) {
            // 上部検索バー吸着表示の場合
            $fixedSearchItem.slideUp(150);
          } else {
            // 下部検索アイコン吸着表示の場合
            $fixedSearchItem.fadeOut(150);
          }
        }
      });
    })();
  }

  var setSearchIconPosition = function setSearchIconPosition($targetIcon) {
    if ($targetIcon.length > 0) {
      var $footerCart = (0, _jquery2['default'])('.fixFooterCart');
      if ($footerCart.length > 0 && $footerCart.hasClass('is-show')) {
        $targetIcon.addClass('is-listButtonFixed');
      }
    }
  };

  var $fixedSearchIcon = (0, _jquery2['default'])('.js-showPanelIcon');

  if ($fixedSearchIcon.length > 0) {
    // 資料請求カートボタンが押下された際、資料請求のBパターンの下部吸着アイコンの表示位置を調整
    (0, _jquery2['default'])(document).on('click', '[data-action="addCartOnly"], [data-action="addCartAndOpen"]', function () {
      $fixedSearchIcon.addClass('is-listButtonFixed');
    });

    // 画面ロード時、資料請求の吸着が表示されていたら Bパターンの下部吸着アイコンの表示位置を調整
    $window.on('load', function () {
      setSearchIconPosition($fixedSearchIcon);
      isFixedPositionSet = true;
    });
  }

  /*-------------------------------------------------------
  * [ENH_2019_016] SP 一覧表示項目切替吸着
  *-------------------------------------------------------*/
  // 切替タブがない時（検索結果0件）は何もしない
  if (!document.querySelector('.searchResults__tabsWrap')) {
    return false;
  }
});
var SEND_LOG_DATA_NAME = 'data-load-send';

window.onload = function () {
  // 特別枠OC導線カセット
  (0, _jquery2['default'])('.js-oc-swiper').each(function () {
    // 現在のSwiperインスタンスのページネーション要素を取得
    var swiperContainer = (0, _jquery2['default'])(this).find('.swiper-container');
    new _swiper2['default'](swiperContainer[0], {
      slidesPerView: 'auto',
      freeMode: true,
      loop: false,
      autoplay: false,
      pagination: {
        el: (0, _jquery2['default'])(this).find('.swiper-pagination'),
        dynamicBullets: true,
        dynamicMainBullets: 1
      },
      navigation: {
        nextEl: (0, _jquery2['default'])(this).find('.swiper-button-next'),
        prevEl: (0, _jquery2['default'])(this).find('.swiper-button-prev')
      }
    });
  });

  // OC動線
  (0, _jquery2['default'])('.js-gakkoSearchOc-swiper').each(function () {
    var swiperContainer = (0, _jquery2['default'])(this).find('.swiper-container');
    new _swiper2['default'](swiperContainer[0], {
      slidesPerView: 'auto',
      freeMode: true,
      loop: false,
      autoplay: false,
      pagination: {
        el: (0, _jquery2['default'])(this).find('.swiper-pagination'),
        dynamicBullets: true,
        dynamicMainBullets: 3
      },
      navigation: {
        nextEl: (0, _jquery2['default'])(this).find('.swiper-button-next'),
        prevEl: (0, _jquery2['default'])(this).find('.swiper-button-prev')
      }
    });
  });
  new _commonConvertDate2['default']();
  (0, _commonClickLog2['default'])();
  // OC導線カセットのロード時のログ送信
  (0, _jquery2['default'])('.js-loadLog').each(function (i) {
    var sendLogUrl = (0, _jquery2['default'])(this).attr(SEND_LOG_DATA_NAME);
    (0, _commonSendLog2['default'])(sendLogUrl);
  });
};

(0, _component_lazyLoad2['default'])('.js-lazyLoad', 'src', { rootMargin: '100px' });
(0, _component_accordionButton2['default'])('.js-relativeBlockItem', '.js-toggleTrigger', 'pB20');(function () {
  (0, _componentSp_s_getCampaignData2['default'])();
})();

/**
  * feat-94032-【UIUX】統合検索一覧_履歴導線追加（SP）
  * 以下のイベントでログ（カスタムリンク）を送信
  * スクロール時、検索カセットが画面内に表示された時
  * 検索カセット内（学校名、画像のエリア）押下時
  * 検索カセット内（学科名カセット）押下時
  * 検索カセット内（パンフをもらうボタン）押下時
  * 検索カセット内（願書ボタン）押下時
  * 検索カセット内（(テレメール)パンフ・願書をもらうボタン）押下時
  * 検索カセット内（カートに追加するボタン）押下時
  * 検索カセット内（この学校のオープンキャンパス情報を見る(もっと見る)リンク）押下時
  **/
(0, _componentSp_s_searchCasettesLog.cassetteInView)();
(0, _componentSp_s_searchCasettesLog.cassetteClicks)();
function userAgentFunction(spCallback, pcCallback) {
  var _this = this;

  // レスポンシブ対応_PC画面にマイペ機能が無いため、UA判断してPCには表示させない
  var handleClientHints = function handleClientHints(uaClientHints) {
    var platformData, mobileData;
    return regeneratorRuntime.async(function handleClientHints$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          context$2$0.prev = 0;
          context$2$0.next = 3;
          return regeneratorRuntime.awrap(uaClientHints.getHighEntropyValues(["platform"]));

        case 3:
          platformData = context$2$0.sent;

          if (!platformData.platform) {
            context$2$0.next = 11;
            break;
          }

          context$2$0.next = 7;
          return regeneratorRuntime.awrap(uaClientHints.getHighEntropyValues(["mobile"]));

        case 7:
          mobileData = context$2$0.sent;

          loadCallback(mobileData.mobile);
          context$2$0.next = 12;
          break;

        case 11:
          fallbackToUserAgent();

        case 12:
          context$2$0.next = 17;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](0);

          fallbackToUserAgent();

        case 17:
        case 'end':
          return context$2$0.stop();
      }
    }, null, _this, [[0, 14]]);
  };

  // User-Agent Client Hintsが利用できないブラウザは従来通り、navigator.userAgentで判定
  var fallbackToUserAgent = function fallbackToUserAgent() {
    var ua = navigator.userAgent || '';
    var isMobile = /iPhone|iPad|Android|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    if (isMobile) {
      spCallback();
    } else {
      pcCallback();
    }
  };

  var loadCallback = function loadCallback(isMobile) {
    if (isMobile) {
      // SPの場合のみ表示
      spCallback();
    } else {
      pcCallback();
    }
  };

  // User-Agent Client Hintsが利用できる場合（Chrome対策）
  var uaClientHints = navigator.userAgentData;
  if (uaClientHints) {
    handleClientHints(uaClientHints);
  } else {
    fallbackToUserAgent();
  }
}

/**
  * feat-98612-検索一覧_共感コンテンツ追加_SP
  **/
document.addEventListener('DOMContentLoaded', _componentSp_s_searchkyokanContent.initKyokanContent);

/**
 * feat-99235-検索一覧_レコメンドロジック改修（SP）
 */
document.addEventListener('DOMContentLoaded', function callee$0$0() {
  var inViewLogTargets;
  return regeneratorRuntime.async(function callee$0$0$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.next = 2;
        return regeneratorRuntime.awrap((0, _componentSp_s_asyncRecommend.initGakkoRecommend)());

      case 2:
        inViewLogTargets = document.querySelectorAll('.js-isInViewRecommend');

        if (inViewLogTargets) {
          (0, _component_sendScrollLogJs.initScrollLog)(window.s, inViewLogTargets, 'inviewLog');
        }

      case 4:
      case 'end':
        return context$1$0.stop();
    }
  }, null, _this2);
});

window.addEventListener('load', function () {

  userAgentFunction(function () {
    /**
     * 【アクション】ENH_SP_検索一覧個社TOP_お気に入り登録導線追加
    */
    var loginStatus = '';
    (0, _frontendSrcJsContents_getLoginStatus.getLoginStatus)(false, function (status) {
      loginStatus = status;
      var searchGakkos = document.querySelectorAll(".js-cassetteInView");
      // カスタマーID
      var customerId = '';
      var customerIdResultCode = null;

      // CSRFトークン発行API
      var issueCsrfToken = function issueCsrfToken() {
        return regeneratorRuntime.async(function issueCsrfToken$(context$4$0) {
          while (1) switch (context$4$0.prev = context$4$0.next) {
            case 0:
              context$4$0.prev = 0;
              context$4$0.next = 3;
              return regeneratorRuntime.awrap(fetch('/smp2/csrfToken/issueCsrfToken'));

            case 3:
              return context$4$0.abrupt('return');

            case 6:
              context$4$0.prev = 6;
              context$4$0.t0 = context$4$0['catch'](0);

            case 8:
            case 'end':
              return context$4$0.stop();
          }
        }, null, _this2, [[0, 6]]);
      };
      // お気に入り登録カスタマーID発行API

      // フロント側でのエラー処理は不要
      var getFavoriteCustomerId = function getFavoriteCustomerId() {
        var response, data;
        return regeneratorRuntime.async(function getFavoriteCustomerId$(context$4$0) {
          while (1) switch (context$4$0.prev = context$4$0.next) {
            case 0:
              context$4$0.prev = 0;
              context$4$0.next = 3;
              return regeneratorRuntime.awrap(fetch('/smp2/quipMember/favorite/getFavoriteCustomerId'));

            case 3:
              response = context$4$0.sent;
              context$4$0.next = 6;
              return regeneratorRuntime.awrap(response.json());

            case 6:
              data = context$4$0.sent;

              if (!(data.resultCode === 0)) {
                context$4$0.next = 11;
                break;
              }

              return context$4$0.abrupt('return', data);

            case 11:
              throw new Error();

            case 12:
              context$4$0.next = 17;
              break;

            case 14:
              context$4$0.prev = 14;
              context$4$0.t0 = context$4$0['catch'](0);
              throw context$4$0.t0;

            case 17:
            case 'end':
              return context$4$0.stop();
          }
        }, null, _this2, [[0, 14]]);
      };

      // お気に入り学校取得API
      var getFavoriteGakkojson = function getFavoriteGakkojson(customerId) {
        var response, data;
        return regeneratorRuntime.async(function getFavoriteGakkojson$(context$4$0) {
          while (1) switch (context$4$0.prev = context$4$0.next) {
            case 0:
              context$4$0.prev = 0;
              context$4$0.next = 3;
              return regeneratorRuntime.awrap(fetch('/smp2/quipMember/favorite/getFavoriteGakko?customerId=' + customerId));

            case 3:
              response = context$4$0.sent;
              context$4$0.next = 6;
              return regeneratorRuntime.awrap(response.json());

            case 6:
              data = context$4$0.sent;

              if (!(data.resultCode === 0)) {
                context$4$0.next = 11;
                break;
              }

              return context$4$0.abrupt('return', data);

            case 11:
              throw new Error();

            case 12:
              context$4$0.next = 17;
              break;

            case 14:
              context$4$0.prev = 14;
              context$4$0.t0 = context$4$0['catch'](0);
              throw context$4$0.t0;

            case 17:
            case 'end':
              return context$4$0.stop();
          }
        }, null, _this2, [[0, 14]]);
      };

      // お気に入りの状態を更新
      var updatefavorites = function updatefavorites(getFavoriteGakkoData) {
        if (getFavoriteGakkoData.resultCode === 0) {
          // favoriteGakkoCdListがundefinedの場合は空配列を使う
          var favoriteGakkoCdList = getFavoriteGakkoData.favoriteGakkoCdList || [];
          // お気に入りの状態を更新
          checkFavoritegakkoCd(favoriteGakkoCdList);
        } else {
          // エラーが発生した場合は全てをハートを灰色状態に設定
          checkFavoritegakkoCd([]);
        }
      };

      // APIを直列に実行する関数
      window.ajaxFlag = true;
      (function callee$3$0() {
        var getFavoriteData, getFavoriteGakkoData;
        return regeneratorRuntime.async(function callee$3$0$(context$4$0) {
          while (1) switch (context$4$0.prev = context$4$0.next) {
            case 0:
              if (window.ajaxFlag) {
                context$4$0.next = 2;
                break;
              }

              return context$4$0.abrupt('return');

            case 2:
              context$4$0.prev = 2;
              context$4$0.next = 5;
              return regeneratorRuntime.awrap(issueCsrfToken());

            case 5:
              context$4$0.next = 7;
              return regeneratorRuntime.awrap(getFavoriteCustomerId());

            case 7:
              getFavoriteData = context$4$0.sent;

              customerId = getFavoriteData.favoriteCustomerId;
              customerIdResultCode = getFavoriteData.resultCode;

              // お気に入り学校を取得
              context$4$0.next = 12;
              return regeneratorRuntime.awrap(getFavoriteGakkojson(customerId));

            case 12:
              getFavoriteGakkoData = context$4$0.sent;

              // お気に入りの状態を更新
              updatefavorites(getFavoriteGakkoData);
              context$4$0.next = 19;
              break;

            case 16:
              context$4$0.prev = 16;
              context$4$0.t0 = context$4$0['catch'](2);

              // エラーが発生した場合は全てのハートを灰色状態に設定
              checkFavoritegakkoCd([]);

            case 19:
              context$4$0.prev = 19;

              // フラグを戻す
              window.ajaxFlag = true;
              return context$4$0.finish(19);

            case 22:
            case 'end':
              return context$4$0.stop();
          }
        }, null, _this2, [[2, 16, 19, 22]]);
      })();

      // CookieからCsrfTokenを取得する
      var getCookie = function getCookie(key) {
        var cookies = document.cookie.split(';');
        var foundCookie = cookies.find(function (cookie) {
          return cookie.split('=')[0].trim() === key.trim();
        });
        if (foundCookie) {
          var cookieValue = decodeURIComponent(foundCookie.split('=')[1]);
          return cookieValue;
        }
        return '';
      };

      // お気に入り学校登録API
      var registerFavoriteGakko = function registerFavoriteGakko(gakkoCd) {
        var responseData, body, csrfToken, response;
        return regeneratorRuntime.async(function registerFavoriteGakko$(context$4$0) {
          while (1) switch (context$4$0.prev = context$4$0.next) {
            case 0:
              responseData = null;
              body = {
                customerId: customerId, // 会員ID
                favoriteGakkoCd: gakkoCd // お気に入り学校コード
              };
              csrfToken = getCookie('csrf-token');
              context$4$0.prev = 3;
              context$4$0.next = 6;
              return regeneratorRuntime.awrap(fetch('/smp2/quipMember/favorite/setFavoriteGakko', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
              }));

            case 6:
              response = context$4$0.sent;
              context$4$0.next = 9;
              return regeneratorRuntime.awrap(response.json());

            case 9:
              responseData = context$4$0.sent;
              return context$4$0.abrupt('return', responseData);

            case 13:
              context$4$0.prev = 13;
              context$4$0.t0 = context$4$0['catch'](3);
              return context$4$0.abrupt('return', responseData);

            case 16:
            case 'end':
              return context$4$0.stop();
          }
        }, null, _this2, [[3, 13]]);
      };

      // 初期状態
      var FAVORITE_IMAGE = "/images/s/s_icon_favorite.png";
      var NO_FAVORITE_IMAGE = "/images/s/s_icon_nofavorite.png";
      var FAVORITE_CLASS = "searchResults__item__container--favorite";
      var NO_FAVORITE_CLASS = "searchResults__item__container--nofavorite";

      // お気に入りの状態を確認する
      var checkFavoritegakkoCd = function checkFavoritegakkoCd(favoriteGakkoCdList) {
        searchGakkos.forEach(function (item) {
          var gakkoCd = item.getAttribute("data-gakkocd");
          var heartContainer = item.querySelector(".js-favorite__container");
          var favoriteHeart = item.querySelector(".js-favorite__heart");
          var favoriteclick = item.querySelector(".js-favorite__click");

          // お気に入りかどうかを判定
          var isFavorite = favoriteGakkoCdList.includes(gakkoCd);

          // お気に入りの画像とクラスを設定
          favoriteclick.style.visibility = "visible";
          favoriteHeart.src = isFavorite ? FAVORITE_IMAGE : NO_FAVORITE_IMAGE;
          heartContainer.classList.add(isFavorite ? FAVORITE_CLASS : NO_FAVORITE_CLASS);
        });
      };

      // ハートの状態を変更
      var updateFavoriteStatus = function updateFavoriteStatus(button, setFavoriteGakkoResponse, gakkoCd) {
        if (!setFavoriteGakkoResponse) return;
        // ハートを取得
        var favoriteHeart = button.querySelector(".js-favorite__clickheart");
        // 通常学校カセットとレコメンド学校カセットのdom構造が違うため要素の取得が以下のようにしている
        var heartContainer = button.querySelector(".js-favorite__container") || button;
        //PR枠判定（スタイルが異なるため追加）
        var isPr = button.querySelector(".js-isPr") ? true : false;

        // ハートの状態更新(resultCode:「成功: 0」、「登録済: 1」)
        if (setFavoriteGakkoResponse.resultCode === 0 || setFavoriteGakkoResponse.resultCode === 1) {
          // 成功または登録済
          favoriteHeart.src = FAVORITE_IMAGE;
          heartContainer.classList.add(FAVORITE_CLASS);
          heartContainer.classList.remove(NO_FAVORITE_CLASS);
        }

        // カセット表示順位を取得
        var buttonDataIndex = button.getAttribute("data-index");
        var cassetteRank = buttonDataIndex !== null ? buttonDataIndex : button.closest(".searchResults__item").getAttribute("data-index");

        var clickLogName = undefined;
        // 吹き出しorトースト表示
        if (loginStatus === 0) {
          // 会員
          // 上限超過
          if (setFavoriteGakkoResponse.resultCode === 3) {
            (0, _componentSp_popupContent2['default'])(loginStatus, { resultCode: 3 }, button, isPr);
            clickLogName = 'slist_f_all_SCcassette_member_FavoriteLimit_click_' + cassetteRank + '_' + gakkoCd;
          } else if (setFavoriteGakkoResponse.resultCode === 1) {
            clickLogName = 'slist_f_all_SCcassette_member_FavoriteEdit_click_' + cassetteRank + '_' + gakkoCd;
            // 登録済み（マイペに遷移）
            window.location.href = "/smp2/quipMember/favorite/top/?favoriteSchool=show";
          } else if (setFavoriteGakkoResponse.resultCode === 0) {
            // 通常（トースト表示）
            (0, _componentSp_FavoriteToast2['default'])();
            clickLogName = 'slist_f_all_SCcassette_member_FavoriteRegister_click_' + cassetteRank + '_' + gakkoCd;
          }
        } else {
          // 非会員
          // 上限超過
          if (setFavoriteGakkoResponse.resultCode === 3) {
            (0, _componentSp_popupContent2['default'])(loginStatus, { resultCode: 3 }, button, isPr);
            clickLogName = 'slist_f_all_SCcassette_nonmember_FavoriteLimit_click_' + cassetteRank + '_' + gakkoCd;
          } else if (setFavoriteGakkoResponse.resultCode === 1) {
            // 登録済み
            (0, _componentSp_popupContent2['default'])(loginStatus, { resultCode: 1 }, button, isPr);
            clickLogName = 'slist_f_all_SCcassette_nonmember_FavoriteEdit_click_' + cassetteRank + '_' + gakkoCd;
          } else if (setFavoriteGakkoResponse.resultCode === 0) {
            // 通常
            (0, _componentSp_popupContent2['default'])(loginStatus, { resultCode: 0 }, button, isPr);
            clickLogName = 'slist_f_all_SCcassette_nonmember_FavoriteRegister_click_' + cassetteRank + '_' + gakkoCd;
          }
        }
        sendLog(button, clickLogName);
      };

      // お気に入りをクリックした時の処理
      var favoriteButtons = document.querySelectorAll(".js-favorite__click");
      // ダブルサブミット処理変数
      var isSubmitFlag = false;
      favoriteButtons.forEach(function (button) {
        button.addEventListener("click", function callee$4$0(event) {
          var buttonDataGakkoCd, gakkoCd, setFavoriteGakkoResponse;
          return regeneratorRuntime.async(function callee$4$0$(context$5$0) {
            while (1) switch (context$5$0.prev = context$5$0.next) {
              case 0:
                if (!(customerIdResultCode === null || customerIdResultCode === 1)) {
                  context$5$0.next = 2;
                  break;
                }

                return context$5$0.abrupt('return');

              case 2:
                if (!isSubmitFlag) {
                  context$5$0.next = 4;
                  break;
                }

                return context$5$0.abrupt('return');

              case 4:
                isSubmitFlag = true;
                // カセットクリックイベント削除
                event.preventDefault();
                event.stopPropagation();
                // 他のボタンを非活性
                favoriteButtons.forEach(function (button) {
                  return button.disabled = true;
                });
                // 学校コード取得
                buttonDataGakkoCd = button.getAttribute("data-gakkocd");
                gakkoCd = buttonDataGakkoCd !== null ? buttonDataGakkoCd : button.closest(".searchResults__item").getAttribute("data-gakkocd");
                context$5$0.next = 12;
                return regeneratorRuntime.awrap(registerFavoriteGakko(gakkoCd));

              case 12:
                setFavoriteGakkoResponse = context$5$0.sent;

                // 登録結果に応じてハートの表示変更、吹き出し、トーストの表示制御
                updateFavoriteStatus(button, setFavoriteGakkoResponse, gakkoCd);
                // ボタンを有効にする
                favoriteButtons.forEach(function (btn) {
                  return btn.disabled = false;
                });
                isSubmitFlag = false;

              case 16:
              case 'end':
                return context$5$0.stop();
            }
          }, null, _this2);
        });
      });
    });
  }, function () {
    //PC お気に入り非表示対応
    var favoriteButtons = document.querySelectorAll(".js-favorite__click");

    favoriteButtons.forEach(function (el) {
      el.style.display = 'none';
    });
  });
});

// マイページ
(0, _componentSp_s_headerRecommend2['default'])();

// iosのChromeではなぜかnavigator.userAgentDataが正しく取得できないが、"mobile"だけfalseが返却されてしまうy
// "platform"はnavigator.userAgentDataが取得できた場合には必ず値が入るため、"platform"の条件分岐を追加した

// APIレスポンスヘッダーからCookieを取得、保存

// ajaxFlag が true の場合のみ実行する

// CSRFトークンを発行

// カスタマーIDを取得

// csrfTokenをCookieから取得

// カスタマーID発行APIの resultCode が null または 1 の場合、処理を終了する

// ダブルサブミット防止処理

// お気に入り学校登録処理

},{"../../../../frontend/src/js/contents/_getLoginStatus":172,"./common/ClickLog":104,"./common/ConvertDate":105,"./common/SendLog":106,"./component/_accordionButton":107,"./component/_lazyLoad":109,"./component/_searchList_searchHistory":110,"./component/_sendClickLog.js":111,"./component/_sendCustomScrollLog.js":112,"./component/_sendScrollLog.js":113,"./component/prArea/modules/_prArea.js":129,"./component/sp/_FavoriteToast":143,"./component/sp/_popupContent":147,"./component/sp/_s_addCartWithCampaignBanner":148,"./component/sp/_s_asyncRecommend":149,"./component/sp/_s_cartNumber":150,"./component/sp/_s_cartRevisitBalloon":151,"./component/sp/_s_getCampaignData":152,"./component/sp/_s_headerRecommend":153,"./component/sp/_s_revisitFlagSetting":154,"./component/sp/_s_searchCasettesLog":155,"./component/sp/_s_searchListPanel_integration_responsive.js":156,"./component/sp/_s_searchkyokanContent":158,"./component/sp/_s_slidePanel":159,"jquery":97,"swiper":100}],172:[function(require,module,exports){
/**
 * @description ユーザーのログイン状態を取得するAjax
 * @param {boolean} isPc trueならpc, falseならspを表す
 * @return {boolean} trueならログイン, spなら未ログイン
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getLoginStatus = function getLoginStatus(isPc, callBack) {
  var xhr = new XMLHttpRequest();
  var type = isPc ? 'net2' : 'smp2';
  var getLoginStatusInterval = window.setInterval(function () {
    // 非同期処理直列化 ajaxFlagはグローバル変数で、非同期処理実行判定フラグとして用いている
    if (!window.ajaxFlag) return;
    window.ajaxFlag = false;
    xhr.open('GET', '/' + type + '/quipMember/auth/signInStatusJson', true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          // リクエスト正常終了時
          callBack(JSON.parse(xhr.response).resultCode);
        } else {
          // リクエストエラー時
          callBack(1);
        }
      }
    };
    xhr.onloadend = function () {
      window.ajaxFlag = true;
    };
    // 非同期処理直列化 ajax実行完了したら繰り返し処理を解除する
    window.clearInterval(getLoginStatusInterval);
    xhr.send();
  }, 500);
};
exports.getLoginStatus = getLoginStatus;

},{}]},{},[171]);
